export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Binary: { input: string; output: string; }
  Color: { input: string; output: string; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Object: { input: Record<string, unknown>; output: Record<string, unknown>; }
  UUID: { input: string; output: string; }
};

/** A flat membership group. Membership alone does not share personal data or publish content. */
export type AccessGroup = {
  __typename?: 'AccessGroup';
  canDelete: Scalars['Boolean']['output'];
  canManageMembers: Scalars['Boolean']['output'];
  canManageRoles: Scalars['Boolean']['output'];
  /** Backend action eligibility for the current caller. */
  canUpdate: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the identity is maintained by the system; membership management may still be manual. */
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Organizational source; its name and direct roster are maintained through this OrgUnit. */
  orgUnitId?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type AccessGroup */
export type AccessGroupFilterInput = {
  and?: InputMaybe<Array<AccessGroupFilterInput>>;
  not?: InputMaybe<AccessGroupFilterInput>;
  or?: InputMaybe<Array<AccessGroupFilterInput>>;
};

export type AccessGroupMember = {
  __typename?: 'AccessGroupMember';
  memberships: Array<AccessGroupMembership>;
  /** Uses the ordinary Person read guard and consent-aware loader. */
  person?: Maybe<Person>;
  personId: Scalars['ID']['output'];
};

/** The filterable fields of type AccessGroupMember */
export type AccessGroupMemberFilterInput = {
  and?: InputMaybe<Array<AccessGroupMemberFilterInput>>;
  not?: InputMaybe<AccessGroupMemberFilterInput>;
  or?: InputMaybe<Array<AccessGroupMemberFilterInput>>;
};

/** Manual membership only. There is no writable source, nested group, or direct Person-role input. */
export type AccessGroupMemberInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

export type AccessGroupMembersResult = {
  __typename?: 'AccessGroupMembersResult';
  hasNextPage: Scalars['Boolean']['output'];
  members: Array<AccessGroupMember>;
  nextAfter?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type AccessGroupMembersResult */
export type AccessGroupMembersResultFilterInput = {
  and?: InputMaybe<Array<AccessGroupMembersResultFilterInput>>;
  not?: InputMaybe<AccessGroupMembersResultFilterInput>;
  or?: InputMaybe<Array<AccessGroupMembersResultFilterInput>>;
};

/** One independent assertion of membership. Identity assertions can only be changed at their source. */
export type AccessGroupMembership = {
  __typename?: 'AccessGroupMembership';
  canRemove: Scalars['Boolean']['output'];
  source: GroupMembershipSource;
};

/** The filterable fields of type AccessGroupMembership */
export type AccessGroupMembershipFilterInput = {
  and?: InputMaybe<Array<AccessGroupMembershipFilterInput>>;
  not?: InputMaybe<AccessGroupMembershipFilterInput>;
  or?: InputMaybe<Array<AccessGroupMembershipFilterInput>>;
};

/** A Role assigned on a Group. Its id addresses this relationship within that Group. */
export type AccessGroupRoleAssignment = {
  __typename?: 'AccessGroupRoleAssignment';
  canRemove: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  roleId: Scalars['ID']['output'];
  roleName: Scalars['String']['output'];
  scope: AccessScope;
};

/** The filterable fields of type AccessGroupRoleAssignment */
export type AccessGroupRoleAssignmentFilterInput = {
  and?: InputMaybe<Array<AccessGroupRoleAssignmentFilterInput>>;
  not?: InputMaybe<AccessGroupRoleAssignmentFilterInput>;
  or?: InputMaybe<Array<AccessGroupRoleAssignmentFilterInput>>;
};

export type AccessGroupsResult = {
  __typename?: 'AccessGroupsResult';
  groups: Array<AccessGroup>;
  hasNextPage: Scalars['Boolean']['output'];
  nextAfter?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type AccessGroupsResult */
export type AccessGroupsResultFilterInput = {
  and?: InputMaybe<Array<AccessGroupsResultFilterInput>>;
  not?: InputMaybe<AccessGroupsResultFilterInput>;
  or?: InputMaybe<Array<AccessGroupsResultFilterInput>>;
};

export type AccessInspectionGroup = {
  __typename?: 'AccessInspectionGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orgUnitId?: Maybe<Scalars['ID']['output']>;
  roles: Array<AccessInspectionRole>;
  sources: Array<GroupMembershipSource>;
};

/** The filterable fields of type AccessInspectionGroup */
export type AccessInspectionGroupFilterInput = {
  and?: InputMaybe<Array<AccessInspectionGroupFilterInput>>;
  not?: InputMaybe<AccessInspectionGroupFilterInput>;
  or?: InputMaybe<Array<AccessInspectionGroupFilterInput>>;
};

export type AccessInspectionRole = {
  __typename?: 'AccessInspectionRole';
  assignmentId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissionCodes: Array<Scalars['String']['output']>;
  roleId: Scalars['ID']['output'];
  scope: AccessScope;
};

/** The filterable fields of type AccessInspectionRole */
export type AccessInspectionRoleFilterInput = {
  and?: InputMaybe<Array<AccessInspectionRoleFilterInput>>;
  not?: InputMaybe<AccessInspectionRoleFilterInput>;
  or?: InputMaybe<Array<AccessInspectionRoleFilterInput>>;
};

export enum AccessLevel {
  Read = 'READ',
  Write = 'WRITE'
}

/** Read-only deployment configuration for login-derived Group membership. */
export type AccessMembershipPolicy = {
  __typename?: 'AccessMembershipPolicy';
  /** Verified email domains granting Employee membership; empty disables domain-based assignment. */
  employeeEmailDomains: Array<Scalars['String']['output']>;
};

/** The filterable fields of type AccessMembershipPolicy */
export type AccessMembershipPolicyFilterInput = {
  and?: InputMaybe<Array<AccessMembershipPolicyFilterInput>>;
  not?: InputMaybe<AccessMembershipPolicyFilterInput>;
  or?: InputMaybe<Array<AccessMembershipPolicyFilterInput>>;
};

/** A code-defined Permission. Read-only; description comes from the Genesis catalog. */
export type AccessPermission = {
  __typename?: 'AccessPermission';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** The filterable fields of type AccessPermission */
export type AccessPermissionFilterInput = {
  and?: InputMaybe<Array<AccessPermissionFilterInput>>;
  not?: InputMaybe<AccessPermissionFilterInput>;
  or?: InputMaybe<Array<AccessPermissionFilterInput>>;
};

export type AccessPermissionsResult = {
  __typename?: 'AccessPermissionsResult';
  permissions: Array<AccessPermission>;
};

/** The filterable fields of type AccessPermissionsResult */
export type AccessPermissionsResultFilterInput = {
  and?: InputMaybe<Array<AccessPermissionsResultFilterInput>>;
  not?: InputMaybe<AccessPermissionsResultFilterInput>;
  or?: InputMaybe<Array<AccessPermissionsResultFilterInput>>;
};

/** Administrative snapshot of one active person's Group-derived access; resource-specific checks remain separate. */
export type AccessPersonInspection = {
  __typename?: 'AccessPersonInspection';
  globalPermissionCodes: Array<Scalars['String']['output']>;
  groups: Array<AccessInspectionGroup>;
  personId: Scalars['ID']['output'];
};

/** The filterable fields of type AccessPersonInspection */
export type AccessPersonInspectionFilterInput = {
  and?: InputMaybe<Array<AccessPersonInspectionFilterInput>>;
  not?: InputMaybe<AccessPersonInspectionFilterInput>;
  or?: InputMaybe<Array<AccessPersonInspectionFilterInput>>;
};

/** A reusable bundle of supported Permissions, assigned within an explicit scope on a Group. */
export type AccessRole = {
  __typename?: 'AccessRole';
  /** Distinct persons across all current Group memberships; not the sum of assignment rows. */
  assignedPersonCount: Scalars['Int']['output'];
  assignments: Array<AccessRoleAssignment>;
  canDelete: Scalars['Boolean']['output'];
  /** Backend lifecycle eligibility; mutation authorization is rechecked when saving. */
  canUpdate: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** At least one Group has this Role, including Groups with no current members. */
  isInUse: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<AccessPermission>;
  /** Scopes compatible with every Permission in this bundle. */
  supportedScopes: Array<AccessScopeKind>;
};

/** A scoped Role relationship on a Group; no standalone Grant catalog. */
export type AccessRoleAssignment = {
  __typename?: 'AccessRoleAssignment';
  groupId: Scalars['ID']['output'];
  groupName: Scalars['String']['output'];
  /** Addresses this relationship together with groupId. */
  id: Scalars['ID']['output'];
  personCount: Scalars['Int']['output'];
  scope: AccessScope;
};

/** The filterable fields of type AccessRoleAssignment */
export type AccessRoleAssignmentFilterInput = {
  and?: InputMaybe<Array<AccessRoleAssignmentFilterInput>>;
  not?: InputMaybe<AccessRoleAssignmentFilterInput>;
  or?: InputMaybe<Array<AccessRoleAssignmentFilterInput>>;
};

/** The filterable fields of type AccessRole */
export type AccessRoleFilterInput = {
  and?: InputMaybe<Array<AccessRoleFilterInput>>;
  not?: InputMaybe<AccessRoleFilterInput>;
  or?: InputMaybe<Array<AccessRoleFilterInput>>;
};

/** Advisory impact of a proposed bundle; saving rechecks current assignments. Other sources may retain removed rights. */
export type AccessRoleImpact = {
  __typename?: 'AccessRoleImpact';
  addedPermissions: Array<AccessPermission>;
  canSave: Scalars['Boolean']['output'];
  groups: Array<AccessRoleImpactGroup>;
  groupsHasNextPage: Scalars['Boolean']['output'];
  groupsNextAfter?: Maybe<Scalars['ID']['output']>;
  peopleHasNextPage: Scalars['Boolean']['output'];
  peopleNextAfter?: Maybe<Scalars['ID']['output']>;
  /** Active holder ids are configuration metadata, not permission to read their profiles. At most 50 per page. */
  personIds: Array<Scalars['ID']['output']>;
  removedPermissions: Array<AccessPermission>;
};

/** The filterable fields of type AccessRoleImpact */
export type AccessRoleImpactFilterInput = {
  and?: InputMaybe<Array<AccessRoleImpactFilterInput>>;
  not?: InputMaybe<AccessRoleImpactFilterInput>;
  or?: InputMaybe<Array<AccessRoleImpactFilterInput>>;
};

export type AccessRoleImpactGroup = {
  __typename?: 'AccessRoleImpactGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The filterable fields of type AccessRoleImpactGroup */
export type AccessRoleImpactGroupFilterInput = {
  and?: InputMaybe<Array<AccessRoleImpactGroupFilterInput>>;
  not?: InputMaybe<AccessRoleImpactGroupFilterInput>;
  or?: InputMaybe<Array<AccessRoleImpactGroupFilterInput>>;
};

/** Minimal identity for the read-only Role assignment list; ordinary Person read checks apply. */
export type AccessRoleMember = {
  __typename?: 'AccessRoleMember';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Resolved by the ordinary batched Person loader, including avatar handling and field consent. */
  person?: Maybe<Person>;
};

/** The filterable fields of type AccessRoleMember */
export type AccessRoleMemberFilterInput = {
  and?: InputMaybe<Array<AccessRoleMemberFilterInput>>;
  not?: InputMaybe<AccessRoleMemberFilterInput>;
  or?: InputMaybe<Array<AccessRoleMemberFilterInput>>;
};

export type AccessRoleMembersResult = {
  __typename?: 'AccessRoleMembersResult';
  hasNextPage: Scalars['Boolean']['output'];
  members: Array<AccessRoleMember>;
  /** Last returned Person id, used unchanged as after for the next page. */
  nextAfter?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type AccessRoleMembersResult */
export type AccessRoleMembersResultFilterInput = {
  and?: InputMaybe<Array<AccessRoleMembersResultFilterInput>>;
  not?: InputMaybe<AccessRoleMembersResultFilterInput>;
  or?: InputMaybe<Array<AccessRoleMembersResultFilterInput>>;
};

export type AccessRolesResult = {
  __typename?: 'AccessRolesResult';
  roles: Array<AccessRole>;
};

/** The filterable fields of type AccessRolesResult */
export type AccessRolesResultFilterInput = {
  and?: InputMaybe<Array<AccessRolesResultFilterInput>>;
  not?: InputMaybe<AccessRolesResultFilterInput>;
  or?: InputMaybe<Array<AccessRolesResultFilterInput>>;
};

export type AccessScope = {
  __typename?: 'AccessScope';
  groupId?: Maybe<Scalars['ID']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  kind: AccessScopeKind;
};

/** The filterable fields of type AccessScope */
export type AccessScopeFilterInput = {
  and?: InputMaybe<Array<AccessScopeFilterInput>>;
  not?: InputMaybe<AccessScopeFilterInput>;
  or?: InputMaybe<Array<AccessScopeFilterInput>>;
};

export type AccessScopeInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  kind: AccessScopeKind;
};

/** Closed set of supported Group Role assignment scopes. */
export enum AccessScopeKind {
  Global = 'GLOBAL',
  GroupMembers = 'GROUP_MEMBERS',
  ManagedPeople = 'MANAGED_PEOPLE'
}

/** Execute one of the actions offered by an actionable notification. */
export type ActOnNotificationInput = {
  /** The action to execute. */
  action: NotificationActionType;
  /** The notification to act on. */
  notificationId: Scalars['UUID']['input'];
};

export type ActiveQuestionnairesByElementInput = {
  element: CreativityElement;
};

export type AddContactsInput = {
  contacts: Array<Scalars['UUID']['input']>;
  groups?: InputMaybe<Array<Scalars['UUID']['input']>>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  removeContactsFromOtherGroups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddContactsOutput = AddContactsResult | DailyQuotaExceeded | TooManyRecordsResult;

export type AddContactsResult = {
  __typename?: 'AddContactsResult';
  contactsAdded: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type AddContactsResult */
export type AddContactsResultFilterInput = {
  and?: InputMaybe<Array<AddContactsResultFilterInput>>;
  not?: InputMaybe<AddContactsResultFilterInput>;
  or?: InputMaybe<Array<AddContactsResultFilterInput>>;
};

export type AddPinsInput = {
  groups?: InputMaybe<Array<Scalars['UUID']['input']>>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  persons?: InputMaybe<Array<Scalars['UUID']['input']>>;
  removePinsFromOtherGroups?: InputMaybe<Scalars['Boolean']['input']>;
  sharedItems?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type AddPinsOutput = AddPinsResult | DailyQuotaExceeded | TooManyRecordsResult;

export type AddPinsResult = {
  __typename?: 'AddPinsResult';
  personsPinned?: Maybe<Array<Scalars['UUID']['output']>>;
  sharedItemsPinned?: Maybe<Array<Scalars['UUID']['output']>>;
};

/** The filterable fields of type AddPinsResult */
export type AddPinsResultFilterInput = {
  and?: InputMaybe<Array<AddPinsResultFilterInput>>;
  not?: InputMaybe<AddPinsResultFilterInput>;
  or?: InputMaybe<Array<AddPinsResultFilterInput>>;
};

export enum AdministrativeGender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN'
}

/**
 * An AI agent product (Claude Code, Paradox Olivia, Zip) that this instance lists as available to its projects.
 * PROJECT CONTEXT, NEVER A TEAM MEMBER: not a Person, not a candidate, never a seat in any solve.
 *
 * Instance data (`@adr GENESIS-0074-ai-agents-are-instance-data-copied-once-from-editable-defaults@1`): any
 * authenticated caller reads the list; create, update and delete need `write:reference-data`. The Default agents
 * are copied in once by a migration and are ordinary rows from then on — a later change to the defaults never
 * reaches an existing instance. Delete is a HARD delete; a match keeps its own snapshot in `design.agents[]`.
 * `agents` is a connection like `companies`: page with `first`/`after` (or `skip`/`take`), at most 100 per page,
 * ordered by `name` unless `order` says otherwise, filtered with `where` (`id: {in: [...]}` resolves a set of ids).
 * `updateAgent` restates `name`, `vendor` and `integrations` (non-null on the input) and replaces every other
 * field it is given, lists as a whole; a field left out stays as stored.
 *
 * Prose (`role`, `covers`, tool descriptions, `guardrails`) carries German and English, an absent language as null;
 * `localized` falls back to the other language when the requested one is absent. Product tokens (`name`, `vendor`,
 * tool names, `integrations`) are single-language
 * (`@adr GENESIS-0075-agent-prose-is-stored-in-both-languages-with-null-for-an-absent-one@1`).
 */
export type Agent = Node & {
  __typename?: 'Agent';
  /** Capability areas in plain words. Free text on purpose: how an agent offsets requirements is undecided. */
  covers: Array<LocalizedText>;
  guardrails: Array<LocalizedText>;
  /** Filter with `id: {in: [...]}` to resolve a set of agents, e.g. `globalSearch` hits or a match's stored ids. */
  id: Scalars['ID']['output'];
  /** The integration surface as the vendor names it (MCP servers, connectors, plugins). Product tokens. */
  integrations: Array<Scalars['String']['output']>;
  /** The model, when known. */
  model?: Maybe<Scalars['String']['output']>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name: Scalars['String']['output'];
  /** What the agent does. At least one of german / english must be non-blank. */
  role: LocalizedText;
  tools: Array<AgentTool>;
  /** The vendor's product page. */
  url?: Maybe<Scalars['String']['output']>;
  /** The vendor's name. Must not be blank. */
  vendor: Scalars['String']['output'];
};

export type AgentConnection = {
  __typename?: 'AgentConnection';
  edges: Array<AgentEdge>;
  nodes: Array<Agent>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgentEdge = {
  __typename?: 'AgentEdge';
  cursor: Scalars['String']['output'];
  node: Agent;
};

/** The filterable fields of type Agent */
export type AgentFilterInput = {
  and?: InputMaybe<Array<AgentFilterInput>>;
  /** Filter with `id: {in: [...]}` to resolve a set of agents, e.g. `globalSearch` hits or a match's stored ids. */
  id?: InputMaybe<IdFilterInput>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<AgentFilterInput>;
  or?: InputMaybe<Array<AgentFilterInput>>;
};

/** The parameters for requesting multiple instances of Agent. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type AgentQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<AgentSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<AgentFilterInput>;
};

export type AgentSortInput = {
  /** Filter with `id: {in: [...]}` to resolve a set of agents, e.g. `globalSearch` hits or a match's stored ids. */
  id?: InputMaybe<SortOrder>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name?: InputMaybe<SortOrder>;
};

/** One tool of an Agent. */
export type AgentTool = {
  __typename?: 'AgentTool';
  description: LocalizedText;
  /** Product token, never translated. */
  name: Scalars['String']['output'];
};

/** The filterable fields of type AgentTool */
export type AgentToolFilterInput = {
  and?: InputMaybe<Array<AgentToolFilterInput>>;
  not?: InputMaybe<AgentToolFilterInput>;
  or?: InputMaybe<Array<AgentToolFilterInput>>;
};

export type ApplicationError = {
  correlationId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ApplicationError */
export type ApplicationErrorFilterInput = {
  and?: InputMaybe<Array<ApplicationErrorFilterInput>>;
  not?: InputMaybe<ApplicationErrorFilterInput>;
  or?: InputMaybe<Array<ApplicationErrorFilterInput>>;
};

export type AssignAccessGroupRoleInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  scope: AccessScopeInput;
};

/**
 * Assigns a person's manager, or clears it. The manager is a nullable self-reference on person; a chain that
 * would form a cycle is refused by the database. Maintained under `write:access-config`.
 */
export type AssignManagerInput = {
  /** If true, only the validation is performed but nothing is written. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The managing person, or null to clear the manager. */
  managerId?: InputMaybe<Scalars['ID']['input']>;
  /** The person whose manager is being set. */
  personId: Scalars['ID']['input'];
};

/** The result of assigning a person's manager — echoes the resulting assignment. */
export type AssignManagerOutput = {
  __typename?: 'AssignManagerOutput';
  /** The assigned manager's person id, or null if the manager was cleared. */
  managerId?: Maybe<Scalars['ID']['output']>;
  personId: Scalars['ID']['output'];
};

/** The filterable fields of type AssignManagerOutput */
export type AssignManagerOutputFilterInput = {
  and?: InputMaybe<Array<AssignManagerOutputFilterInput>>;
  not?: InputMaybe<AssignManagerOutputFilterInput>;
  or?: InputMaybe<Array<AssignManagerOutputFilterInput>>;
};

/**
 * Assigns a person to an OrgUnit, or clears the assignment. The fast-moving, person-lifecycle-bound half of
 * the org surfaces (`@adr GENESIS-0065-all-group-consent-is-explicit-and-dynamic@1` §8), kept apart from the OrgUnit tree
 * so each can carry a different provenance later. Maintained under `write:access-config`.
 */
export type AssignOrgUnitInput = {
  /** If true, only the validation is performed but nothing is written. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The OrgUnit to assign, or null to clear the assignment. */
  orgUnitId?: InputMaybe<Scalars['ID']['input']>;
  /** The person whose org unit is being set. */
  personId: Scalars['ID']['input'];
};

/** The result of assigning a person's OrgUnit — echoes the resulting assignment. */
export type AssignOrgUnitOutput = {
  __typename?: 'AssignOrgUnitOutput';
  /** The assigned OrgUnit id, or null if the assignment was cleared. */
  orgUnitId?: Maybe<Scalars['ID']['output']>;
  personId: Scalars['ID']['output'];
};

/** The filterable fields of type AssignOrgUnitOutput */
export type AssignOrgUnitOutputFilterInput = {
  and?: InputMaybe<Array<AssignOrgUnitOutputFilterInput>>;
  not?: InputMaybe<AssignOrgUnitOutputFilterInput>;
  or?: InputMaybe<Array<AssignOrgUnitOutputFilterInput>>;
};

export type AssignQuestionnaireToGroupInput = {
  /**
   * If true, only the validation is performed but the membership is not changed - same meaning as on
   * UpdateDocumentInput, which is how a document changes its group.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Position within the target group. Null appends at the end. Ignored when ungrouping. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Null removes the questionnaire from its group and clears its position. Moving to a different group always assigns a fresh position - the old one described a different group. */
  questionnaireGroupId?: InputMaybe<Scalars['UUID']['input']>;
  questionnaireId: Scalars['UUID']['input'];
};

export type AttachProjectDocumentInput = {
  files: Array<CreateFileDataInput>;
  matchId: Scalars['UUID']['input'];
};

export type AttachProjectDocumentOutput = AttachProjectDocumentResult;

export type AttachProjectDocumentResult = {
  __typename?: 'AttachProjectDocumentResult';
  match: Match;
};

/** The filterable fields of type AttachProjectDocumentResult */
export type AttachProjectDocumentResultFilterInput = {
  and?: InputMaybe<Array<AttachProjectDocumentResultFilterInput>>;
  not?: InputMaybe<AttachProjectDocumentResultFilterInput>;
  or?: InputMaybe<Array<AttachProjectDocumentResultFilterInput>>;
};

export type AudioElement = GrowElement & PlayableGrowElement & {
  __typename?: 'AudioElement';
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  sources: Array<AudioElementSource>;
  thumbnail?: Maybe<Scalars['Binary']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type AudioElement */
export type AudioElementFilterInput = {
  and?: InputMaybe<Array<AudioElementFilterInput>>;
  not?: InputMaybe<AudioElementFilterInput>;
  or?: InputMaybe<Array<AudioElementFilterInput>>;
};

export type AudioElementSource = {
  __typename?: 'AudioElementSource';
  mimeType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type AudioElementSource */
export type AudioElementSourceFilterInput = {
  and?: InputMaybe<Array<AudioElementSourceFilterInput>>;
  not?: InputMaybe<AudioElementSourceFilterInput>;
  or?: InputMaybe<Array<AudioElementSourceFilterInput>>;
};

/** Filtering for fields of type Boolean */
export type BooleanFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<BooleanFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<BooleanFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<BooleanFilterInput>>;
};

/** Counts of records created (or that would have been created in a dry run) per entity collection. */
export type BulkImportPersonCounts = {
  __typename?: 'BulkImportPersonCounts';
  certificates: Scalars['Int']['output'];
  educations: Scalars['Int']['output'];
  experiences: Scalars['Int']['output'];
  expertises: Scalars['Int']['output'];
  languageSkills: Scalars['Int']['output'];
  personUpdated: Scalars['Boolean']['output'];
};

/** The filterable fields of type BulkImportPersonCounts */
export type BulkImportPersonCountsFilterInput = {
  and?: InputMaybe<Array<BulkImportPersonCountsFilterInput>>;
  not?: InputMaybe<BulkImportPersonCountsFilterInput>;
  or?: InputMaybe<Array<BulkImportPersonCountsFilterInput>>;
};

export type BulkImportPersonDetailData = {
  bio?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for the provider-agnostic bulk-import mutation. The caller provides the
 * target personId plus optional lists for each profile collection and an optional
 * personDetail fragment. Collections that are already non-empty for the target
 * person are left untouched and their name is appended to `skipped` in the result.
 * Non-fatal mapping issues surfaced by the caller (e.g. unrecognized language
 * proficiency while parsing a provider export) can be relayed via `clientWarnings`
 * so they appear in the aggregated result alongside any server-side warnings.
 */
export type BulkImportPersonInput = {
  certificates?: InputMaybe<Array<CreateCertificateDataInput>>;
  clientWarnings?: InputMaybe<Array<Scalars['String']['input']>>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  educations?: InputMaybe<Array<CreateEducationDataInput>>;
  experiences?: InputMaybe<Array<CreateExperienceDataInput>>;
  expertises?: InputMaybe<Array<CreateExpertiseDataInput>>;
  languageSkills?: InputMaybe<Array<CreateLanguageSkillDataInput>>;
  personDetail?: InputMaybe<BulkImportPersonDetailData>;
  personId: Scalars['ID']['input'];
};

/**
 * Result of a bulk person-data import. `skipped` lists the collection names that
 * were left untouched because the target person already had data of that kind
 * (current policy: never overwrite existing data). `warnings` aggregates
 * non-fatal issues — both mapping warnings relayed from the caller via
 * `clientWarnings` and any server-side issues (e.g. optimistic-lock loss during
 * personDetail update).
 */
export type BulkImportPersonResult = {
  __typename?: 'BulkImportPersonResult';
  counts: BulkImportPersonCounts;
  skipped: Array<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

/** The filterable fields of type BulkImportPersonResult */
export type BulkImportPersonResultFilterInput = {
  and?: InputMaybe<Array<BulkImportPersonResultFilterInput>>;
  not?: InputMaybe<BulkImportPersonResultFilterInput>;
  or?: InputMaybe<Array<BulkImportPersonResultFilterInput>>;
};

export enum CefrScale {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2'
}

export type CefrScaleFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<CefrScaleFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<CefrScale>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<CefrScale>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<CefrScale>;
  /** Negates the predicate */
  not?: InputMaybe<CefrScaleFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<CefrScaleFilterInput>>;
};

/** A thing to pick in the toplist game: facts from Wikidata, keyed by its QID. */
export type CatalogItem = {
  __typename?: 'CatalogItem';
  domain: FavoriteDomain;
  id: Scalars['UUID']['output'];
  /** First release or publication, where the domain has one. */
  releaseYear?: Maybe<Scalars['Int']['output']>;
  /** At most three codes from a small list per domain: a film genre, a continent, a cuisine. */
  tags: Array<Scalars['String']['output']>;
  title: LocalizedText;
};

/** The filterable fields of type CatalogItem */
export type CatalogItemFilterInput = {
  and?: InputMaybe<Array<CatalogItemFilterInput>>;
  not?: InputMaybe<CatalogItemFilterInput>;
  or?: InputMaybe<Array<CatalogItemFilterInput>>;
};

export type CatalogItemsInput = {
  domain: FavoriteDomain;
};

export type Category = {
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type Category */
export type CategoryFilterInput = {
  and?: InputMaybe<Array<CategoryFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CategoryFilterInput>;
  or?: InputMaybe<Array<CategoryFilterInput>>;
};

export type CategorySortInput = {
  name?: InputMaybe<SortOrder>;
};

export type Certificate = Node & SharableEntity & {
  __typename?: 'Certificate';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<DateInstant>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  person: Person;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

/** The filterable fields of type Certificate */
export type CertificateFilterInput = {
  and?: InputMaybe<Array<CertificateFilterInput>>;
  not?: InputMaybe<CertificateFilterInput>;
  or?: InputMaybe<Array<CertificateFilterInput>>;
};

export type ChatMessage = Node & {
  __typename?: 'ChatMessage';
  content: Scalars['String']['output'];
  conversationId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  senderId: Scalars['UUID']['output'];
  sentAt: Scalars['DateTime']['output'];
};

/** The filterable fields of type ChatMessage */
export type ChatMessageFilterInput = {
  and?: InputMaybe<Array<ChatMessageFilterInput>>;
  not?: InputMaybe<ChatMessageFilterInput>;
  or?: InputMaybe<Array<ChatMessageFilterInput>>;
};

/**
 * A place-of-residence requirement. `radiusKm` is the distance the criterion applies within -- a hard
 * geographic gate, not decoration: without it the criterion degrades to a literal city-name comparison.
 * Omit it (or send 0) only for an exact city match. City has its own input rather than sharing
 * `StringConditionInput` precisely because those two fields have nowhere to go there, and a write that
 * drops them destroys a hand-authored radius with no undo (genesis#331).
 */
export type CityConditionInput = {
  aiMode?: ConditionAiMode;
  radiusKm?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

/**
 * Preview diff for one collection section (experiences, educations, languageSkills, certificates,
 * expertises): one row per proposed row, in the source's order. The exception is `languageSkills`,
 * where a language the source proposes more than once yields a SINGLE row — a person holds at most
 * one row per language, so a second one could never be created.
 */
export type CollectionDiff = {
  __typename?: 'CollectionDiff';
  rows: Array<CollectionRowDiff>;
};

/** The filterable fields of type CollectionDiff */
export type CollectionDiffFilterInput = {
  and?: InputMaybe<Array<CollectionDiffFilterInput>>;
  not?: InputMaybe<CollectionDiffFilterInput>;
  or?: InputMaybe<Array<CollectionDiffFilterInput>>;
};

/**
 * Preview diff for one collection row. `rowKey` is this row's identity within the preview:
 * `"<section>:<ordinal>"` (`certificates:0`, `certificates:1`, …), unique across the WHOLE preview
 * and never equal to a `PersonDetailFieldDiff.key`, so decisions and edits for every proposal of a
 * preview can share one namespace. Treat it as opaque — do not parse it, and do not store or cache
 * it: it identifies a row inside ONE preview and nothing beyond it. `existingRowId` identifies the
 * matched existing row (null for an ADD) and is what makes a re-preview recognize an already-saved
 * row, keeping re-import idempotent; no two rows of one preview ever carry the same one. `fields`
 * carries the per-field diff (existing vs incoming machine values) the client renders and can edit.
 * Existing rows with no incoming match are not emitted — they are always kept.
 */
export type CollectionRowDiff = {
  __typename?: 'CollectionRowDiff';
  action: ImportDiffAction;
  existingRowId?: Maybe<Scalars['ID']['output']>;
  fields: Array<RowFieldDiff>;
  rowKey: Scalars['String']['output'];
};

/** The filterable fields of type CollectionRowDiff */
export type CollectionRowDiffFilterInput = {
  and?: InputMaybe<Array<CollectionRowDiffFilterInput>>;
  not?: InputMaybe<CollectionRowDiffFilterInput>;
  or?: InputMaybe<Array<CollectionRowDiffFilterInput>>;
};

export type Colors = {
  __typename?: 'Colors';
  background?: Maybe<Scalars['Color']['output']>;
  text?: Maybe<Scalars['Color']['output']>;
};

/** The filterable fields of type Colors */
export type ColorsFilterInput = {
  and?: InputMaybe<Array<ColorsFilterInput>>;
  not?: InputMaybe<ColorsFilterInput>;
  or?: InputMaybe<Array<ColorsFilterInput>>;
};

export type Communication = {
  __typename?: 'Communication';
  language: Scalars['String']['output'];
  preferred?: Maybe<Scalars['Boolean']['output']>;
};

/** The filterable fields of type Communication */
export type CommunicationFilterInput = {
  and?: InputMaybe<Array<CommunicationFilterInput>>;
  not?: InputMaybe<CommunicationFilterInput>;
  or?: InputMaybe<Array<CommunicationFilterInput>>;
};

/**
 * Company — an organisation that people belong to.
 *
 * A company can be a passive candidate in a RANK_COMPANIES match. Each company is scored independently
 * against the requirements; it never enters the team solver. The ranking implementation is recorded in
 * @adr GENESIS-0034-a-company-ranking-is-a-fourth-match-setting@4.
 * A company does not initiate or own a match. Matching as a company remains deferred (genesis#277).
 *
 * The profile contains name, industry, logo, size and one free-text summary. It has no separate tagline,
 * vision, mission, product, culture or Powers fields.
 *
 * `@update` and `@delete` were held back until the row-scoped gate existed: editing a Company is not a
 * platform-wide decision but one that belongs to company membership
 * (the company account model). Their resolvers are gated on
 * `CompanyAccess#validateCompanyAdmin` — an admin membership row — and never on a platform role;
 * `create:company` gates creation only. A directive here publishes a root field whether or not a
 * resolver exists, so the directive set is kept to exactly what is implemented.
 */
export type Company = Node & {
  __typename?: 'Company';
  /**
   * Whether the caller is an active admin of this Company. Group roles, HR and sharing overrides
   * confer no Company authority. Applies to profile and membership administration, including
   * reactivation; individual mutation validation and the freeze on inactive Company content still apply.
   */
  canAdminister: Scalars['Boolean']['output'];
  /**
   *   Size, as a headcount.
   *
   * PROFILE FIELD — POPULATED ON THE SINGLE-COMPANY QUERY AND ON `companies` NODES, the same rule as
   *   `summary` below. See
   *   `summary` for why, and for why `logo` is no longer governed by that same rule.
   *
   * ONE EXCEPTION, AND ONLY THIS ONE: `MatchCompany.company` and `MatchResultCompany.company` carry it
   *   too, because in a company match the head count is the actual value of a size criterion, shown beside
   *   every company in the pool and the ranking
   *   (@adr GENESIS-0078-a-match-company-carries-its-size-but-not-its-summary@2). `summary` does not
   *   follow it there.
   */
  employeeCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Industry. The curated Industry reference entity, shared with Experience. */
  industry?: Maybe<Industry>;
  /**
   *   The company logo, stored in backdrop and owned by the default user
   *   (@adr GENESIS-0013-backdrop-blob-storage-boundary@1). Null when none was uploaded; the page then renders
   *   the monogram fallback that the company page displays.
   *
   * THE TEST IS WHETHER THE CALLER DECIDED THE NUMBER OF IMAGES BEFORE SENDING THE REQUEST. The CSP
   *   admits images only from self, data: and blob:, so the bytes travel base64-encoded inside the GraphQL
   *   response; one image is a picture, a page of them is a payload. Where the count is settled in advance
   *   the caller is asking for exactly those images on purpose, and this field answers. Where it is
   *   "whatever matched", it does not.
   *
   * IT THEREFORE RESOLVES IN FOUR PLACES, AND NOWHERE ELSE:
   *
   * - the single-company query — one company, the one being shown;
   *   - `myCompanies` — bounded by the caller's own company_membership rows, each Company at most once;
   *   - `companyIdentities` — bounded by an explicit, server-capped id list the caller already held;
   *   - `SharedItem.company` on the SINGLE-ITEM read and the create/update payloads — one item, one owner,
   *     which is the "Published by <company>" byline of that item's own page.
   *
   * EVERYWHERE ELSE IT IS NULL EVEN WHEN A LOGO EXISTS — CompanyMembership.company in a member roster,
   *   and SharedItem.company in any feed or company-page listing. That is structural rather than a
   *   convention a client is asked to keep: the logo travels as local context, and the list surfaces
   *   attach none, so the field cannot resolve there however the query is written. An earlier revision of
   *   this paragraph stated the rule while the code left the context attached on every shared-item
   *   surface — a feed selecting `nodes { company { logo } }` really did return one image per row, on an
   *   endpoint that takes no page-size cap. Do not re-widen it by attaching the map somewhere new; add a
   *   bounded, id-driven query instead, the way `companyIdentities` was.
   *
   * `summary` and `employeeCount` are populated on the single-company query and on `companies` nodes
   *   only (GENESIS-0036) — null on every Company beside something else, including `myCompanies`, with
   *   the one exception that the Match pool and ranking carry `employeeCount` (see that field). `id`,
   *   `name` and `industry` are what a Company beside something else always carries.
   *
   * profile accepts "card" (max height 140) or "share_preview" (max height 250); omit it for the
   *   unscaled original.
   *
   * ON WRITE (the generated create/update inputs carry this field as CreateFileDataInput): max 5 MB, and
   *   the content must BE a PNG, JPEG, GIF, BMP, TIFF or WebP. The check is on the bytes, never on the
   *   declared mimeType, so a payload announcing image/png while carrying something else is rejected. SVG
   *   is refused outright — it carries script and the blob store cannot scale it. On update, omitting the
   *   field leaves the current logo alone and passing null removes it, the same presence-versus-value rule
   *   the other optional fields follow.
   */
  logo?: Maybe<File>;
  name: Scalars['String']['output'];
  /**
   *   ACTIVE or INACTIVE — see the enum for what the two mean and why there are only two.
   *
   * NOT CREATABLE: a company is born ACTIVE and there is no reason to create a dormant one, so the
   *   column's default is the only way it is ever first set. Updatable by an admin of this company, which
   *   is the same gate `updateCompany` already applies to every other field here — deactivating is a
   *   per-company write like any other, and deliberately NOT a platform-moderation action (there is no
   *   role for that, and adding one is a realm change).
   *
   * Not `@filterable`, and that is not an oversight: an INACTIVE company is not in the search index at
   *   all, so a status filter over search results would have nothing to select from — and the `companies`
   *   connection applies `status = ACTIVE` as a row rule to every page and to `totalCount`, so a filter
   *   there would have nothing to add either (GENESIS-0036).
   *
   * NULLABLE ON THE WIRE, ALWAYS SET IN PRACTICE. Every resolver that returns a Company populates it,
   *   so a caller reading this field gets a value. It is declared nullable because the generated update
   *   input mirrors the field's nullability, and a non-null one would make `status` REQUIRED on every
   *   `updateCompany` — the same way `name` is — so an edit that only touched the summary would have to
   *   restate the status or be rejected. That is the opposite of the property-set mechanism this mutation
   *   is built on, where an unmentioned field is left alone.
   */
  status?: Maybe<CompanyStatus>;
  /**
   *   About us — one free text carrying vision, mission, product, culture and expectations.
   *
   * One unbounded field:
   *   everything a company says about itself arrives here, so a populated `summary` is a page of text, not
   *   a label.
   *
   * PROFILE FIELD — POPULATED ON THE SINGLE-COMPANY QUERY AND ON `companies` NODES. Everywhere else a
   *   Company is reachable — CompanyMembership.company in a member strip, MyCompanyMembership.company in
   *   myCompanies, SharedItem.company, SharedItemComment.company, Project.company, `companyIdentities`, and
   *   the Match pool and ranking (MatchCompany.company, MatchResultCompany.company) — this resolves to null
   *   even when a summary is stored, for the reason `logo` gives: every
   *   row of a member strip points at the SAME Company, so populating it would ship one full copy of that
   *   text per member beside three short fields. Ask for the profile on the company you are showing, once.
   *   A `companies` page is different in kind (@adr GENESIS-0036-a-company-is-queryable-like-a-person@2):
   *   every node is a DIFFERENT company, selected on purpose and bounded by `first`, so the text is
   *   delivered once per company the caller asked for — the same reasoning that admits `logo` on
   *   `myCompanies`.
   *
   * `logo` is NOT the same rule any more, so do not read one off the other: it is also delivered on
   *   `myCompanies`, because that list is bounded by the caller's own memberships. `summary` is not,
   *   because a whole "About us" page per row is unwelcome at any length of list.
   *
   * A null here therefore means "not asked on this query" on every one of those surfaces, NOT "this
   *   company wrote nothing" — and on `company` and `companies` it IS the stored value, so a null there means the
   *   company has no description. The identity fields a strip does carry are `id`, `name` and `industry`.
   *
   * NOT FILTERABLE: summary text is excluded from the search index and the filter layer. A consumer that needs to find companies by what
   *   their description says reads the descriptions off `companies` nodes and searches them itself
   *   (agent-service does, by embedding — @adr GENESIS-0036-a-company-is-queryable-like-a-person@2).
   */
  summary?: Maybe<Scalars['String']['output']>;
};


/**
 * Company — an organisation that people belong to.
 *
 * A company can be a passive candidate in a RANK_COMPANIES match. Each company is scored independently
 * against the requirements; it never enters the team solver. The ranking implementation is recorded in
 * @adr GENESIS-0034-a-company-ranking-is-a-fourth-match-setting@4.
 * A company does not initiate or own a match. Matching as a company remains deferred (genesis#277).
 *
 * The profile contains name, industry, logo, size and one free-text summary. It has no separate tagline,
 * vision, mission, product, culture or Powers fields.
 *
 * `@update` and `@delete` were held back until the row-scoped gate existed: editing a Company is not a
 * platform-wide decision but one that belongs to company membership
 * (the company account model). Their resolvers are gated on
 * `CompanyAccess#validateCompanyAdmin` — an admin membership row — and never on a platform role;
 * `create:company` gates creation only. A directive here publishes a root field whether or not a
 * resolver exists, so the directive set is kept to exactly what is implemented.
 */
export type CompanyLogoArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyCompetenciesInput = {
  companyId: Scalars['ID']['input'];
};

/**
 * One expertise a company lists: a free-text label it typed and how strongly it holds it
 * (@adr GENESIS-0031-company-expertise-is-per-company-free-text@3).
 *
 * THE LABEL IS THE COMPANY'S OWN TEXT. There is no shared vocabulary and no catalogue behind it, so two
 * companies writing "Photonik" simply both wrote "Photonik" — the strings carry no relationship, and a
 * client must not treat them as one entity. Within ONE company a label is unique, folding case and
 * surrounding whitespace.
 *
 * Only listed expertise exists as a row: a label that is absent was never claimed.
 *
 * NO LEVEL, ON EITHER SIDE (concept v17, the company capability model, decided
 * by Kevin with Janek 2026-09-09). An entry is the label and nothing else. The level was a
 * self-assessment with no counter-check — the company set it, nobody verified it, and the same level at
 * two companies meant nothing — while what the match actually uses is an AI judgement over the TEXT
 * (v14). A number beside that invited readers to treat it as comparable. This retires the SUBJECT of
 * `@adr GENESIS-0021-company-competency-degree-stored-as-percent@4`, not its argument.
 */
export type CompanyCompetency = {
  __typename?: 'CompanyCompetency';
  /** The expertise, exactly as the company admin typed it (trimmed). Unique per company, case-insensitively. */
  label: Scalars['String']['output'];
};

/**
 * HAND-DECLARED, not generated. The generator skips any type the schema already declares
 * (`GeneratorContext.register` opens with `if (hasUserProvidedTypeWithName(name)) return;`), which is how
 * `RecipientFilterInput` above is written by hand, and it is the only way to put an operator on a filter
 * input that the operator vocabulary does not have. `and`/`or`/`not`/`label` below are a verbatim copy of
 * what the generator produced for this type; `matches` is the addition.
 */
export type CompanyCompetencyFilterInput = {
  and?: InputMaybe<Array<CompanyCompetencyFilterInput>>;
  /** The expertise, exactly as the company admin typed it (trimmed). Unique per company, case-insensitively. */
  label?: InputMaybe<StringFilterInput>;
  /**
   *   The label matched the way the LABEL SEARCH matches it — german and english stemming plus a prefix
   *   arm, the same five ORed conditions `globalSearch` runs (`FullTextSearch`, lifted out of
   *   SearchController so there is one implementation and not two).
   *
   * WHY IT EXISTS. `label` compares strings; the search does not. So `label: {eq: "Fernwärme"}` did not
   *   exclude a company whose label reads "Fernwärmeversorgung", while the very search that confirmed the
   *   word to the caller reached it (measured 2026-10-07). A caller that found a label by searching and
   *   then filters on it needs the filter to agree with the search.
   *
   * ONE TEXT per condition, in PostgreSQL websearch syntax. Alternatives are an `or` of whole conditions,
   *   not a list. It extends a word to the RIGHT only: "Fernwärme" reaches "Fernwärmeversorgung", "Wärme"
   *   does not reach "Fernwärme". It does NOT translate — "Luftfracht" does not find "Air Freight";
   *   stemming is not a dictionary, and a company that wants both files both (DACHSER lists "Luftfracht"
   *   beside "Air & Sea Logistics").
   *
   * `label` stays for what it is good at: an exact value, a list of them, a prefix.
   */
  matches?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<CompanyCompetencyFilterInput>;
  or?: InputMaybe<Array<CompanyCompetencyFilterInput>>;
};

/** One company's expertise, as a fingerprint — see `companyCompetencyHashes`. */
export type CompanyCompetencyHash = {
  __typename?: 'CompanyCompetencyHash';
  companyId: Scalars['ID']['output'];
  /** sha-256 (hex) over that company's labels. A company listing nothing hashes the empty string. */
  labelsHash: Scalars['String']['output'];
};

/** The filterable fields of type CompanyCompetencyHash */
export type CompanyCompetencyHashFilterInput = {
  and?: InputMaybe<Array<CompanyCompetencyHashFilterInput>>;
  not?: InputMaybe<CompanyCompetencyHashFilterInput>;
  or?: InputMaybe<Array<CompanyCompetencyHashFilterInput>>;
};

export type CompanyCompetencyHashesResult = {
  __typename?: 'CompanyCompetencyHashesResult';
  hashes: Array<CompanyCompetencyHash>;
};

/** The filterable fields of type CompanyCompetencyHashesResult */
export type CompanyCompetencyHashesResultFilterInput = {
  and?: InputMaybe<Array<CompanyCompetencyHashesResultFilterInput>>;
  not?: InputMaybe<CompanyCompetencyHashesResultFilterInput>;
  or?: InputMaybe<Array<CompanyCompetencyHashesResultFilterInput>>;
};

/** Filtering options for a list of elements with type CompanyCompetency */
export type CompanyCompetencyListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<CompanyCompetencyFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<CompanyCompetencyFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<CompanyCompetencyFilterInput>;
};

export type CompanyCompetencyResult = {
  __typename?: 'CompanyCompetencyResult';
  competencies: Array<CompanyCompetency>;
};

/** The filterable fields of type CompanyCompetencyResult */
export type CompanyCompetencyResultFilterInput = {
  and?: InputMaybe<Array<CompanyCompetencyResultFilterInput>>;
  not?: InputMaybe<CompanyCompetencyResultFilterInput>;
  or?: InputMaybe<Array<CompanyCompetencyResultFilterInput>>;
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  edges: Array<CompanyEdge>;
  nodes: Array<Company>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyContactPersonsInput = {
  companyId: Scalars['ID']['input'];
};

/**
 * The contact persons of one company — a capped set, and never paged
 * (the company page caps them).
 */
export type CompanyContactPersonsResult = {
  __typename?: 'CompanyContactPersonsResult';
  contactPersons: Array<CompanyMembership>;
};

/** The filterable fields of type CompanyContactPersonsResult */
export type CompanyContactPersonsResultFilterInput = {
  and?: InputMaybe<Array<CompanyContactPersonsResultFilterInput>>;
  not?: InputMaybe<CompanyContactPersonsResultFilterInput>;
  or?: InputMaybe<Array<CompanyContactPersonsResultFilterInput>>;
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node: Company;
};

/** The filterable fields of type Company */
export type CompanyFilterInput = {
  and?: InputMaybe<Array<CompanyFilterInput>>;
  /**
   * The same expertise, as a LIST — so a criterion can say `none` as well as `some`.
   *
   * WHY BOTH. `competencyFieldName` is a scalar over a child table, so the only question it can answer
   * is "does SOME row match". A caller asking for companies that do NOT list something has no way to say
   * so: `not` on a filter object is refused, and `competencyFieldName: {not: …}` asks "has some OTHER
   * label", which every company holding two labels satisfies — on a 200-company set it returned all 200,
   * including every company carrying the excluded label. This field is the `none` that question needs,
   * and it is the shape Person already has: `Person.expertises` is a filterable list, so
   * `expertises: {none: …}` has always worked for people. The docstring on `competencyFieldName` says
   * this filter exists "so the extended search can narrow companies by expertise the way it narrows
   * people by `expertises`" — until now it could not.
   *
   * FILTER ONLY, like its scalar sibling: the Company type stays thin, and the company page reads its
   * expertise through `companyCompetencies`. `competencyFieldName` is kept because clients send it.
   */
  competencies?: InputMaybe<CompanyCompetencyListFilterInput>;
  /**
   * The company's expertise BY LABEL, as a FILTER ONLY.
   *
   * Not readable, and deliberately so: the Company type stays thin (see `summary` above), and the
   * company page already reads its expertise through `companyCompetencies`. This exists so the extended
   * search can narrow companies by expertise the way it narrows people by `expertises`, and it mirrors
   * that field: a searcher types a topic and the filter matches expertise labels.
   *
   * Modelled on Person.personGroupId, the same shape of problem: the value lives in a child table
   * (`company_competency`), so it is not a column on `company` and CompanyFilterSpec resolves it with a
   * join rather than a comparison. A company holding several matching labels is returned ONCE — the
   * caller's GROUP BY on (entity_type, entity_id) collapses the joined rows.
   *
   * A PLAIN COLUMN MATCH, with no locale and no catalogue behind it. Concept v4 retired the shared
   * competency vocabulary: a label is free text belonging to one company
   * (@adr GENESIS-0031-company-expertise-is-per-company-free-text@3), so there is no localized name to
   * choose between and no hidden/retired state to exclude. Its sibling `competencyFieldId` went with the
   * catalogue — an id filter has nothing left to name. The FIELD NAME is kept as it was because clients
   * send it and it is not worth a breaking rename on its own; it means "expertise label".
   */
  competencyFieldName?: InputMaybe<StringFilterInput>;
  /**
   * Size, as a headcount.
   *
   * PROFILE FIELD — POPULATED ON THE SINGLE-COMPANY QUERY AND ON `companies` NODES, the same rule as
   * `summary` below. See
   * `summary` for why, and for why `logo` is no longer governed by that same rule.
   *
   * ONE EXCEPTION, AND ONLY THIS ONE: `MatchCompany.company` and `MatchResultCompany.company` carry it
   * too, because in a company match the head count is the actual value of a size criterion, shown beside
   * every company in the pool and the ranking
   * (@adr GENESIS-0078-a-match-company-carries-its-size-but-not-its-summary@2). `summary` does not
   * follow it there.
   */
  employeeCount?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  /** Industry. The curated Industry reference entity, shared with Experience. */
  industry?: InputMaybe<IndustryFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CompanyFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
};

export type CompanyIdentitiesInput = {
  /**
   * The companies to identify. At most 50 — the server refuses a longer list rather than truncating it,
   * because a silently shortened answer would render as "these companies have no logo".
   */
  ids: Array<Scalars['ID']['input']>;
};

/**
 * The identity of companies the caller already knows the ids of: name and logo, for drawing a list of
 * known references as the companies they point at.
 *
 * WHY THIS EXISTS AT ALL. The search index carries an id and a label and no image (V0023__GlobalSearch),
 * so a company hit could be drawn only as a monogram, while a person hit beside it showed a real face —
 * the person search hydrates its page of ids back through `persons` for exactly this reason. This is the
 * same step for companies, and nothing more: it is a hydration surface for ids in hand, NOT a company
 * directory. It takes no filter, no sort and no cursor, so it cannot be used to enumerate companies or
 * to reach one that was not already found some other way.
 *
 * AN INACTIVE COMPANY IS RETURNED LIKE ANY OTHER. Deactivating decides FINDABILITY, and it decides it in
 * the index (the company search), so an inactive company's id never
 * reaches this query from a search in the first place. Anyone who holds the id can already open the page
 * (the company entity model), and answering null here would
 * make the same company nameless in a list and named on its page.
 *
 * An id that matches no company is skipped rather than erroring: a stale hit in a result set is an
 * ordinary race, and the row it belongs to simply keeps its monogram.
 */
export type CompanyIdentitiesResult = {
  __typename?: 'CompanyIdentitiesResult';
  companies: Array<Company>;
};

/** The filterable fields of type CompanyIdentitiesResult */
export type CompanyIdentitiesResultFilterInput = {
  and?: InputMaybe<Array<CompanyIdentitiesResultFilterInput>>;
  not?: InputMaybe<CompanyIdentitiesResultFilterInput>;
  or?: InputMaybe<Array<CompanyIdentitiesResultFilterInput>>;
};

export type CompanyInput = {
  id: Scalars['ID']['input'];
};

/**
 * One company requirement. Exactly one of industryId, minimumEmployees or expertise must be set.
 * Industry is an equality comparison; employee count is a non-negative minimum; expertise has no level.
 * The match's existing Agentic AI setting controls expertise evaluation.
 */
export type CompanyMatchConditionInput = {
  active?: Scalars['Boolean']['input'];
  expertise?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  minimumEmployees?: InputMaybe<Scalars['Int']['input']>;
  requirement?: InputMaybe<ConditionRequirement>;
};

/**
 * The member strip of one company (the company page), paged.
 *
 * CURSOR PAGING, FORWARD ONLY. @adr GENESIS-0006-cursor-pagination-discourage-totalcount@1 makes keyset
 * paging the default for list endpoints, and a member strip is only ever walked forwards — so `last`
 * and `before` are deliberately absent rather than accepted and untested. Omitting `first` is a first
 * page of the server default, never the whole roster.
 *
 * `first` IS CAPPED SERVER-SIDE. An unbounded page is the same defect as an unpaged list: each row can
 * carry an inline avatar, so a caller asking for the roster in one request is asking for one full image
 * per member. Above the cap the request is refused (GENESIS001009) rather than silently trimmed, so a
 * client cannot mistake a clamped page for a complete one.
 */
export type CompanyMembersInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  /**
   * Cursor-based pagination: number of members to return, at most the server cap. Use in conjunction
   * with 'after'. Omitted means the server default.
   */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A person's membership of a Company. `role` is an open string, not an enum: the current model uses `admin` and `member` for the MVP but requires later roles to be
 * addable without a schema migration.
 */
export type CompanyMembership = {
  __typename?: 'CompanyMembership';
  /** The Company, as identity only — `id`, `name`, `industry`. See Company.summary. */
  company: Company;
  /**
   *   Whether this member is one of the company's contact persons — the "Ansprechpartner" of
   *   the company page, which are referenced members (a capped set — see companyContactPersons)
   *   and deliberately NOT a free-text e-mail or phone field.
   *
   * ORTHOGONAL TO `role`, not a value of it. A contact person is still a `member` or an `admin`; being
   *   marked adds nothing to what they may do and taking the mark away removes nothing. Set through
   *   setCompanyContactPerson, which is gated on an admin membership row like every other per-company
   *   write (@adr GENESIS-0023-company-membership-is-the-per-company-authorization@4).
   *
   * IT IS PUBLISHED EXACTLY AS THE MEMBERSHIP IS. companyContactPersons applies the same predicate as
   *   companyMembers — literally the same helper, with `contactPerson` ANDed on — so the two can never
   *   disagree about who is on the page. This flag is still selectable on the roster, where it
   *   says which of the members on THIS page are contacts; the complete, capped set is
   *   companyContactPersons.
   */
  contactPerson: Scalars['Boolean']['output'];
  person: Person;
  role: Scalars['String']['output'];
};

/**
 * A page of one company's members. Modelled on SharedItemConnection, which companyOwnedSharedItems — the
 * other list on the same company page — already returns.
 *
 * `totalCount` goes through the same predicate as the page, so the count and the rows can never
 * disagree — a strip saying "12" that only ever renders nine is the failure this rules out. Since
 * concept v5 there is nothing per-caller left for it to withhold: it is the company's active members,
 * the same number for everybody. It is what the company page means by "Anzahl",
 * and unlike the totals @adr GENESIS-0006-cursor-pagination-discourage-totalcount@1 warns about it is
 * scoped to one company by an indexed column rather than being a full table scan. It is only counted
 * when selected.
 */
export type CompanyMembershipConnection = {
  __typename?: 'CompanyMembershipConnection';
  edges: Array<CompanyMembershipEdge>;
  nodes: Array<CompanyMembership>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** The filterable fields of type CompanyMembershipConnection */
export type CompanyMembershipConnectionFilterInput = {
  and?: InputMaybe<Array<CompanyMembershipConnectionFilterInput>>;
  not?: InputMaybe<CompanyMembershipConnectionFilterInput>;
  or?: InputMaybe<Array<CompanyMembershipConnectionFilterInput>>;
};

export type CompanyMembershipEdge = {
  __typename?: 'CompanyMembershipEdge';
  cursor: Scalars['String']['output'];
  node: CompanyMembership;
};

/** The filterable fields of type CompanyMembershipEdge */
export type CompanyMembershipEdgeFilterInput = {
  and?: InputMaybe<Array<CompanyMembershipEdgeFilterInput>>;
  not?: InputMaybe<CompanyMembershipEdgeFilterInput>;
  or?: InputMaybe<Array<CompanyMembershipEdgeFilterInput>>;
};

/** The filterable fields of type CompanyMembership */
export type CompanyMembershipFilterInput = {
  and?: InputMaybe<Array<CompanyMembershipFilterInput>>;
  not?: InputMaybe<CompanyMembershipFilterInput>;
  or?: InputMaybe<Array<CompanyMembershipFilterInput>>;
};

export type CompanyMembershipInput = {
  companyId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  role: Scalars['String']['input'];
};

/** The parameters for requesting multiple instances of Company. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type CompanyQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<CompanySortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<CompanyFilterInput>;
};

/** Contains information for linking 'Company' to other entities */
export type CompanyRelationInput = {
  /** The identifier of 'Company' */
  id: Scalars['ID']['input'];
};

export type CompanyResult = {
  __typename?: 'CompanyResult';
  company?: Maybe<Company>;
};

/** The filterable fields of type CompanyResult */
export type CompanyResultFilterInput = {
  and?: InputMaybe<Array<CompanyResultFilterInput>>;
  not?: InputMaybe<CompanyResultFilterInput>;
  or?: InputMaybe<Array<CompanyResultFilterInput>>;
};

export type CompanySortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

/**
 * The lifecycle state of a company — two values, where a person has four.
 *
 * The lifecycle has only ACTIVE and INACTIVE. There is no DELETED, because INACTIVE already is it: `deleteCompany` is a SOFT delete —
 * it sets this field and removes nothing — so deleting and deactivating are one act and a second state
 * for it would be a distinction without a difference. There is no SUSPENDED, because nothing on the
 * platform may act on a company it is not a member of; `create:company` is a creation gate and
 * @adr GENESIS-0023-company-membership-is-the-per-company-authorization@4 §1a renamed it precisely to stop
 * it being read as more.
 *
 * DEACTIVATING CLEARS NOTHING. Name, industry, logo, size, summary, expertise, members and contact
 * persons all survive, so reactivating restores the company whole. That is the deliberate difference
 * from a deleted person, whose names are nulled because that stands in for a right to erasure.
 *
 * WHAT IT DOES DO, IN TWO KINDS. The first two are ABSENCES and raise nothing at all — the index simply
 * has no row, so a search returns fewer results and no error is produced. The rest are REFUSALS, and
 * those carry `GENESIS001250`. An earlier revision of this paragraph called all of it "six acts refused,
 * all with GENESIS001250", which described the absences as errors and miscounted the refusals. The count
 * is deliberately no longer stated: it went stale twice, once there and again when v16 and v20 added the
 * comment refusals below. The RULE is what to read — every write in the company's name, and every write
 * on its content, is refused.
 *
 * It is not findable:
 *
 * 1. The company itself is absent from the topbar and the extended search.
 * 2. So are its posts and projects — except to a caller who has PINNED one, whose own reference to it
 *    survives the freeze (the pin board is not a search).
 *
 * And its content is frozen — each act below refused with `GENESIS001250`:
 *
 * 3. Nothing new can be published in its name.
 * 4. Nothing it already published can be edited.
 * 5. Nor deleted.
 * 6. Nobody can apply to its projects.
 * 7. Nobody can rate them.
 * 8. Nobody counts as a viewer of them — 6 to 8 are figures a reader is meant to trust, and a company
 *    nobody can find must not keep accruing them.
 * 9. No comment can be created, edited or deleted IN ITS NAME, on any item at all (concept v16).
 * 10. And no comment can be created, edited or deleted ON ITS CONTENT, by anybody — a private comment by
 *    somebody with no connection to the company included (concept v20, 2026-09-10, which withdrew v16's
 *    "Gesperrt ist die Firmenstimme, nicht die Diskussion" and its "private Kommentare bleiben
 *    ungesperrt"). 9 and 10 are different sets: 9 follows the COMMENT's company, 10 the ITEM's, and a
 *    company commenting on its own post is simply in both. READING a thread is untouched by either —
 *    what freezes is writing.
 *
 * One CONSEQUENCE rather than a seventh refusal: the documents attached to a frozen item cannot be
 * deleted either. That is `deleteDocument` refusing while a shared item still uses one — its own
 * refusal, not this code — and it bites because the post can no longer be edited to detach it.
 *
 * Reactivating lifts all of it at once, and nothing was cleared in the meantime.
 *
 * MOSTLY EXCLUDED IN THE INDEX, WITH ONE QUERY-TIME EXCEPTION. The trigger simply does not write the
 * rows, so a search surface reading `global_search` cannot forget the rule. One surface does not read
 * it: the extended search's Share tab filters `sharedItems` by column text, so that query carries the
 * condition itself. The company PAGE deliberately carries none — freezing removes discoverability, not
 * the content, and anyone holding the URL still sees both the company and its posts.
 */
export enum CompanyStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ConditionAiMode {
  FullAi = 'FULL_AI',
  NoAi = 'NO_AI'
}

export type ConditionCompositionInput = {
  operator: ConditionCompositionOperator;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export enum ConditionCompositionOperator {
  All = 'ALL',
  Any = 'ANY',
  Exact = 'EXACT',
  Max = 'MAX',
  Min = 'MIN'
}

export enum ConditionLanguageLevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
  Native = 'NATIVE'
}

export enum ConditionOperator {
  Eq = 'EQ',
  Ge = 'GE',
  Gt = 'GT',
  Le = 'LE',
  Lt = 'LT',
  Ne = 'NE'
}

export enum ConditionRequirement {
  Must = 'MUST',
  Optional = 'OPTIONAL'
}

export type ContactPoint = {
  __typename?: 'ContactPoint';
  period?: Maybe<Period>;
  rank?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<ContactPointSystem>;
  use?: Maybe<ContactPointUse>;
  value?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ContactPoint */
export type ContactPointFilterInput = {
  and?: InputMaybe<Array<ContactPointFilterInput>>;
  not?: InputMaybe<ContactPointFilterInput>;
  or?: InputMaybe<Array<ContactPointFilterInput>>;
};

export enum ContactPointSystem {
  Bluesky = 'BLUESKY',
  Discord = 'DISCORD',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Fax = 'FAX',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Mastodon = 'MASTODON',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Phone = 'PHONE',
  Pinterest = 'PINTEREST',
  Snapchat = 'SNAPCHAT',
  Threads = 'THREADS',
  Tiktok = 'TIKTOK',
  Twitch = 'TWITCH',
  Twitter = 'TWITTER',
  Website = 'WEBSITE',
  Youtube = 'YOUTUBE'
}

export enum ContactPointUse {
  Home = 'HOME',
  Mobile = 'MOBILE',
  Old = 'OLD',
  Temp = 'TEMP',
  Work = 'WORK'
}

export type ContactPowersDevStatsInput = {
  amount: Scalars['Int']['input'];
  days: Scalars['Int']['input'];
};

export type ContactTopElements = {
  __typename?: 'ContactTopElements';
  elements: Array<CreativityElement>;
  person: PersonLean;
};

/** The filterable fields of type ContactTopElements */
export type ContactTopElementsFilterInput = {
  and?: InputMaybe<Array<ContactTopElementsFilterInput>>;
  not?: InputMaybe<ContactTopElementsFilterInput>;
  or?: InputMaybe<Array<ContactTopElementsFilterInput>>;
};

export type ContactTopElementsInput = {
  amount: Scalars['Int']['input'];
};

export type ContactWithGrowScore = {
  __typename?: 'ContactWithGrowScore';
  person: Person;
  score: Scalars['Int']['output'];
  userRank: UserRank;
};

/** The filterable fields of type ContactWithGrowScore */
export type ContactWithGrowScoreFilterInput = {
  and?: InputMaybe<Array<ContactWithGrowScoreFilterInput>>;
  not?: InputMaybe<ContactWithGrowScoreFilterInput>;
  or?: InputMaybe<Array<ContactWithGrowScoreFilterInput>>;
};

export type Contacts = {
  __typename?: 'Contacts';
  bluesky?: Maybe<Scalars['String']['output']>;
  discord?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  github?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  mastodon?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  snapchat?: Maybe<Scalars['String']['output']>;
  threads?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitch?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Contacts */
export type ContactsFilterInput = {
  and?: InputMaybe<Array<ContactsFilterInput>>;
  not?: InputMaybe<ContactsFilterInput>;
  or?: InputMaybe<Array<ContactsFilterInput>>;
};

export type ContactsWithHighestScoreInput = {
  limit: Scalars['Int']['input'];
};

/** A Group selected for ordinary content sharing. Eligibility controls new choices, not existing readership. */
export type ContentSharingRecipient = Node & {
  __typename?: 'ContentSharingRecipient';
  eligible: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The filterable fields of type ContentSharingRecipient */
export type ContentSharingRecipientFilterInput = {
  and?: InputMaybe<Array<ContentSharingRecipientFilterInput>>;
  not?: InputMaybe<ContentSharingRecipientFilterInput>;
  or?: InputMaybe<Array<ContentSharingRecipientFilterInput>>;
};

/** Contains information for linking 'ContentSharingRecipient' to other entities */
export type ContentSharingRecipientRelationInput = {
  /** The identifier of 'ContentSharingRecipient' */
  id: Scalars['ID']['input'];
};

export type ContractType = Node & {
  __typename?: 'ContractType';
  desc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localizedDesc?: Maybe<LocalizedText>;
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ContractType */
export type ContractTypeFilterInput = {
  and?: InputMaybe<Array<ContractTypeFilterInput>>;
  desc?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContractTypeFilterInput>;
  or?: InputMaybe<Array<ContractTypeFilterInput>>;
};

/** Contains information for linking 'ContractType' to other entities */
export type ContractTypeRelationInput = {
  /** The identifier of 'ContractType' */
  id: Scalars['ID']['input'];
};

export type ContractTypeSortInput = {
  desc?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ContractTypesResult = {
  __typename?: 'ContractTypesResult';
  contractTypes: Array<ContractType>;
};

/** The filterable fields of type ContractTypesResult */
export type ContractTypesResultFilterInput = {
  and?: InputMaybe<Array<ContractTypesResultFilterInput>>;
  not?: InputMaybe<ContractTypesResultFilterInput>;
  or?: InputMaybe<Array<ContractTypesResultFilterInput>>;
};

export type Conversation = Node & {
  __typename?: 'Conversation';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  participantIds: Array<Scalars['UUID']['output']>;
};

export type ConversationEvent = {
  __typename?: 'ConversationEvent';
  conversationId: Scalars['UUID']['output'];
  message?: Maybe<ChatMessage>;
  presence?: Maybe<PresenceIndicator>;
  readReceipt?: Maybe<ConversationReadReceipt>;
  type: ConversationEventType;
  typing?: Maybe<TypingIndicator>;
};

/** The filterable fields of type ConversationEvent */
export type ConversationEventFilterInput = {
  and?: InputMaybe<Array<ConversationEventFilterInput>>;
  not?: InputMaybe<ConversationEventFilterInput>;
  or?: InputMaybe<Array<ConversationEventFilterInput>>;
};

export enum ConversationEventType {
  MessageCreated = 'MESSAGE_CREATED',
  PresenceChanged = 'PRESENCE_CHANGED',
  ReadReceiptUpdated = 'READ_RECEIPT_UPDATED',
  TypingChanged = 'TYPING_CHANGED'
}

/** The filterable fields of type Conversation */
export type ConversationFilterInput = {
  and?: InputMaybe<Array<ConversationFilterInput>>;
  not?: InputMaybe<ConversationFilterInput>;
  or?: InputMaybe<Array<ConversationFilterInput>>;
};

export type ConversationLifecycleEvent = {
  __typename?: 'ConversationLifecycleEvent';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['UUID']['output'];
  type: ConversationLifecycleEventType;
};

/** The filterable fields of type ConversationLifecycleEvent */
export type ConversationLifecycleEventFilterInput = {
  and?: InputMaybe<Array<ConversationLifecycleEventFilterInput>>;
  not?: InputMaybe<ConversationLifecycleEventFilterInput>;
  or?: InputMaybe<Array<ConversationLifecycleEventFilterInput>>;
};

export enum ConversationLifecycleEventType {
  Created = 'CREATED',
  Deleted = 'DELETED'
}

export type ConversationMessagesInput = {
  afterMessageId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['UUID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationReadReceipt = {
  __typename?: 'ConversationReadReceipt';
  conversationId: Scalars['UUID']['output'];
  lastReadMessageId: Scalars['UUID']['output'];
  personId: Scalars['UUID']['output'];
  readAt: Scalars['DateTime']['output'];
};

/** The filterable fields of type ConversationReadReceipt */
export type ConversationReadReceiptFilterInput = {
  and?: InputMaybe<Array<ConversationReadReceiptFilterInput>>;
  not?: InputMaybe<ConversationReadReceiptFilterInput>;
  or?: InputMaybe<Array<ConversationReadReceiptFilterInput>>;
};

export type CountriesResult = {
  __typename?: 'CountriesResult';
  countries: Array<Country>;
};

/** The filterable fields of type CountriesResult */
export type CountriesResultFilterInput = {
  and?: InputMaybe<Array<CountriesResultFilterInput>>;
  not?: InputMaybe<CountriesResultFilterInput>;
  or?: InputMaybe<Array<CountriesResultFilterInput>>;
};

export type Country = Node & {
  __typename?: 'Country';
  hasStates?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  iso2?: Maybe<Scalars['String']['output']>;
  iso3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  obsolete?: Maybe<Scalars['Boolean']['output']>;
  osmId?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type Country */
export type CountryFilterInput = {
  and?: InputMaybe<Array<CountryFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  iso2?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CountryFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
};

/** Filtering options for a list of elements with type Country */
export type CountryListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<CountryFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<CountryFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<CountryFilterInput>;
};

/** Contains information for linking 'Country' to other entities */
export type CountryRelationInput = {
  /** The identifier of 'Country' */
  id: Scalars['ID']['input'];
};

export type CountryState = Node & {
  __typename?: 'CountryState';
  countryId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  osmId?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type CountryState */
export type CountryStateFilterInput = {
  and?: InputMaybe<Array<CountryStateFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CountryStateFilterInput>;
  or?: InputMaybe<Array<CountryStateFilterInput>>;
};

/** Contains information for linking 'CountryState' to other entities */
export type CountryStateRelationInput = {
  /** The identifier of 'CountryState' */
  id: Scalars['ID']['input'];
};

export type CountryStatesByCountryInput = {
  countryId: Scalars['UUID']['input'];
};

export type CountryStatesByCountryResult = {
  __typename?: 'CountryStatesByCountryResult';
  states: Array<CountryState>;
};

/** The filterable fields of type CountryStatesByCountryResult */
export type CountryStatesByCountryResultFilterInput = {
  and?: InputMaybe<Array<CountryStatesByCountryResultFilterInput>>;
  not?: InputMaybe<CountryStatesByCountryResultFilterInput>;
  or?: InputMaybe<Array<CountryStatesByCountryResultFilterInput>>;
};

export type CreateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

/** Create a new custom Role only. No existing Role, scope, Grant or membership can be addressed. */
export type CreateAccessRoleInput = {
  /** Optional description, up to 2000 characters. */
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name, 1–120 characters after trimming. */
  name: Scalars['String']['input'];
  /** Existing Permission ids. At least one; duplicate ids are treated as one selection. */
  permissionIds: Array<Scalars['ID']['input']>;
};

/** The input data for creating an instance of Agent */
export type CreateAgentDataInput = {
  /** Capability areas in plain words. Free text on purpose: how an agent offsets requirements is undecided. */
  covers: Array<CreateLocalizedTextDataInput>;
  guardrails: Array<CreateLocalizedTextDataInput>;
  /** The integration surface as the vendor names it (MCP servers, connectors, plugins). Product tokens. */
  integrations: Array<Scalars['String']['input']>;
  /** The model, when known. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name: Scalars['String']['input'];
  /** What the agent does. At least one of german / english must be non-blank. */
  role: CreateLocalizedTextDataInput;
  tools: Array<CreateAgentToolDataInput>;
  /** The vendor's product page. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's name. Must not be blank. */
  vendor: Scalars['String']['input'];
};

/** Data structure to create a new instance of Agent */
export type CreateAgentInput = {
  /** The actual data of Agent */
  data: CreateAgentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Agent */
export type CreateAgentOutput = CreateAgentResult | ValidateAgentResult;

/** The result data structure of creating an instance of Agent */
export type CreateAgentResult = {
  __typename?: 'CreateAgentResult';
  /** The actual data returned for Agent */
  result: Agent;
};

/** The input data for creating an instance of AgentTool */
export type CreateAgentToolDataInput = {
  description: CreateLocalizedTextDataInput;
  /** Product token, never translated. */
  name: Scalars['String']['input'];
};

/** The input data for creating an instance of Certificate */
export type CreateCertificateDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<CreateDateInstantDataInput>;
  name: Scalars['String']['input'];
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

/** Data structure to create a new instance of Certificate */
export type CreateCertificateInput = {
  /** The actual data of Certificate */
  data: CreateCertificateDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Certificate */
export type CreateCertificateOutput = CreateCertificateResult | ValidateCertificateResult;

/** The result data structure of creating an instance of Certificate */
export type CreateCertificateResult = {
  __typename?: 'CreateCertificateResult';
  /** The actual data returned for Certificate */
  result: Certificate;
};

/** The input data for creating an instance of Colors */
export type CreateColorsDataInput = {
  background?: InputMaybe<Scalars['Color']['input']>;
  text?: InputMaybe<Scalars['Color']['input']>;
};

/** The input data for creating an instance of Company */
export type CreateCompanyDataInput = {
  /**
   * Size, as a headcount.
   *
   * PROFILE FIELD — POPULATED ON THE SINGLE-COMPANY QUERY AND ON `companies` NODES, the same rule as
   * `summary` below. See
   * `summary` for why, and for why `logo` is no longer governed by that same rule.
   *
   * ONE EXCEPTION, AND ONLY THIS ONE: `MatchCompany.company` and `MatchResultCompany.company` carry it
   * too, because in a company match the head count is the actual value of a size criterion, shown beside
   * every company in the pool and the ranking
   * (@adr GENESIS-0078-a-match-company-carries-its-size-but-not-its-summary@2). `summary` does not
   * follow it there.
   */
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  /** Industry. The curated Industry reference entity, shared with Experience. */
  industry?: InputMaybe<IndustryRelationInput>;
  /**
   * The company logo, stored in backdrop and owned by the default user
   * (@adr GENESIS-0013-backdrop-blob-storage-boundary@1). Null when none was uploaded; the page then renders
   * the monogram fallback that the company page displays.
   *
   * THE TEST IS WHETHER THE CALLER DECIDED THE NUMBER OF IMAGES BEFORE SENDING THE REQUEST. The CSP
   * admits images only from self, data: and blob:, so the bytes travel base64-encoded inside the GraphQL
   * response; one image is a picture, a page of them is a payload. Where the count is settled in advance
   * the caller is asking for exactly those images on purpose, and this field answers. Where it is
   * "whatever matched", it does not.
   *
   * IT THEREFORE RESOLVES IN FOUR PLACES, AND NOWHERE ELSE:
   *
   * - the single-company query — one company, the one being shown;
   * - `myCompanies` — bounded by the caller's own company_membership rows, each Company at most once;
   * - `companyIdentities` — bounded by an explicit, server-capped id list the caller already held;
   * - `SharedItem.company` on the SINGLE-ITEM read and the create/update payloads — one item, one owner,
   *   which is the "Published by <company>" byline of that item's own page.
   *
   * EVERYWHERE ELSE IT IS NULL EVEN WHEN A LOGO EXISTS — CompanyMembership.company in a member roster,
   * and SharedItem.company in any feed or company-page listing. That is structural rather than a
   * convention a client is asked to keep: the logo travels as local context, and the list surfaces
   * attach none, so the field cannot resolve there however the query is written. An earlier revision of
   * this paragraph stated the rule while the code left the context attached on every shared-item
   * surface — a feed selecting `nodes { company { logo } }` really did return one image per row, on an
   * endpoint that takes no page-size cap. Do not re-widen it by attaching the map somewhere new; add a
   * bounded, id-driven query instead, the way `companyIdentities` was.
   *
   * `summary` and `employeeCount` are populated on the single-company query and on `companies` nodes
   * only (GENESIS-0036) — null on every Company beside something else, including `myCompanies`, with
   * the one exception that the Match pool and ranking carry `employeeCount` (see that field). `id`,
   * `name` and `industry` are what a Company beside something else always carries.
   *
   * profile accepts "card" (max height 140) or "share_preview" (max height 250); omit it for the
   * unscaled original.
   *
   * ON WRITE (the generated create/update inputs carry this field as CreateFileDataInput): max 5 MB, and
   * the content must BE a PNG, JPEG, GIF, BMP, TIFF or WebP. The check is on the bytes, never on the
   * declared mimeType, so a payload announcing image/png while carrying something else is rejected. SVG
   * is refused outright — it carries script and the blob store cannot scale it. On update, omitting the
   * field leaves the current logo alone and passing null removes it, the same presence-versus-value rule
   * the other optional fields follow.
   */
  logo?: InputMaybe<CreateFileDataInput>;
  name: Scalars['String']['input'];
  /**
   * About us — one free text carrying vision, mission, product, culture and expectations.
   *
   * One unbounded field:
   * everything a company says about itself arrives here, so a populated `summary` is a page of text, not
   * a label.
   *
   * PROFILE FIELD — POPULATED ON THE SINGLE-COMPANY QUERY AND ON `companies` NODES. Everywhere else a
   * Company is reachable — CompanyMembership.company in a member strip, MyCompanyMembership.company in
   * myCompanies, SharedItem.company, SharedItemComment.company, Project.company, `companyIdentities`, and
   * the Match pool and ranking (MatchCompany.company, MatchResultCompany.company) — this resolves to null
   * even when a summary is stored, for the reason `logo` gives: every
   * row of a member strip points at the SAME Company, so populating it would ship one full copy of that
   * text per member beside three short fields. Ask for the profile on the company you are showing, once.
   * A `companies` page is different in kind (@adr GENESIS-0036-a-company-is-queryable-like-a-person@2):
   * every node is a DIFFERENT company, selected on purpose and bounded by `first`, so the text is
   * delivered once per company the caller asked for — the same reasoning that admits `logo` on
   * `myCompanies`.
   *
   * `logo` is NOT the same rule any more, so do not read one off the other: it is also delivered on
   * `myCompanies`, because that list is bounded by the caller's own memberships. `summary` is not,
   * because a whole "About us" page per row is unwelcome at any length of list.
   *
   * A null here therefore means "not asked on this query" on every one of those surfaces, NOT "this
   * company wrote nothing" — and on `company` and `companies` it IS the stored value, so a null there means the
   * company has no description. The identity fields a strip does carry are `id`, `name` and `industry`.
   *
   * NOT FILTERABLE: summary text is excluded from the search index and the filter layer. A consumer that needs to find companies by what
   * their description says reads the descriptions off `companies` nodes and searches them itself
   * (agent-service does, by embedding — @adr GENESIS-0036-a-company-is-queryable-like-a-person@2).
   */
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of Company */
export type CreateCompanyInput = {
  /** The actual data of Company */
  data: CreateCompanyDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Company */
export type CreateCompanyOutput = CreateCompanyResult | ValidateCompanyResult;

/** The result data structure of creating an instance of Company */
export type CreateCompanyResult = {
  __typename?: 'CreateCompanyResult';
  /** The actual data returned for Company */
  result: Company;
};

/** The input data for creating an instance of ContractType */
export type CreateContractTypeDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of ContractType */
export type CreateContractTypeInput = {
  /** The actual data of ContractType */
  data: CreateContractTypeDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of ContractType */
export type CreateContractTypeOutput = CreateContractTypeResult | ValidateContractTypeResult;

/** The result data structure of creating an instance of ContractType */
export type CreateContractTypeResult = {
  __typename?: 'CreateContractTypeResult';
  /** The actual data returned for ContractType */
  result: ContractType;
};

export type CreateConversationInput = {
  participantIds: Array<Scalars['UUID']['input']>;
};

/** The input data for creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeDataInput = {
  apiVersion: Scalars['Int']['input'];
  configuration?: InputMaybe<Scalars['Object']['input']>;
  content?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
};

/** Data structure to create a new instance of CurriculumVitae */
export type CreateCurriculumVitaeInput = {
  /** The actual data of CurriculumVitae */
  data: CreateCurriculumVitaeDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeOutput = CreateCurriculumVitaeResult | ValidateCurriculumVitaeResult;

/** The result data structure of creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeResult = {
  __typename?: 'CreateCurriculumVitaeResult';
  /** The actual data returned for CurriculumVitae */
  result: CurriculumVitae;
};

/** The input data for creating an instance of DateInstant */
export type CreateDateInstantDataInput = {
  date: Scalars['Date']['input'];
  precision: DatePrecision;
};

/** The input data for creating an instance of Deceased */
export type CreateDeceasedDataInput = {
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  deceasedDate?: InputMaybe<CreateDateInstantDataInput>;
};

/** The input data for creating an instance of Degree */
export type CreateDegreeDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of Degree */
export type CreateDegreeInput = {
  /** The actual data of Degree */
  data: CreateDegreeDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Degree */
export type CreateDegreeOutput = CreateDegreeResult | ValidateDegreeResult;

/** The result data structure of creating an instance of Degree */
export type CreateDegreeResult = {
  __typename?: 'CreateDegreeResult';
  /** The actual data returned for Degree */
  result: Degree;
};

/** The input data for creating an instance of DiscoveryCategory */
export type CreateDiscoveryCategoryDataInput = {
  name?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of DiscoveryCategory */
export type CreateDiscoveryCategoryInput = {
  /** The actual data of DiscoveryCategory */
  data: CreateDiscoveryCategoryDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of DiscoveryCategory */
export type CreateDiscoveryCategoryOutput = CreateDiscoveryCategoryResult | ValidateDiscoveryCategoryResult;

/** The result data structure of creating an instance of DiscoveryCategory */
export type CreateDiscoveryCategoryResult = {
  __typename?: 'CreateDiscoveryCategoryResult';
  /** The actual data returned for DiscoveryCategory */
  result: DiscoveryCategory;
};

/** The input data for creating an instance of Document */
export type CreateDocumentDataInput = {
  category?: InputMaybe<DocumentClassifier>;
  content: CreateFileDataInput;
  fileName?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<DocumentGroupRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input data for creating an instance of DocumentGroup */
export type CreateDocumentGroupDataInput = {
  name: Scalars['String']['input'];
};

/** Data structure to create a new instance of DocumentGroup */
export type CreateDocumentGroupInput = {
  /** The actual data of the document group */
  data: CreateDocumentGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

/** The result of creating an instance of document group */
export type CreateDocumentGroupOutput = CreateDocumentGroupResult | TooManyRecordsResult | ValidateDocumentGroupResult;

/** The result data structure of creating an instance of DocumentGroup */
export type CreateDocumentGroupResult = {
  __typename?: 'CreateDocumentGroupResult';
  /** The actual data returned for DocumentGroup */
  result: DocumentGroup;
};

/** Data structure to create a new instance of Document */
export type CreateDocumentInput = {
  /** The actual data of Document */
  data: CreateDocumentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Document */
export type CreateDocumentOutput = CreateDocumentResult | ValidateDocumentResult;

/** The result data structure of creating an instance of Document */
export type CreateDocumentResult = {
  __typename?: 'CreateDocumentResult';
  /** The actual data returned for Document */
  result: Document;
};

/** The input data for creating an instance of Education */
export type CreateEducationDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  degree?: InputMaybe<DegreeRelationInput>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  field: Scalars['String']['input'];
  institution?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  startDate: CreateDateInstantDataInput;
};

/** Data structure to create a new instance of Education */
export type CreateEducationInput = {
  /** The actual data of Education */
  data: CreateEducationDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Education */
export type CreateEducationOutput = CreateEducationResult | ValidateEducationResult;

/** The result data structure of creating an instance of Education */
export type CreateEducationResult = {
  __typename?: 'CreateEducationResult';
  /** The actual data returned for Education */
  result: Education;
};

/** The input data for creating an instance of ElementWeight */
export type CreateElementWeightDataInput = {
  element?: InputMaybe<CreativityElement>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** The input data for creating an instance of Experience */
export type CreateExperienceDataInput = {
  activities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  industry?: InputMaybe<IndustryRelationInput>;
  jobTitle: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  startDate: CreateDateInstantDataInput;
};

/** Data structure to create a new instance of Experience */
export type CreateExperienceInput = {
  /** The actual data of Experience */
  data: CreateExperienceDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Experience */
export type CreateExperienceOutput = CreateExperienceResult | ValidateExperienceResult;

/** The result data structure of creating an instance of Experience */
export type CreateExperienceResult = {
  __typename?: 'CreateExperienceResult';
  /** The actual data returned for Experience */
  result: Experience;
};

/** The input data for creating an instance of Expertise */
export type CreateExpertiseDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  person: PersonRelationInput;
  position: Scalars['Int']['input'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

/** Data structure to create a new instance of Expertise */
export type CreateExpertiseInput = {
  /** The actual data of Expertise */
  data: CreateExpertiseDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Expertise */
export type CreateExpertiseOutput = CreateExpertiseResult | ValidateExpertiseResult;

/** The result data structure of creating an instance of Expertise */
export type CreateExpertiseResult = {
  __typename?: 'CreateExpertiseResult';
  /** The actual data returned for Expertise */
  result: Expertise;
};

/** The input data for creating an instance of File */
export type CreateFileDataInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of Gender */
export type CreateGenderDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of Gender */
export type CreateGenderInput = {
  /** The actual data of Gender */
  data: CreateGenderDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Gender */
export type CreateGenderOutput = CreateGenderResult | ValidateGenderResult;

/** The result data structure of creating an instance of Gender */
export type CreateGenderResult = {
  __typename?: 'CreateGenderResult';
  /** The actual data returned for Gender */
  result: Gender;
};

/** The input data for creating an instance of HumanName */
export type CreateHumanNameDataInput = {
  family?: InputMaybe<Scalars['String']['input']>;
  given?: InputMaybe<Array<Scalars['String']['input']>>;
  period?: InputMaybe<CreatePeriodDataInput>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  use: NameUse;
};

/** The input data for creating an instance of Industry */
export type CreateIndustryDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of Industry */
export type CreateIndustryInput = {
  /** The actual data of Industry */
  data: CreateIndustryDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Industry */
export type CreateIndustryOutput = CreateIndustryResult | ValidateIndustryResult;

/** The result data structure of creating an instance of Industry */
export type CreateIndustryResult = {
  __typename?: 'CreateIndustryResult';
  /** The actual data returned for Industry */
  result: Industry;
};

/** The input data for creating an instance of JobDepartment */
export type CreateJobDepartmentDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of JobDepartment */
export type CreateJobDepartmentInput = {
  /** The actual data of JobDepartment */
  data: CreateJobDepartmentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of JobDepartment */
export type CreateJobDepartmentOutput = CreateJobDepartmentResult | ValidateJobDepartmentResult;

/** The result data structure of creating an instance of JobDepartment */
export type CreateJobDepartmentResult = {
  __typename?: 'CreateJobDepartmentResult';
  /** The actual data returned for JobDepartment */
  result: JobDepartment;
};

/** The input data for creating an instance of JobLocation */
export type CreateJobLocationDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of JobLocation */
export type CreateJobLocationInput = {
  /** The actual data of JobLocation */
  data: CreateJobLocationDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of JobLocation */
export type CreateJobLocationOutput = CreateJobLocationResult | ValidateJobLocationResult;

/** The result data structure of creating an instance of JobLocation */
export type CreateJobLocationResult = {
  __typename?: 'CreateJobLocationResult';
  /** The actual data returned for JobLocation */
  result: JobLocation;
};

/** The input data for creating an instance of LanguageSkill */
export type CreateLanguageSkillDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  cefr?: InputMaybe<CefrScale>;
  languageTag: Scalars['String']['input'];
  nativeSpeaker: Scalars['Boolean']['input'];
  person: PersonRelationInput;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  selfAssessed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

/** Data structure to create a new instance of LanguageSkill */
export type CreateLanguageSkillInput = {
  /** The actual data of LanguageSkill */
  data: CreateLanguageSkillDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of LanguageSkill */
export type CreateLanguageSkillOutput = CreateLanguageSkillResult | ValidateLanguageSkillResult;

/** The result data structure of creating an instance of LanguageSkill */
export type CreateLanguageSkillResult = {
  __typename?: 'CreateLanguageSkillResult';
  /** The actual data returned for LanguageSkill */
  result: LanguageSkill;
};

/** The input data for creating an instance of LocalizedText */
export type CreateLocalizedTextDataInput = {
  english?: InputMaybe<Scalars['String']['input']>;
  german?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of MaritalStatus */
export type CreateMaritalStatusDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of MaritalStatus */
export type CreateMaritalStatusInput = {
  /** The actual data of MaritalStatus */
  data: CreateMaritalStatusDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MaritalStatus */
export type CreateMaritalStatusOutput = CreateMaritalStatusResult | ValidateMaritalStatusResult;

/** The result data structure of creating an instance of MaritalStatus */
export type CreateMaritalStatusResult = {
  __typename?: 'CreateMaritalStatusResult';
  /** The actual data returned for MaritalStatus */
  result: MaritalStatus;
};

/** The input data for creating an instance of MatchAccess */
export type CreateMatchAccessDataInput = {
  design: AccessLevel;
  discover: AccessLevel;
  match: AccessLevel;
  person: PersonRelationInput;
  prepare: AccessLevel;
};

/** The input data for creating an instance of MatchCandidate */
export type CreateMatchCandidateDataInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<MatchRelationInput>;
  person?: InputMaybe<PersonRelationInput>;
};

/** Data structure to create a new instance of MatchCandidate */
export type CreateMatchCandidateInput = {
  /** The actual data of MatchCandidate */
  data: CreateMatchCandidateDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MatchCandidate */
export type CreateMatchCandidateOutput = CreateMatchCandidateResult | ValidateMatchCandidateResult;

/** The result data structure of creating an instance of MatchCandidate */
export type CreateMatchCandidateResult = {
  __typename?: 'CreateMatchCandidateResult';
  /** The actual data returned for MatchCandidate */
  result: MatchCandidate;
};

/** The input data for creating multiple instances of MatchCandidate */
export type CreateMatchCandidatesDataInput = {
  locked: Scalars['Boolean']['input'];
  /**
   * REQUIRED, like `locked`: the resolver has nothing to write without it. Both were nullable while the
   * resolver dereferenced them, so an omitted field was a server error after the gate had run (genesis#404).
   * Required in the schema since every consumer was shown to send both — the same path
   * `CreateMatchCandidatesInput.match` took in genesis#314.
   */
  person: PersonRelationInput;
};

/** Data structure to create a multiple instances of MatchCandidate */
export type CreateMatchCandidatesInput = {
  /** The actual data of MatchCandidate */
  data: Array<CreateMatchCandidatesDataInput>;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  match: MatchRelationInput;
};

export type CreateMatchCandidatesOutput = {
  __typename?: 'CreateMatchCandidatesOutput';
  match?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type CreateMatchCandidatesOutput */
export type CreateMatchCandidatesOutputFilterInput = {
  and?: InputMaybe<Array<CreateMatchCandidatesOutputFilterInput>>;
  not?: InputMaybe<CreateMatchCandidatesOutputFilterInput>;
  or?: InputMaybe<Array<CreateMatchCandidatesOutputFilterInput>>;
};

/** The input data for creating multiple instances of MatchCompany */
export type CreateMatchCompaniesDataInput = {
  company?: InputMaybe<CompanyRelationInput>;
};

export type CreateMatchCompaniesInput = {
  /** The actual data of MatchCompany */
  data: Array<CreateMatchCompaniesDataInput>;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *   The match whose pool is being filled. REQUIRED, like the person pool's twin.
   *
   * It is not a convenience: the authorization gate is built on this argument, and it is the narrowing
   *   the mutation-authorization audit credits for this mutation. A caller who omits it is not asking for
   *   a default, they are asking for a write with nothing to scope it — so the schema refuses the request
   *   instead of the resolver dereferencing a null and answering a server error before the gate has run.
   *
   * The company inputs had no consumers yet and took this shape first. The person twins
   *   (`CreateMatchCandidatesInput.match`, `DeleteMatchCandidatesInput.match`) followed in genesis#314, once
   *   every consumer was shown to send the field.
   */
  match: MatchRelationInput;
};

export type CreateMatchCompaniesOutput = {
  __typename?: 'CreateMatchCompaniesOutput';
  match?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type CreateMatchCompaniesOutput */
export type CreateMatchCompaniesOutputFilterInput = {
  and?: InputMaybe<Array<CreateMatchCompaniesOutputFilterInput>>;
  not?: InputMaybe<CreateMatchCompaniesOutputFilterInput>;
  or?: InputMaybe<Array<CreateMatchCompaniesOutputFilterInput>>;
};

/** The input data for creating an instance of MatchCompany */
export type CreateMatchCompanyDataInput = {
  /**
   * The pinned company: its identity plus `employeeCount`, the value a size criterion is judged on.
   * `summary` is null here — see Company.employeeCount for the one exception this field makes.
   */
  company?: InputMaybe<CompanyRelationInput>;
  match?: InputMaybe<MatchRelationInput>;
};

/** Data structure to create a new instance of MatchCompany */
export type CreateMatchCompanyInput = {
  /** The actual data of MatchCompany */
  data: CreateMatchCompanyDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MatchCompany */
export type CreateMatchCompanyOutput = CreateMatchCompanyResult | ValidateMatchCompanyResult;

/** The result data structure of creating an instance of MatchCompany */
export type CreateMatchCompanyResult = {
  __typename?: 'CreateMatchCompanyResult';
  /** The actual data returned for MatchCompany */
  result: MatchCompany;
};

/** The input data for creating an instance of Match */
export type CreateMatchDataInput = {
  /**
   * The whole truth about the match's access grants, never a delta: on `updateMatch` the list
   * replaces every existing grant, so a person left out of it loses access. An empty list revokes
   * everyone; `null` — like omitting the field — leaves the existing grants untouched (genesis#326).
   */
  access?: InputMaybe<Array<CreateMatchAccessDataInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The whole design as one JSON object; on `updateMatch` it replaces the stored design, except that
   * the attached `project.documents` survive. `null` — like omitting the field — leaves the stored
   * design untouched (genesis#407): a match without a design is not assessable, so there is no way to
   * clear it.
   */
  design?: InputMaybe<Scalars['Object']['input']>;
  matchMode?: InputMaybe<MatchMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedItem?: InputMaybe<SharedItemRelationInput>;
};

/** Data structure to create a new instance of Match */
export type CreateMatchInput = {
  /** The actual data of Match */
  data: CreateMatchDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Match */
export type CreateMatchOutput = CreateMatchResult | ValidateMatchResult;

/** The result data structure of creating an instance of Match */
export type CreateMatchResult = {
  __typename?: 'CreateMatchResult';
  /** The actual data returned for Match */
  result: Match;
};

/** The input data for creating an instance of MatchResult */
export type CreateMatchResultDataInput = {
  candidateCount?: InputMaybe<Scalars['Int']['input']>;
  design?: InputMaybe<Scalars['Object']['input']>;
  hiddenSections?: InputMaybe<Array<Scalars['String']['input']>>;
  kept?: InputMaybe<Scalars['Boolean']['input']>;
  matchId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<CreateMatchResultTeamDataInput>>;
};

/** Data structure to create a new instance of MatchResult */
export type CreateMatchResultInput = {
  /** The actual data of MatchResult */
  data: CreateMatchResultDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MatchResult */
export type CreateMatchResultOutput = CreateMatchResultResult | ValidateMatchResultResult;

/** The result data structure of creating an instance of MatchResult */
export type CreateMatchResultResult = {
  __typename?: 'CreateMatchResultResult';
  /** The actual data returned for MatchResult */
  result: MatchResult;
};

/** The input data for creating an instance of MatchResultTeam */
export type CreateMatchResultTeamDataInput = {
  persons?: InputMaybe<Array<InputMaybe<PersonRelationInput>>>;
  result?: InputMaybe<Scalars['Object']['input']>;
};

/** The input data for creating an instance of OrgUnit */
export type CreateOrgUnitDataInput = {
  /**
   * Retires the unit: a hidden unit is dropped from the tree query and is not a valid assignment target,
   * without being deleted. This is the retirement path for an in-use unit — one with children or assigned
   * people cannot be hard-deleted (the foreign keys are RESTRICT).
   */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  /** The parent unit, or null for a root. Setting a parent that would form a cycle is refused. */
  parent?: InputMaybe<OrgUnitRelationInput>;
};

/** Data structure to create a new instance of OrgUnit */
export type CreateOrgUnitInput = {
  /** The actual data of OrgUnit */
  data: CreateOrgUnitDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of OrgUnit */
export type CreateOrgUnitOutput = CreateOrgUnitResult | ValidateOrgUnitResult;

/** The result data structure of creating an instance of OrgUnit */
export type CreateOrgUnitResult = {
  __typename?: 'CreateOrgUnitResult';
  /** The actual data returned for OrgUnit */
  result: OrgUnit;
};

export type CreateOrganizationalRecordCommentDataInput = {
  content: Scalars['String']['input'];
  entry?: InputMaybe<OrganizationalRecordReferenceInput>;
  links?: InputMaybe<Array<OrganizationalRecordLinkTargetInput>>;
  organizationalRecord: OrganizationalRecordReferenceInput;
};

export type CreateOrganizationalRecordCommentInput = {
  data: CreateOrganizationalRecordCommentDataInput;
};

export type CreateOrganizationalRecordDocumentInput = {
  content: CreateFileDataInput;
  fileName: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateOrganizationalRecordEntryInput = {
  content: Scalars['String']['input'];
  kind: OrganizationalRecordEntryKind;
  /** At most 20 references to documents or other entries in this organizational record; duplicate targets collapse. */
  links?: InputMaybe<Array<OrganizationalRecordLinkTargetInput>>;
  recordId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** The input data for creating an instance of Period */
export type CreatePeriodDataInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The input data for creating an instance of Person */
export type CreatePersonDataInput = {
  administrativeGender?: InputMaybe<AdministrativeGender>;
  alternativeAvatar?: InputMaybe<CreateFileDataInput>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<CreateFileDataInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  childCount?: InputMaybe<Scalars['Int']['input']>;
  citizenships?: InputMaybe<Array<InputMaybe<CountryRelationInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<ContractTypeRelationInput>;
  country?: InputMaybe<CountryRelationInput>;
  countryState?: InputMaybe<CountryStateRelationInput>;
  currentActivity?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  currentTasks?: InputMaybe<Scalars['String']['input']>;
  deceased?: InputMaybe<CreateDeceasedDataInput>;
  drivingLicence?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPrimary: Scalars['String']['input'];
  gender?: InputMaybe<GenderRelationInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  jobDepartment?: InputMaybe<JobDepartmentRelationInput>;
  jobLocation?: InputMaybe<JobLocationRelationInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatusRelationInput>;
  miscellaneous?: InputMaybe<Scalars['String']['input']>;
  name: CreateHumanNameDataInput;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workingTimeModel?: InputMaybe<WorkingTimeModelRelationInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of PersonGroup */
export type CreatePersonGroupDataInput = {
  name: Scalars['String']['input'];
};

/** Data structure to create a new instance of PersonGroup */
export type CreatePersonGroupInput = {
  /** The actual data of the document group */
  data: CreatePersonGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonGroupOutput = CreatePersonGroupResult | TooManyRecordsResult | ValidatePersonGroupResult;

/** The result data structure of creating an instance of PersonGroup */
export type CreatePersonGroupResult = {
  __typename?: 'CreatePersonGroupResult';
  /** The actual data returned for PersonGroup */
  result: PersonGroup;
};

/** Data structure to create a new instance of Person */
export type CreatePersonInput = {
  /** The actual data of Person */
  data: CreatePersonDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Must match the subject Id from Keycloak */
  person: Scalars['String']['input'];
};

/** The result of creating an instance of Person */
export type CreatePersonOutput = CreatePersonResult | ValidatePersonResult;

/** The result data structure of creating an instance of Person */
export type CreatePersonResult = {
  __typename?: 'CreatePersonResult';
  /** The actual data returned for Person */
  result: Person;
};

/** Recipient Group selections. Omitted attributes are unchanged; an empty list revokes their consent. */
export type CreatePersonSharedAttributesDataInput = {
  /** Replace the complete set of attributes in dynamic All mode. Omit to preserve other modes; an explicit Group selection disables All for that attribute. */
  allGroupsAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedAge?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedApartmentNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedBio?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedBirthdate?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedChildCount?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCitizenships?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCity?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedContractType?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCountry?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentActivity?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentEmployer?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentTasks?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedDriversLicense?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedEmail?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedGender?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedHouseNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedMaritalStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedMiscellaneous?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedNationality?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Recipient Group IDs for powers consent. An empty list selects no recipients. */
  sharedPowers?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedProfession?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedState?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedStreet?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedWebsite?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedWorkingTimeModel?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedZipCode?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input data for creating an instance of PinGroup */
export type CreatePinGroupDataInput = {
  name: Scalars['String']['input'];
  pinType: PinType;
};

/** Data structure to create a new instance of PersonGroup */
export type CreatePinGroupInput = {
  /** The actual data of the pin group */
  data: CreatePinGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePinGroupOutput = CreatePinGroupResult | TooManyRecordsResult | ValidatePinGroupResult;

/** The result data structure of creating an instance of PinGroup */
export type CreatePinGroupResult = {
  __typename?: 'CreatePinGroupResult';
  /** The actual data returned for PinGroup */
  result: PinGroup;
};

/** The input data for creating an instance of ProjectAccess */
export type CreateProjectAccessDataInput = {
  /** Wer angefragt wird und wer zusagt. */
  candidates: AccessLevel;
  person: PersonRelationInput;
  /** Anlass, Aufteilung, Einordnung, Anforderungen. */
  plan: AccessLevel;
  /** Einträge im Ablauf - die Editor-Rolle. */
  timeline: AccessLevel;
};

/** The input data for creating an instance of Project */
export type CreateProjectDataInput = {
  /**
   * Wer Zugriff hat, als ganzer Sollzustand wie bei `Match.access`: bei `updateProject` ersetzt die
   * Liste alle Zugriffe, wer fehlt, verliert seinen. Eine leere Liste entzieht allen den Zugriff;
   * `null` oder ein weggelassenes Feld lässt ihn stehen. Ausnahme ist bei einem persönlichen Projekt
   * der Ersteller: seine Zeile bleibt mit WRITE auf allen Flächen stehen, Einträge für ihn werden
   * ignoriert (genesis#392). Ein Firmenprojekt hat keine solche Zeile; dort ist der Ersteller ein
   * Eintrag wie jeder andere (genesis#418).
   */
  access?: InputMaybe<Array<CreateProjectAccessDataInput>>;
  /**
   * Die Firma, in deren Namen das Projekt angelegt wurde, oder null für ein persönliches Projekt
   * (genesis#418). Wie bei `SharedItem.company`: nur beim Anlegen setzbar, nur durch einen Admin dieser
   * Firma, und die Firma muss aktiv sein. Ein persönliches Projekt wird nie zum Firmenprojekt und
   * umgekehrt. Ein Firmenprojekt sehen, ändern und löschen die Admins der Firma; eine inaktive Firma
   * friert ihre Projekte ein. `createdBy` nennt weiter, wer es angelegt hat, entscheidet aber nichts.
   */
  company?: InputMaybe<CompanyRelationInput>;
  data?: InputMaybe<Scalars['Object']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Data structure for creating an instance of Project.
 *
 * HAND-WRITTEN for `actingAsCompanyId` alone, as `CreateSharedItemCommentInput` is (genesis#418).
 */
export type CreateProjectInput = {
  /**
   * Die Firma, als die die aufrufende Person handelt. Wie bei `CreateSharedItemInput` (Konzept v23):
   * beim Anlegen ist nur die Angabe selbst freiwillig. Fehlt sie, entscheidet `data.company`. Ist sie
   * da, muss sie `data.company` gleichen (sonst `GENESIS001259`); bei einem persönlichen Projekt darf
   * sie nicht da sein (`GENESIS001260`).
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** The actual data of Project */
  data: CreateProjectDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Project */
export type CreateProjectOutput = CreateProjectResult | ValidateProjectResult;

/** The result data structure of creating an instance of Project */
export type CreateProjectResult = {
  __typename?: 'CreateProjectResult';
  /** The actual data returned for Project */
  result: Project;
};

/** The input data for creating an instance of SharedItemComment */
export type CreateSharedItemCommentDataInput = {
  /**
   * The company this comment was written in the name of, or null for a personal comment.
   *
   * Concept v16 (the company account model, Kevin 2026-09-08) allows an admin
   * acting as a company to comment. Until v15 the concept forbade it, and gave this type's shape as
   * the reason — a comment carried a person and nothing else, so one written in company context would
   * have read as the human's.
   *
   * BOTH ARE SHOWN, company above author, exactly as a company post has read since v10 ("Beides, nicht
   * statt"): the comment is the company's and it stands behind it, while who typed it stays visible and
   * the order says whose statement it is. `person` therefore keeps naming the human and stays non-null
   * in the database. If that person later erases themselves the name goes and this line remains, so a
   * company comment without an author name still names its company.
   *
   * CREATABLE, NOT UPDATABLE. Which company a comment belongs to is settled when it is written: an
   * update that could move a comment between companies would let an admin of one company rewrite a
   * line into another's name. Editing the CONTENT of a company comment is allowed, gated on the
   * current admin membership rather than on authorship (0002 §6, v8).
   *
   * NO LOGO IS RESOLVED UNDER THIS FIELD. `Company.logo` answers only where a parent supplies a logo
   * context, and a comment thread is a list whose length the caller does not settle — exactly the case
   * the four-surface rule for `Company.logo` exists to prevent (see that field's description).
   *
   * NOT `@filterable`, deliberately. Nothing lists comments BY company — a thread is read by its shared
   * item — and `shared_item_comment.company_id` carries no index for exactly that reason (V0075). A
   * published filter would offer a sequential scan for a query no screen makes, and it would owe a
   * filter leg that `FilterSpecCompletenessTest` rightly demands. If a caller ever needs it, the index
   * and the leg are added together.
   */
  company?: InputMaybe<CompanyRelationInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<PersonRelationInput>;
  /**
   * The item this comment hangs off, named once when the comment is written and immutable thereafter.
   *
   * NOT UPDATABLE, stated explicitly (concept v20 follow-up, 2026-09-10). `updatable` defaults to false
   * in the directive, but the generator keys on the argument being PRESENT: omitting it put both fields
   * in `UpdateSharedItemCommentDataInput`, where `updateRecord` handles `CONTENT` alone and dropped them
   * without a word. A client could send "move this comment to that post", be told it succeeded, and find
   * nothing had happened. `company` and `person` on this type already say `updatable: false` and are
   * correctly absent from that input; these two now match, so the schema REFUSES the move rather than
   * accepting and discarding it.
   */
  sharedItem?: InputMaybe<SharedItemRelationInput>;
  sharedItemId?: InputMaybe<Scalars['UUID']['input']>;
};

/**
 * Data structure to create a new instance of SharedItemComment.
 *
 * HAND-WRITTEN for `actingAsCompanyId`; everything else reproduces the generated shape.
 */
export type CreateSharedItemCommentInput = {
  /**
   *   The company the caller declares they are acting AS while writing this comment.
   *
   * ON CREATE ITS PRESENCE IS OPTIONAL, AND THAT IS ALL THAT DIFFERS. A comment written in a company's
   *   name already names that company in `data.company`, which is the ownership half, checked against the
   *   caller's admin membership since v16 — so a create that omits this says nothing ambiguous and is
   *   accepted. Concept v23 keeps that deliberately: „wer ohne Kontext anlegt, legt privat an, und das
   *   bleibt erlaubt — kein Aufruf von vor v23 wird dadurch abgelehnt."
   *
   * SENT, IT MUST MATCH WHAT IS BEING CREATED, in both directions. Together with a `data.company` it
   *   must name the SAME company; naming a different one is refused with `GENESIS001259`, the same code
   *   the edit and the delete raise. With NO `data.company` the comment is the author's own, and declaring
   *   a context over it is refused with `GENESIS001260` — the mirror code. The field is here so a client
   *   has ONE rule, "send the company you are acting as", across all three calls, and so a client whose
   *   context has drifted from the company it is posting under is told rather than believed.
   *
   * CREATING WAS EXEMPT UNTIL 2026-09-12, and this description said so („Das ANLEGEN ändert sich nicht"),
   *   with the private case explicitly IGNORED. Kevin extended v23 that day — „Auch das ANLEGEN, und damit
   *   ist v23 ohne Ausnahme" — so both sentences are now false and have been removed rather than qualified.
   *
   * IT NARROWS AND NEVER GRANTS, and it is NOT an access boundary. The company that governs is the one
   *   in `data.company`, checked against `company_membership`; this only has to agree with it. The value
   *   is CLIENT-DECLARED, so anybody who may already comment in this company's name can send it —
   *   genesis#300 records that Kevin accepted this knowingly. See `UpdateSharedItemInput` for the full
   *   reasoning.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** The actual data of SharedItemComment */
  data: CreateSharedItemCommentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of SharedItemComment */
export type CreateSharedItemCommentOutput = CreateSharedItemCommentResult | ValidateSharedItemCommentResult;

/** The result data structure of creating an instance of SharedItemComment */
export type CreateSharedItemCommentResult = {
  __typename?: 'CreateSharedItemCommentResult';
  /** The actual data returned for SharedItemComment */
  result: SharedItemComment;
};

/** The input data for creating an instance of SharedItem */
export type CreateSharedItemDataInput = {
  /** Replace classification IDs; omitted preserves them, an empty list clears them. PROJECT items only. */
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /**
   * The company this item was published IN THE NAME OF, or null when the author published it as
   * themselves. Concept v7: the company account model.
   *
   * SET AT CREATION ONLY, never on update — `@constrained(updatable: false)`. A personal post cannot
   * become a company post later and a company post cannot be taken private: the two live in different
   * places (the author's own area versus the company page), so a switch would move content between them
   * and change who may edit it mid-life. Kevin decided that explicitly.
   *
   * WHO MAY SET IT: an admin of that company, by the same `company_membership` row that gates every
   * other per-company write (@adr GENESIS-0023-company-membership-is-the-per-company-authorization@4 §1). There is no platform role for it.
   *
   * IT DOES NOT REPLACE `createdBy`. `person_id` stays NOT NULL and still names the human who wrote the
   * item — shown as the byline. This column decides whose the item IS; `createdBy` says who typed it.
   * For a company item those are two different questions, and the edit gate reads THIS one.
   *
   * THE COMPANY MUST BE ACTIVE (concept v9). Naming an INACTIVE company here is refused with
   * `GENESIS001250` even when the caller administers it — a distinct code from the authorisation
   * refusal on purpose, because this one is repaired by reactivating the company and that one by being
   * made an admin. An inactive company's existing content is FROZEN, not merely closed to new posts:
   * it cannot be edited, deleted, applied to, rated or counted as viewed, and the documents attached to
   * it cannot be deleted. Reactivating the company lifts all of it at once.
   *
   * FILTERABLE, AND ONE CRITERION ANSWERS FOUR DIFFERENT QUESTIONS. The filter is a nested
   * `CompanyFilterInput` reached over a LEFT join, because `company_id` is nullable and a personal item
   * has no row on the other side:
   *
   *     { company: { name: { any: true } } }         everything published by ANY company
   *     { company: { name: { any: false } } }        the complement — every personal item
   *     { company: { name: { contains: "Acme" } } }  one company, by the name a searcher types
   *     { company: { id: { eq: "<uuid>" } } }        one company, by id
   *
   * AN INNER JOIN WOULD ANSWER THE SECOND LINE WITH NOTHING, silently, which is why the join type is
   * recorded here rather than left to be rediscovered. `company.name` is NOT NULL, so after the left
   * join a null name means "there is no company" and nothing else — that is what carries `any`.
   *
   * IT DOES NOT WIDEN WHAT A SEARCH CAN SEE. `sharedItems` still ANDs its `findable` condition on top,
   * so naming an INACTIVE company here returns nothing: freezing takes a dormant company's content out
   * of search, and a filter is a search. The company's own page (`companyOwnedSharedItems`) shares this
   * spec and is deliberately not affected — it never carried the findability condition.
   */
  company?: InputMaybe<CompanyRelationInput>;
  darkMode?: InputMaybe<CreateColorsDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<CreateFileDataInput>>;
  filesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  images?: InputMaybe<Array<CreateFileDataInput>>;
  imagesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  itemType?: InputMaybe<SharedItemType>;
  lightMode?: InputMaybe<CreateColorsDataInput>;
  mainImage?: InputMaybe<CreateFileDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Data structure to create a new instance of SharedItem.
 *
 * HAND-WRITTEN for acting context and explicit private intent; see `UpdateSharedItemInput`.
 */
export type CreateSharedItemInput = {
  /**
   *   The company the caller declares they are acting AS while publishing this item.
   *
   * OPTIONAL HERE, AND ONLY ITS PRESENCE IS. `data.company` already says whose the item is and has been
   *   checked against the caller's admin membership since concept v7, so a create that omits this says
   *   nothing ambiguous and is accepted: „wer ohne Kontext anlegt, legt privat an, und das bleibt erlaubt
   *   — kein Aufruf von vor v23 wird dadurch abgelehnt."
   *
   * SENT, IT MUST MATCH WHAT IS BEING CREATED, in both directions. Together with a `data.company` it
   *   must name the SAME company; naming another is `GENESIS001259`. With NO `data.company` the item is
   *   the caller's own, and declaring a context over it is `GENESIS001260` — whoever is acting as Acme
   *   does not publish something of their own on the way past. Creating was exempt from v23 until Kevin
   *   extended it on 2026-09-12 („Auch das ANLEGEN, und damit ist v23 ohne Ausnahme"); the exemption is
   *   gone, and only the "not required" half of it survives, above.
   *
   * IT NARROWS AND NEVER GRANTS, and it is NOT an access boundary: the company that governs is the one
   *   in `data.company`, checked against `company_membership`, and this value is CLIENT-DECLARED — every
   *   principal who may already publish in a company's name can send it. See `UpdateSharedItemInput` for
   *   the full reasoning and genesis#300 for the risk Kevin accepted.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** The actual data of SharedItem */
  data: CreateSharedItemDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reject unless the saved ordinary item has no third-party recipients. Prevents a changed default from widening an explicit private choice. Not supported for Company items. */
  privateToOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of SharedItem */
export type CreateSharedItemOutput = CreateSharedItemResult | ValidateSharedItemResult;

/** The result data structure of creating an instance of SharedItem */
export type CreateSharedItemResult = {
  __typename?: 'CreateSharedItemResult';
  /** The actual data returned for SharedItem */
  result: SharedItem;
};

/** The input data for creating an instance of StudioNotebook */
export type CreateStudioNotebookDataInput = {
  /** Der Text des Notizbuchs als Markdown, mit den Abschnitten, die spark darin markiert. */
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of StudioNotebook */
export type CreateStudioNotebookInput = {
  /** The actual data of StudioNotebook */
  data: CreateStudioNotebookDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of StudioNotebook */
export type CreateStudioNotebookOutput = CreateStudioNotebookResult | ValidateStudioNotebookResult;

/** The result data structure of creating an instance of StudioNotebook */
export type CreateStudioNotebookResult = {
  __typename?: 'CreateStudioNotebookResult';
  /** The actual data returned for StudioNotebook */
  result: StudioNotebook;
};

/** The input data for creating an instance of TeamProfile */
export type CreateTeamProfileDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  weights: Array<CreateElementWeightDataInput>;
};

/** Data structure to create a new instance of TeamProfile */
export type CreateTeamProfileInput = {
  /** The actual data of TeamProfile */
  data: CreateTeamProfileDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of TeamProfile */
export type CreateTeamProfileOutput = CreateTeamProfileResult | ValidateTeamProfileResult;

/** The result data structure of creating an instance of TeamProfile */
export type CreateTeamProfileResult = {
  __typename?: 'CreateTeamProfileResult';
  /** The actual data returned for TeamProfile */
  result: TeamProfile;
};

/** The input data for creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of WorkingTimeModel */
export type CreateWorkingTimeModelInput = {
  /** The actual data of WorkingTimeModel */
  data: CreateWorkingTimeModelDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelOutput = CreateWorkingTimeModelResult | ValidateWorkingTimeModelResult;

/** The result data structure of creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelResult = {
  __typename?: 'CreateWorkingTimeModelResult';
  /** The actual data returned for WorkingTimeModel */
  result: WorkingTimeModel;
};

export enum CreativityCategory {
  CognitiveIntelligence = 'COGNITIVE_INTELLIGENCE',
  EmotionalIntelligence = 'EMOTIONAL_INTELLIGENCE',
  FictionalIntelligence = 'FICTIONAL_INTELLIGENCE',
  IdentityCore = 'IDENTITY_CORE',
  MolecularIntelligence = 'MOLECULAR_INTELLIGENCE'
}

/**
 * enum MaritalStatus {
 * ANNULLED,
 * DIVORCED,
 * INTERLOCUTORY
 * LEGALLY_SEPARATED
 * MARRIED
 * COMMON_LAW
 * POLYGAMOUS
 * DOMESTIC_PARTNER
 * UNMARRIED
 * NEVER_MARRIED
 * WIDOWED
 * UNKNOWN
 * }
 */
export enum CreativityElement {
  Abstraction = 'ABSTRACTION',
  Adaption = 'ADAPTION',
  Aggression = 'AGGRESSION',
  Alertness = 'ALERTNESS',
  Altruism = 'ALTRUISM',
  Angst = 'ANGST',
  Audio = 'AUDIO',
  Autonomy = 'AUTONOMY',
  Balance = 'BALANCE',
  Beauty = 'BEAUTY',
  Biorhythm = 'BIORHYTHM',
  Candor = 'CANDOR',
  Charisma = 'CHARISMA',
  Composition = 'COMPOSITION',
  Concentration = 'CONCENTRATION',
  Cooperation = 'COOPERATION',
  Coordination = 'COORDINATION',
  Courage = 'COURAGE',
  Curiosity = 'CURIOSITY',
  Diligence = 'DILIGENCE',
  Disgust = 'DISGUST',
  Dolor = 'DOLOR',
  Doubt = 'DOUBT',
  Empathy = 'EMPATHY',
  Expression = 'EXPRESSION',
  Fairness = 'FAIRNESS',
  Faith = 'FAITH',
  Fidelity = 'FIDELITY',
  FlightMotion = 'FLIGHT_MOTION',
  Gender = 'GENDER',
  Greed = 'GREED',
  Grief = 'GRIEF',
  Habit = 'HABIT',
  Homeostasis = 'HOMEOSTASIS',
  Honesty = 'HONESTY',
  Hope = 'HOPE',
  Hormones = 'HORMONES',
  Humor = 'HUMOR',
  Ignorance = 'IGNORANCE',
  Imagination = 'IMAGINATION',
  Immunity = 'IMMUNITY',
  Improvisation = 'IMPROVISATION',
  Infatuation = 'INFATUATION',
  Inspiration = 'INSPIRATION',
  Intention = 'INTENTION',
  Introversion = 'INTROVERSION',
  Intuition = 'INTUITION',
  Joy = 'JOY',
  Language = 'LANGUAGE',
  Love = 'LOVE',
  Lust = 'LUST',
  Memory = 'MEMORY',
  Metabolism = 'METABOLISM',
  Mindfulness = 'MINDFULNESS',
  Modesty = 'MODESTY',
  Motorics = 'MOTORICS',
  Objectiation = 'OBJECTIATION',
  Olfaction = 'OLFACTION',
  Opposition = 'OPPOSITION',
  Orientation = 'ORIENTATION',
  Passion = 'PASSION',
  Patience = 'PATIENCE',
  Perception = 'PERCEPTION',
  Perseverance = 'PERSEVERANCE',
  Reflexes = 'REFLEXES',
  Respiration = 'RESPIRATION',
  Responsibility = 'RESPONSIBILITY',
  Satisfaction = 'SATISFACTION',
  SelfAwareness = 'SELF_AWARENESS',
  Sensitivity = 'SENSITIVITY',
  Skillfulness = 'SKILLFULNESS',
  Sleep = 'SLEEP',
  Spontaneity = 'SPONTANEITY',
  Strategy = 'STRATEGY',
  Taste = 'TASTE',
  Temper = 'TEMPER',
  Tenderness = 'TENDERNESS',
  Tolerance = 'TOLERANCE',
  Touch = 'TOUCH',
  Vision = 'VISION',
  Willpower = 'WILLPOWER',
  Wisdom = 'WISDOM'
}

export type CurriculumVitae = Node & {
  __typename?: 'CurriculumVitae';
  apiVersion: Scalars['Int']['output'];
  configuration?: Maybe<Scalars['Object']['output']>;
  content?: Maybe<Scalars['Object']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person: Person;
};

export type CurriculumVitaeConnection = {
  __typename?: 'CurriculumVitaeConnection';
  edges: Array<CurriculumVitaeEdge>;
  nodes: Array<CurriculumVitae>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumVitaeEdge = {
  __typename?: 'CurriculumVitaeEdge';
  cursor: Scalars['String']['output'];
  node: CurriculumVitae;
};

/** The filterable fields of type CurriculumVitae */
export type CurriculumVitaeFilterInput = {
  and?: InputMaybe<Array<CurriculumVitaeFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CurriculumVitaeFilterInput>;
  or?: InputMaybe<Array<CurriculumVitaeFilterInput>>;
};

/** The parameters for requesting multiple instances of CurriculumVitae. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type CurriculumVitaeQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<CurriculumVitaeSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<CurriculumVitaeFilterInput>;
};

export type CurriculumVitaeSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CvBatchImportResult = {
  __typename?: 'CvBatchImportResult';
  results: Array<CvFileResult>;
};

/** The filterable fields of type CvBatchImportResult */
export type CvBatchImportResultFilterInput = {
  and?: InputMaybe<Array<CvBatchImportResultFilterInput>>;
  not?: InputMaybe<CvBatchImportResultFilterInput>;
  or?: InputMaybe<Array<CvBatchImportResultFilterInput>>;
};

/** One document in an admin batch CV import. */
export type CvFileInput = {
  file: Scalars['Binary']['input'];
  fileName: Scalars['String']['input'];
};

/** Per-file result of importCvBatch. */
export type CvFileResult = {
  __typename?: 'CvFileResult';
  /** Resulting person's primary email — the scanned address, or a generated cv-import+<id>@smycles.invalid when the CV had none; null on FAILED. */
  email?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  /** Resulting person's given name, for a display label; null on FAILED or when unknown. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Resulting person's family name; null on FAILED or when unknown. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** How the person was matched (e.g. "primary_email"); null when created or failed. */
  matchedBy?: Maybe<Scalars['String']['output']>;
  /** Error reason (FAILED) or non-fatal warnings (e.g. an unresolved gender), joined; null when clean. */
  message?: Maybe<Scalars['String']['output']>;
  outcome: CvImportOutcome;
  /** The created/updated person; null when outcome is FAILED. */
  personId?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type CvFileResult */
export type CvFileResultFilterInput = {
  and?: InputMaybe<Array<CvFileResultFilterInput>>;
  not?: InputMaybe<CvFileResultFilterInput>;
  or?: InputMaybe<Array<CvFileResultFilterInput>>;
};

/** What happened to a single CV in a batch import. */
export enum CvImportOutcome {
  /** No unambiguous match; a new candidate Person was created. */
  Created = 'CREATED',
  /** Extraction or persistence failed for this file; nothing was written. */
  Failed = 'FAILED',
  /** The CV matched an existing person by primary email; missing fields/collections were filled. */
  Updated = 'UPDATED'
}

export type DailyQuotaExceeded = {
  __typename?: 'DailyQuotaExceeded';
  limit?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type DailyQuotaExceeded */
export type DailyQuotaExceededFilterInput = {
  and?: InputMaybe<Array<DailyQuotaExceededFilterInput>>;
  not?: InputMaybe<DailyQuotaExceededFilterInput>;
  or?: InputMaybe<Array<DailyQuotaExceededFilterInput>>;
};

export type DateInstant = {
  __typename?: 'DateInstant';
  date: Scalars['Date']['output'];
  precision: DatePrecision;
};

/** The filterable fields of type DateInstant */
export type DateInstantFilterInput = {
  and?: InputMaybe<Array<DateInstantFilterInput>>;
  not?: InputMaybe<DateInstantFilterInput>;
  or?: InputMaybe<Array<DateInstantFilterInput>>;
};

export enum DatePrecision {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

/** Filtering for fields of type Date */
export type DateTimeFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<DateTimeFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<DateTimeFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<DateTimeFilterInput>>;
};

export type DateTimeInstant = {
  __typename?: 'DateTimeInstant';
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  precision?: Maybe<DateTimePrecision>;
};

/** The filterable fields of type DateTimeInstant */
export type DateTimeInstantFilterInput = {
  and?: InputMaybe<Array<DateTimeInstantFilterInput>>;
  not?: InputMaybe<DateTimeInstantFilterInput>;
  or?: InputMaybe<Array<DateTimeInstantFilterInput>>;
};

export enum DateTimePrecision {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Precise = 'PRECISE',
  Second = 'SECOND',
  Year = 'YEAR'
}

export type Deceased = {
  __typename?: 'Deceased';
  deceased?: Maybe<Scalars['Boolean']['output']>;
  deceasedDate?: Maybe<DateInstant>;
};

/** The filterable fields of type Deceased */
export type DeceasedFilterInput = {
  and?: InputMaybe<Array<DeceasedFilterInput>>;
  not?: InputMaybe<DeceasedFilterInput>;
  or?: InputMaybe<Array<DeceasedFilterInput>>;
};

export type Degree = Node & {
  __typename?: 'Degree';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Degree */
export type DegreeFilterInput = {
  and?: InputMaybe<Array<DegreeFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DegreeFilterInput>;
  or?: InputMaybe<Array<DegreeFilterInput>>;
};

/** Contains information for linking 'Degree' to other entities */
export type DegreeRelationInput = {
  /** The identifier of 'Degree' */
  id: Scalars['ID']['input'];
};

export type DegreeSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type DegreesResult = {
  __typename?: 'DegreesResult';
  degrees: Array<Degree>;
};

/** The filterable fields of type DegreesResult */
export type DegreesResultFilterInput = {
  and?: InputMaybe<Array<DegreesResultFilterInput>>;
  not?: InputMaybe<DegreesResultFilterInput>;
  or?: InputMaybe<Array<DegreesResultFilterInput>>;
};

/** Deletion requires an empty group without role assignments. Base groups cannot be deleted. */
export type DeleteAccessGroupInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

/** Delete a custom Role with no Group assignments, including any unused legacy storage rows. */
export type DeleteAccessRoleInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

/** Data structure for deleting an instance of Agent */
export type DeleteAgentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Agent */
export type DeleteAgentOutput = {
  __typename?: 'DeleteAgentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Certificate */
export type DeleteCertificateInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Certificate */
export type DeleteCertificateOutput = {
  __typename?: 'DeleteCertificateOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Company */
export type DeleteCompanyInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Company */
export type DeleteCompanyOutput = {
  __typename?: 'DeleteCompanyOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of ContractType */
export type DeleteContractTypeInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of ContractType */
export type DeleteContractTypeOutput = {
  __typename?: 'DeleteContractTypeOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of CurriculumVitae */
export type DeleteCurriculumVitaeInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of CurriculumVitae */
export type DeleteCurriculumVitaeOutput = {
  __typename?: 'DeleteCurriculumVitaeOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Degree */
export type DeleteDegreeInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Degree */
export type DeleteDegreeOutput = {
  __typename?: 'DeleteDegreeOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of DiscoveryCategory */
export type DeleteDiscoveryCategoryInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of DiscoveryCategory */
export type DeleteDiscoveryCategoryOutput = {
  __typename?: 'DeleteDiscoveryCategoryOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of DocumentGroup */
export type DeleteDocumentGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of DocumentGroup */
export type DeleteDocumentGroupOutput = {
  __typename?: 'DeleteDocumentGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Document */
export type DeleteDocumentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Document */
export type DeleteDocumentOutput = {
  __typename?: 'DeleteDocumentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Education */
export type DeleteEducationInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Education */
export type DeleteEducationOutput = {
  __typename?: 'DeleteEducationOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Experience */
export type DeleteExperienceInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Experience */
export type DeleteExperienceOutput = {
  __typename?: 'DeleteExperienceOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Expertise */
export type DeleteExpertiseInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Expertise */
export type DeleteExpertiseOutput = {
  __typename?: 'DeleteExpertiseOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Gender */
export type DeleteGenderInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Gender */
export type DeleteGenderOutput = {
  __typename?: 'DeleteGenderOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Industry */
export type DeleteIndustryInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Industry */
export type DeleteIndustryOutput = {
  __typename?: 'DeleteIndustryOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of JobDepartment */
export type DeleteJobDepartmentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of JobDepartment */
export type DeleteJobDepartmentOutput = {
  __typename?: 'DeleteJobDepartmentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of JobLocation */
export type DeleteJobLocationInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of JobLocation */
export type DeleteJobLocationOutput = {
  __typename?: 'DeleteJobLocationOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of LanguageSkill */
export type DeleteLanguageSkillInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of LanguageSkill */
export type DeleteLanguageSkillOutput = {
  __typename?: 'DeleteLanguageSkillOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MaritalStatus */
export type DeleteMaritalStatusInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MaritalStatus */
export type DeleteMaritalStatusOutput = {
  __typename?: 'DeleteMaritalStatusOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MatchCandidate */
export type DeleteMatchCandidateInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MatchCandidate */
export type DeleteMatchCandidateOutput = {
  __typename?: 'DeleteMatchCandidateOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

export type DeleteMatchCandidatesInput = {
  candidates: Array<Scalars['UUID']['input']>;
  match: Scalars['UUID']['input'];
};

export type DeleteMatchCandidatesOutput = DeleteMatchCandidatesResult;

export type DeleteMatchCandidatesResult = {
  __typename?: 'DeleteMatchCandidatesResult';
  candidatesRemoved: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type DeleteMatchCandidatesResult */
export type DeleteMatchCandidatesResultFilterInput = {
  and?: InputMaybe<Array<DeleteMatchCandidatesResultFilterInput>>;
  not?: InputMaybe<DeleteMatchCandidatesResultFilterInput>;
  or?: InputMaybe<Array<DeleteMatchCandidatesResultFilterInput>>;
};

export type DeleteMatchCompaniesInput = {
  companies: Array<Scalars['UUID']['input']>;
  /**
   * The match the rows belong to. REQUIRED, for the reason `CreateMatchCompaniesInput.match` gives: the
   * gate is built on it, and it is what stops a caller reaching pool rows of a match they do not own.
   * A null here used to be a 500 raised before the gate ran.
   */
  match: Scalars['UUID']['input'];
};

export type DeleteMatchCompaniesOutput = DeleteMatchCompaniesResult;

export type DeleteMatchCompaniesResult = {
  __typename?: 'DeleteMatchCompaniesResult';
  companiesRemoved: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type DeleteMatchCompaniesResult */
export type DeleteMatchCompaniesResultFilterInput = {
  and?: InputMaybe<Array<DeleteMatchCompaniesResultFilterInput>>;
  not?: InputMaybe<DeleteMatchCompaniesResultFilterInput>;
  or?: InputMaybe<Array<DeleteMatchCompaniesResultFilterInput>>;
};

/** Data structure for deleting an instance of MatchCompany */
export type DeleteMatchCompanyInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MatchCompany */
export type DeleteMatchCompanyOutput = {
  __typename?: 'DeleteMatchCompanyOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Match */
export type DeleteMatchInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Match */
export type DeleteMatchOutput = {
  __typename?: 'DeleteMatchOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MatchResult */
export type DeleteMatchResultInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MatchResult */
export type DeleteMatchResultOutput = {
  __typename?: 'DeleteMatchResultOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of OrgUnit */
export type DeleteOrgUnitInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of OrgUnit */
export type DeleteOrgUnitOutput = {
  __typename?: 'DeleteOrgUnitOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of PersonGroup */
export type DeletePersonGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of PersonGroup */
export type DeletePersonGroupOutput = {
  __typename?: 'DeletePersonGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Person */
export type DeletePersonInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Person */
export type DeletePersonOutput = {
  __typename?: 'DeletePersonOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of PinGroup */
export type DeletePinGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of PinGroup */
export type DeletePinGroupOutput = {
  __typename?: 'DeletePinGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/**
 * Data structure for deleting an instance of Project.
 *
 * HAND-WRITTEN for `actingAsCompanyId` alone (genesis#418); see `UpdateProjectInput`.
 */
export type DeleteProjectInput = {
  /**
   * Ein Firmenprojekt löschen die Admins der Firma, und nur mit dieser Angabe (genesis#418); ein
   * persönliches nur sein Ersteller, ohne Angabe. Codes wie bei `UpdateProjectInput`.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Project */
export type DeleteProjectOutput = {
  __typename?: 'DeleteProjectOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/**
 * Data structure for deleting an instance of SharedItemComment.
 *
 * HAND-WRITTEN for `actingAsCompanyId` alone; see `UpdateSharedItemInput`.
 */
export type DeleteSharedItemCommentInput = {
  /**
   *   The company the caller declares they are acting AS while deleting this comment.
   *
   * REQUIRED ON A COMPANY COMMENT AND FORBIDDEN ON A PERSONAL ONE. On a company comment it must EQUAL
   *   the `company_id` stored on the row — absent or different is refused with `GENESIS001259`; on a
   *   personal comment any declaration at all is refused with `GENESIS001260`, which is the mirror code
   *   Kevin's 2026-09-12 extension of v23 added (it was IGNORED there until that date). It sits on the
   *   ENVELOPE beside `dryRun` rather than on `SharedItemComment` for a reason this mutation makes
   *   plainest: a delete carries no `data` at all, so a field on the type could never reach it. It is
   *   also a statement of the REQUEST, which is a different kind of thing from every field on that type
   *   — those are either properties of the row or, like `isAdminOfCompany`, answers the server gives
   *   about the row AND the caller.
   *
   * IT NARROWS AND NEVER GRANTS, and it is NOT an access boundary: the company is still read from the
   *   ROW, the `company_membership` row still authorises, and this value is CLIENT-DECLARED — every
   *   principal who may already delete this comment can send it (genesis#300). See
   *   `UpdateSharedItemInput` for the full reasoning.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of SharedItemComment */
export type DeleteSharedItemCommentOutput = {
  __typename?: 'DeleteSharedItemCommentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/**
 * Data structure for deleting an instance of SharedItem.
 *
 * HAND-WRITTEN for `actingAsCompanyId` alone; see `UpdateSharedItemInput`.
 */
export type DeleteSharedItemInput = {
  /**
   *   The company the caller declares they are acting AS while deleting this item.
   *
   * REQUIRED ON A COMPANY ITEM AND FORBIDDEN ON A PERSONAL ONE. On a company item it must EQUAL the
   *   `company_id` stored on the row — absent or different is refused with `GENESIS001259`; on a personal
   *   item any declaration at all is refused with `GENESIS001260`. Concept v23 gives creating, editing and
   *   deleting one rule, and `validateMayWriteSharedItem` is literally one gate for both write mutations,
   *   so the two inputs carry the same field for the same reason. It was IGNORED on a personal item until
   *   Kevin extended v23 on 2026-09-12; that sentence is gone rather than softened.
   *
   * IT NARROWS AND NEVER GRANTS, and it is NOT an access boundary: the company is still read from the
   *   ROW, the `company_membership` row still authorises, and this value is CLIENT-DECLARED — every
   *   principal who may already delete this item can send it. See `UpdateSharedItemInput` for the full
   *   reasoning and genesis#300 for the risk Kevin accepted.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of SharedItem */
export type DeleteSharedItemOutput = {
  __typename?: 'DeleteSharedItemOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of StudioNotebook */
export type DeleteStudioNotebookInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of StudioNotebook */
export type DeleteStudioNotebookOutput = {
  __typename?: 'DeleteStudioNotebookOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of TeamProfile */
export type DeleteTeamProfileInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of TeamProfile */
export type DeleteTeamProfileOutput = {
  __typename?: 'DeleteTeamProfileOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of WorkingTimeModel */
export type DeleteWorkingTimeModelInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of WorkingTimeModel */
export type DeleteWorkingTimeModelOutput = {
  __typename?: 'DeleteWorkingTimeModelOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

export type DetachProjectDocumentInput = {
  backdropFileId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
};

export type DetachProjectDocumentOutput = DetachProjectDocumentResult;

export type DetachProjectDocumentResult = {
  __typename?: 'DetachProjectDocumentResult';
  match: Match;
};

/** The filterable fields of type DetachProjectDocumentResult */
export type DetachProjectDocumentResultFilterInput = {
  and?: InputMaybe<Array<DetachProjectDocumentResultFilterInput>>;
  not?: InputMaybe<DetachProjectDocumentResultFilterInput>;
  or?: InputMaybe<Array<DetachProjectDocumentResultFilterInput>>;
};

/** The platform of a mobile device for push notifications. */
export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type DiscoveryCategoriesResult = {
  __typename?: 'DiscoveryCategoriesResult';
  categories: Array<DiscoveryCategory>;
};

/** The filterable fields of type DiscoveryCategoriesResult */
export type DiscoveryCategoriesResultFilterInput = {
  and?: InputMaybe<Array<DiscoveryCategoriesResultFilterInput>>;
  not?: InputMaybe<DiscoveryCategoriesResultFilterInput>;
  or?: InputMaybe<Array<DiscoveryCategoriesResultFilterInput>>;
};

/** Applicant-facing classification, independent of access, departments and publication. */
export type DiscoveryCategory = Node & {
  __typename?: 'DiscoveryCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<LocalizedText>;
};

/** The filterable fields of type DiscoveryCategory */
export type DiscoveryCategoryFilterInput = {
  and?: InputMaybe<Array<DiscoveryCategoryFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<DiscoveryCategoryFilterInput>;
  or?: InputMaybe<Array<DiscoveryCategoryFilterInput>>;
};

/** Filtering options for a list of elements with type DiscoveryCategory */
export type DiscoveryCategoryListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<DiscoveryCategoryFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<DiscoveryCategoryFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<DiscoveryCategoryFilterInput>;
};

export type Document = Node & SharableEntity & {
  __typename?: 'Document';
  category?: Maybe<DocumentClassifier>;
  content: File;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  group?: Maybe<DocumentGroup>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person: Person;
  powersExtractedAt?: Maybe<Scalars['DateTime']['output']>;
  preview?: Maybe<File>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  skillsExtractedAt?: Maybe<Scalars['DateTime']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};


export type DocumentPreviewArgs = {
  profile: Scalars['String']['input'];
};

export enum DocumentClassifier {
  CurriculumVitae = 'CURRICULUM_VITAE'
}

export type DocumentClassifierFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<DocumentClassifierFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<DocumentClassifier>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<DocumentClassifier>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<DocumentClassifier>;
  /** Negates the predicate */
  not?: InputMaybe<DocumentClassifierFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<DocumentClassifierFilterInput>>;
};

export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  edges: Array<DocumentEdge>;
  nodes: Array<Document>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  cursor: Scalars['String']['output'];
  node: Document;
};

/** The filterable fields of type Document */
export type DocumentFilterInput = {
  and?: InputMaybe<Array<DocumentFilterInput>>;
  category?: InputMaybe<DocumentClassifierFilterInput>;
  fileName?: InputMaybe<StringFilterInput>;
  group?: InputMaybe<DocumentGroupFilterInput>;
  hasGroup?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DocumentFilterInput>;
  or?: InputMaybe<Array<DocumentFilterInput>>;
  tags?: InputMaybe<StringListFilterInput>;
};

export type DocumentGroup = Category & Node & {
  __typename?: 'DocumentGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type DocumentGroup */
export type DocumentGroupFilterInput = {
  and?: InputMaybe<Array<DocumentGroupFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DocumentGroupFilterInput>;
  or?: InputMaybe<Array<DocumentGroupFilterInput>>;
};

export type DocumentGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentGroupOutput = DocumentGroupResult;

/** Contains information for linking 'DocumentGroup' to other entities */
export type DocumentGroupRelationInput = {
  /** The identifier of 'DocumentGroup' */
  id: Scalars['ID']['input'];
};

export type DocumentGroupResult = {
  __typename?: 'DocumentGroupResult';
  documentGroups: Array<DocumentGroup>;
};

/** The filterable fields of type DocumentGroupResult */
export type DocumentGroupResultFilterInput = {
  and?: InputMaybe<Array<DocumentGroupResultFilterInput>>;
  not?: InputMaybe<DocumentGroupResultFilterInput>;
  or?: InputMaybe<Array<DocumentGroupResultFilterInput>>;
};

export type DocumentGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

/** Document pagination. Omitted personId preserves the caller's own document workspace. */
export type DocumentQueryInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<DocumentSortInput>;
  /** Reading another person's documents requires an explicit personal-information override. */
  personId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentFilterInput>;
};

export type DocumentSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

/** The text of one document as `documentText` reads it. */
export type DocumentText = {
  __typename?: 'DocumentText';
  documentId: Scalars['UUID']['output'];
  fileName: Scalars['String']['output'];
  /** In page order; one page for a document without pages (a DOCX or a text file). */
  pages: Array<DocumentTextPage>;
};

/** The filterable fields of type DocumentText */
export type DocumentTextFilterInput = {
  and?: InputMaybe<Array<DocumentTextFilterInput>>;
  not?: InputMaybe<DocumentTextFilterInput>;
  or?: InputMaybe<Array<DocumentTextFilterInput>>;
};

export type DocumentTextPage = {
  __typename?: 'DocumentTextPage';
  markdown: Scalars['String']['output'];
  /** 0-based, as the OCR provider numbers pages. */
  pageNo: Scalars['Int']['output'];
};

/** The filterable fields of type DocumentTextPage */
export type DocumentTextPageFilterInput = {
  and?: InputMaybe<Array<DocumentTextPageFilterInput>>;
  not?: InputMaybe<DocumentTextPageFilterInput>;
  or?: InputMaybe<Array<DocumentTextPageFilterInput>>;
};

/** Realtime event of a background documents-extraction job (powers + skills). */
export type DocumentsExtractionEvent = {
  __typename?: 'DocumentsExtractionEvent';
  jobId: Scalars['UUID']['output'];
  /** Human-readable detail, e.g. the failure reason or the stage that started. */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * Final pipeline result. Set on COMPLETED, and on FAILED when the pipeline itself produced
   * a result (per-document errors, counters); null when the job failed before running.
   */
  result?: Maybe<ProcessDocumentsResult>;
  type: ExtractionEventType;
};

/** The filterable fields of type DocumentsExtractionEvent */
export type DocumentsExtractionEventFilterInput = {
  and?: InputMaybe<Array<DocumentsExtractionEventFilterInput>>;
  not?: InputMaybe<DocumentsExtractionEventFilterInput>;
  or?: InputMaybe<Array<DocumentsExtractionEventFilterInput>>;
};

export type Education = Node & SharableEntity & {
  __typename?: 'Education';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  degree?: Maybe<Degree>;
  endDate?: Maybe<DateInstant>;
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institution?: Maybe<Scalars['String']['output']>;
  person: Person;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  startDate: DateInstant;
};

/** The filterable fields of type Education */
export type EducationFilterInput = {
  and?: InputMaybe<Array<EducationFilterInput>>;
  degree?: InputMaybe<DegreeFilterInput>;
  not?: InputMaybe<EducationFilterInput>;
  or?: InputMaybe<Array<EducationFilterInput>>;
};

export type ElementEvaluationResult = {
  __typename?: 'ElementEvaluationResult';
  answeredQuestionCount: Scalars['Int']['output'];
  element: CreativityElement;
  lastEvaluationOn?: Maybe<Scalars['Date']['output']>;
  questionCount: Scalars['Int']['output'];
  result?: Maybe<Scalars['Int']['output']>;
  resultText?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ElementEvaluationResult */
export type ElementEvaluationResultFilterInput = {
  and?: InputMaybe<Array<ElementEvaluationResultFilterInput>>;
  not?: InputMaybe<ElementEvaluationResultFilterInput>;
  or?: InputMaybe<Array<ElementEvaluationResultFilterInput>>;
};

export enum ElementGroup {
  Communication = 'COMMUNICATION',
  FutureOrientation = 'FUTURE_ORIENTATION',
  Inventiveness = 'INVENTIVENESS',
  Resilience = 'RESILIENCE',
  ResultOrientation = 'RESULT_ORIENTATION',
  TeamSpirit = 'TEAM_SPIRIT'
}

export type ElementWeight = {
  __typename?: 'ElementWeight';
  element?: Maybe<CreativityElement>;
  weight?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ElementWeight */
export type ElementWeightFilterInput = {
  and?: InputMaybe<Array<ElementWeightFilterInput>>;
  not?: InputMaybe<ElementWeightFilterInput>;
  or?: InputMaybe<Array<ElementWeightFilterInput>>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  body?: Maybe<Scalars['String']['output']>;
  defaultBody: Scalars['String']['output'];
  defaultSubject: Scalars['String']['output'];
  kind: EmailTemplateKind;
  maxBodyLength: Scalars['Int']['output'];
  /**
   * Length limits Genesis enforces after {appName} substitution. Clients validate against these values
   * instead of hard-coding them.
   */
  maxSubjectLength: Scalars['Int']['output'];
  placeholders: Array<EmailTemplatePlaceholder>;
  storageStatus: EmailTemplateStorageStatus;
  subject?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The filterable fields of type EmailTemplate */
export type EmailTemplateFilterInput = {
  and?: InputMaybe<Array<EmailTemplateFilterInput>>;
  not?: InputMaybe<EmailTemplateFilterInput>;
  or?: InputMaybe<Array<EmailTemplateFilterInput>>;
};

export type EmailTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  kind: EmailTemplateKind;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailTemplateKind {
  Invitation = 'INVITATION'
}

export type EmailTemplatePlaceholder = {
  __typename?: 'EmailTemplatePlaceholder';
  required: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
};

/** The filterable fields of type EmailTemplatePlaceholder */
export type EmailTemplatePlaceholderFilterInput = {
  and?: InputMaybe<Array<EmailTemplatePlaceholderFilterInput>>;
  not?: InputMaybe<EmailTemplatePlaceholderFilterInput>;
  or?: InputMaybe<Array<EmailTemplatePlaceholderFilterInput>>;
};

/**
 * Health of the store behind a template. DISABLED is the rollout default on a server without Gemstone,
 * UNAVAILABLE means Gemstone is configured but could not be read. Spark renders anything but AVAILABLE
 * read-only; the stored subject and body are unknown while UNAVAILABLE and therefore null.
 */
export enum EmailTemplateStorageStatus {
  Available = 'AVAILABLE',
  Disabled = 'DISABLED',
  Unavailable = 'UNAVAILABLE'
}

export enum EvidencePolarity {
  Contra = 'CONTRA',
  Pro = 'PRO'
}

export enum EvidenceStrength {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Experience = Node & SharableEntity & {
  __typename?: 'Experience';
  activities?: Maybe<Array<Scalars['String']['output']>>;
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Country>;
  department?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<DateInstant>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  jobTitle: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  person: Person;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  startDate: DateInstant;
};

/** The filterable fields of type Experience */
export type ExperienceFilterInput = {
  and?: InputMaybe<Array<ExperienceFilterInput>>;
  industry?: InputMaybe<IndustryFilterInput>;
  not?: InputMaybe<ExperienceFilterInput>;
  or?: InputMaybe<Array<ExperienceFilterInput>>;
};

/** Filtering options for a list of elements with type Experience */
export type ExperienceListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<ExperienceFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<ExperienceFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<ExperienceFilterInput>;
};

export type Expertise = Node & SharableEntity & {
  __typename?: 'Expertise';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  person: Person;
  position: Scalars['Int']['output'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

export type ExpertiseConditionInput = {
  aiMode: ConditionAiMode;
  expertise: Scalars['String']['input'];
  level: Scalars['Int']['input'];
};

/** The filterable fields of type Expertise */
export type ExpertiseFilterInput = {
  and?: InputMaybe<Array<ExpertiseFilterInput>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ExpertiseFilterInput>;
  or?: InputMaybe<Array<ExpertiseFilterInput>>;
};

/** Filtering options for a list of elements with type Expertise */
export type ExpertiseListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<ExpertiseFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<ExpertiseFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<ExpertiseFilterInput>;
};

export type ExtractionChanges = {
  __typename?: 'ExtractionChanges';
  /** Fachkompetenzen, die dieser Lauf neu angelegt hat. */
  addedExpertises: Array<ExtractionExpertiseChange>;
  /** Powers, für die dieser Lauf einen Wert geschrieben hat. */
  scoredPowers: Array<ExtractionPowerChange>;
};

/** The filterable fields of type ExtractionChanges */
export type ExtractionChangesFilterInput = {
  and?: InputMaybe<Array<ExtractionChangesFilterInput>>;
  not?: InputMaybe<ExtractionChangesFilterInput>;
  or?: InputMaybe<Array<ExtractionChangesFilterInput>>;
};

/** Type of a realtime event emitted for a background documents-extraction job. */
export enum ExtractionEventType {
  /** Terminal: the job finished; result is present. */
  Completed = 'COMPLETED',
  /** Terminal: the job failed; message carries the reason. */
  Failed = 'FAILED',
  /** Coarse progress signal; message says which stage started. */
  Progress = 'PROGRESS',
  /** Snapshot only: the job is still queued and has not started running. */
  Queued = 'QUEUED',
  /** The job started running (per-person extraction lock acquired). */
  Started = 'STARTED'
}

export type ExtractionExpertiseChange = {
  __typename?: 'ExtractionExpertiseChange';
  description: Scalars['String']['output'];
  /** Null, wenn die Fachkompetenz inzwischen gelöscht ist. */
  expertiseId?: Maybe<Scalars['ID']['output']>;
  level: Scalars['Int']['output'];
};

/** The filterable fields of type ExtractionExpertiseChange */
export type ExtractionExpertiseChangeFilterInput = {
  and?: InputMaybe<Array<ExtractionExpertiseChangeFilterInput>>;
  not?: InputMaybe<ExtractionExpertiseChangeFilterInput>;
  or?: InputMaybe<Array<ExtractionExpertiseChangeFilterInput>>;
};

/** Handle for a background extraction job started via startDocumentsExtraction. */
export type ExtractionJob = {
  __typename?: 'ExtractionJob';
  /** Was der Lauf am Profil geändert hat; gesetzt, sobald der Job COMPLETED ist. */
  changes?: Maybe<ExtractionChanges>;
  /** Wann der Job angenommen wurde. */
  createdAt: Scalars['DateTime']['output'];
  /** Welche Analysen der Lauf hatte. */
  extractPowers: Scalars['Boolean']['output'];
  extractSkills: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** Endergebnis; gesetzt bei COMPLETED und bei FAILED, wenn die Pipeline selbst ein Ergebnis erzeugt hat. */
  result?: Maybe<ProcessDocumentsResult>;
  status: ExtractionJobStatus;
};

/** The filterable fields of type ExtractionJob */
export type ExtractionJobFilterInput = {
  and?: InputMaybe<Array<ExtractionJobFilterInput>>;
  not?: InputMaybe<ExtractionJobFilterInput>;
  or?: InputMaybe<Array<ExtractionJobFilterInput>>;
};

/** Lifecycle status of a background documents-extraction job. */
export enum ExtractionJobStatus {
  /** Terminal: the job finished; the result is available. */
  Completed = 'COMPLETED',
  /** Terminal: the job failed; the message carries the reason. */
  Failed = 'FAILED',
  /** The job was accepted and has not started running yet (e.g. waiting for the per-person extraction lock). */
  Queued = 'QUEUED',
  /** The job is currently extracting. */
  Running = 'RUNNING'
}

export type ExtractionPowerChange = {
  __typename?: 'ExtractionPowerChange';
  element: CreativityElement;
  /** Wert vor dem Lauf; null, wenn die Power vorher keinen hatte. */
  previousScore?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
};

/** The filterable fields of type ExtractionPowerChange */
export type ExtractionPowerChangeFilterInput = {
  and?: InputMaybe<Array<ExtractionPowerChangeFilterInput>>;
  not?: InputMaybe<ExtractionPowerChangeFilterInput>;
  or?: InputMaybe<Array<ExtractionPowerChangeFilterInput>>;
};

/**
 * One of a person's ranked favourites: a catalogue item or a title of the person's own, exactly one of the two.
 * Readable by its owner, and by others as far as its Toplist is shared.
 */
export type Favorite = {
  __typename?: 'Favorite';
  domain: FavoriteDomain;
  id: Scalars['UUID']['output'];
  /** The catalogue item; null for a title of the person's own. */
  item?: Maybe<CatalogItem>;
  /** 1 is the favourite. */
  position: Scalars['Int']['output'];
  /** The person's own title for something the catalogue lacks; null for a catalogue item. It never enters the catalogue. */
  title?: Maybe<Scalars['String']['output']>;
};

/** What a catalogue item and a favourite are about; each has its own toplist game (toplist.movies, toplist.cities, ...). */
export enum FavoriteDomain {
  Book = 'BOOK',
  /** Travel destinations: cities. */
  City = 'CITY',
  Dish = 'DISH',
  Hobby = 'HOBBY',
  Movie = 'MOVIE',
  MusicArtist = 'MUSIC_ARTIST',
  Series = 'SERIES',
  Sport = 'SPORT'
}

/** The filterable fields of type Favorite */
export type FavoriteFilterInput = {
  and?: InputMaybe<Array<FavoriteFilterInput>>;
  not?: InputMaybe<FavoriteFilterInput>;
  or?: InputMaybe<Array<FavoriteFilterInput>>;
};

/**
 * A code-defined feature enabled by its explicit Permission in a Group-assigned Role.
 * Eligibility never grants data visibility or personal consent. Configure through accessRoles and
 * Group role assignments.
 */
export type Feature = {
  __typename?: 'Feature';
  /** The stable, code-defined key of the feature. */
  key: Scalars['String']['output'];
  /** The explicit Role Permission enabling this feature. Global scope is required. */
  permissionCode: Scalars['String']['output'];
};

/** The filterable fields of type Feature */
export type FeatureFilterInput = {
  and?: InputMaybe<Array<FeatureFilterInput>>;
  not?: InputMaybe<FeatureFilterInput>;
  or?: InputMaybe<Array<FeatureFilterInput>>;
};

/** The code-defined features and their explicit Permissions. Config-admin read. */
export type FeaturesResult = {
  __typename?: 'FeaturesResult';
  features: Array<Feature>;
};

/** The filterable fields of type FeaturesResult */
export type FeaturesResultFilterInput = {
  and?: InputMaybe<Array<FeaturesResultFilterInput>>;
  not?: InputMaybe<FeaturesResultFilterInput>;
  or?: InputMaybe<Array<FeaturesResultFilterInput>>;
};

export type File = {
  __typename?: 'File';
  content?: Maybe<Scalars['Binary']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type File */
export type FileFilterInput = {
  and?: InputMaybe<Array<FileFilterInput>>;
  not?: InputMaybe<FileFilterInput>;
  or?: InputMaybe<Array<FileFilterInput>>;
};

/**
 * Route-independent snapshot of one file dropped via `startFileImport`: which type was detected,
 * which existing worker runs it, and how far it got. Deliberately thin — it is the common denominator
 * of both routes. The full, route-specific result stays on the route's own query/subscription
 * (`importJob` / `importJobEvents` for YAML, `extractionJob` / `documentsExtractionEvents` for
 * extraction), which this snapshot's `id` addresses unchanged.
 */
export type FileImportJob = {
  __typename?: 'FileImportJob';
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileType: ImportFileType;
  /** Job id of the underlying worker's job — usable verbatim with the route-specific query. */
  id: Scalars['UUID']['output'];
  /** Failure reason on FAILED, latest progress detail while RUNNING; null otherwise. */
  message?: Maybe<Scalars['String']['output']>;
  /** Documents processed so far; null on routes that do not report a document count. */
  processedDocuments?: Maybe<Scalars['Int']['output']>;
  /**
   *   Client route back to this job in the shared drop, for both routes — it carries the job id, so a
   *   client that left the page resolves it through `fileImportJob` without knowing the route.
   *
   * For the YAML route this is identical to the deep link of that job's IMPORT_STARTED /
   *   IMPORT_COMPLETED / IMPORT_FAILED notification. For the extraction route it is not: the
   *   EXTRACTION_* notifications predate the shared drop and point at the person's own documents page
   *   (`/save/basics`, for a finished run `/save/basics?extractionJob=<id>`), where extracted powers and
   *   skills actually show up.
   */
  resultLink: Scalars['String']['output'];
  route: FileImportRoute;
  /** Rows the importer affected; null on routes that do not write rows (extraction). */
  rowsAffected?: Maybe<Scalars['Int']['output']>;
  status: FileImportJobStatus;
  /** Total documents to process; null on routes that do not report a document count. */
  totalDocuments?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** The filterable fields of type FileImportJob */
export type FileImportJobFilterInput = {
  and?: InputMaybe<Array<FileImportJobFilterInput>>;
  not?: InputMaybe<FileImportJobFilterInput>;
  or?: InputMaybe<Array<FileImportJobFilterInput>>;
};

/** Route-independent lifecycle of a job started through the shared drop. */
export enum FileImportJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

/**
 * The already existing processing path a dropped file was routed to. The drop only routes;
 * it never adds a processing path of its own.
 */
export enum FileImportRoute {
  /**
   * The background documents-extraction pipeline (`startDocumentsExtraction`'s worker). Modelled
   * for the drop, but not currently started by it — see `startFileImport`.
   */
  DocumentExtraction = 'DOCUMENT_EXTRACTION',
  /** The full-fidelity YAML importer engine — the same worker `startImportDocuments` uses. */
  YamlImport = 'YAML_IMPORT'
}

export type FloatFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<FloatFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['Float']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<FloatFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<FloatFilterInput>>;
};

/**
 * One play of one game by one person, readable and writable by that person only. The head every game kind shares;
 * what a kind keeps beyond it, and what finishing writes, belongs to that kind's own operations.
 */
export type GameSession = {
  __typename?: 'GameSession';
  /** Set exactly when the session is no longer IN_PROGRESS. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Kind and instance, e.g. toplist.movies. */
  gameKey: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: GameSessionStatus;
  /** Active play time reported by the client, in milliseconds. */
  timeTakenMs: Scalars['Int']['output'];
};

/** The filterable fields of type GameSession */
export type GameSessionFilterInput = {
  and?: InputMaybe<Array<GameSessionFilterInput>>;
  not?: InputMaybe<GameSessionFilterInput>;
  or?: InputMaybe<Array<GameSessionFilterInput>>;
};

export enum GameSessionStatus {
  /** Replaced by a restart. */
  Abandoned = 'ABANDONED',
  Completed = 'COMPLETED',
  /** Idle for longer than its game kind allows. */
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS'
}

export type Gender = Node & {
  __typename?: 'Gender';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Gender */
export type GenderFilterInput = {
  and?: InputMaybe<Array<GenderFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<GenderFilterInput>;
  or?: InputMaybe<Array<GenderFilterInput>>;
};

/** Contains information for linking 'Gender' to other entities */
export type GenderRelationInput = {
  /** The identifier of 'Gender' */
  id: Scalars['ID']['input'];
};

export type GenderSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type GendersResult = {
  __typename?: 'GendersResult';
  genders: Array<Gender>;
};

/** The filterable fields of type GendersResult */
export type GendersResultFilterInput = {
  and?: InputMaybe<Array<GendersResultFilterInput>>;
  not?: InputMaybe<GendersResultFilterInput>;
  or?: InputMaybe<Array<GendersResultFilterInput>>;
};

export type GenerateAiRequirementsInput = {
  /**
   * When true, the proposed conditions are returned on the (unpersisted) Match.design so the client can
   * diff/accept them; the match is left unchanged. Defaults to false (generate and persist).
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  matchId: Scalars['UUID']['input'];
};

export type GenerateAiRequirementsOutput = GenerateAiRequirementsResult;

export type GenerateAiRequirementsResult = {
  __typename?: 'GenerateAIRequirementsResult';
  match: Match;
};

/** The filterable fields of type GenerateAIRequirementsResult */
export type GenerateAiRequirementsResultFilterInput = {
  and?: InputMaybe<Array<GenerateAiRequirementsResultFilterInput>>;
  not?: InputMaybe<GenerateAiRequirementsResultFilterInput>;
  or?: InputMaybe<Array<GenerateAiRequirementsResultFilterInput>>;
};

export type GenerateTransientMatchResultInput = {
  matchId: Scalars['UUID']['input'];
  /**
   * Optional, fresh per call. Subscribe to operationProgress with it to follow the run in stages. A
   * progressId that is already in use leaves this run without progress; the run itself is unaffected.
   */
  progressId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GlobalSearchInput = {
  /** Optional structured Company filter. Intersected with the full-text results by company id before paging, and restricts results to COMPANY. Mutually exclusive with personFilter and sharedItemFilter. */
  companyFilter?: InputMaybe<CompanyFilterInput>;
  /** Optional filter to restrict results to specific entity types. */
  entityTypes?: InputMaybe<Array<SearchEntityType>>;
  /** Optional structured Person filter (same type as persons(where)). Intersected with the full-text results by person_id before paging. Mutually exclusive with sharedItemFilter. */
  personFilter?: InputMaybe<PersonFilterInput>;
  /** Optional account-binding criterion, applied before paging. Requires provision:invitee and restricts results to people; not evidence of authentication. */
  personLoginStatus?: InputMaybe<Array<PersonLoginStatus>>;
  /** Person search scope. IDENTITY searches names and stored email only, requires provision:invitee, and restricts results to people. */
  personSearchScope?: InputMaybe<PersonSearchScope>;
  /** Full-text query (PostgreSQL websearch syntax). Optional: when null/blank, results are filter/entityType-only with rank 0 and a stable label/entity-id order. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Optional structured SharedItem filter (same type as sharedItems(where)). Intersected with the full-text results by shared_item id before paging. Mutually exclusive with personFilter. */
  sharedItemFilter?: InputMaybe<SharedItemFilterInput>;
  /** Number of rows to skip (offset-based pagination). Defaults to 0. */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of results to return. Defaults to 50. */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalSearchOutput = {
  __typename?: 'GlobalSearchOutput';
  /** True if more results exist beyond the current page. */
  hasNextPage: Scalars['Boolean']['output'];
  results: Array<GlobalSearchResult>;
};

/** The filterable fields of type GlobalSearchOutput */
export type GlobalSearchOutputFilterInput = {
  and?: InputMaybe<Array<GlobalSearchOutputFilterInput>>;
  not?: InputMaybe<GlobalSearchOutputFilterInput>;
  or?: InputMaybe<Array<GlobalSearchOutputFilterInput>>;
};

export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  entityId: Scalars['ID']['output'];
  entityType: SearchEntityType;
  /** Human-readable display label for this result. */
  label?: Maybe<Scalars['String']['output']>;
  /** Administrative login details for a Person result. Requires provision:invitee; loaded in one batch with current person visibility. */
  loginAssignment?: Maybe<PersonLoginAssignment>;
  /** The person who owns this entity. Null for match and shared_item. */
  personId?: Maybe<Scalars['ID']['output']>;
  /** Relevance score from full-text search ranking. */
  rank: Scalars['Float']['output'];
};

/** The filterable fields of type GlobalSearchResult */
export type GlobalSearchResultFilterInput = {
  and?: InputMaybe<Array<GlobalSearchResultFilterInput>>;
  not?: InputMaybe<GlobalSearchResultFilterInput>;
  or?: InputMaybe<Array<GlobalSearchResultFilterInput>>;
};

export enum GroupMembershipSource {
  Identity = 'IDENTITY',
  Manual = 'MANUAL',
  Organization = 'ORGANIZATION'
}

export type GrowElement = {
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type GrowElement */
export type GrowElementFilterInput = {
  and?: InputMaybe<Array<GrowElementFilterInput>>;
  not?: InputMaybe<GrowElementFilterInput>;
  or?: InputMaybe<Array<GrowElementFilterInput>>;
};

export type GrowRanking = {
  __typename?: 'GrowRanking';
  score: Scalars['Int']['output'];
  selfAssessmentCompleted: Scalars['Boolean']['output'];
  userRank: UserRank;
};

/** The filterable fields of type GrowRanking */
export type GrowRankingFilterInput = {
  and?: InputMaybe<Array<GrowRankingFilterInput>>;
  not?: InputMaybe<GrowRankingFilterInput>;
  or?: InputMaybe<Array<GrowRankingFilterInput>>;
};

export type GrowResource = {
  __typename?: 'GrowResource';
  audio?: Maybe<Array<AudioElement>>;
  element?: Maybe<CreativityElement>;
  text?: Maybe<Array<TextElement>>;
  videos?: Maybe<Array<VideoElement>>;
};

/** The filterable fields of type GrowResource */
export type GrowResourceFilterInput = {
  and?: InputMaybe<Array<GrowResourceFilterInput>>;
  not?: InputMaybe<GrowResourceFilterInput>;
  or?: InputMaybe<Array<GrowResourceFilterInput>>;
};

export type GrowResourceQueryInput = {
  element: CreativityElement;
};

export type HeartbeatConversationPresenceInput = {
  conversationId: Scalars['UUID']['input'];
  online?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HumanName = {
  __typename?: 'HumanName';
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Scalars['String']['output']>>;
  period?: Maybe<Period>;
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  use: NameUse;
};

/** The filterable fields of type HumanName */
export type HumanNameFilterInput = {
  and?: InputMaybe<Array<HumanNameFilterInput>>;
  family?: InputMaybe<StringFilterInput>;
  given?: InputMaybe<StringListFilterInput>;
  not?: InputMaybe<HumanNameFilterInput>;
  or?: InputMaybe<Array<HumanNameFilterInput>>;
};

export type HumanNameSortInput = {
  family?: InputMaybe<SortOrder>;
  given?: InputMaybe<SortOrder>;
};

export type IdFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<IdFilterInput>>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['UUID']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<IdFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<IdFilterInput>>;
};

/**
 * One multi-file drop, as the client groups it. The id is client-generated; Genesis counts accepted
 * jobs. Batches are scoped to the caller: two principals using the same id get two distinct batches.
 */
export type ImportBatchInput = {
  /** Shared by every file of the drop. */
  id: Scalars['UUID']['input'];
};

/** How a single preview item differs between existing genesis data and incoming LinkedIn data. */
export enum ImportDiffAction {
  /** Target is empty / has no matching row; the LinkedIn value would be added. Default resolution: USE_LINKEDIN. */
  Add = 'ADD',
  /** Target and LinkedIn differ; the user must choose. Default resolution: KEEP_EXISTING. */
  Conflict = 'CONFLICT',
  /** Target and LinkedIn agree; nothing to decide. */
  Unchanged = 'UNCHANGED'
}

/** The operation a document declared, before it is resolved against the database. */
export enum ImportDocumentOperation {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Merge = 'MERGE',
  Update = 'UPDATE'
}

/**
 * Result of the importDocuments mutation: the total number of rows the importer
 * inserted / updated / deleted across every document in the YAML payload, plus the
 * per-unit breakdown. `rowsAffected` counts only units that actually persisted, so a
 * partially failed import never reads as if the whole file had been stored.
 */
export type ImportDocumentsResult = {
  __typename?: 'ImportDocumentsResult';
  /** Whether this run was a simulation that was deliberately rolled back. */
  dryRun: Scalars['Boolean']['output'];
  failedUnits: Scalars['Int']['output'];
  mode: ImportMode;
  /** Per-Person action resolved against the database, available for simulations and committed imports. */
  personActions: Array<ImportPersonActionPreview>;
  /**
   * Rows the import touched. When dryRun is true this is the number of rows the
   * import WOULD have touched: the transaction was rolled back, so nothing was
   * stored. Clients must present it as a simulation, never as a saved result.
   */
  rowsAffected: Scalars['Int']['output'];
  skippedUnits: Scalars['Int']['output'];
  succeededUnits: Scalars['Int']['output'];
  totalUnits: Scalars['Int']['output'];
  /** Per-unit outcomes in payload order. */
  units: Array<ImportUnitResult>;
  /** Non-fatal problems; empty in the normal case. */
  warnings: Array<ImportWarning>;
};

/** The filterable fields of type ImportDocumentsResult */
export type ImportDocumentsResultFilterInput = {
  and?: InputMaybe<Array<ImportDocumentsResultFilterInput>>;
  not?: InputMaybe<ImportDocumentsResultFilterInput>;
  or?: InputMaybe<Array<ImportDocumentsResultFilterInput>>;
};

/**
 * Type of a file recognized by the drop (`startFileImport`). The type is decided from the
 * file name extension, the client-declared MIME type and the actual leading bytes together; any
 * contradiction between the three is rejected before a job is started. Only YAML is currently
 * accepted — PDF and DOCX are recognized but rejected, see `startFileImport`.
 */
export enum ImportFileType {
  /** An OOXML word-processing document (.docx). Recognized, currently rejected by the drop. */
  Docx = 'DOCX',
  /** A PDF document (CV, application form, …). Recognized, currently rejected by the drop. */
  Pdf = 'PDF',
  /** A multi-document genesis importer YAML payload. */
  Yaml = 'YAML'
}

/** Restorable progress and result snapshot for one YAML import run. */
export type ImportJob = {
  __typename?: 'ImportJob';
  createdAt: Scalars['DateTime']['output'];
  currentKind?: Maybe<Scalars['String']['output']>;
  /** Whether this job was a simulation that was deliberately rolled back. */
  dryRun: Scalars['Boolean']['output'];
  failedUnits: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  mode: ImportMode;
  /**
   * Per-Person action resolved against the database, restorable after navigating
   * away for both simulations and committed imports.
   */
  personActions: Array<ImportPersonActionPreview>;
  /** Safe structured failure guidance; populated when status is FAILED. */
  problem?: Maybe<ImportProblem>;
  processedDocuments: Scalars['Int']['output'];
  /**
   * Rows actually persisted so far; final committed count when status is COMPLETED.
   * When dryRun is true nothing was committed, so a COMPLETED job reports the rows the
   * import WOULD have touched and clients must label it as a simulation. In
   * KEEP_SUCCESSFUL only units that actually committed are counted. A FAILED job
   * always reports 0.
   */
  rowsAffected: Scalars['Int']['output'];
  skippedUnits: Scalars['Int']['output'];
  stage: ImportJobStage;
  status: ImportJobStatus;
  succeededUnits: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
  /** Total number of units (documents) in the payload; 0 until indexing finished. */
  totalUnits: Scalars['Int']['output'];
  /**
   * Per-unit outcomes in payload order. Only populated once the job reached a terminal
   * state: while it runs, only the counters above are updated, so a long import does not
   * rewrite the whole breakdown on every progress tick.
   */
  units: Array<ImportUnitResult>;
  updatedAt: Scalars['DateTime']['output'];
  /** Non-fatal problems; empty in the normal case. */
  warnings: Array<ImportWarning>;
};

/** The filterable fields of type ImportJob */
export type ImportJobFilterInput = {
  and?: InputMaybe<Array<ImportJobFilterInput>>;
  not?: InputMaybe<ImportJobFilterInput>;
  or?: InputMaybe<Array<ImportJobFilterInput>>;
};

/** Current stage of a detached YAML import job. */
export enum ImportJobStage {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Importing = 'IMPORTING',
  Indexing = 'INDEXING',
  Queued = 'QUEUED'
}

/** Lifecycle of a detached YAML import job. */
export enum ImportJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

/**
 * How an import reacts to a unit it cannot write. ALL_OR_NOTHING is the default and
 * the behaviour every caller had before partial imports existed: one transaction for
 * the whole file, any failure rolls all of it back. KEEP_SUCCESSFUL keeps the units
 * that committed — but only after the payload has been validated as a whole, so a
 * syntax error, an unknown kind, an unknown field or a malformed UUID still prevents
 * every single write in this mode too.
 */
export enum ImportMode {
  AllOrNothing = 'ALL_OR_NOTHING',
  KeepSuccessful = 'KEEP_SUCCESSFUL'
}

/**
 * How an import run should behave. Optional everywhere it appears; the defaults below are the
 * behaviour every endpoint had before the option existed, so an absent input (or an absent field
 * in it) changes nothing for a client that never sends one.
 *
 * The two fields are orthogonal: every combination of them is valid, and a run reports both back
 * independently. A dry run is not a third mode — it is either mode with the commit removed. In the
 * KEEP_SUCCESSFUL + dryRun combination, validation is deliberately atomic for the whole file so
 * references between documents are tested exactly as in a real import; no unit is retained.
 *
 * Modelled as an input object rather than as loose arguments so both import entry points
 * share one extension point — and because the GraphQL client generator cannot emit a
 * field argument of an enum type, only an input object carrying one.
 */
export type ImportOptionsInput = {
  /**
   * Validate instead of import. Runs the identical handlers, reference resolution,
   * constraints and asset uploads, then rolls the transaction back and deletes the blobs
   * it uploaded. Blobs it would only have superseded are never touched. Authorization is
   * identical to a real import.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Choosing a partial import is an explicit act; the default is the atomic behaviour. */
  mode?: InputMaybe<ImportMode>;
};

/** What a document would do to a Person row, resolved against what is stored. */
export enum ImportPersonAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  /** A soft-deleted Person row is reactivated by an explicit merge. */
  Restore = 'RESTORE',
  Update = 'UPDATE'
}

/**
 * What a run would do or did to one Person document. Produced for both a
 * simulation (dryRun: true) and a committed import.
 *
 * Carries personal data (display name, primary email) and therefore only the
 * fields the validation or result view needs. Persisted alongside the import job it
 * belongs to, under the same owner check and the same TTL as the rest of that
 * job's state, and never copied into notifications or logs.
 */
export type ImportPersonActionPreview = {
  __typename?: 'ImportPersonActionPreview';
  action: ImportPersonAction;
  /** Zero-based position of the document inside the YAML file, in file order. */
  documentPosition: Scalars['Int']['output'];
  /** The stored display name, for an UPDATE or DELETE. */
  existingDisplayName?: Maybe<Scalars['String']['output']>;
  /** The stored primary email, for an UPDATE or DELETE. */
  existingPrimaryEmail?: Maybe<Scalars['String']['output']>;
  /** The display name the document carries, if it carries one. */
  incomingDisplayName?: Maybe<Scalars['String']['output']>;
  /** The primary email the document carries, if it carries one. */
  incomingPrimaryEmail?: Maybe<Scalars['String']['output']>;
  operation: ImportDocumentOperation;
  /**
   * The UUID the document supplies. Null when the document supplies none;
   * generated database identities are reported by the corresponding unit result.
   */
  personId?: Maybe<Scalars['UUID']['output']>;
  warnings: Array<ImportPersonWarningCode>;
};

/** The filterable fields of type ImportPersonActionPreview */
export type ImportPersonActionPreviewFilterInput = {
  and?: InputMaybe<Array<ImportPersonActionPreviewFilterInput>>;
  not?: InputMaybe<ImportPersonActionPreviewFilterInput>;
  or?: InputMaybe<Array<ImportPersonActionPreviewFilterInput>>;
};

/** Machine-readable warning code on a previewed Person action. */
export enum ImportPersonWarningCode {
  /**
   * The document addresses an existing person by UUID and BOTH identity fields it
   * carries — display name and primary email — differ from what is stored. This is
   * a statement of fact, not a verdict: a legitimate rename and a UUID pasted onto
   * the wrong row look identical from here, so the backend reports both identities
   * and the admin decides. It never fails the simulation.
   */
  PersonIdentityMismatch = 'PERSON_IDENTITY_MISMATCH'
}

/** Safe structured details from which a client can build actionable, localized guidance. */
export type ImportProblem = {
  __typename?: 'ImportProblem';
  /** One-based YAML column, when the parser supplied a location. */
  column?: Maybe<Scalars['Int']['output']>;
  /** Heading id in ImportSpecification.markdown, without the leading '#'. */
  documentationAnchor: Scalars['String']['output'];
  /** Accepted members or values when the importer knows them. */
  expectedValues: Array<Scalars['String']['output']>;
  /** Field path, or the unknown member name, when it can be determined safely. */
  fieldPath?: Maybe<Scalars['String']['output']>;
  /** One-based YAML line, when the parser supplied a location. */
  line?: Maybe<Scalars['Int']['output']>;
  reason: ImportProblemReason;
  /** Rejected scalar value, truncated to a safe display length. */
  rejectedValue?: Maybe<Scalars['String']['output']>;
  /** Importer-provided replacement when one is known. */
  suggestedValue?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ImportProblem */
export type ImportProblemFilterInput = {
  and?: InputMaybe<Array<ImportProblemFilterInput>>;
  not?: InputMaybe<ImportProblemFilterInput>;
  or?: InputMaybe<Array<ImportProblemFilterInput>>;
};

/** Stable, localizable reason for an import problem. Never contains a server exception message. */
export enum ImportProblemReason {
  DependencyFailed = 'DEPENDENCY_FAILED',
  Duplicate = 'DUPLICATE',
  InvalidFormat = 'INVALID_FORMAT',
  InvalidReference = 'INVALID_REFERENCE',
  InvalidValue = 'INVALID_VALUE',
  MissingValue = 'MISSING_VALUE',
  PermissionDenied = 'PERMISSION_DENIED',
  PersistenceError = 'PERSISTENCE_ERROR',
  UnexpectedError = 'UNEXPECTED_ERROR',
  UnknownProperty = 'UNKNOWN_PROPERTY',
  UnsupportedModification = 'UNSUPPORTED_MODIFICATION'
}

/**
 * The read-only description of the YAML import format this deployment accepts, generated from the
 * importer contract itself rather than maintained by hand. Clients must not keep their own field
 * list: `jsonSchema` carries the accepted members, their types, the document kinds, the reference
 * targets and the `x-genesis-*` metadata (allowed operations, required-on, limits).
 */
export type ImportSpecification = {
  __typename?: 'ImportSpecification';
  /** Runnable example payloads, including Person and SharedItem. */
  examples: Array<ImportSpecificationExample>;
  /** The import format version; the value every document's `version` must carry. */
  formatVersion: Scalars['String']['output'];
  /** JSON Schema (draft 2020-12) of one import document, as a JSON string. */
  jsonSchema: Scalars['String']['output'];
  /** The same specification as human-readable Markdown. */
  markdown: Scalars['String']['output'];
};

/** One generated example payload of the YAML import format. */
export type ImportSpecificationExample = {
  __typename?: 'ImportSpecificationExample';
  /** What the example demonstrates. */
  description: Scalars['String']['output'];
  /** File name of the example under docs/importer/generated/examples. */
  fileName: Scalars['String']['output'];
  /** The payload itself. */
  yaml: Scalars['String']['output'];
};

/** The filterable fields of type ImportSpecificationExample */
export type ImportSpecificationExampleFilterInput = {
  and?: InputMaybe<Array<ImportSpecificationExampleFilterInput>>;
  not?: InputMaybe<ImportSpecificationExampleFilterInput>;
  or?: InputMaybe<Array<ImportSpecificationExampleFilterInput>>;
};

/** The filterable fields of type ImportSpecification */
export type ImportSpecificationFilterInput = {
  and?: InputMaybe<Array<ImportSpecificationFilterInput>>;
  not?: InputMaybe<ImportSpecificationFilterInput>;
  or?: InputMaybe<Array<ImportSpecificationFilterInput>>;
};

/** Coarse classification of why an import unit did not succeed. */
export enum ImportUnitErrorCode {
  /** Not attempted: a unit this one depends on did not succeed. */
  DependencyFailed = 'DEPENDENCY_FAILED',
  /**
   * The row already exists: an `insert` payload run a second time, or a document whose id or unique
   * field is taken. Split out of PERSISTENCE_ERROR because the user can act on this one — importing
   * the same file again needs `merge`, not `insert`.
   */
  Duplicate = 'DUPLICATE',
  /** The document was understood but rejected (value out of range, missing mandatory field, …). */
  InvalidInput = 'INVALID_INPUT',
  /** A reference in the document does not resolve to anything that exists. */
  InvalidReference = 'INVALID_REFERENCE',
  /** The database refused the write (constraint violation, lost optimistic lock, …). */
  PersistenceError = 'PERSISTENCE_ERROR',
  /** Anything the classification does not recognise. */
  UnexpectedError = 'UNEXPECTED_ERROR'
}

/**
 * What one unit of an import did. A unit is one YAML document — the granularity the
 * importer resolves references at, and therefore the smallest slice that can be
 * committed without leaving a half-written entity behind.
 */
export type ImportUnitResult = {
  __typename?: 'ImportUnitResult';
  /** For SKIPPED_DEPENDENCY: the position of the unit whose failure caused the skip. */
  dependsOnPosition?: Maybe<Scalars['Int']['output']>;
  /**
   *   Primary key of the row this unit wrote, so a client can address the imported entity — link to the
   *   person it created, reload the shared item it updated. Null when the unit wrote no row: a failure, a
   *   skip, a delete, or a kind whose handler registers no key.
   *
   * This is the reference; `label` above is only display text. `id` carries a uuid only when the document
   *   had no name, so it must not be parsed to get here.
   *
   * Never set for a dry run either: a simulation is rolled back, so the key it would report addresses a
   *   row that no longer exists.
   */
  entityId?: Maybe<Scalars['UUID']['output']>;
  errorCode?: Maybe<ImportUnitErrorCode>;
  /** Stable technical identity: `Kind/name`, `Kind/uuid`, or `Kind#position`. */
  id: Scalars['String']['output'];
  /** The document's `kind:` as written in the payload. */
  kind: Scalars['String']['output'];
  /** Short content-derived display label, such as a person's name or an expertise description. Not unique. */
  label: Scalars['String']['output'];
  /** Short, human-readable reason. Null for a successful unit. */
  message?: Maybe<Scalars['String']['output']>;
  /** Blobs this unit's compensating cleanup could not remove. Empty in the normal case. */
  orphanedStorageIds: Array<Scalars['UUID']['output']>;
  /** Zero-based index of the document in the payload, independent of the order units were written in. */
  position: Scalars['Int']['output'];
  /** Localized clients should render this instead of the technical message below. */
  problem?: Maybe<ImportProblem>;
  /** Rows this unit persisted. Always 0 unless it succeeded. */
  rowsAffected: Scalars['Int']['output'];
  status: ImportUnitStatus;
};

/** The filterable fields of type ImportUnitResult */
export type ImportUnitResultFilterInput = {
  and?: InputMaybe<Array<ImportUnitResultFilterInput>>;
  not?: InputMaybe<ImportUnitResultFilterInput>;
  or?: InputMaybe<Array<ImportUnitResultFilterInput>>;
};

/** Outcome of one independently committed import unit (one YAML document). */
export enum ImportUnitStatus {
  /** Attempted and rolled back on its own; its blobs were compensated. */
  Failed = 'FAILED',
  /** Never attempted, because a unit it depends on did not succeed. */
  SkippedDependency = 'SKIPPED_DEPENDENCY',
  /** Committed. Nothing that happens afterwards changes this. */
  Succeeded = 'SUCCEEDED'
}

/** Structured, non-fatal warning attached to an import or simulation result. */
export type ImportWarning = {
  __typename?: 'ImportWarning';
  /** How many blobs this warning is about. */
  blobCount: Scalars['Int']['output'];
  code: ImportWarningCode;
  /** The storage ids an operator needs in order to remove them by hand. */
  storageIds: Array<Scalars['UUID']['output']>;
};

/**
 * Machine-readable warning code for a problem that did NOT fail the import or
 * simulation itself. Codes are stable and localized by the client; the backend
 * never sends an exception text a UI could render.
 */
export enum ImportWarningCode {
  /**
   * Blobs this run uploaded could not be removed again afterwards and remain
   * stored. Only reachable on a rolled-back run (a failure or a dry run), where
   * the uploads have to be compensated because no row points at them any more.
   */
  BlobCleanupIncomplete = 'BLOB_CLEANUP_INCOMPLETE'
}

/** The filterable fields of type ImportWarning */
export type ImportWarningFilterInput = {
  and?: InputMaybe<Array<ImportWarningFilterInput>>;
  not?: InputMaybe<ImportWarningFilterInput>;
  or?: InputMaybe<Array<ImportWarningFilterInput>>;
};

export type IndustriesResult = {
  __typename?: 'IndustriesResult';
  industries: Array<Industry>;
};

/** The filterable fields of type IndustriesResult */
export type IndustriesResultFilterInput = {
  and?: InputMaybe<Array<IndustriesResultFilterInput>>;
  not?: InputMaybe<IndustriesResultFilterInput>;
  or?: InputMaybe<Array<IndustriesResultFilterInput>>;
};

export type Industry = Node & {
  __typename?: 'Industry';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IndustryExperienceConditionInput = {
  industryId: Scalars['UUID']['input'];
  minimumYears: Scalars['Float']['input'];
};

/** The filterable fields of type Industry */
export type IndustryFilterInput = {
  and?: InputMaybe<Array<IndustryFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<IndustryFilterInput>;
  or?: InputMaybe<Array<IndustryFilterInput>>;
};

/** Contains information for linking 'Industry' to other entities */
export type IndustryRelationInput = {
  /** The identifier of 'Industry' */
  id: Scalars['ID']['input'];
};

export type IndustrySortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<IntFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<IntFilterInput>>;
};

export type IntegerConditionInput = {
  kind: IntegerConditionKind;
  value: Scalars['Int']['input'];
};

export enum IntegerConditionKind {
  Age = 'AGE',
  AnnualSalary = 'ANNUAL_SALARY',
  ChildrenCount = 'CHILDREN_COUNT'
}

/**
 * Invite one EXISTING Person: bind a new external login to the Genesis Person already in hand.
 *
 * Distinct from `provisionInvitee` on purpose. That one takes an email and knows no Person; this one
 * takes the Person and binds the account it creates to that exact `personId`, leaving the id, the
 * profile and every relation in place.
 */
export type InviteExistingPersonInput = {
  /** The confirmed recipient. A reserved placeholder address is refused. */
  email: Scalars['String']['input'];
  /** The Person to bind a login to. Their id never changes. */
  personId: Scalars['UUID']['input'];
  /** Idempotency key minted by the client, one per user-confirmed attempt. */
  requestId: Scalars['UUID']['input'];
};

export type JobDepartment = Node & {
  __typename?: 'JobDepartment';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type JobDepartment */
export type JobDepartmentFilterInput = {
  and?: InputMaybe<Array<JobDepartmentFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<JobDepartmentFilterInput>;
  or?: InputMaybe<Array<JobDepartmentFilterInput>>;
};

/** Contains information for linking 'JobDepartment' to other entities */
export type JobDepartmentRelationInput = {
  /** The identifier of 'JobDepartment' */
  id: Scalars['ID']['input'];
};

export type JobDepartmentSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type JobDepartmentsResult = {
  __typename?: 'JobDepartmentsResult';
  jobDepartments: Array<JobDepartment>;
};

/** The filterable fields of type JobDepartmentsResult */
export type JobDepartmentsResultFilterInput = {
  and?: InputMaybe<Array<JobDepartmentsResultFilterInput>>;
  not?: InputMaybe<JobDepartmentsResultFilterInput>;
  or?: InputMaybe<Array<JobDepartmentsResultFilterInput>>;
};

export type JobLocation = Node & {
  __typename?: 'JobLocation';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type JobLocation */
export type JobLocationFilterInput = {
  and?: InputMaybe<Array<JobLocationFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<JobLocationFilterInput>;
  or?: InputMaybe<Array<JobLocationFilterInput>>;
};

/** Contains information for linking 'JobLocation' to other entities */
export type JobLocationRelationInput = {
  /** The identifier of 'JobLocation' */
  id: Scalars['ID']['input'];
};

export type JobLocationSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type JobLocationsResult = {
  __typename?: 'JobLocationsResult';
  jobLocations: Array<JobLocation>;
};

/** The filterable fields of type JobLocationsResult */
export type JobLocationsResultFilterInput = {
  and?: InputMaybe<Array<JobLocationsResultFilterInput>>;
  not?: InputMaybe<JobLocationsResultFilterInput>;
  or?: InputMaybe<Array<JobLocationsResultFilterInput>>;
};

export type LanguageConditionInput = {
  languageTag: Scalars['String']['input'];
  level: ConditionLanguageLevel;
};

export type LanguageSkill = Node & {
  __typename?: 'LanguageSkill';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  cefr?: Maybe<CefrScale>;
  id: Scalars['ID']['output'];
  languageTag: Scalars['String']['output'];
  nativeSpeaker: Scalars['Boolean']['output'];
  person: Person;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  selfAssessed?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

/** The filterable fields of type LanguageSkill */
export type LanguageSkillFilterInput = {
  and?: InputMaybe<Array<LanguageSkillFilterInput>>;
  cefr?: InputMaybe<CefrScaleFilterInput>;
  languageTag?: InputMaybe<StringFilterInput>;
  nativeSpeaker?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<LanguageSkillFilterInput>;
  or?: InputMaybe<Array<LanguageSkillFilterInput>>;
};

/** Filtering options for a list of elements with type LanguageSkill */
export type LanguageSkillListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<LanguageSkillFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<LanguageSkillFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<LanguageSkillFilterInput>;
};

export type LinkProjectMatchInput = {
  /** Wählt den Weg wie bei `UpdateProjectInput.actingAsCompanyId` (genesis#418). */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  matchId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};

export type LinkProjectMatchOutput = LinkProjectMatchResult;

export type LinkProjectMatchResult = {
  __typename?: 'LinkProjectMatchResult';
  project: Project;
};

/** The filterable fields of type LinkProjectMatchResult */
export type LinkProjectMatchResultFilterInput = {
  and?: InputMaybe<Array<LinkProjectMatchResultFilterInput>>;
  not?: InputMaybe<LinkProjectMatchResultFilterInput>;
  or?: InputMaybe<Array<LinkProjectMatchResultFilterInput>>;
};

/**
 * Payload for the LinkedIn onboarding import mutation. Each client (Vaadin,
 * Android, iOS, Compose) runs its own LinkedIn OAuth flow — confidential-client
 * with PKCE for discovery, public-client PKCE for mobile — and forwards the
 * resulting {@code accessToken} here. The backend uses the token as a Bearer
 * credential to fetch the member's DMA snapshot, maps it to a
 * {@code BulkImportPersonInput}, and persists everything in a single
 * transaction via the internal bulk-import path. OAuth state (PKCE verifier,
 * nonce, client_secret) stays entirely on the client that initiated the flow.
 *
 * The optional {@code scope} field lets callers restrict the import to specific
 * collections / Person scalar fields. When omitted, every part of the DMA
 * snapshot is mapped.
 */
export type LinkedInImportInput = {
  accessToken: Scalars['String']['input'];
  scope?: InputMaybe<LinkedInImportScope>;
};

/**
 * Per-collection and per-Person-field scope flags for the LinkedIn import.
 * Each flag controls whether genesis maps and writes that portion of the
 * DMA snapshot. A null or missing flag is treated as {@code true} (import),
 * preserving backwards compatibility with clients that haven't been updated
 * to send a scope. Discovery uses these flags to skip collections/fields it
 * knows are already populated in the user's profile — saving the per-row
 * mapping work and aligning with the "only-if-empty" merge policy in
 * {@code BulkImportPersonService}.
 */
export type LinkedInImportScope = {
  importBio?: InputMaybe<Scalars['Boolean']['input']>;
  importCertificates?: InputMaybe<Scalars['Boolean']['input']>;
  importCurrentEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  importEducations?: InputMaybe<Scalars['Boolean']['input']>;
  importExperiences?: InputMaybe<Scalars['Boolean']['input']>;
  importExpertises?: InputMaybe<Scalars['Boolean']['input']>;
  importJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  importLanguageSkills?: InputMaybe<Scalars['Boolean']['input']>;
  importProfession?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalizedText = {
  __typename?: 'LocalizedText';
  english?: Maybe<Scalars['String']['output']>;
  german?: Maybe<Scalars['String']['output']>;
  localized?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type LocalizedText */
export type LocalizedTextFilterInput = {
  and?: InputMaybe<Array<LocalizedTextFilterInput>>;
  english?: InputMaybe<StringFilterInput>;
  german?: InputMaybe<StringFilterInput>;
  localized?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LocalizedTextFilterInput>;
  or?: InputMaybe<Array<LocalizedTextFilterInput>>;
};

export type LocalizedTextSortInput = {
  english?: InputMaybe<SortOrder>;
  german?: InputMaybe<SortOrder>;
  localized?: InputMaybe<SortOrder>;
};

export type MaritalStatus = Node & {
  __typename?: 'MaritalStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type MaritalStatus */
export type MaritalStatusFilterInput = {
  and?: InputMaybe<Array<MaritalStatusFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MaritalStatusFilterInput>;
  or?: InputMaybe<Array<MaritalStatusFilterInput>>;
};

/** Contains information for linking 'MaritalStatus' to other entities */
export type MaritalStatusRelationInput = {
  /** The identifier of 'MaritalStatus' */
  id: Scalars['ID']['input'];
};

export type MaritalStatusSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type MaritalStatusesResult = {
  __typename?: 'MaritalStatusesResult';
  maritalStatuses: Array<MaritalStatus>;
};

/** The filterable fields of type MaritalStatusesResult */
export type MaritalStatusesResultFilterInput = {
  and?: InputMaybe<Array<MaritalStatusesResultFilterInput>>;
  not?: InputMaybe<MaritalStatusesResultFilterInput>;
  or?: InputMaybe<Array<MaritalStatusesResultFilterInput>>;
};

export type MarkConversationReadInput = {
  conversationId: Scalars['UUID']['input'];
  lastReadMessageId: Scalars['UUID']['input'];
};

export type Match = Node & {
  __typename?: 'Match';
  /**
   * The whole truth about the match's access grants, never a delta: on `updateMatch` the list
   * replaces every existing grant, so a person left out of it loses access. An empty list revokes
   * everyone; `null` — like omitting the field — leaves the existing grants untouched (genesis#326).
   */
  access?: Maybe<Array<MatchAccess>>;
  actions: MatchActions;
  candidateCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The whole design as one JSON object; on `updateMatch` it replaces the stored design, except that
   * the attached `project.documents` survive. `null` — like omitting the field — leaves the stored
   * design untouched (genesis#407): a match without a design is not assessable, so there is no way to
   * clear it.
   */
  design?: Maybe<Scalars['Object']['output']>;
  id: Scalars['ID']['output'];
  matchMode?: Maybe<MatchMode>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Die Projekte, zu denen dieses Match gehört. Gegenrichtung von `Project.matches`, dieselbe
   * Relation `project_match`: eine Beziehung ist von beiden Seiten lesbar, sonst
   * weiß das Match nicht, wofür es angelegt wurde. `@readonly` wie drüben, gepflegt wird die
   * Zuordnung über linkProjectMatch/unlinkProjectMatch.
   */
  projects?: Maybe<Array<Project>>;
  sharedItem?: Maybe<SharedItem>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Person>;
};

export type MatchAccess = {
  __typename?: 'MatchAccess';
  design: AccessLevel;
  discover: AccessLevel;
  match: AccessLevel;
  person: Person;
  prepare: AccessLevel;
};

/** The filterable fields of type MatchAccess */
export type MatchAccessFilterInput = {
  and?: InputMaybe<Array<MatchAccessFilterInput>>;
  not?: InputMaybe<MatchAccessFilterInput>;
  or?: InputMaybe<Array<MatchAccessFilterInput>>;
};

/**
 * Effective authorization for this Match and the current caller. Independent of platform features,
 * Group roles and personal sharing. Result actions still respect each draft's creator-only privacy.
 */
export type MatchActions = {
  __typename?: 'MatchActions';
  canDelete: Scalars['Boolean']['output'];
  /** Existing visibility-based authorization to generate a transient result; does not imply permission to save it. */
  canGenerateResult: Scalars['Boolean']['output'];
  canLinkSharedItem: Scalars['Boolean']['output'];
  canManageAccess: Scalars['Boolean']['output'];
  canUpdateDesign: Scalars['Boolean']['output'];
  canUpdateDiscover: Scalars['Boolean']['output'];
  canUpdatePrepare: Scalars['Boolean']['output'];
  canUpdateResults: Scalars['Boolean']['output'];
};

/** The filterable fields of type MatchActions */
export type MatchActionsFilterInput = {
  and?: InputMaybe<Array<MatchActionsFilterInput>>;
  not?: InputMaybe<MatchActionsFilterInput>;
  or?: InputMaybe<Array<MatchActionsFilterInput>>;
};

export type MatchCandidate = Node & {
  __typename?: 'MatchCandidate';
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  matchId?: Maybe<Scalars['ID']['output']>;
  person?: Maybe<Person>;
};

export type MatchCandidateConnection = {
  __typename?: 'MatchCandidateConnection';
  edges: Array<MatchCandidateEdge>;
  nodes: Array<MatchCandidate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchCandidateEdge = {
  __typename?: 'MatchCandidateEdge';
  cursor: Scalars['String']['output'];
  node: MatchCandidate;
};

/** The filterable fields of type MatchCandidate */
export type MatchCandidateFilterInput = {
  and?: InputMaybe<Array<MatchCandidateFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  locked?: InputMaybe<BooleanFilterInput>;
  matchId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MatchCandidateFilterInput>;
  or?: InputMaybe<Array<MatchCandidateFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
};

/** The parameters for requesting multiple instances of MatchCandidate. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchCandidateQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchCandidateSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchCandidateFilterInput>;
};

export type MatchCandidateSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  formattedName?: InputMaybe<SortOrder>;
};

/**
 * A company pinned into one match's pool (concept v14, the company matching model).
 *
 * Deliberately its own type beside MatchCandidate rather than a nullable company on that one: the
 * person pool keeps its NOT NULL person and its uniqueness rule, and nothing already shipped inherits
 * a weaker guarantee.
 *
 * A company is only ever a PASSIVE candidate — it neither owns nor runs a match
 * (the company account model).
 */
export type MatchCompany = Node & {
  __typename?: 'MatchCompany';
  /**
   * The pinned company: its identity plus `employeeCount`, the value a size criterion is judged on.
   * `summary` is null here — see Company.employeeCount for the one exception this field makes.
   */
  company?: Maybe<Company>;
  id: Scalars['ID']['output'];
  match?: Maybe<Match>;
  matchId?: Maybe<Scalars['ID']['output']>;
};

export type MatchCompanyConnection = {
  __typename?: 'MatchCompanyConnection';
  edges: Array<MatchCompanyEdge>;
  nodes: Array<MatchCompany>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchCompanyEdge = {
  __typename?: 'MatchCompanyEdge';
  cursor: Scalars['String']['output'];
  node: MatchCompany;
};

/** The filterable fields of type MatchCompany */
export type MatchCompanyFilterInput = {
  and?: InputMaybe<Array<MatchCompanyFilterInput>>;
  /**
   * The pinned company: its identity plus `employeeCount`, the value a size criterion is judged on.
   * `summary` is null here — see Company.employeeCount for the one exception this field makes.
   */
  company?: InputMaybe<CompanyFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  matchId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MatchCompanyFilterInput>;
  or?: InputMaybe<Array<MatchCompanyFilterInput>>;
};

/** The parameters for requesting multiple instances of MatchCompany. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchCompanyQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchCompanySortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchCompanyFilterInput>;
};

export type MatchCompanySortInput = {
  createdAt?: InputMaybe<SortOrder>;
};

/**
 * One requirement to set on a match. The shared fields (operator, composition, active, requirement)
 * apply to every kind; EXACTLY ONE of the payload fields (integer / string / city / reference /
 * expertise / text / industryExperience / language) must be set — genesis rejects zero or multiple. The payload's
 * `kind` (where present) selects the concrete condition within its family.
 */
export type MatchConditionInput = {
  active: Scalars['Boolean']['input'];
  city?: InputMaybe<CityConditionInput>;
  composition: ConditionCompositionInput;
  expertise?: InputMaybe<ExpertiseConditionInput>;
  industryExperience?: InputMaybe<IndustryExperienceConditionInput>;
  integer?: InputMaybe<IntegerConditionInput>;
  language?: InputMaybe<LanguageConditionInput>;
  operator: ConditionOperator;
  reference?: InputMaybe<ReferenceConditionInput>;
  requirement?: InputMaybe<ConditionRequirement>;
  string?: InputMaybe<StringConditionInput>;
  text?: InputMaybe<TextConditionInput>;
};

export type MatchConnection = {
  __typename?: 'MatchConnection';
  edges: Array<MatchEdge>;
  nodes: Array<Match>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchEdge = {
  __typename?: 'MatchEdge';
  cursor: Scalars['String']['output'];
  node: Match;
};

/** The filterable fields of type Match */
export type MatchFilterInput = {
  and?: InputMaybe<Array<MatchFilterInput>>;
  description?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MatchFilterInput>;
  or?: InputMaybe<Array<MatchFilterInput>>;
};

/**
 * Match mode, chosen at creation and immutable thereafter. Drives the solver's assessOnly:
 * ASSESS and RANK -> assessOnly=true, OPTIMIZE -> false. RANK is the renamed former APPLY token.
 * RANK_COMPANIES is not on that axis at all: it takes its own arm of the run, which never reaches the
 * solver, so there is no assessOnly to set for it.
 *
 * RANK_COMPANIES ranks COMPANIES instead of people (concept v14, the company matching model).
 * Its candidates are the match's company pool, never `match_candidate`, and it never reaches the solver:
 * every company is evaluated on its own against the requirement profile. A company is only ever a
 * PASSIVE candidate — a company neither owns nor runs a match (the company account model), so this token
 * says nothing about who created the match.
 */
export enum MatchMode {
  Assess = 'ASSESS',
  Optimize = 'OPTIMIZE',
  Rank = 'RANK',
  RankCompanies = 'RANK_COMPANIES'
}

/** The parameters for requesting multiple instances of Match. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchFilterInput>;
};

/** Contains information for linking 'Match' to other entities */
export type MatchRelationInput = {
  /** The identifier of 'Match' */
  id: Scalars['ID']['input'];
};

export type MatchResult = Node & {
  __typename?: 'MatchResult';
  candidateCount?: Maybe<Scalars['Int']['output']>;
  companies?: Maybe<Array<MatchResultCompany>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  design?: Maybe<Scalars['Object']['output']>;
  hiddenSections?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  kept?: Maybe<Scalars['Boolean']['output']>;
  /** Das Match, zu dem dieses Ergebnis gehört. Die Spalte gab es immer, nach aussen sichtbar war sie nicht - ohne sie kann ein Aufrufer eine Ergebnisliste nicht ihren Matches zuordnen. */
  matchId?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<MatchResultTeam>>;
  usesOrganizationalRecord?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * One company's place in a saved ranking (concept v14, the company matching model).
 *
 * A company match produces a RANKED LIST, not a team, and @adr GENESIS-0028-a-partner-set-is-its-own-relation@3 forbids persisting that ranking
 * as a MatchResultTeam: a team is an ASSEMBLY the solver picks jointly and whose members are people,
 * while a ranking is an ORDER over candidates each judged on its own. So this is its own relation off
 * the same MatchResult, exactly as MatchResultTeam is - one row per company, carrying its own position.
 *
 * Read-only: rows are written by the run that produced them and never edited afterwards.
 */
export type MatchResultCompany = {
  __typename?: 'MatchResultCompany';
  /**
   *   The ranked company. Null only when the caller did not select it deeply enough to be loaded; the
   *   foreign key means the row itself always has one.
   *
   * Its identity plus `employeeCount`, as on MatchCompany.company; `summary` is null here.
   */
  company?: Maybe<Company>;
  /**
   * Identifies this ranking row. Deliberately NOT called `companyId` - that name would read as the id of
   * the company below, which is a different thing. Mirrors MatchResultTeam.teamId in role.
   */
  entryId: Scalars['UUID']['output'];
  /** 1-based place in the ranking, contiguous within one result. Stored, not derived from `result`. */
  position: Scalars['Int']['output'];
  /**
   *   Why this company sits where it sits: the per-criterion breakdown atoms (@external-adr SPARK-0030-match-result-scoring-atom-derived §2) - for each
   *   company criterion whether it is met, PARTLY met, not met, or CANNOT TELL, its degree of fulfilment,
   *   the ACTUAL value the run found on the company (`actual`), and the AI's reason where a hard check
   *   could not settle it. Percentages and A/B/C bands are derived from these at render time and
   *   deliberately not stored. Same role as MatchResultTeam.result on the person side.
   *
   * PARTLY met is a real outcome here, not a placeholder for a future criterion: an expertise criterion
   *   whose wording matched at a degree BELOW the required minimum yields it, with a fulfilment strictly
   *   between 0 and 1. Read it as a MEASUREMENT under the requirement rather than as missing information -
   *   for a MUST criterion the Muss gate fails on it, exactly as it does on the person side (@external-adr SPARK-0030-match-result-scoring-atom-derived §1),
   *   and the stored `position` orders it accordingly. Only CANNOT TELL means "nothing could be assessed".
   *
   * `actual` is a displayable raw value per criterion kind - the same convention as the person side's
   *   breakdown items: the industry as its id (resolve the name from your own reference data), the
   *   employee count as a number, an expertise as the COMPANY's own matching label plus its stored
   *   0..100 degree. It is the state AT THE TIME OF THE RUN, so a saved ranking keeps printing what was
   *   judged rather than what the company says today. A key that is present but null means "recorded,
   *   and there is none" - for an expertise criterion: nothing the company lists matched the wording. A
   *   MISSING key means the run recorded no actual values at all (a ranking stored before they existed);
   *   the two must not be shown as the same sentence. Only the matching entry is carried, never a
   *   company's full competency list.
   */
  result?: Maybe<Scalars['Object']['output']>;
};

/** The filterable fields of type MatchResultCompany */
export type MatchResultCompanyFilterInput = {
  and?: InputMaybe<Array<MatchResultCompanyFilterInput>>;
  not?: InputMaybe<MatchResultCompanyFilterInput>;
  or?: InputMaybe<Array<MatchResultCompanyFilterInput>>;
};

export type MatchResultConnection = {
  __typename?: 'MatchResultConnection';
  edges: Array<MatchResultEdge>;
  nodes: Array<MatchResult>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchResultEdge = {
  __typename?: 'MatchResultEdge';
  cursor: Scalars['String']['output'];
  node: MatchResult;
};

/** The filterable fields of type MatchResult */
export type MatchResultFilterInput = {
  and?: InputMaybe<Array<MatchResultFilterInput>>;
  kept?: InputMaybe<BooleanFilterInput>;
  matchId?: InputMaybe<UuidFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MatchResultFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<MatchResultFilterInput>>;
};

/** The parameters for requesting multiple instances of MatchResult. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchResultQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchResultSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchResultFilterInput>;
};

export type MatchResultSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type MatchResultTeam = {
  __typename?: 'MatchResultTeam';
  persons?: Maybe<Array<Maybe<Person>>>;
  result?: Maybe<Scalars['Object']['output']>;
  teamId: Scalars['UUID']['output'];
};

/** The filterable fields of type MatchResultTeam */
export type MatchResultTeamFilterInput = {
  and?: InputMaybe<Array<MatchResultTeamFilterInput>>;
  not?: InputMaybe<MatchResultTeamFilterInput>;
  or?: InputMaybe<Array<MatchResultTeamFilterInput>>;
};

export type MatchSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MicrosoftAccountKind {
  Company = 'COMPANY',
  Personal = 'PERSONAL'
}

export type MicrosoftCalendarConfiguration = {
  __typename?: 'MicrosoftCalendarConfiguration';
  clientId: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** The filterable fields of type MicrosoftCalendarConfiguration */
export type MicrosoftCalendarConfigurationFilterInput = {
  and?: InputMaybe<Array<MicrosoftCalendarConfigurationFilterInput>>;
  not?: InputMaybe<MicrosoftCalendarConfigurationFilterInput>;
  or?: InputMaybe<Array<MicrosoftCalendarConfigurationFilterInput>>;
};

export type MicrosoftCalendarConnection = {
  __typename?: 'MicrosoftCalendarConnection';
  checkedAt?: Maybe<Scalars['String']['output']>;
  configured: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mailAvailable: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  teamsAvailable: Scalars['Boolean']['output'];
};

/** The filterable fields of type MicrosoftCalendarConnection */
export type MicrosoftCalendarConnectionFilterInput = {
  and?: InputMaybe<Array<MicrosoftCalendarConnectionFilterInput>>;
  not?: InputMaybe<MicrosoftCalendarConnectionFilterInput>;
  or?: InputMaybe<Array<MicrosoftCalendarConnectionFilterInput>>;
};

export type MicrosoftCalendarEvent = {
  __typename?: 'MicrosoftCalendarEvent';
  allDay: Scalars['Boolean']['output'];
  end: Scalars['String']['output'];
  id: Scalars['String']['output'];
  privateEvent: Scalars['Boolean']['output'];
  showAs: Scalars['String']['output'];
  start: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  webUrl: Scalars['String']['output'];
};

/** The filterable fields of type MicrosoftCalendarEvent */
export type MicrosoftCalendarEventFilterInput = {
  and?: InputMaybe<Array<MicrosoftCalendarEventFilterInput>>;
  not?: InputMaybe<MicrosoftCalendarEventFilterInput>;
  or?: InputMaybe<Array<MicrosoftCalendarEventFilterInput>>;
};

export type MicrosoftCalendarView = {
  __typename?: 'MicrosoftCalendarView';
  end: Scalars['String']['output'];
  events: Array<MicrosoftCalendarEvent>;
  fetchedAt: Scalars['String']['output'];
  organizerEmail: Scalars['String']['output'];
  start: Scalars['String']['output'];
  truncated: Scalars['Boolean']['output'];
};

/** The filterable fields of type MicrosoftCalendarView */
export type MicrosoftCalendarViewFilterInput = {
  and?: InputMaybe<Array<MicrosoftCalendarViewFilterInput>>;
  not?: InputMaybe<MicrosoftCalendarViewFilterInput>;
  or?: InputMaybe<Array<MicrosoftCalendarViewFilterInput>>;
};

export type MicrosoftMessageInput = {
  accountKind?: InputMaybe<MicrosoftAccountKind>;
  end?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  organizerEmail: Scalars['String']['input'];
  recipients: Array<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  teams: Scalars['Boolean']['input'];
};

export type MicrosoftMessageResult = {
  __typename?: 'MicrosoftMessageResult';
  joinUrl?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  webUrl?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type MicrosoftMessageResult */
export type MicrosoftMessageResultFilterInput = {
  and?: InputMaybe<Array<MicrosoftMessageResultFilterInput>>;
  not?: InputMaybe<MicrosoftMessageResultFilterInput>;
  or?: InputMaybe<Array<MicrosoftMessageResultFilterInput>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Executes a notification action, such as accepting or rejecting a contact request. */
  actOnNotification: Notification;
  addAccessGroupMember: AccessGroupMember;
  addCompanyMember: CompanyMembership;
  addContacts?: Maybe<AddContactsOutput>;
  addPins?: Maybe<AddPinsOutput>;
  applyOrganizationalPowerAnalysis: OrganizationalPowerAnalysis;
  assignAccessGroupRole: AccessGroupRoleAssignment;
  /**
   * Assigns a person's manager, or clears it — the other half of the `write:access-config` per-person org
   * surface (genesis#257). A manager chain that would form a cycle is refused.
   */
  assignManager: AssignManagerOutput;
  /**
   * Assigns a person to an OrgUnit, or clears it — the fast-moving half of the `write:access-config` HR-org
   * surface (genesis#257, `@adr GENESIS-0065-all-group-consent-is-explicit-and-dynamic@1` §8). Org data is an input to
   * the visibility arm, never an enforcement authority in itself.
   */
  assignOrgUnit: AssignOrgUnitOutput;
  /** Assigns a questionnaire to a group, moves it to a different one, or removes it from its group. Requires the `write:questionnaire` permission. */
  assignQuestionnaireToGroup: Questionnaire;
  /**
   * Uploads inline file content to backdrop server-side and appends one entry per file to
   * MatchDesign.project.documents. The uploaded blob is owned by the match owner regardless of
   * who invokes this mutation. Not deduplicated: identical bytes uploaded twice produce two
   * entries with distinct backdropFileIds. Caller needs design-write access on the match.
   */
  attachProjectDocument: AttachProjectDocumentOutput;
  /**
   * Bulk-imports a person's Experience / Education / LanguageSkill / Certificate /
   * Expertise collections plus an optional personDetail fragment in a single
   * transaction. Per-collection merge policy: only populate collections that are
   * currently empty for the target person; non-empty collections are left
   * untouched and their name is returned in `skipped`. Used by provider-specific
   * importers (LinkedIn, vCard, CSV, …) to populate a profile in one round-trip
   * with atomic rollback on any server-side failure.
   */
  bulkImportPerson: BulkImportPersonResult;
  checkMicrosoftCalendar: MicrosoftCalendarConnection;
  connectMicrosoftCalendar: MicrosoftCalendarConnection;
  createAccessGroup: AccessGroup;
  /** Creates a custom Role and its Permission bundle atomically, guarded by write:access-config. */
  createAccessRole: AccessRole;
  /** Creates a new agent instance */
  createAgent: CreateAgentOutput;
  /** Creates a new certificate instance */
  createCertificate: CreateCertificateOutput;
  /** Creates a new company instance */
  createCompany: CreateCompanyOutput;
  /** Creates a new contracttype instance */
  createContractType: CreateContractTypeOutput;
  createConversation: Conversation;
  /** Creates a new curriculumvitae instance */
  createCurriculumVitae: CreateCurriculumVitaeOutput;
  /** Creates a new degree instance */
  createDegree: CreateDegreeOutput;
  /** Creates a new discoverycategory instance */
  createDiscoveryCategory: CreateDiscoveryCategoryOutput;
  /** Creates a new document instance */
  createDocument: CreateDocumentOutput;
  /** Creates a new documentgroup instance */
  createDocumentGroup: CreateDocumentGroupOutput;
  /** Creates a new education instance */
  createEducation: CreateEducationOutput;
  /** Creates a new experience instance */
  createExperience: CreateExperienceOutput;
  /** Creates a new expertise instance */
  createExpertise: CreateExpertiseOutput;
  /** Creates a new gender instance */
  createGender: CreateGenderOutput;
  /** Creates a new industry instance */
  createIndustry: CreateIndustryOutput;
  /** Creates a new jobdepartment instance */
  createJobDepartment: CreateJobDepartmentOutput;
  /** Creates a new joblocation instance */
  createJobLocation: CreateJobLocationOutput;
  /** Creates a new languageskill instance */
  createLanguageSkill: CreateLanguageSkillOutput;
  /** Creates a new maritalstatus instance */
  createMaritalStatus: CreateMaritalStatusOutput;
  /** Creates a new match instance */
  createMatch: CreateMatchOutput;
  /** Creates a new matchcandidate instance */
  createMatchCandidate: CreateMatchCandidateOutput;
  createMatchCandidates?: Maybe<CreateMatchCandidatesOutput>;
  createMatchCompanies?: Maybe<CreateMatchCompaniesOutput>;
  /** Creates a new matchcompany instance */
  createMatchCompany: CreateMatchCompanyOutput;
  /** Creates a new matchresult instance */
  createMatchResult: CreateMatchResultOutput;
  /** Creates a new orgunit instance */
  createOrgUnit: CreateOrgUnitOutput;
  /**
   * Creates the organisational record about one subject, or returns the existing one: exactly one of `personId` and
   * `companyId` must be set. Requires `write:organizational-record`.
   */
  createOrganizationalRecord: OrganizationalRecord;
  createOrganizationalRecordComment: OrganizationalRecordComment;
  createOrganizationalRecordDocument: OrganizationalRecordDocument;
  createOrganizationalRecordEntry: OrganizationalRecordEntry;
  /** Creates a new person instance */
  createPerson: CreatePersonOutput;
  /** Creates a new persongroup instance */
  createPersonGroup: CreatePersonGroupOutput;
  /** Creates a new pingroup instance */
  createPinGroup: CreatePinGroupOutput;
  /** Creates a new project instance */
  createProject: CreateProjectOutput;
  /** Creates a new shareditem instance */
  createSharedItem: CreateSharedItemOutput;
  /** Creates a new shareditemcomment instance */
  createSharedItemComment: CreateSharedItemCommentOutput;
  /** Creates a new studionotebook instance */
  createStudioNotebook: CreateStudioNotebookOutput;
  /** Creates a new teamprofile instance */
  createTeamProfile: CreateTeamProfileOutput;
  /** Creates a new workingtimemodel instance */
  createWorkingTimeModel: CreateWorkingTimeModelOutput;
  deleteAccessGroup: Scalars['Boolean']['output'];
  deleteAccessRole: Scalars['Boolean']['output'];
  /** Deletes existing instances of agent */
  deleteAgent: DeleteAgentOutput;
  /**
   * Deletes every notification from the current user's inbox except those still awaiting a
   * decision from the user, such as an unanswered contact request: those are kept so they stay
   * answerable (see Notification.deletable). Only notifications of the supplied types are
   * affected, and an explicitly empty supportedTypes list affects nothing. Returns the number of
   * notifications deleted.
   */
  deleteAllNotifications: Scalars['Int']['output'];
  /** Deletes existing instances of certificate */
  deleteCertificate: DeleteCertificateOutput;
  /** Deletes existing instances of company */
  deleteCompany: DeleteCompanyOutput;
  /** Deletes existing instances of contracttype */
  deleteContractType: DeleteContractTypeOutput;
  deleteConversation: Scalars['Boolean']['output'];
  /** Deletes existing instances of curriculumvitae */
  deleteCurriculumVitae: DeleteCurriculumVitaeOutput;
  /** Deletes existing instances of degree */
  deleteDegree: DeleteDegreeOutput;
  /** Deletes existing instances of discoverycategory */
  deleteDiscoveryCategory: DeleteDiscoveryCategoryOutput;
  /** Deletes existing instances of document */
  deleteDocument: DeleteDocumentOutput;
  /** Deletes existing instances of documentgroup */
  deleteDocumentGroup: DeleteDocumentGroupOutput;
  /** Deletes existing instances of education */
  deleteEducation: DeleteEducationOutput;
  /** Deletes existing instances of experience */
  deleteExperience: DeleteExperienceOutput;
  /** Deletes existing instances of expertise */
  deleteExpertise: DeleteExpertiseOutput;
  /** Deletes existing instances of gender */
  deleteGender: DeleteGenderOutput;
  /** Deletes existing instances of industry */
  deleteIndustry: DeleteIndustryOutput;
  /** Deletes existing instances of jobdepartment */
  deleteJobDepartment: DeleteJobDepartmentOutput;
  /** Deletes existing instances of joblocation */
  deleteJobLocation: DeleteJobLocationOutput;
  /** Deletes existing instances of languageskill */
  deleteLanguageSkill: DeleteLanguageSkillOutput;
  /** Deletes existing instances of maritalstatus */
  deleteMaritalStatus: DeleteMaritalStatusOutput;
  /** Deletes existing instances of match */
  deleteMatch: DeleteMatchOutput;
  /** Deletes existing instances of matchcandidate */
  deleteMatchCandidate: DeleteMatchCandidateOutput;
  deleteMatchCandidates?: Maybe<DeleteMatchCandidatesOutput>;
  deleteMatchCompanies?: Maybe<DeleteMatchCompaniesOutput>;
  /** Deletes existing instances of matchcompany */
  deleteMatchCompany: DeleteMatchCompanyOutput;
  /** Deletes existing instances of matchresult */
  deleteMatchResult: DeleteMatchResultOutput;
  /** Removes one of the caller's favourites. */
  deleteMyFavorite: Scalars['UUID']['output'];
  /** Deletes a notification from the current user's inbox. */
  deleteNotification: Notification;
  /** Deletes existing instances of orgunit */
  deleteOrgUnit: DeleteOrgUnitOutput;
  deleteOrganizationalRecordComment: Scalars['ID']['output'];
  deleteOrganizationalRecordDocument: Scalars['ID']['output'];
  deleteOrganizationalRecordEntry: Scalars['ID']['output'];
  /** Deletes existing instances of person */
  deletePerson: DeletePersonOutput;
  /** Deletes existing instances of persongroup */
  deletePersonGroup: DeletePersonGroupOutput;
  /** Deletes existing instances of pingroup */
  deletePinGroup: DeletePinGroupOutput;
  /** Deletes existing instances of project */
  deleteProject: DeleteProjectOutput;
  /** Hard-deletes a questionnaire tree if no results exist for it; otherwise marks it as DELETED. Returns true if hard-deleted, false if soft-deleted. */
  deleteQuestionnaire: Scalars['Boolean']['output'];
  /** Deletes a group and ungroups its questionnaires; the questionnaires and every answer given to them survive (same shape as deleteDocumentGroup). Requires the `write:questionnaire` permission. */
  deleteQuestionnaireGroup: Scalars['Boolean']['output'];
  /** Deletes existing instances of shareditem */
  deleteSharedItem: DeleteSharedItemOutput;
  /** Deletes existing instances of shareditemcomment */
  deleteSharedItemComment: DeleteSharedItemCommentOutput;
  /** Deletes existing instances of studionotebook */
  deleteStudioNotebook: DeleteStudioNotebookOutput;
  /** Deletes existing instances of teamprofile */
  deleteTeamProfile: DeleteTeamProfileOutput;
  /** Deletes existing instances of workingtimemodel */
  deleteWorkingTimeModel: DeleteWorkingTimeModelOutput;
  /**
   * Removes a document from a match's Project.documents by backdropFileId. No-op if absent.
   * Triggers deletion of the backdrop blob as a fire-and-forget side effect. Caller needs
   * design-write access on the match.
   */
  detachProjectDocument: DetachProjectDocumentOutput;
  disconnectMicrosoftCalendar: Scalars['Boolean']['output'];
  /** Extract a profile from a single uploaded document (CV, LinkedIn export, application form, biography, …). Returns the same two-sided ProfileImportPreview as previewLinkedInImport — a per-field / per-row diff against the caller's existing Person. The mutation persists nothing; the frontend reviews the diff and applies accepted changes via the ordinary updatePerson / createExperience / … mutations. */
  extractProfileFromDocument: ProfileImportPreview;
  /**
   * Replaces the caller's favourites of the session's domain with entries, best first, and completes the session in
   * one transaction. A toplist finishes with exactly ten entries. The same catalogue item twice, or the same own title
   * twice regardless of case and surrounding spaces, is refused. The toplist's sharing is kept: a replay replaces the
   * entries, never who may read them. On a session that is already complete it writes nothing and returns the
   * favourites.
   */
  finishToplistSession: Array<Favorite>;
  generateAIRequirements?: Maybe<GenerateAiRequirementsOutput>;
  /** Run the team-matching solver for the given match and persist the result as an unsaved draft (kept:false), replacing any prior draft for this (match, user). Not idempotent — the solve runs once and writes. */
  generateTransientMatchResult?: Maybe<MatchResult>;
  heartbeatConversationPresence: PresenceIndicator;
  /** Requires `write:import`. Extracts each uploaded CV and persists it — updating the person matched by primary email (filling only empty fields/collections) or creating a new candidate Person when there is no unambiguous match. Returns a per-file outcome; a failed file never aborts the others. */
  importCvBatch: CvBatchImportResult;
  /**
   * Full-fidelity import of a multi-document YAML payload through the genesis importer
   * engine, acting as the authenticated principal (used for created_by / updated_by).
   * Unlike bulkImportPerson, this spans all entity kinds (reference data, persons,
   * documents, …) and honours per-document insert / update / merge / delete operations.
   * By default the whole payload is one transaction; see `mode` for the optional partial
   * import. Operator/admin use (requires reference-data write permission).
   */
  importDocuments: ImportDocumentsResult;
  /**
   * Imports the authenticated user's LinkedIn profile. The backend exchanges the
   * OAuth authorization code for an access token, fetches the DMA snapshot from
   * LinkedIn, maps it, and persists everything in a single transaction using
   * the same merge policy as bulkImportPerson. Returns the aggregated import
   * result so callers can surface per-collection skipped / warnings to the user.
   */
  importLinkedInProfile: BulkImportPersonResult;
  /**
   *   Binds a new external login to an EXISTING Person and sends their onboarding mail.
   *
   * Needs both `provision:invitee` and write access to that exact Person. The Person's id, profile and
   *   relations are untouched: the mutation writes `person.subject_id` (the binding) and
   *   `person.primary_email` (the confirmed login address), and nothing else. The mail goes out only after
   *   the binding is durably stored, so a send failure leaves a resumable state rather than an account
   *   nobody can reach.
   *
   * Idempotent per `requestId`: a repeated or concurrent call with the same key never creates a second
   *   account and never deliberately sends a second mail. An address already used by another account is
   *   `EMAIL_CONFLICT`: this flow never merges two identities because they share a mailbox.
   */
  inviteExistingPerson: PersonLoginInvitationOutput;
  /**
   * Verknüpft ein bestehendes Match mit einem Projekt. Die Beziehung liegt in der Relation
   * project_match, nicht im JSONB-Dokument des Projekts: sie braucht
   * referentielle Integrität und die Abfrage in beide Richtungen. Zweimal dieselbe Verknüpfung ist
   * kein Fehler, sondern folgenlos. Aufrufer braucht Schreibrecht auf den Plan des Projekts oder, bei einem
   * Firmenprojekt, die Admin-Rolle der Firma im Firmenkontext (`actingAsCompanyId`).
   */
  linkProjectMatch: LinkProjectMatchOutput;
  /**
   * Marks every unread notification in the current user's inbox as read. Only notifications of the
   * supplied types are affected, mirroring the filter applied by notifications and
   * unreadNotificationCount; an explicitly empty supportedTypes list affects nothing. Returns the
   * number of notifications that changed from unread to read.
   */
  markAllNotificationsRead: Scalars['Int']['output'];
  markConversationRead: ConversationReadReceipt;
  /** Marks a notification as read. */
  markNotificationRead: Notification;
  /**
   * Computes a non-destructive preview of a LinkedIn import for the authenticated user:
   * fetches the full DMA snapshot, maps it, and diffs it against existing data per field
   * and per collection row. Nothing is written and no server-side state is kept. The client
   * reviews and edits the returned proposals, then persists the accepted ones through the
   * ordinary profile mutations (updatePerson, createExperience, …) — the same write path as
   * manual editing. Re-run before saving to keep a retry idempotent: already-saved rows come
   * back UNCHANGED (matched by natural key).
   */
  previewLinkedInImport: ProfileImportPreview;
  /**
   * Synchronous variant of the powers/skills extraction: holds the HTTP request open for the
   * full pipeline duration (minutes). Superseded by startDocumentsExtraction +
   * documentsExtractionEvents; kept until all clients have migrated.
   */
  processDocuments?: Maybe<ProcessDocumentsOutput>;
  /**
   * Provisions one external invitee: creates their login and sends the onboarding email. Requires the
   * caller to hold the `provision:invitee` permission. Acting as the genesis service account, Genesis
   * runs the Keycloak Admin recipe: a brand-new email creates an enabled, credential-less user in
   * `invited-outsiders` and sends a 72h action-token link (UPDATE_PROFILE, UPDATE_PASSWORD, VERIFY_EMAIL);
   * a still-pending invitee's link is re-sent (idempotent); an established account is rejected (CONFLICT)
   * and left untouched — firing UPDATE_PASSWORD at a live account would be a password-reset vector. The
   * invitee always lands EXTERNAL by construction: this sets only the Keycloak group, and the Genesis
   * Group membership follows on the invitee's first login (EXTERNAL-Person); no input can make them internal.
   */
  provisionInvitee: ProvisionInviteeOutput;
  /** Makes a group visible in Grow. Requires the `write:questionnaire` permission. */
  publishQuestionnaireGroup: QuestionnaireGroup;
  rateSharedItem?: Maybe<RateSharedItemOutput>;
  /** Registers a device token for push notifications. Overwrites if the token already exists for another user. */
  registerDeviceToken: Scalars['Boolean']['output'];
  removeAccessGroupMember: AccessGroupMember;
  removeAccessGroupRole: Scalars['Boolean']['output'];
  removeCompanyCompetency: Scalars['Boolean']['output'];
  removeCompanyMember: Scalars['Boolean']['output'];
  removeContacts?: Maybe<RemoveContactsOutput>;
  removePins?: Maybe<RemovePinsOutput>;
  /** Creates a contact-request notification for another user. */
  requestContact: Notification;
  /** Creates contact-request notifications for multiple users. */
  requestContacts: Array<Notification>;
  /**
   * Re-sends a still-pending invitation for an existing Person, to a recipient re-confirmed in the
   * dialog. Changing the recipient rewrites the pending account's address and resets its verified flag;
   * an account that has meanwhile been set up is refused (`ACCOUNT_CHANGED`) rather than being sent a
   * password action, which would be a reset vector.
   */
  resendExistingPersonInvitation: PersonLoginInvitationOutput;
  /** Abandons the caller's open session of this game, if any, and starts a new one in the same transaction. */
  restartGameSession: GameSession;
  /** Upserts a questionnaire and its questions + answer choices. Null UUIDs mean create; existing UUIDs update in place. Rows in the DB that are not in the payload are left untouched. */
  saveQuestionnaire: SaveQuestionnaireOutput;
  /** Creates or updates a questionnaire group, including its artwork. A newly created group is always DRAFT. Creating past the configured group limit answers with TooManyRecordsResult instead; updating an existing group is never limited, and the limit is reported for a dry run too. Requires the `write:questionnaire` permission. */
  saveQuestionnaireGroup: SaveQuestionnaireGroupOutput;
  /** Persists the current user's chosen answer for one or more questionnaire questions. For each item, replaces any prior answer the user gave to the same question (delete-then-insert). */
  saveQuestionnaireResults: Scalars['Boolean']['output'];
  saveSelfAssessmentResults: Scalars['Boolean']['output'];
  /** Stores the client's snapshot of an open toplist session (at most 64 KiB) and its active play time. */
  saveToplistProgress: ToplistSession;
  sendChatMessage: ChatMessage;
  sendMicrosoftMessage: MicrosoftMessageResult;
  setCompanyCompetency: CompanyCompetency;
  /**
   *   Mark or unmark an existing member as one of the company's contact persons
   *   (the company page: referenced members, a capped set).
   *
   * CAPPED PER COMPANY, refused with a validation error once one more is marked. Unmarking is the
   *   same mutation with `contactPerson: false` and is never refused.
   *
   * Gated on an admin membership row for this company and nothing else
   *   (@adr GENESIS-0023-company-membership-is-the-per-company-authorization@4) — the platform role
   *   create:company confers nothing here. The mark decides ordering on the page, not visibility: since
   *   concept v5 a contact person is shown because they are a member, like everybody else on the roster.
   */
  setCompanyContactPerson: CompanyMembership;
  setCompanyMemberRole: CompanyMembership;
  setConversationTyping: TypingIndicator;
  setGroupSharingEligibility: PersonalSharingRecipient;
  /**
   * Replaces only MatchDesign.companyConditions on a RANK_COMPANIES match. Other design fields and
   * attached documents are preserved; expertise uses the existing Agentic AI setting. Each input
   * sets exactly one company payload. Caller needs design-write access on the match.
   */
  setMatchCompanyConditions: SetMatchCompanyConditionsOutput;
  /**
   * Replaces a match's requirements (MatchDesign.conditions) with the given typed conditions, merged
   * into the existing design server-side — team size, project and notes are preserved. Each condition
   * must set EXACTLY ONE payload field; genesis rejects zero or multiple. Caller needs design-write
   * access on the match.
   */
  setMatchConditions: SetMatchConditionsOutput;
  /**
   * Sets a match's notes (aiCopilotText) by merging only that field into the existing MatchDesign
   * server-side — every other design field is preserved. Pass null to clear the notes. Caller needs
   * design-write access on the match.
   */
  setMatchNotes: SetMatchNotesOutput;
  /**
   * Sets a match's project brief text (name, shortDescription, description) by merging only the
   * provided fields into the existing MatchDesign.project server-side — any field left null is kept
   * as-is, and MatchDesign.project.documents is always preserved (documents are owned by
   * attach/detachProjectDocument). Pass an empty string to clear a field. Intent-scoped alternative
   * to updateMatch(design)'s whole-blob replace. Destructive overwrite of the fields you do pass —
   * UI/assistant must confirm with the user first. Caller needs design-write access on the match.
   */
  setMatchProject: SetMatchProjectOutput;
  /**
   * Sets a match's team size (and optionally team count) by merging only those fields into the
   * existing MatchDesign server-side — every other design field (conditions, project, notes) is
   * preserved. Intent-scoped alternative to updateMatch(design)'s whole-blob replace. Caller needs
   * design-write access on the match.
   */
  setMatchTeamSize: SetMatchTeamSizeOutput;
  /**
   * Sets who may read the caller's toplist of a domain, like a profile entry's sharing: omitted fields keep their
   * value, an explicit empty sharedWith revokes Group readership, and a sharedWith without allGroups leaves All mode.
   * The toplist must exist, i.e. have been finished once.
   */
  setMyToplistSharing: Toplist;
  setPersonalSharing: PersonalSharing;
  signUpSharedProject?: Maybe<SignUpSharedProjectOutput>;
  /**
   * Starts the powers/skills extraction as a detached background job and returns immediately
   * with a QUEUED ExtractionJob. Progress and the final result are delivered via the
   * documentsExtractionEvents subscription; an EXTRACTION_COMPLETED / EXTRACTION_FAILED
   * notification fires on the terminal transition as the durable fallback for closed tabs.
   * Pipeline semantics (per-person lock, per-document evidence skip, sequential
   * powers → skills) are identical to processDocuments.
   */
  startDocumentsExtraction: ExtractionJob;
  /**
   *   File drop for the YAML importer: detects the file type, then hands a YAML payload to the same
   *   worker `startImportDocuments` uses. No processing of its own happens here.
   *
   * The detection is fail-closed: the file name extension, the declared MIME type and the actual
   *   leading bytes must agree, so a PDF cannot be imported as YAML by renaming it or by mislabelling
   *   its MIME type. Empty, unknown and unsupported files are rejected before any job is created.
   *
   * The YAML importer is currently the only route this drop starts. PDF and DOCX files are
   *   recognized by the detection but rejected with a validation error before any job is created;
   *   routing them into the documents extraction (`startDocumentsExtraction`) is a deliberate product
   *   decision still open, which is why `ImportFileType` and `FileImportRoute` already model them.
   *
   * Admission: the payload size cap and the reference-data write permission are checked before the
   *   content is even inspected, then the same permission gates and the document-count cap of
   *   `startImportDocuments` apply. Returns immediately with the QUEUED job; progress arrives through
   *   `importJobEvents` or `fileImportJob`, and the usual notification fires on the terminal transition.
   */
  startFileImport: FileImportJob;
  /** Returns the caller's open session of this game, or starts one. Expired sessions do not count as open. */
  startGameSession: GameSession;
  /** Starts the same YAML import as a detached background job and returns immediately. */
  startImportDocuments: ImportJob;
  startOrganizationalPowerAnalysis: OrganizationalPowerAnalysis;
  /**
   * Copies a share item's Project text fields (name, short-description, description) into the
   * target match's MatchDesign.project (name, shortDescription, description) and sets
   * Match.sharedItem. Destructive overwrite of those text fields — UI must confirm with the
   * user. Existing MatchDesign.project.documents are preserved (documents are owned by
   * attach/detach, not by takeover). Share item documents are not copied in v1.
   */
  takeOverSharedItem: TakeOverSharedItemOutput;
  /** Löst die Verknüpfung wieder. Das Match selbst bleibt unangetastet. */
  unlinkProjectMatch: UnlinkProjectMatchOutput;
  /** Takes a group back to DRAFT, hiding it from every user including those mid-questionnaire. Answers already given are kept and keep counting towards the score. Requires the `write:questionnaire` permission. */
  unpublishQuestionnaireGroup: QuestionnaireGroup;
  /** Removes a device token. Called on logout. */
  unregisterDeviceToken: Scalars['Boolean']['output'];
  updateAccessGroup: AccessGroup;
  updateAccessRole: AccessRole;
  /** Updates an existing agent instance */
  updateAgent: UpdateAgentOutput;
  /** Updates an existing certificate instance */
  updateCertificate: UpdateCertificateOutput;
  /** Updates an existing company instance */
  updateCompany: UpdateCompanyOutput;
  /** Updates an existing contracttype instance */
  updateContractType: UpdateContractTypeOutput;
  /** Updates an existing curriculumvitae instance */
  updateCurriculumVitae: UpdateCurriculumVitaeOutput;
  /** Updates an existing degree instance */
  updateDegree: UpdateDegreeOutput;
  /** Updates an existing discoverycategory instance */
  updateDiscoveryCategory: UpdateDiscoveryCategoryOutput;
  /** Updates an existing document instance */
  updateDocument: UpdateDocumentOutput;
  /** Updates an existing documentgroup instance */
  updateDocumentGroup: UpdateDocumentGroupOutput;
  /** Updates an existing education instance */
  updateEducation: UpdateEducationOutput;
  updateEmailTemplate: EmailTemplate;
  /** Updates an existing experience instance */
  updateExperience: UpdateExperienceOutput;
  /** Updates an existing expertise instance */
  updateExpertise: UpdateExpertiseOutput;
  /** Updates an existing gender instance */
  updateGender: UpdateGenderOutput;
  /** Updates an existing industry instance */
  updateIndustry: UpdateIndustryOutput;
  /** Updates an existing jobdepartment instance */
  updateJobDepartment: UpdateJobDepartmentOutput;
  /** Updates an existing joblocation instance */
  updateJobLocation: UpdateJobLocationOutput;
  /** Updates an existing languageskill instance */
  updateLanguageSkill: UpdateLanguageSkillOutput;
  /** Updates an existing maritalstatus instance */
  updateMaritalStatus: UpdateMaritalStatusOutput;
  /** Updates an existing match instance */
  updateMatch: UpdateMatchOutput;
  /** Updates an existing matchcandidate instance */
  updateMatchCandidate: UpdateMatchCandidateOutput;
  /** Updates an existing matchresult instance */
  updateMatchResult: UpdateMatchResultOutput;
  /** Updates an existing orgunit instance */
  updateOrgUnit: UpdateOrgUnitOutput;
  updateOrganizationalRecordComment: OrganizationalRecordComment;
  updateOrganizationalRecordDocument: OrganizationalRecordDocument;
  updateOrganizationalRecordEntry: OrganizationalRecordEntry;
  /** Updates an existing person instance */
  updatePerson: UpdatePersonOutput;
  /** Updates an existing persongroup instance */
  updatePersonGroup: UpdatePersonGroupOutput;
  /** Updates an existing pingroup instance */
  updatePinGroup: UpdatePinGroupOutput;
  /** Updates an existing project instance */
  updateProject: UpdateProjectOutput;
  updateSettings?: Maybe<Scalars['Boolean']['output']>;
  /** Updates an existing shareditem instance */
  updateSharedItem: UpdateSharedItemOutput;
  /** Updates an existing shareditemcomment instance */
  updateSharedItemComment: UpdateSharedItemCommentOutput;
  /** Updates an existing studionotebook instance */
  updateStudioNotebook: UpdateStudioNotebookOutput;
  updateSystemSettings: Scalars['Boolean']['output'];
  /** Updates an existing teamprofile instance */
  updateTeamProfile: UpdateTeamProfileOutput;
  /** Updates an existing workingtimemodel instance */
  updateWorkingTimeModel: UpdateWorkingTimeModelOutput;
  viewSharedItem?: Maybe<ViewSharedItemOutput>;
  viewUserProfile?: Maybe<ViewUserProfileOutput>;
};


export type MutationActOnNotificationArgs = {
  input: ActOnNotificationInput;
};


export type MutationAddAccessGroupMemberArgs = {
  input: AccessGroupMemberInput;
};


export type MutationAddCompanyMemberArgs = {
  input: CompanyMembershipInput;
};


export type MutationAddContactsArgs = {
  input: AddContactsInput;
};


export type MutationAddPinsArgs = {
  input: AddPinsInput;
};


export type MutationApplyOrganizationalPowerAnalysisArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAssignAccessGroupRoleArgs = {
  input: AssignAccessGroupRoleInput;
};


export type MutationAssignManagerArgs = {
  input: AssignManagerInput;
};


export type MutationAssignOrgUnitArgs = {
  input: AssignOrgUnitInput;
};


export type MutationAssignQuestionnaireToGroupArgs = {
  input: AssignQuestionnaireToGroupInput;
};


export type MutationAttachProjectDocumentArgs = {
  input: AttachProjectDocumentInput;
};


export type MutationBulkImportPersonArgs = {
  input: BulkImportPersonInput;
};


export type MutationCheckMicrosoftCalendarArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConnectMicrosoftCalendarArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  verifier: Scalars['String']['input'];
};


export type MutationCreateAccessGroupArgs = {
  input: CreateAccessGroupInput;
};


export type MutationCreateAccessRoleArgs = {
  input: CreateAccessRoleInput;
};


export type MutationCreateAgentArgs = {
  input: CreateAgentInput;
};


export type MutationCreateCertificateArgs = {
  input: CreateCertificateInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateContractTypeArgs = {
  input: CreateContractTypeInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


export type MutationCreateCurriculumVitaeArgs = {
  input: CreateCurriculumVitaeInput;
};


export type MutationCreateDegreeArgs = {
  input: CreateDegreeInput;
};


export type MutationCreateDiscoveryCategoryArgs = {
  input: CreateDiscoveryCategoryInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateDocumentGroupArgs = {
  input: CreateDocumentGroupInput;
};


export type MutationCreateEducationArgs = {
  input: CreateEducationInput;
};


export type MutationCreateExperienceArgs = {
  input: CreateExperienceInput;
};


export type MutationCreateExpertiseArgs = {
  input: CreateExpertiseInput;
};


export type MutationCreateGenderArgs = {
  input: CreateGenderInput;
};


export type MutationCreateIndustryArgs = {
  input: CreateIndustryInput;
};


export type MutationCreateJobDepartmentArgs = {
  input: CreateJobDepartmentInput;
};


export type MutationCreateJobLocationArgs = {
  input: CreateJobLocationInput;
};


export type MutationCreateLanguageSkillArgs = {
  input: CreateLanguageSkillInput;
};


export type MutationCreateMaritalStatusArgs = {
  input: CreateMaritalStatusInput;
};


export type MutationCreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationCreateMatchCandidateArgs = {
  input: CreateMatchCandidateInput;
};


export type MutationCreateMatchCandidatesArgs = {
  input: CreateMatchCandidatesInput;
};


export type MutationCreateMatchCompaniesArgs = {
  input: CreateMatchCompaniesInput;
};


export type MutationCreateMatchCompanyArgs = {
  input: CreateMatchCompanyInput;
};


export type MutationCreateMatchResultArgs = {
  input: CreateMatchResultInput;
};


export type MutationCreateOrgUnitArgs = {
  input: CreateOrgUnitInput;
};


export type MutationCreateOrganizationalRecordArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOrganizationalRecordCommentArgs = {
  input: CreateOrganizationalRecordCommentInput;
};


export type MutationCreateOrganizationalRecordDocumentArgs = {
  input: CreateOrganizationalRecordDocumentInput;
};


export type MutationCreateOrganizationalRecordEntryArgs = {
  input: CreateOrganizationalRecordEntryInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePersonGroupArgs = {
  input: CreatePersonGroupInput;
};


export type MutationCreatePinGroupArgs = {
  input: CreatePinGroupInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateSharedItemArgs = {
  input: CreateSharedItemInput;
};


export type MutationCreateSharedItemCommentArgs = {
  input: CreateSharedItemCommentInput;
};


export type MutationCreateStudioNotebookArgs = {
  input: CreateStudioNotebookInput;
};


export type MutationCreateTeamProfileArgs = {
  input: CreateTeamProfileInput;
};


export type MutationCreateWorkingTimeModelArgs = {
  input: CreateWorkingTimeModelInput;
};


export type MutationDeleteAccessGroupArgs = {
  input: DeleteAccessGroupInput;
};


export type MutationDeleteAccessRoleArgs = {
  input: DeleteAccessRoleInput;
};


export type MutationDeleteAgentArgs = {
  input: DeleteAgentInput;
};


export type MutationDeleteAllNotificationsArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type MutationDeleteCertificateArgs = {
  input: DeleteCertificateInput;
};


export type MutationDeleteCompanyArgs = {
  input: DeleteCompanyInput;
};


export type MutationDeleteContractTypeArgs = {
  input: DeleteContractTypeInput;
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type MutationDeleteCurriculumVitaeArgs = {
  input: DeleteCurriculumVitaeInput;
};


export type MutationDeleteDegreeArgs = {
  input: DeleteDegreeInput;
};


export type MutationDeleteDiscoveryCategoryArgs = {
  input: DeleteDiscoveryCategoryInput;
};


export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};


export type MutationDeleteDocumentGroupArgs = {
  input: DeleteDocumentGroupInput;
};


export type MutationDeleteEducationArgs = {
  input: DeleteEducationInput;
};


export type MutationDeleteExperienceArgs = {
  input: DeleteExperienceInput;
};


export type MutationDeleteExpertiseArgs = {
  input: DeleteExpertiseInput;
};


export type MutationDeleteGenderArgs = {
  input: DeleteGenderInput;
};


export type MutationDeleteIndustryArgs = {
  input: DeleteIndustryInput;
};


export type MutationDeleteJobDepartmentArgs = {
  input: DeleteJobDepartmentInput;
};


export type MutationDeleteJobLocationArgs = {
  input: DeleteJobLocationInput;
};


export type MutationDeleteLanguageSkillArgs = {
  input: DeleteLanguageSkillInput;
};


export type MutationDeleteMaritalStatusArgs = {
  input: DeleteMaritalStatusInput;
};


export type MutationDeleteMatchArgs = {
  input: DeleteMatchInput;
};


export type MutationDeleteMatchCandidateArgs = {
  input: DeleteMatchCandidateInput;
};


export type MutationDeleteMatchCandidatesArgs = {
  input: DeleteMatchCandidatesInput;
};


export type MutationDeleteMatchCompaniesArgs = {
  input: DeleteMatchCompaniesInput;
};


export type MutationDeleteMatchCompanyArgs = {
  input: DeleteMatchCompanyInput;
};


export type MutationDeleteMatchResultArgs = {
  input: DeleteMatchResultInput;
};


export type MutationDeleteMyFavoriteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['UUID']['input'];
};


export type MutationDeleteOrgUnitArgs = {
  input: DeleteOrgUnitInput;
};


export type MutationDeleteOrganizationalRecordCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationalRecordDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationalRecordEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonArgs = {
  input: DeletePersonInput;
};


export type MutationDeletePersonGroupArgs = {
  input: DeletePersonGroupInput;
};


export type MutationDeletePinGroupArgs = {
  input: DeletePinGroupInput;
};


export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


export type MutationDeleteQuestionnaireArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireId: Scalars['UUID']['input'];
};


export type MutationDeleteQuestionnaireGroupArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireGroupId: Scalars['UUID']['input'];
};


export type MutationDeleteSharedItemArgs = {
  input: DeleteSharedItemInput;
};


export type MutationDeleteSharedItemCommentArgs = {
  input: DeleteSharedItemCommentInput;
};


export type MutationDeleteStudioNotebookArgs = {
  input: DeleteStudioNotebookInput;
};


export type MutationDeleteTeamProfileArgs = {
  input: DeleteTeamProfileInput;
};


export type MutationDeleteWorkingTimeModelArgs = {
  input: DeleteWorkingTimeModelInput;
};


export type MutationDetachProjectDocumentArgs = {
  input: DetachProjectDocumentInput;
};


export type MutationDisconnectMicrosoftCalendarArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExtractProfileFromDocumentArgs = {
  file: Scalars['Binary']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationFinishToplistSessionArgs = {
  entries: Array<ToplistEntryInput>;
  id: Scalars['UUID']['input'];
};


export type MutationGenerateAiRequirementsArgs = {
  input: GenerateAiRequirementsInput;
};


export type MutationGenerateTransientMatchResultArgs = {
  input: GenerateTransientMatchResultInput;
};


export type MutationHeartbeatConversationPresenceArgs = {
  input: HeartbeatConversationPresenceInput;
};


export type MutationImportCvBatchArgs = {
  files: Array<CvFileInput>;
  importPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportDocumentsArgs = {
  options?: InputMaybe<ImportOptionsInput>;
  yaml: Scalars['String']['input'];
};


export type MutationImportLinkedInProfileArgs = {
  input: LinkedInImportInput;
};


export type MutationInviteExistingPersonArgs = {
  input: InviteExistingPersonInput;
};


export type MutationLinkProjectMatchArgs = {
  input: LinkProjectMatchInput;
};


export type MutationMarkAllNotificationsReadArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput;
};


export type MutationMarkNotificationReadArgs = {
  notificationId: Scalars['UUID']['input'];
};


export type MutationPreviewLinkedInImportArgs = {
  input: LinkedInImportInput;
};


export type MutationProcessDocumentsArgs = {
  input: ProcessDocumentsInput;
};


export type MutationProvisionInviteeArgs = {
  input: ProvisionInviteeInput;
};


export type MutationPublishQuestionnaireGroupArgs = {
  questionnaireGroupId: Scalars['UUID']['input'];
};


export type MutationRateSharedItemArgs = {
  input: RateSharedItemInput;
};


export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};


export type MutationRemoveAccessGroupMemberArgs = {
  input: AccessGroupMemberInput;
};


export type MutationRemoveAccessGroupRoleArgs = {
  input: RemoveAccessGroupRoleInput;
};


export type MutationRemoveCompanyCompetencyArgs = {
  input: RemoveCompanyCompetencyInput;
};


export type MutationRemoveCompanyMemberArgs = {
  input: RemoveCompanyMemberInput;
};


export type MutationRemoveContactsArgs = {
  input: RemoveContactsInput;
};


export type MutationRemovePinsArgs = {
  input: RemovePinsInput;
};


export type MutationRequestContactArgs = {
  contactId: Scalars['UUID']['input'];
  justification?: InputMaybe<Scalars['String']['input']>;
  personGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationRequestContactsArgs = {
  contactIds: Array<Scalars['UUID']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  personGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationResendExistingPersonInvitationArgs = {
  input: ResendExistingPersonInvitationInput;
};


export type MutationRestartGameSessionArgs = {
  gameKey: Scalars['String']['input'];
};


export type MutationSaveQuestionnaireArgs = {
  input: SaveQuestionnaireInput;
};


export type MutationSaveQuestionnaireGroupArgs = {
  input: SaveQuestionnaireGroupInput;
};


export type MutationSaveQuestionnaireResultsArgs = {
  input: SaveQuestionnaireResultsInput;
};


export type MutationSaveSelfAssessmentResultsArgs = {
  input: SaveSelfAssessmentResultsInput;
};


export type MutationSaveToplistProgressArgs = {
  id: Scalars['UUID']['input'];
  snapshot: Scalars['Object']['input'];
  snapshotVersion: Scalars['Int']['input'];
  timeTakenMs: Scalars['Int']['input'];
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSendMicrosoftMessageArgs = {
  input: MicrosoftMessageInput;
};


export type MutationSetCompanyCompetencyArgs = {
  input: SetCompanyCompetencyInput;
};


export type MutationSetCompanyContactPersonArgs = {
  input: SetCompanyContactPersonInput;
};


export type MutationSetCompanyMemberRoleArgs = {
  input: CompanyMembershipInput;
};


export type MutationSetConversationTypingArgs = {
  input: SetConversationTypingInput;
};


export type MutationSetGroupSharingEligibilityArgs = {
  input: SetGroupSharingEligibilityInput;
};


export type MutationSetMatchCompanyConditionsArgs = {
  input: SetMatchCompanyConditionsInput;
};


export type MutationSetMatchConditionsArgs = {
  input: SetMatchConditionsInput;
};


export type MutationSetMatchNotesArgs = {
  input: SetMatchNotesInput;
};


export type MutationSetMatchProjectArgs = {
  input: SetMatchProjectInput;
};


export type MutationSetMatchTeamSizeArgs = {
  input: SetMatchTeamSizeInput;
};


export type MutationSetMyToplistSharingArgs = {
  input: SetMyToplistSharingInput;
};


export type MutationSetPersonalSharingArgs = {
  input: SetPersonalSharingInput;
};


export type MutationSignUpSharedProjectArgs = {
  input: SignUpSharedProjectInput;
};


export type MutationStartDocumentsExtractionArgs = {
  input: ProcessDocumentsInput;
};


export type MutationStartFileImportArgs = {
  batch?: InputMaybe<ImportBatchInput>;
  file: Scalars['Binary']['input'];
  fileName: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ImportOptionsInput>;
};


export type MutationStartGameSessionArgs = {
  gameKey: Scalars['String']['input'];
};


export type MutationStartImportDocumentsArgs = {
  fileName: Scalars['String']['input'];
  options?: InputMaybe<ImportOptionsInput>;
  yaml: Scalars['String']['input'];
};


export type MutationStartOrganizationalPowerAnalysisArgs = {
  documentIds: Array<Scalars['UUID']['input']>;
  recordId: Scalars['UUID']['input'];
};


export type MutationTakeOverSharedItemArgs = {
  input: TakeOverSharedItemInput;
};


export type MutationUnlinkProjectMatchArgs = {
  input: UnlinkProjectMatchInput;
};


export type MutationUnpublishQuestionnaireGroupArgs = {
  questionnaireGroupId: Scalars['UUID']['input'];
};


export type MutationUnregisterDeviceTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateAccessGroupArgs = {
  input: UpdateAccessGroupInput;
};


export type MutationUpdateAccessRoleArgs = {
  input: UpdateAccessRoleInput;
};


export type MutationUpdateAgentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAgentInput;
};


export type MutationUpdateCertificateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCertificateInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateContractTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateContractTypeInput;
};


export type MutationUpdateCurriculumVitaeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCurriculumVitaeInput;
};


export type MutationUpdateDegreeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDegreeInput;
};


export type MutationUpdateDiscoveryCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDiscoveryCategoryInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentInput;
};


export type MutationUpdateDocumentGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentGroupInput;
};


export type MutationUpdateEducationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEducationInput;
};


export type MutationUpdateEmailTemplateArgs = {
  input: EmailTemplateInput;
};


export type MutationUpdateExperienceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExperienceInput;
};


export type MutationUpdateExpertiseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExpertiseInput;
};


export type MutationUpdateGenderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGenderInput;
};


export type MutationUpdateIndustryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIndustryInput;
};


export type MutationUpdateJobDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobDepartmentInput;
};


export type MutationUpdateJobLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobLocationInput;
};


export type MutationUpdateLanguageSkillArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLanguageSkillInput;
};


export type MutationUpdateMaritalStatusArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMaritalStatusInput;
};


export type MutationUpdateMatchArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchInput;
};


export type MutationUpdateMatchCandidateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchCandidateInput;
};


export type MutationUpdateMatchResultArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchResultInput;
};


export type MutationUpdateOrgUnitArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrgUnitInput;
};


export type MutationUpdateOrganizationalRecordCommentArgs = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  links?: InputMaybe<Array<OrganizationalRecordLinkTargetInput>>;
};


export type MutationUpdateOrganizationalRecordDocumentArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationUpdateOrganizationalRecordEntryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationalRecordEntryInput;
};


export type MutationUpdatePersonArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePersonInput;
};


export type MutationUpdatePersonGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePersonGroupInput;
};


export type MutationUpdatePinGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePinGroupInput;
};


export type MutationUpdateProjectArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProjectInput;
};


export type MutationUpdateSettingsArgs = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  settings?: InputMaybe<Scalars['Object']['input']>;
};


export type MutationUpdateSharedItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSharedItemInput;
};


export type MutationUpdateSharedItemCommentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSharedItemCommentInput;
};


export type MutationUpdateStudioNotebookArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStudioNotebookInput;
};


export type MutationUpdateSystemSettingsArgs = {
  input: SystemSettingsInput;
};


export type MutationUpdateTeamProfileArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTeamProfileInput;
};


export type MutationUpdateWorkingTimeModelArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkingTimeModelInput;
};


export type MutationViewSharedItemArgs = {
  input: ViewSharedItemInput;
};


export type MutationViewUserProfileArgs = {
  input: ViewUserProfileInput;
};

/** The filterable fields of type Mutation */
export type MutationFilterInput = {
  and?: InputMaybe<Array<MutationFilterInput>>;
  not?: InputMaybe<MutationFilterInput>;
  or?: InputMaybe<Array<MutationFilterInput>>;
};

export type MyCompaniesResult = {
  __typename?: 'MyCompaniesResult';
  memberships: Array<MyCompanyMembership>;
};

/** The filterable fields of type MyCompaniesResult */
export type MyCompaniesResultFilterInput = {
  and?: InputMaybe<Array<MyCompaniesResultFilterInput>>;
  not?: InputMaybe<MyCompaniesResultFilterInput>;
  or?: InputMaybe<Array<MyCompaniesResultFilterInput>>;
};

/**
 * One of the caller's own memberships: a Company they belong to, and the role they hold in it
 * (the company account model, "die Person sieht ihre Firmen (aus ihren
 * company_membership-Zeilen)").
 *
 * Deliberately NOT CompanyMembership. That type carries a non-null `person`, which here would always be
 * the caller, and selecting it would drive the person loader to read the caller as if they were a third
 * party. A membership of one's own is described by the Company and the role, and by nothing else.
 *
 * `role` is the same open string as on CompanyMembership: the company account model fixes `admin`
 * and `member` for the MVP but requires later roles to be addable without a schema migration.
 */
export type MyCompanyMembership = {
  __typename?: 'MyCompanyMembership';
  /**
   * The Company, as identity — `id`, `name`, `industry` — plus `logo`, which this list delivers and the
   * member roster does not. See Company.logo for why the two lists differ, and Company.summary for the
   * profile text neither of them carries.
   */
  company: Company;
  role: Scalars['String']['output'];
};

/** The filterable fields of type MyCompanyMembership */
export type MyCompanyMembershipFilterInput = {
  and?: InputMaybe<Array<MyCompanyMembershipFilterInput>>;
  not?: InputMaybe<MyCompanyMembershipFilterInput>;
  or?: InputMaybe<Array<MyCompanyMembershipFilterInput>>;
};

export type MyFavoritesInput = {
  /** All domains when absent. */
  domain?: InputMaybe<FavoriteDomain>;
};

/**
 * The Permission codes the current principal holds — the rights projection's own read surface,
 * `@adr GENESIS-0065-all-group-consent-is-explicit-and-dynamic@1` §3. Where `reachableFeatures` answers the
 * feature-eligibility question ("which features may I use"), this answers the rights-derived one: which
 * `principal_grants` rows, at the INTERNAL audience, the same set every mutation guard checks one
 * Permission at a time. A client gate should check membership in this list rather than reading a
 * retired Keycloak role — `provisionInvitee`'s guard is `provision:invitee`, not a client-side realm
 * role.
 */
export type MyPermissionsResult = {
  __typename?: 'MyPermissionsResult';
  permissionCodes: Array<Scalars['String']['output']>;
};

/** The filterable fields of type MyPermissionsResult */
export type MyPermissionsResultFilterInput = {
  and?: InputMaybe<Array<MyPermissionsResultFilterInput>>;
  not?: InputMaybe<MyPermissionsResultFilterInput>;
  or?: InputMaybe<Array<MyPermissionsResultFilterInput>>;
};

export type MyPowersDevStatsInput = {
  amount: Scalars['Int']['input'];
};

export enum NameUse {
  Anonymous = 'ANONYMOUS',
  Maiden = 'MAIDEN',
  Nickname = 'NICKNAME',
  Official = 'OFFICIAL',
  Old = 'OLD',
  Temp = 'TEMP',
  Usual = 'USUAL'
}

export type Node = {
  id: Scalars['ID']['output'];
};

/** The filterable fields of type Node */
export type NodeFilterInput = {
  and?: InputMaybe<Array<NodeFilterInput>>;
  not?: InputMaybe<NodeFilterInput>;
  or?: InputMaybe<Array<NodeFilterInput>>;
};

/** A user-scoped inbox item delivered by the notification subsystem. */
export type Notification = Node & {
  __typename?: 'Notification';
  /** Actions currently associated with the notification. */
  actions: Array<NotificationAction>;
  /** Localized body text for the notification. */
  body: LocalizedText;
  /** When the notification was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User who triggered the notification, if applicable. */
  createdBy?: Maybe<Person>;
  /** Optional client route or deep link for navigation. */
  deepLink?: Maybe<Scalars['String']['output']>;
  /** True when this notification can be deleted. False while it still awaits a decision from the user, such as an unanswered contact request. */
  deletable: Scalars['Boolean']['output'];
  /**
   * Names of the documents a background analysis is working on, in the order they were submitted.
   * Empty for every notification that is not about a documents analysis.
   */
  documentNames: Array<Scalars['String']['output']>;
  /** Optional domain entity referenced by the notification. */
  entityId?: Maybe<Scalars['UUID']['output']>;
  /** When the notification expires automatically. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /**
   * True while the background job this notification announces is still running, so a client can show
   * a live indicator on it and drop that indicator the moment the job stops. Always false for
   * notifications that do not announce a job, and for one that does it turns false on its own if the
   * runner dies without reporting a terminal state. Do not infer this from the presence of a later
   * notification: an interrupted job never sends one.
   */
  jobActive: Scalars['Boolean']['output'];
  /**
   * Counters of the batch this notification tracks, for rendering a progress bar. Null for every
   * notification that does not track a batch (which today is everything except IMPORT_BATCH).
   */
  progress?: Maybe<NotificationProgress>;
  /** When the user marked the notification as read. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current lifecycle state of the notification. */
  state: NotificationState;
  /** Localized title for the notification. */
  title: LocalizedText;
  /** The category of the notification. */
  type: NotificationType;
};

/** An action rendered together with a notification. */
export type NotificationAction = {
  __typename?: 'NotificationAction';
  /** Localized label shown for the action in the UI. */
  label: LocalizedText;
  /** Whether the action can still be executed. */
  status: NotificationActionStatus;
  /** The action to perform. */
  type: NotificationActionType;
};

/** The filterable fields of type NotificationAction */
export type NotificationActionFilterInput = {
  and?: InputMaybe<Array<NotificationActionFilterInput>>;
  not?: InputMaybe<NotificationActionFilterInput>;
  or?: InputMaybe<Array<NotificationActionFilterInput>>;
};

/** Availability state of a notification action. */
export enum NotificationActionStatus {
  /** The action is currently available to the user. */
  Available = 'AVAILABLE',
  /** The action was executed. */
  Completed = 'COMPLETED',
  /** The action can no longer be executed. */
  Unavailable = 'UNAVAILABLE'
}

/** Action that can be performed from an actionable notification. */
export enum NotificationActionType {
  /** Accept the incoming contact request. */
  AcceptContactRequest = 'ACCEPT_CONTACT_REQUEST',
  /** Reject the incoming contact request. */
  RejectContactRequest = 'REJECT_CONTACT_REQUEST',
  /** View the post related to this notification */
  ViewPostContent = 'VIEW_POST_CONTENT',
  /** View the project related to this notification */
  ViewProjectContent = 'VIEW_PROJECT_CONTENT'
}

/** Realtime wrapper around a notification change event. */
export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  /** The current notification snapshot after the change. */
  notification: Notification;
  /** The affected notification id. */
  notificationId: Scalars['UUID']['output'];
  /** The kind of notification change. */
  type: NotificationEventType;
};

/** The filterable fields of type NotificationEvent */
export type NotificationEventFilterInput = {
  and?: InputMaybe<Array<NotificationEventFilterInput>>;
  not?: InputMaybe<NotificationEventFilterInput>;
  or?: InputMaybe<Array<NotificationEventFilterInput>>;
};

/** Type of realtime change emitted for a notification. */
export enum NotificationEventType {
  /** A notification action was executed. */
  Actioned = 'ACTIONED',
  /** A new notification was created. */
  Created = 'CREATED',
  /** A notification was deleted from the inbox. */
  Deleted = 'DELETED',
  /** A notification expired. */
  Expired = 'EXPIRED',
  /** A notification was marked as read. */
  Read = 'READ',
  /** An existing notification changed in place, e.g. a batch progress tick. */
  Updated = 'UPDATED'
}

/** The filterable fields of type Notification */
export type NotificationFilterInput = {
  and?: InputMaybe<Array<NotificationFilterInput>>;
  not?: InputMaybe<NotificationFilterInput>;
  or?: InputMaybe<Array<NotificationFilterInput>>;
};

/** Running counters of a multi-file import batch. done includes the failed jobs. */
export type NotificationProgress = {
  __typename?: 'NotificationProgress';
  done: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** The filterable fields of type NotificationProgress */
export type NotificationProgressFilterInput = {
  and?: InputMaybe<Array<NotificationProgressFilterInput>>;
  not?: InputMaybe<NotificationProgressFilterInput>;
  or?: InputMaybe<Array<NotificationProgressFilterInput>>;
};

/** Lifecycle state of a notification in the user's inbox. */
export enum NotificationState {
  /** A user action was executed for this notification. */
  Actioned = 'ACTIONED',
  /** The notification is visible and may still be actionable. */
  Active = 'ACTIVE',
  /** The notification was removed from the user's inbox. */
  Deleted = 'DELETED',
  /** The notification expired automatically and is no longer shown by default. */
  Expired = 'EXPIRED'
}

/** Domain-specific category of a notification. */
export enum NotificationType {
  /** Another user wants to add the current user as a contact. */
  ContactRequest = 'CONTACT_REQUEST',
  /** A previously sent contact request was accepted. */
  ContactRequestAccepted = 'CONTACT_REQUEST_ACCEPTED',
  /** A background documents extraction (powers/skills) finished successfully. */
  ExtractionCompleted = 'EXTRACTION_COMPLETED',
  /** A background documents extraction (powers/skills) failed. */
  ExtractionFailed = 'EXTRACTION_FAILED',
  /** A background documents extraction (powers/skills) was accepted and is running in the background. */
  ExtractionStarted = 'EXTRACTION_STARTED',
  /**
   * One notification for a whole multi-file drop. Created with the first file's job and updated in
   * place as the batch's jobs finish; `Notification.progress` carries the counters for a progress bar.
   */
  ImportBatch = 'IMPORT_BATCH',
  /** A YAML import finished successfully. */
  ImportCompleted = 'IMPORT_COMPLETED',
  /** A YAML import failed and was rolled back. */
  ImportFailed = 'IMPORT_FAILED',
  /** A YAML import was accepted and is running in the background. */
  ImportStarted = 'IMPORT_STARTED',
  /** A time-bounded maintenance or downtime notice. */
  MaintenanceWindow = 'MAINTENANCE_WINDOW',
  /** A post was published that might be of interest to the current user. */
  PostPublished = 'POST_PUBLISHED',
  /** A project was published that might be of interest to the current user. */
  ProjectPublished = 'PROJECT_PUBLISHED',
  /** The UI is outdated and need to be refreshed */
  SystemUpdate = 'SYSTEM_UPDATE'
}

/** Pagination and filtering options for the notification inbox query. */
export type NotificationsInput = {
  /** Return notifications created before this notification id. */
  afterNotificationId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, include expired notifications in the result. */
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Notification types this client understands. Notifications of other types are filtered out
   * of the result. When absent or empty, only the six original types
   * (CONTACT_REQUEST … SYSTEM_UPDATE) are returned, so clients built against an older schema
   * never receive enum values they cannot deserialize. Clients should pass the full set of
   * types they support.
   */
  supportedTypes?: InputMaybe<Array<NotificationType>>;
  /** Maximum number of notifications to return. */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** If true, only unread notifications are returned. */
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberOfPinsOutput = NumberOfPinsResult;

export type NumberOfPinsResult = {
  __typename?: 'NumberOfPinsResult';
  pinnedPersons?: Maybe<Scalars['Int']['output']>;
  pinnedPosts?: Maybe<Scalars['Int']['output']>;
  pinnedProjects?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type NumberOfPinsResult */
export type NumberOfPinsResultFilterInput = {
  and?: InputMaybe<Array<NumberOfPinsResultFilterInput>>;
  not?: InputMaybe<NumberOfPinsResultFilterInput>;
  or?: InputMaybe<Array<NumberOfPinsResultFilterInput>>;
};

/**
 * Progress of one long-running operation, streamed beside it through operationProgress. It never carries
 * the operation's result; the operation still returns that itself. The first snapshot already has its
 * shape: either stages (planned in order and complete from the start; a stage that does not run is
 * SKIPPED, never removed) or a continuous bar (stages empty, done and total on this type).
 */
export type OperationProgress = {
  __typename?: 'OperationProgress';
  /** Facts of a continuous bar; empty when the operation reports stages. */
  details: Array<ProgressDetail>;
  /** Continuous bar only (stages empty); total null means indeterminate. */
  done?: Maybe<Scalars['Int']['output']>;
  progressId: Scalars['UUID']['output'];
  /** Increases with every stored snapshot. Clients drop a snapshot older than the last one they saw. */
  revision: Scalars['Int']['output'];
  stages: Array<ProgressStageState>;
  status: OperationProgressStatus;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type OperationProgress */
export type OperationProgressFilterInput = {
  and?: InputMaybe<Array<OperationProgressFilterInput>>;
  not?: InputMaybe<OperationProgressFilterInput>;
  or?: InputMaybe<Array<OperationProgressFilterInput>>;
};

/** State of an operation reported through operationProgress. */
export enum OperationProgressStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

/**
 * OrgUnit — a node in the deployment's HR-org tree, maintained as a reference-data-style catalog under
 * `write:access-config` and following the Industry/Degree pattern (`@adr GENESIS-0065-all-group-consent-is-explicit-and-dynamic@1`
 * §8, genesis#257). Structure, slow-moving; the fast-moving per-person assignment (`assignOrgUnit` /
 * `assignManager`) is a deliberately separate surface, so each can carry a different provenance when an
 * external HR feed arrives later.
 *
 * `parent` is a nullable self-reference — a root has none. **Only the graph is stored**: no transitive
 * closure is materialised, because whether org visibility is transitive is a query-time policy decided in
 * the visibility ticket (genesis#258), so the tree stays flat here and extends without a migration. A cycle
 * cannot be created — the database refuses a parent that is the unit itself or one of its descendants.
 *
 * Org data is Genesis-owned relational data in v1, **not** a mirror of an HRIS and **never** a Keycloak
 * claim read at decision time: a data source is not an enforcement authority. A later external feed may fill
 * these columns (including from OIDC claims at import time) and is still never a second enforcement writer.
 */
export type OrgUnit = Node & {
  __typename?: 'OrgUnit';
  /**
   * Retires the unit: a hidden unit is dropped from the tree query and is not a valid assignment target,
   * without being deleted. This is the retirement path for an in-use unit — one with children or assigned
   * people cannot be hard-deleted (the foreign keys are RESTRICT).
   */
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
  /** The parent unit, or null for a root. Setting a parent that would form a cycle is refused. */
  parent?: Maybe<OrgUnit>;
};

/** The filterable fields of type OrgUnit */
export type OrgUnitFilterInput = {
  and?: InputMaybe<Array<OrgUnitFilterInput>>;
  /**
   * Retires the unit: a hidden unit is dropped from the tree query and is not a valid assignment target,
   * without being deleted. This is the retirement path for an in-use unit — one with children or assigned
   * people cannot be hard-deleted (the foreign keys are RESTRICT).
   */
  hidden?: InputMaybe<BooleanFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<OrgUnitFilterInput>;
  or?: InputMaybe<Array<OrgUnitFilterInput>>;
};

/** Contains information for linking 'OrgUnit' to other entities */
export type OrgUnitRelationInput = {
  /** The identifier of 'OrgUnit' */
  id: Scalars['ID']['input'];
};

export type OrgUnitSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

/** The OrgUnit tree of this deployment — retired units excluded. */
export type OrgUnitsResult = {
  __typename?: 'OrgUnitsResult';
  orgUnits: Array<OrgUnit>;
};

/** The filterable fields of type OrgUnitsResult */
export type OrgUnitsResultFilterInput = {
  and?: InputMaybe<Array<OrgUnitsResultFilterInput>>;
  not?: InputMaybe<OrgUnitsResultFilterInput>;
  or?: InputMaybe<Array<OrgUnitsResultFilterInput>>;
};

/** A protected organizational-document analysis; only explicit application changes profile scores. */
export type OrganizationalPowerAnalysis = {
  __typename?: 'OrganizationalPowerAnalysis';
  id: Scalars['UUID']['output'];
  recordId: Scalars['UUID']['output'];
  status: OrganizationalPowerAnalysisStatus;
  subjectPersonId: Scalars['UUID']['output'];
  traits: Array<OrganizationalPowerTrait>;
};

/** The filterable fields of type OrganizationalPowerAnalysis */
export type OrganizationalPowerAnalysisFilterInput = {
  and?: InputMaybe<Array<OrganizationalPowerAnalysisFilterInput>>;
  not?: InputMaybe<OrganizationalPowerAnalysisFilterInput>;
  or?: InputMaybe<Array<OrganizationalPowerAnalysisFilterInput>>;
};

export enum OrganizationalPowerAnalysisStatus {
  Applied = 'APPLIED',
  Failed = 'FAILED',
  Ready = 'READY',
  Running = 'RUNNING'
}

export type OrganizationalPowerTrait = {
  __typename?: 'OrganizationalPowerTrait';
  confidence: Scalars['Float']['output'];
  element: CreativityElement;
  rationale: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

/** The filterable fields of type OrganizationalPowerTrait */
export type OrganizationalPowerTraitFilterInput = {
  and?: InputMaybe<Array<OrganizationalPowerTraitFilterInput>>;
  not?: InputMaybe<OrganizationalPowerTraitFilterInput>;
  or?: InputMaybe<Array<OrganizationalPowerTraitFilterInput>>;
};

/**
 * Organisational record about a person or a company; it has no personal-owner self-scope. Exactly one of
 * `subjectPersonId` and `subjectCompanyId` is set.
 */
export type OrganizationalRecord = Node & {
  __typename?: 'OrganizationalRecord';
  id: Scalars['ID']['output'];
  subjectCompanyId?: Maybe<Scalars['UUID']['output']>;
  subjectPersonId?: Maybe<Scalars['UUID']['output']>;
};

export type OrganizationalRecordAccess = {
  __typename?: 'OrganizationalRecordAccess';
  canAnalyzePowers: Scalars['Boolean']['output'];
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  /** Effective read scope, or null when denied. GLOBAL includes records beyond departmental applications. */
  readScope?: Maybe<AccessScope>;
  /** Effective write scope, or null when denied. Write includes read; only GLOBAL is currently supported. */
  writeScope?: Maybe<AccessScope>;
};

/** The filterable fields of type OrganizationalRecordAccess */
export type OrganizationalRecordAccessFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordAccessFilterInput>>;
  not?: InputMaybe<OrganizationalRecordAccessFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordAccessFilterInput>>;
};

export type OrganizationalRecordBacklink = Node & {
  __typename?: 'OrganizationalRecordBacklink';
  id: Scalars['ID']['output'];
  source: OrganizationalRecordItemReference;
};

export type OrganizationalRecordBacklinkConnection = {
  __typename?: 'OrganizationalRecordBacklinkConnection';
  nodes: Array<OrganizationalRecordBacklink>;
  pageInfo: PageInfo;
};

/** The filterable fields of type OrganizationalRecordBacklinkConnection */
export type OrganizationalRecordBacklinkConnectionFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordBacklinkConnectionFilterInput>>;
  not?: InputMaybe<OrganizationalRecordBacklinkConnectionFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordBacklinkConnectionFilterInput>>;
};

/** The filterable fields of type OrganizationalRecordBacklink */
export type OrganizationalRecordBacklinkFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordBacklinkFilterInput>>;
  not?: InputMaybe<OrganizationalRecordBacklinkFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordBacklinkFilterInput>>;
};

export type OrganizationalRecordBacklinksInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  recordId: Scalars['ID']['input'];
  target: OrganizationalRecordLinkTargetInput;
};

/** Uses SharedItemComment's content/person/postedAt convention. */
export type OrganizationalRecordComment = Node & {
  __typename?: 'OrganizationalRecordComment';
  content: Scalars['String']['output'];
  entryId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  links: Array<OrganizationalRecordItemReference>;
  person?: Maybe<Person>;
  postedAt: Scalars['DateTime']['output'];
  recordId: Scalars['UUID']['output'];
};

export type OrganizationalRecordCommentConnection = {
  __typename?: 'OrganizationalRecordCommentConnection';
  nodes: Array<OrganizationalRecordComment>;
  pageInfo: PageInfo;
};

/** The filterable fields of type OrganizationalRecordCommentConnection */
export type OrganizationalRecordCommentConnectionFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordCommentConnectionFilterInput>>;
  not?: InputMaybe<OrganizationalRecordCommentConnectionFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordCommentConnectionFilterInput>>;
};

/** The filterable fields of type OrganizationalRecordComment */
export type OrganizationalRecordCommentFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordCommentFilterInput>>;
  not?: InputMaybe<OrganizationalRecordCommentFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordCommentFilterInput>>;
};

/** Chronological order of comments, applied consistently across cursor pages. */
export type OrganizationalRecordCommentSortInput = {
  order?: SortOrder;
};

export type OrganizationalRecordDocument = Node & {
  __typename?: 'OrganizationalRecordDocument';
  content: File;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Person>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  preview?: Maybe<File>;
  recordId: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};


export type OrganizationalRecordDocumentPreviewArgs = {
  profile: Scalars['String']['input'];
};

export type OrganizationalRecordDocumentConnection = {
  __typename?: 'OrganizationalRecordDocumentConnection';
  nodes: Array<OrganizationalRecordDocument>;
  pageInfo: PageInfo;
};

/** The filterable fields of type OrganizationalRecordDocumentConnection */
export type OrganizationalRecordDocumentConnectionFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordDocumentConnectionFilterInput>>;
  not?: InputMaybe<OrganizationalRecordDocumentConnectionFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordDocumentConnectionFilterInput>>;
};

/** The filterable fields of type OrganizationalRecordDocument */
export type OrganizationalRecordDocumentFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordDocumentFilterInput>>;
  not?: InputMaybe<OrganizationalRecordDocumentFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordDocumentFilterInput>>;
};

export type OrganizationalRecordEntry = Node & {
  __typename?: 'OrganizationalRecordEntry';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Person>;
  id: Scalars['ID']['output'];
  kind: OrganizationalRecordEntryKind;
  links: Array<OrganizationalRecordItemReference>;
  recordId: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Person>;
};

export type OrganizationalRecordEntryConnection = {
  __typename?: 'OrganizationalRecordEntryConnection';
  nodes: Array<OrganizationalRecordEntry>;
  pageInfo: PageInfo;
};

/** The filterable fields of type OrganizationalRecordEntryConnection */
export type OrganizationalRecordEntryConnectionFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordEntryConnectionFilterInput>>;
  not?: InputMaybe<OrganizationalRecordEntryConnectionFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordEntryConnectionFilterInput>>;
};

/** The filterable fields of type OrganizationalRecordEntry */
export type OrganizationalRecordEntryFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordEntryFilterInput>>;
  not?: InputMaybe<OrganizationalRecordEntryFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordEntryFilterInput>>;
};

export enum OrganizationalRecordEntryKind {
  Note = 'NOTE',
  Report = 'REPORT'
}

/** The filterable fields of type OrganizationalRecord */
export type OrganizationalRecordFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordFilterInput>>;
  not?: InputMaybe<OrganizationalRecordFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordFilterInput>>;
};

export enum OrganizationalRecordItemKind {
  Comment = 'COMMENT',
  Document = 'DOCUMENT',
  Entry = 'ENTRY'
}

/** A current title and stable identity within one organizational record. entryId locates an entry's comment thread. */
export type OrganizationalRecordItemReference = {
  __typename?: 'OrganizationalRecordItemReference';
  entryId?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['ID']['output'];
  kind: OrganizationalRecordItemKind;
  title: Scalars['String']['output'];
};

/** The filterable fields of type OrganizationalRecordItemReference */
export type OrganizationalRecordItemReferenceFilterInput = {
  and?: InputMaybe<Array<OrganizationalRecordItemReferenceFilterInput>>;
  not?: InputMaybe<OrganizationalRecordItemReferenceFilterInput>;
  or?: InputMaybe<Array<OrganizationalRecordItemReferenceFilterInput>>;
};

/** Targets may be DOCUMENT or ENTRY. COMMENT is only returned as a backlink source. */
export type OrganizationalRecordLinkTargetInput = {
  id: Scalars['ID']['input'];
  kind: OrganizationalRecordItemKind;
};

/** Forward cursor pagination. Null entryId selects the organizational record's general discussion. */
export type OrganizationalRecordPageInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  entryId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  recordId: Scalars['ID']['input'];
};

export type OrganizationalRecordReferenceInput = {
  id: Scalars['ID']['input'];
};

/** Provides additional information for paged data. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the current page's last item. To be used when fetching the next page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** True if there is at least one more page available, otherwise false */
  hasNextPage: Scalars['Boolean']['output'];
  /** True if the is a previous page available, otherwise false */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor of the current page's first item. To be used when fetching the previous page. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Period = {
  __typename?: 'Period';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

/** The filterable fields of type Period */
export type PeriodFilterInput = {
  and?: InputMaybe<Array<PeriodFilterInput>>;
  not?: InputMaybe<PeriodFilterInput>;
  or?: InputMaybe<Array<PeriodFilterInput>>;
};

export type Person = Node & {
  __typename?: 'Person';
  administrativeGender?: Maybe<AdministrativeGender>;
  ageInYears?: Maybe<Scalars['Int']['output']>;
  alternativeAvatar?: Maybe<File>;
  apartment?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<File>;
  bio?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Whether the caller may read this person’s provided documents and raw questionnaire answers:
   * self or an explicit External-information or managed-people override.
   */
  canReadProvidedInformation: Scalars['Boolean']['output'];
  /** Whether the acting Person may edit this profile. Field consent is independent. */
  canUpdate: Scalars['Boolean']['output'];
  certifications?: Maybe<Array<Certificate>>;
  childCount?: Maybe<Scalars['Int']['output']>;
  citizenships?: Maybe<Array<Country>>;
  city?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryState?: Maybe<CountryState>;
  currentActivity?: Maybe<Scalars['String']['output']>;
  currentEmployer?: Maybe<Scalars['String']['output']>;
  currentTasks?: Maybe<Scalars['String']['output']>;
  deceased?: Maybe<Deceased>;
  drivingLicence?: Maybe<Scalars['String']['output']>;
  educations?: Maybe<Array<Education>>;
  email?: Maybe<Scalars['String']['output']>;
  emailPrimary: Scalars['String']['output'];
  experiences?: Maybe<Array<Experience>>;
  expertises?: Maybe<Array<Expertise>>;
  formattedName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isContact?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  jobDepartment?: Maybe<JobDepartment>;
  jobLocation?: Maybe<JobLocation>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  languageSkills?: Maybe<Array<LanguageSkill>>;
  maritalStatus?: Maybe<MaritalStatus>;
  miscellaneous?: Maybe<Scalars['String']['output']>;
  name: HumanName;
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * As `selfAssessmentResults`, restricted to the powers: creativity elements belonging to an
   * ElementGroup (@adr GENESIS-0001-power-cluster-taxonomy@2). Same visibility rules and null/entry semantics. Both fields are
   * served by one batch loader, so selecting both costs no extra queries.
   */
  powersEvaluationResults?: Maybe<Array<ElementEvaluationResult>>;
  profession?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  /**
   *   The person's self-assessment results — the person-scoped counterpart of the principal-scoped
   *   `selfAssessmentResults` root query, and it returns the same rows that query would for that person.
   *
   * Visibility: the own profile always resolves. A foreign profile resolves when the person shares
   *   POWERS with a Group the caller currently belongs to, or the caller holds the explicit
   *   External-information or managed-people read override for that person. Picker eligibility does not supply consent.
   *   New clients use `setPersonalSharing(data: { sharedPowers: [groupId] })`; an empty list revokes
   *   third-party consent. Row visibility and feature permissions remain independent.
   *
   * `null` = the caller may not see this person's powers. Otherwise one entry per configured
   *   self-assessment, exactly like the root query: an entry whose `result` is null means that element
   *   has not been scored yet, so "permitted but nothing assessed" is a list of entries with null
   *   `result` — not an empty list. `[]` only occurs if no self-assessments are configured at all.
   *
   * Never resolves to a GraphQL error for an unauthorized caller — clients select this alongside the
   *   rest of the profile and must not lose the whole payload to a permission outcome.
   */
  selfAssessmentResults?: Maybe<Array<ElementEvaluationResult>>;
  /**
   *   The person's smart-analysis scores — derived from their uploaded documents rather than self-reported.
   *   Same visibility rule and same `null`-means-not-permitted semantics as `selfAssessmentResults`.
   *
   * Ordinary powers sharing leaves `evidences` empty and `rationale` null: both describe the owner's
   *   documents. Self-access and explicit personal-information read overrides return both, because
   *   they also authorize the underlying documents.
   */
  smartAnalysisResults?: Maybe<Array<SmartAnalysisResult>>;
  street?: Maybe<Scalars['String']['output']>;
  /**
   * The person's toplists from the toplist game, ordered by domain code. The own profile lists every one; a foreign
   * profile lists those shared with a Group the caller belongs to, with all eligible Groups or publicly, exactly like
   * the profile entries above. Empty when nothing is visible.
   */
  toplists?: Maybe<Array<Toplist>>;
  userRank?: Maybe<UserRank>;
  website?: Maybe<Scalars['String']['output']>;
  workingTimeModel?: Maybe<WorkingTimeModel>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type PersonAlternativeAvatarArgs = {
  profile: Scalars['String']['input'];
};


export type PersonAvatarArgs = {
  profile: Scalars['String']['input'];
  useAlternative: Scalars['Boolean']['input'];
};

export type PersonConnection = {
  __typename?: 'PersonConnection';
  edges: Array<PersonEdge>;
  nodes: Array<Person>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * Preview diff for one person_detail scalar field. `existingValue` is the current
 * genesis value (null if empty), `incomingValue` is what the import proposes (null if
 * the source has nothing). `key` is the field name (e.g. "bio"). A blank/absent
 * `incomingValue` is never offered as a destructive replace. `additive` is true for a
 * set-membership field (e.g. citizenship) where the incoming value is the merged
 * superset rather than a replacement — the client shows an "adds to" note, not a
 * destructive "replaces your value" warning.
 */
export type PersonDetailFieldDiff = {
  __typename?: 'PersonDetailFieldDiff';
  action: ImportDiffAction;
  additive: Scalars['Boolean']['output'];
  existingValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  incomingValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

/** The filterable fields of type PersonDetailFieldDiff */
export type PersonDetailFieldDiffFilterInput = {
  and?: InputMaybe<Array<PersonDetailFieldDiffFilterInput>>;
  not?: InputMaybe<PersonDetailFieldDiffFilterInput>;
  or?: InputMaybe<Array<PersonDetailFieldDiffFilterInput>>;
};

export type PersonEdge = {
  __typename?: 'PersonEdge';
  cursor: Scalars['String']['output'];
  node: Person;
};

/** The filterable fields of type Person */
export type PersonFilterInput = {
  ageInYears?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<PersonFilterInput>>;
  childCount?: InputMaybe<IntFilterInput>;
  citizenships?: InputMaybe<CountryListFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  contractType?: InputMaybe<ContractTypeFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryState?: InputMaybe<CountryStateFilterInput>;
  experiences?: InputMaybe<ExperienceListFilterInput>;
  expertises?: InputMaybe<ExpertiseListFilterInput>;
  formattedName?: InputMaybe<StringFilterInput>;
  gender?: InputMaybe<GenderFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isContact?: InputMaybe<BooleanFilterInput>;
  isInAnyPersonGroup?: InputMaybe<BooleanFilterInput>;
  isInAnyPinGroup?: InputMaybe<BooleanFilterInput>;
  isPinned?: InputMaybe<BooleanFilterInput>;
  jobDepartment?: InputMaybe<JobDepartmentFilterInput>;
  jobLocation?: InputMaybe<JobLocationFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  languageSkills?: InputMaybe<LanguageSkillListFilterInput>;
  maritalStatus?: InputMaybe<MaritalStatusFilterInput>;
  name?: InputMaybe<HumanNameFilterInput>;
  nationality?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PersonFilterInput>;
  or?: InputMaybe<Array<PersonFilterInput>>;
  personGroupId?: InputMaybe<UuidFilterInput>;
  pinGroupId?: InputMaybe<UuidFilterInput>;
  workingTimeModel?: InputMaybe<WorkingTimeModelFilterInput>;
};

export type PersonGroup = Category & Node & {
  __typename?: 'PersonGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type PersonGroup */
export type PersonGroupFilterInput = {
  and?: InputMaybe<Array<PersonGroupFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PersonGroupFilterInput>;
  or?: InputMaybe<Array<PersonGroupFilterInput>>;
};

export type PersonGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
};

export type PersonGroupMembershipInput = {
  personId: Scalars['UUID']['input'];
};

export type PersonGroupMembershipOutput = PersonGroupMembershipResult;

export type PersonGroupMembershipResult = {
  __typename?: 'PersonGroupMembershipResult';
  personGroups: Array<PersonGroup>;
};

/** The filterable fields of type PersonGroupMembershipResult */
export type PersonGroupMembershipResultFilterInput = {
  and?: InputMaybe<Array<PersonGroupMembershipResultFilterInput>>;
  not?: InputMaybe<PersonGroupMembershipResultFilterInput>;
  or?: InputMaybe<Array<PersonGroupMembershipResultFilterInput>>;
};

export type PersonGroupOutput = PersonGroupResult;

export type PersonGroupRecipient = Node & Recipient & {
  __typename?: 'PersonGroupRecipient';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type PersonGroupRecipient */
export type PersonGroupRecipientFilterInput = {
  and?: InputMaybe<Array<PersonGroupRecipientFilterInput>>;
  not?: InputMaybe<PersonGroupRecipientFilterInput>;
  or?: InputMaybe<Array<PersonGroupRecipientFilterInput>>;
};

export type PersonGroupResult = {
  __typename?: 'PersonGroupResult';
  personGroups: Array<PersonGroup>;
};

/** The filterable fields of type PersonGroupResult */
export type PersonGroupResultFilterInput = {
  and?: InputMaybe<Array<PersonGroupResultFilterInput>>;
  not?: InputMaybe<PersonGroupResultFilterInput>;
  or?: InputMaybe<Array<PersonGroupResultFilterInput>>;
};

export type PersonGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

export type PersonLean = {
  __typename?: 'PersonLean';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type PersonLean */
export type PersonLeanFilterInput = {
  and?: InputMaybe<Array<PersonLeanFilterInput>>;
  not?: InputMaybe<PersonLeanFilterInput>;
  or?: InputMaybe<Array<PersonLeanFilterInput>>;
};

/** What the administrator may do with this row right now. The server re-checks regardless. */
export enum PersonLoginAction {
  /** Offer the invitation dialog for an unbound person. */
  Invite = 'INVITE',
  /** Offer resend from invitation history; the command checks current account eligibility. */
  Resend = 'RESEND'
}

/**
 * One Person in the login-assignment admin list.
 *
 * The two email fields are different things. `suggestedEmail` is a starting point for the dialog, taken
 * from the Person's stored address and null when that address is a reserved placeholder
 * (`@adr GENESIS-0044-imported-persons-without-email-use-reserved-placeholders@2`); it is never a
 * confirmed recipient, and the dialog re-confirms it every time. `invitationEmail` is the recipient the
 * last invitation from here was actually addressed to, and is answered only to a caller holding
 * `provision:invitee`.
 */
export type PersonLoginAssignment = Node & {
  __typename?: 'PersonLoginAssignment';
  /** What this row offers now. Empty for a row whose state does not permit anything. */
  actions: Array<PersonLoginAction>;
  /** First authenticated Genesis access observed since tracking began. Null means no access recorded, not an unaccepted invitation. */
  firstAuthenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The recipient of the last invitation request. Administrators only. */
  invitationEmail?: Maybe<Scalars['String']['output']>;
  /** The last invitation attempt's step, or null when this Person was never invited from here. */
  invitationStep?: Maybe<PersonLoginInvitationStep>;
  /** Invitation history, newest first. Every page is authorized against the target person. */
  invitations: PersonLoginInvitationConnection;
  lastInvitation?: Maybe<PersonLoginInvitation>;
  /** The Person's formatted name, so the dialog can name who is about to be invited. */
  name: Scalars['String']['output'];
  personId: Scalars['UUID']['output'];
  status: PersonLoginStatus;
  /** An editable suggestion for the dialog. Null when the stored address is a placeholder or missing. */
  suggestedEmail?: Maybe<Scalars['String']['output']>;
};


/**
 * One Person in the login-assignment admin list.
 *
 * The two email fields are different things. `suggestedEmail` is a starting point for the dialog, taken
 * from the Person's stored address and null when that address is a reserved placeholder
 * (`@adr GENESIS-0044-imported-persons-without-email-use-reserved-placeholders@2`); it is never a
 * confirmed recipient, and the dialog re-confirms it every time. `invitationEmail` is the recipient the
 * last invitation from here was actually addressed to, and is answered only to a caller holding
 * `provision:invitee`.
 */
export type PersonLoginAssignmentInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A database-only page of visible active people. No population count or realm survey. */
export type PersonLoginAssignmentConnection = {
  __typename?: 'PersonLoginAssignmentConnection';
  nodes: Array<PersonLoginAssignment>;
  pageInfo: PageInfo;
};

/** The filterable fields of type PersonLoginAssignmentConnection */
export type PersonLoginAssignmentConnectionFilterInput = {
  and?: InputMaybe<Array<PersonLoginAssignmentConnectionFilterInput>>;
  not?: InputMaybe<PersonLoginAssignmentConnectionFilterInput>;
  or?: InputMaybe<Array<PersonLoginAssignmentConnectionFilterInput>>;
};

/** The filterable fields of type PersonLoginAssignment */
export type PersonLoginAssignmentFilterInput = {
  and?: InputMaybe<Array<PersonLoginAssignmentFilterInput>>;
  not?: InputMaybe<PersonLoginAssignmentFilterInput>;
  or?: InputMaybe<Array<PersonLoginAssignmentFilterInput>>;
};

/** One person's database-derived account binding. */
export type PersonLoginAssignmentInput = {
  personId: Scalars['UUID']['input'];
};

/** Filter and page the login-assignment list. Every arm is applied in SQL, before paging. */
export type PersonLoginAssignmentsInput = {
  /** Cursor from a previous page's `pageInfo.endCursor`. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Page size, 1..100. Omitted means 25. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Matches the Person's names and their stored address. Trimmed; blank means no search. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to these states. Omitted or empty means every state. */
  status?: InputMaybe<Array<PersonLoginStatus>>;
};

/** One invitation request. sentAt means Keycloak accepted the send, not delivery or onboarding completion. */
export type PersonLoginInvitation = {
  __typename?: 'PersonLoginInvitation';
  operation: PersonLoginInvitationOperation;
  outcome?: Maybe<PersonLoginInvitationOutcome>;
  recipient: Scalars['String']['output'];
  requestId: Scalars['UUID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['UUID']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  step: PersonLoginInvitationStep;
};

export type PersonLoginInvitationConnection = {
  __typename?: 'PersonLoginInvitationConnection';
  nodes: Array<PersonLoginInvitation>;
  pageInfo: PageInfo;
};

/** The filterable fields of type PersonLoginInvitationConnection */
export type PersonLoginInvitationConnectionFilterInput = {
  and?: InputMaybe<Array<PersonLoginInvitationConnectionFilterInput>>;
  not?: InputMaybe<PersonLoginInvitationConnectionFilterInput>;
  or?: InputMaybe<Array<PersonLoginInvitationConnectionFilterInput>>;
};

/** The filterable fields of type PersonLoginInvitation */
export type PersonLoginInvitationFilterInput = {
  and?: InputMaybe<Array<PersonLoginInvitationFilterInput>>;
  not?: InputMaybe<PersonLoginInvitationFilterInput>;
  or?: InputMaybe<Array<PersonLoginInvitationFilterInput>>;
};

export enum PersonLoginInvitationOperation {
  Invite = 'INVITE',
  Resend = 'RESEND'
}

/** What the invitation actually did. Every value is a normal business result, not an error. */
export enum PersonLoginInvitationOutcome {
  /** The account changed under us (established, disabled or re-bound). Nothing was sent. */
  AccountChanged = 'ACCOUNT_CHANGED',
  /** The Person already has a login. Nothing was created, changed or sent. */
  AlreadyAssigned = 'ALREADY_ASSIGNED',
  /**
   * Creating the account ended ambiguously: an account may or may not exist in the realm, nothing is bound
   * and nothing was sent. Needs a fresh check by a human; a blind repeat is what produces the second
   * account.
   */
  CreateUncertain = 'CREATE_UNCERTAIN',
  /** Another account already uses this address. No merge happens by email; nothing was changed. */
  EmailConflict = 'EMAIL_CONFLICT',
  /** A new account was created, bound to this Person, and the onboarding link sent. */
  Invited = 'INVITED',
  /** The pending invitation's recipient was changed and the link sent to the new address. */
  RecipientUpdated = 'RECIPIENT_UPDATED',
  /** A still-pending invitation was re-sent to the same address. */
  Resent = 'RESENT',
  /**
   * The realm refused the mail. Nothing was delivered and the binding stands, so a resend is the repair -
   * this is the one failure that may safely be repeated.
   */
  SendFailed = 'SEND_FAILED',
  /**
   * The binding is durable but the send ended ambiguously. It may well have arrived, so the client must
   * report the uncertainty for operational repair; automatic replay is blocked.
   */
  SendUncertain = 'SEND_UNCERTAIN'
}

/** The invitation's result together with the refreshed row, so a client need not re-query. */
export type PersonLoginInvitationOutput = {
  __typename?: 'PersonLoginInvitationOutput';
  assignment: PersonLoginAssignment;
  outcome: PersonLoginInvitationOutcome;
};

/** The filterable fields of type PersonLoginInvitationOutput */
export type PersonLoginInvitationOutputFilterInput = {
  and?: InputMaybe<Array<PersonLoginInvitationOutputFilterInput>>;
  not?: InputMaybe<PersonLoginInvitationOutputFilterInput>;
  or?: InputMaybe<Array<PersonLoginInvitationOutputFilterInput>>;
};

/** How far the last invitation attempt for this Person got. A dispatch record, never proof of a login. */
export enum PersonLoginInvitationStep {
  /** A Keycloak account was created but is not yet bound to the Person. */
  AccountCreated = 'ACCOUNT_CREATED',
  /** The account is bound to the Person; the mail has not gone out yet. */
  Bound = 'BOUND',
  /** Finished without sending an invitation, for example because of an email conflict. */
  Completed = 'COMPLETED',
  /** An external write is in flight or ambiguous. Requires operational repair, never automatic replay. */
  OutcomeUncertain = 'OUTCOME_UNCERTAIN',
  /** The attempt is claimed with a confirmed recipient; nothing has been created yet. */
  Reserved = 'RESERVED',
  /** Sending failed in a way that says it did not happen. Resend is safe. */
  SendFailed = 'SEND_FAILED',
  /** Keycloak accepted the action-token mail. */
  Sent = 'SENT'
}

/** Account association stored by Genesis. This does not describe onboarding or account enablement. */
export enum PersonLoginStatus {
  /** The person has an account subject. */
  Assigned = 'ASSIGNED',
  /** The person has no account binding. */
  Unassigned = 'UNASSIGNED'
}

/** The parameters for requesting multiple instances of Person. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type PersonQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<PersonSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<PersonFilterInput>;
};

export type PersonRecipient = Node & Recipient & {
  __typename?: 'PersonRecipient';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<HumanName>;
  thumbnail?: Maybe<File>;
};


export type PersonRecipientThumbnailArgs = {
  profile: Scalars['String']['input'];
  useAlternative: Scalars['Boolean']['input'];
};

/** The filterable fields of type PersonRecipient */
export type PersonRecipientFilterInput = {
  and?: InputMaybe<Array<PersonRecipientFilterInput>>;
  not?: InputMaybe<PersonRecipientFilterInput>;
  or?: InputMaybe<Array<PersonRecipientFilterInput>>;
};

/** Contains information for linking 'Person' to other entities */
export type PersonRelationInput = {
  /** The identifier of 'Person' */
  id: Scalars['ID']['input'];
};

export enum PersonSearchScope {
  Identity = 'IDENTITY',
  Profile = 'PROFILE'
}

export type PersonSharedAttributes = {
  __typename?: 'PersonSharedAttributes';
  sharedAge?: Maybe<Array<Scalars['String']['output']>>;
  sharedApartmentNumber?: Maybe<Array<Scalars['String']['output']>>;
  sharedBio?: Maybe<Array<Scalars['String']['output']>>;
  sharedBirthdate?: Maybe<Array<Scalars['String']['output']>>;
  sharedChildCount?: Maybe<Array<Scalars['String']['output']>>;
  sharedCitizenships?: Maybe<Array<Scalars['String']['output']>>;
  sharedCity?: Maybe<Array<Scalars['String']['output']>>;
  sharedContractType?: Maybe<Array<Scalars['String']['output']>>;
  sharedCountry?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentActivity?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentEmployer?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentTasks?: Maybe<Array<Scalars['String']['output']>>;
  sharedDriversLicense?: Maybe<Array<Scalars['String']['output']>>;
  sharedEmail?: Maybe<Array<Scalars['String']['output']>>;
  sharedGender?: Maybe<Array<Scalars['String']['output']>>;
  sharedHouseNumber?: Maybe<Array<Scalars['String']['output']>>;
  sharedMaritalStatus?: Maybe<Array<Scalars['String']['output']>>;
  sharedMiscellaneous?: Maybe<Array<Scalars['String']['output']>>;
  sharedNationality?: Maybe<Array<Scalars['String']['output']>>;
  sharedPhone?: Maybe<Array<Scalars['String']['output']>>;
  /** Recipient Group IDs for powers consent. An empty list selects no recipients. */
  sharedPowers?: Maybe<Array<Scalars['String']['output']>>;
  sharedProfession?: Maybe<Array<Scalars['String']['output']>>;
  sharedState?: Maybe<Array<Scalars['String']['output']>>;
  sharedStreet?: Maybe<Array<Scalars['String']['output']>>;
  sharedWebsite?: Maybe<Array<Scalars['String']['output']>>;
  sharedWorkingTimeModel?: Maybe<Array<Scalars['String']['output']>>;
  sharedZipCode?: Maybe<Array<Scalars['String']['output']>>;
};

/** The filterable fields of type PersonSharedAttributes */
export type PersonSharedAttributesFilterInput = {
  and?: InputMaybe<Array<PersonSharedAttributesFilterInput>>;
  not?: InputMaybe<PersonSharedAttributesFilterInput>;
  or?: InputMaybe<Array<PersonSharedAttributesFilterInput>>;
};

export type PersonSortInput = {
  contactSince?: InputMaybe<SortOrder>;
  formattedName?: InputMaybe<SortOrder>;
  name?: InputMaybe<HumanNameSortInput>;
};

export type PersonWithDate = {
  __typename?: 'PersonWithDate';
  dateTime: Scalars['DateTime']['output'];
  person: Person;
};

/** The filterable fields of type PersonWithDate */
export type PersonWithDateFilterInput = {
  and?: InputMaybe<Array<PersonWithDateFilterInput>>;
  not?: InputMaybe<PersonWithDateFilterInput>;
  or?: InputMaybe<Array<PersonWithDateFilterInput>>;
};

/** The caller's Group choices, including selected Groups retired from the recipient picker. */
export type PersonalSharing = {
  __typename?: 'PersonalSharing';
  /** Attribute names (for example sharedEmail) explicitly shared with all current and future eligible Groups. */
  allGroupsAttributes: Array<Scalars['String']['output']>;
  /** Each list contains Group IDs. An empty or null list means no ordinary third-party consent. */
  attributes: PersonSharedAttributes;
  recipients: Array<PersonalSharingRecipient>;
};

/** The filterable fields of type PersonalSharing */
export type PersonalSharingFilterInput = {
  and?: InputMaybe<Array<PersonalSharingFilterInput>>;
  not?: InputMaybe<PersonalSharingFilterInput>;
  or?: InputMaybe<Array<PersonalSharingFilterInput>>;
};

/** A named Group available for personal attribute sharing. Eligibility itself grants no access. */
export type PersonalSharingRecipient = {
  __typename?: 'PersonalSharingRecipient';
  eligible: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The filterable fields of type PersonalSharingRecipient */
export type PersonalSharingRecipientFilterInput = {
  and?: InputMaybe<Array<PersonalSharingRecipientFilterInput>>;
  not?: InputMaybe<PersonalSharingRecipientFilterInput>;
  or?: InputMaybe<Array<PersonalSharingRecipientFilterInput>>;
};

export type PinGroup = Category & Node & {
  __typename?: 'PinGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pinType: PinType;
};

/** The filterable fields of type PinGroup */
export type PinGroupFilterInput = {
  and?: InputMaybe<Array<PinGroupFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PinGroupFilterInput>;
  or?: InputMaybe<Array<PinGroupFilterInput>>;
};

export type PinGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
  pinTypes?: InputMaybe<Array<PinType>>;
};

export type PinGroupMembershipInput = {
  personId?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PinGroupMembershipOutput = PinGroupMembershipResult;

export type PinGroupMembershipResult = {
  __typename?: 'PinGroupMembershipResult';
  pinGroups: Array<PinGroup>;
};

/** The filterable fields of type PinGroupMembershipResult */
export type PinGroupMembershipResultFilterInput = {
  and?: InputMaybe<Array<PinGroupMembershipResultFilterInput>>;
  not?: InputMaybe<PinGroupMembershipResultFilterInput>;
  or?: InputMaybe<Array<PinGroupMembershipResultFilterInput>>;
};

export type PinGroupOutput = PinGroupResult;

export type PinGroupResult = {
  __typename?: 'PinGroupResult';
  pinGroups: Array<PinGroup>;
};

/** The filterable fields of type PinGroupResult */
export type PinGroupResultFilterInput = {
  and?: InputMaybe<Array<PinGroupResultFilterInput>>;
  not?: InputMaybe<PinGroupResultFilterInput>;
  or?: InputMaybe<Array<PinGroupResultFilterInput>>;
};

export type PinGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

export enum PinType {
  Person = 'PERSON',
  Post = 'POST',
  Project = 'PROJECT'
}

export type PlayableGrowElement = {
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type PlayableGrowElement */
export type PlayableGrowElementFilterInput = {
  and?: InputMaybe<Array<PlayableGrowElementFilterInput>>;
  not?: InputMaybe<PlayableGrowElementFilterInput>;
  or?: InputMaybe<Array<PlayableGrowElementFilterInput>>;
};

export type PowersDevStat = {
  __typename?: 'PowersDevStat';
  currentValue: Scalars['Int']['output'];
  element: CreativityElement;
  person?: Maybe<PersonLean>;
  previousValue: Scalars['Int']['output'];
};

/** The filterable fields of type PowersDevStat */
export type PowersDevStatFilterInput = {
  and?: InputMaybe<Array<PowersDevStatFilterInput>>;
  not?: InputMaybe<PowersDevStatFilterInput>;
  or?: InputMaybe<Array<PowersDevStatFilterInput>>;
};

export type PresenceIndicator = {
  __typename?: 'PresenceIndicator';
  conversationId: Scalars['UUID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  observedAt: Scalars['DateTime']['output'];
  online: Scalars['Boolean']['output'];
  personId: Scalars['UUID']['output'];
};

/** The filterable fields of type PresenceIndicator */
export type PresenceIndicatorFilterInput = {
  and?: InputMaybe<Array<PresenceIndicatorFilterInput>>;
  not?: InputMaybe<PresenceIndicatorFilterInput>;
  or?: InputMaybe<Array<PresenceIndicatorFilterInput>>;
};

export type ProcessDocumentInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  documentId?: InputMaybe<Scalars['UUID']['input']>;
  fileName: Scalars['String']['input'];
};

export type ProcessDocumentsInput = {
  /**
   * The documents to analyse in one run. At most 10 — genesis prepares the list in parallel, one
   * `/preprocess` call per stored document, so the length of this list is the fan-out into
   * document-extraction. A longer list is refused with a validation error rather than truncated
   * (`ExtractionDocumentLimits.MAX_DOCUMENTS_PER_RUN`, genesis#303). An empty list is refused too.
   */
  documents: Array<ProcessDocumentInput>;
  extractPowers: Scalars['Boolean']['input'];
  extractProfile: Scalars['Boolean']['input'];
  extractSkills: Scalars['Boolean']['input'];
};

export type ProcessDocumentsOutput = ProcessDocumentsResult;

export type ProcessDocumentsResult = {
  __typename?: 'ProcessDocumentsResult';
  documents: Array<ProcessedDocumentResult>;
  /** First fatal message of the run. Diagnostic — not user-facing copy. */
  message?: Maybe<Scalars['String']['output']>;
  /** Overall: `success`, `partial` (some documents unusable, some not) or `error` (all unusable). */
  status: Scalars['String']['output'];
  /** Non-fatal pipeline diagnostics. Diagnostic — not user-facing copy. */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** The filterable fields of type ProcessDocumentsResult */
export type ProcessDocumentsResultFilterInput = {
  and?: InputMaybe<Array<ProcessDocumentsResultFilterInput>>;
  not?: InputMaybe<ProcessDocumentsResultFilterInput>;
  or?: InputMaybe<Array<ProcessDocumentsResultFilterInput>>;
};

/**
 * What one extraction run did with one document. The list of these is the run's only accounting —
 * there are no per-pipeline totals beside it, so a caller that wants a summary counts this list.
 */
export type ProcessedDocumentResult = {
  __typename?: 'ProcessedDocumentResult';
  documentId?: Maybe<Scalars['UUID']['output']>;
  /** Dateiname zum Zeitpunkt des Laufs, auch für nur analysierte, nicht gespeicherte Dateien. */
  fileName?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  /**
   * One of `analysed` (evidence was found in this document), `already_analysed` (evidence for it
   * existed before this run), `nothing_found` (read, contributed no evidence — the next run offers it
   * again), `unreadable` (no text could be extracted) or `failed` (the extraction call, the
   * persistence, or the job deadline ended it). Treat an unknown value as `failed`.
   */
  status: Scalars['String']['output'];
};

/** The filterable fields of type ProcessedDocumentResult */
export type ProcessedDocumentResultFilterInput = {
  and?: InputMaybe<Array<ProcessedDocumentResultFilterInput>>;
  not?: InputMaybe<ProcessedDocumentResultFilterInput>;
  or?: InputMaybe<Array<ProcessedDocumentResultFilterInput>>;
};

/**
 * Selects the areas included in a self-service YAML export. At least one area must be selected.
 * Further profile-related areas can be added here without changing the export query signature.
 */
export type ProfileExportInput = {
  /** The caller's document groups, documents, metadata, tags and file content. Without `profile`, the target Person must already exist when this YAML is imported. */
  documents?: Scalars['Boolean']['input'];
  /** Core profile, details, portraits, experiences, educations, expertises, language skills and certificates. */
  profile?: Scalars['Boolean']['input'];
};

/**
 * Non-destructive preview of a profile import — nothing is written. The importer fetches
 * and maps the source (LinkedIn) data, diffs it against the caller's existing profile, and
 * returns the per-field / per-row diff. The client reviews and edits the proposals, then
 * persists the accepted ones through the ordinary profile mutations (updatePerson,
 * createExperience, …) — the same write path as manual editing. Genesis holds no import
 * state between preview and save.
 */
export type ProfileImportPreview = {
  __typename?: 'ProfileImportPreview';
  certificates: CollectionDiff;
  educations: CollectionDiff;
  experiences: CollectionDiff;
  expertises: CollectionDiff;
  languageSkills: CollectionDiff;
  personDetail: Array<PersonDetailFieldDiff>;
  warnings: Array<Scalars['String']['output']>;
};

/** The filterable fields of type ProfileImportPreview */
export type ProfileImportPreviewFilterInput = {
  and?: InputMaybe<Array<ProfileImportPreviewFilterInput>>;
  not?: InputMaybe<ProfileImportPreviewFilterInput>;
  or?: InputMaybe<Array<ProfileImportPreviewFilterInput>>;
};

/** One fact under a stage: a key plus numbers, never a sentence. */
export type ProgressDetail = {
  __typename?: 'ProgressDetail';
  count?: Maybe<Scalars['Int']['output']>;
  key: ProgressDetailKey;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ProgressDetail */
export type ProgressDetailFilterInput = {
  and?: InputMaybe<Array<ProgressDetailFilterInput>>;
  not?: InputMaybe<ProgressDetailFilterInput>;
  or?: InputMaybe<Array<ProgressDetailFilterInput>>;
};

/** Facts an operation may report under a stage. A closed vocabulary like ProgressStage. */
export enum ProgressDetailKey {
  /** count = candidate assessments that failed. */
  MatchAssessmentsFailed = 'MATCH_ASSESSMENTS_FAILED',
  /** count = candidates in the pool. */
  MatchCandidatesLoaded = 'MATCH_CANDIDATES_LOADED',
  /** count = checks that needed an AI decision so far. */
  MatchChecksWithAi = 'MATCH_CHECKS_WITH_AI',
  /** count = companies in the pool. */
  MatchCompaniesLoaded = 'MATCH_COMPANIES_LOADED',
  /** count = active criteria. */
  MatchCriteriaActive = 'MATCH_CRITERIA_ACTIVE',
  /** count = candidates whose residence was resolved, total = candidates. */
  MatchLocationsResolved = 'MATCH_LOCATIONS_RESOLVED'
}

/**
 * Stages an operation may report. A closed vocabulary: the server sends the key, clients word it. Each
 * key is prefixed by the operation that reports it.
 */
export enum ProgressStage {
  /** Assess each candidate with AI (RANK with AI only); counts completed assessments, including failures reported separately under MATCH_ASSESSMENTS_FAILED. */
  MatchAssessment = 'MATCH_ASSESSMENT',
  /** Check every candidate against every active criterion; counts candidate x criterion checks. */
  MatchCriteria = 'MATCH_CRITERIA',
  /** Build the result and store it as the unsaved draft. */
  MatchFinalize = 'MATCH_FINALIZE',
  /** Load the match, its candidates and their profiles. */
  MatchPrepare = 'MATCH_PREPARE',
  /** Compose the teams with the solver (OPTIMIZE only). */
  MatchSolve = 'MATCH_SOLVE'
}

/**
 * One stage of an operation's progress. total is set only when the denominator was known before the
 * stage's work began and never changes afterwards; null means indeterminate. done never decreases.
 */
export type ProgressStageState = {
  __typename?: 'ProgressStageState';
  /** Facts of this stage, not a log: a key appears once and updates in place. */
  details: Array<ProgressDetail>;
  done?: Maybe<Scalars['Int']['output']>;
  key: ProgressStage;
  status: ProgressStageStatus;
  total?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ProgressStageState */
export type ProgressStageStateFilterInput = {
  and?: InputMaybe<Array<ProgressStageStateFilterInput>>;
  not?: InputMaybe<ProgressStageStateFilterInput>;
  or?: InputMaybe<Array<ProgressStageStateFilterInput>>;
};

/** State of one stage of an operation's progress. */
export enum ProgressStageStatus {
  Active = 'ACTIVE',
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

/**
 * Ein Vorhaben als eigene Entität: die Klammer, unter der Aufteilung, Anforderungen, Matches und
 * der Ablauf zusammenkommen. Ein Projekt existiert, sobald es einen Namen hat; alles andere wird
 * danach ergänzt.
 *
 * Harte Spalten sind nur `name` und `description`. Alles, dessen Form noch in Bewegung ist
 * (Anlass, Pakete mit Aufgaben, Anforderungsprofil, Dokument-StorageIds, Status), liegt in `data`
 * als JSONB mit einem Versionsschlüssel. Ein versionsbewusster `ProjectDataDeserializer` ist
 * vorhanden; der Controller liest und schreibt derzeit Maps und gibt `data` als Object-Skalar aus.
 *
 * `matches` ist bewusst `@readonly`: die Zuordnung ist eine eigene Relation mit Fremdschlüsseln
 * und wird über eigene Mutationen gepflegt, nicht als Liste im Create-Input.
 *
 * Initialer Prototyp: `deleteProject` löscht hart, ein persönliches Projekt nur durch den Ersteller, ein
 * Firmenprojekt nur durch die Admins der Firma; Zugriffszeilen und Match-Verknüpfungen gehen mit, die
 * Matches selbst bleiben (genesis#392). Anlegen verlangt `feature:share.projects`; eigene und geteilte
 * Projekte bleiben ohne das Feature erreichbar (genesis#402). Ein Projekt kann einer Firma gehören,
 * siehe `company` (genesis#418).
 */
export type Project = Node & {
  __typename?: 'Project';
  /**
   * Wer Zugriff hat, als ganzer Sollzustand wie bei `Match.access`: bei `updateProject` ersetzt die
   * Liste alle Zugriffe, wer fehlt, verliert seinen. Eine leere Liste entzieht allen den Zugriff;
   * `null` oder ein weggelassenes Feld lässt ihn stehen. Ausnahme ist bei einem persönlichen Projekt
   * der Ersteller: seine Zeile bleibt mit WRITE auf allen Flächen stehen, Einträge für ihn werden
   * ignoriert (genesis#392). Ein Firmenprojekt hat keine solche Zeile; dort ist der Ersteller ein
   * Eintrag wie jeder andere (genesis#418).
   */
  access?: Maybe<Array<ProjectAccess>>;
  actions: ProjectActions;
  /**
   * Die Firma, in deren Namen das Projekt angelegt wurde, oder null für ein persönliches Projekt
   * (genesis#418). Wie bei `SharedItem.company`: nur beim Anlegen setzbar, nur durch einen Admin dieser
   * Firma, und die Firma muss aktiv sein. Ein persönliches Projekt wird nie zum Firmenprojekt und
   * umgekehrt. Ein Firmenprojekt sehen, ändern und löschen die Admins der Firma; eine inaktive Firma
   * friert ihre Projekte ein. `createdBy` nennt weiter, wer es angelegt hat, entscheidet aber nichts.
   */
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  data?: Maybe<Scalars['Object']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  matches?: Maybe<Array<Match>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Person>;
};

/**
 * Wer an einem Projekt was darf, nach demselben Muster wie `MatchAccess`: eine Zeile je Person,
 * gestufte Rechte je Arbeitsfläche. Drei Flächen statt Matchs vier, weil ein Projekt genau drei hat.
 *
 * Sichtbarkeit ist davon unabhängig und binär: wer das Projekt angelegt hat oder hier genannt ist,
 * sieht es. Die Stufen entscheiden erst, was er darf.
 */
export type ProjectAccess = {
  __typename?: 'ProjectAccess';
  /** Wer angefragt wird und wer zusagt. */
  candidates: AccessLevel;
  person: Person;
  /** Anlass, Aufteilung, Einordnung, Anforderungen. */
  plan: AccessLevel;
  /** Einträge im Ablauf - die Editor-Rolle. */
  timeline: AccessLevel;
};

/** The filterable fields of type ProjectAccess */
export type ProjectAccessFilterInput = {
  and?: InputMaybe<Array<ProjectAccessFilterInput>>;
  not?: InputMaybe<ProjectAccessFilterInput>;
  or?: InputMaybe<Array<ProjectAccessFilterInput>>;
};

/**
 * Was die aufrufende Person an diesem Projekt darf, nach dem Muster von `MatchActions`. Es gilt dieselbe
 * Regel wie beim Schreiben: `updateProject`, `linkProjectMatch` und `unlinkProjectMatch` verlangen WRITE
 * auf `plan`; der Ersteller eines persönlichen Projekts darf es immer, bei einem Firmenprojekt die Admins
 * der Firma, diese aber nur im Firmenkontext (`actingAsCompanyId`). Bei einer inaktiven Firma ist alles
 * false. `candidates` und `timeline` prüft der Server nicht einzeln, deshalb gibt es für sie keine
 * eigenen Rechte.
 */
export type ProjectActions = {
  __typename?: 'ProjectActions';
  /** Der Ersteller eines persönlichen Projekts, bei einem Firmenprojekt die Admins der Firma; genau das prüft `deleteProject`. */
  canDelete: Scalars['Boolean']['output'];
  /** Die Zugriffsliste ändern (`updateProject` mit `access`). */
  canManageAccess: Scalars['Boolean']['output'];
  /** Name, Beschreibung und Planung ändern, Matches verknüpfen und lösen. */
  canUpdate: Scalars['Boolean']['output'];
};

/** The filterable fields of type ProjectActions */
export type ProjectActionsFilterInput = {
  and?: InputMaybe<Array<ProjectActionsFilterInput>>;
  not?: InputMaybe<ProjectActionsFilterInput>;
  or?: InputMaybe<Array<ProjectActionsFilterInput>>;
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  edges: Array<ProjectEdge>;
  nodes: Array<Project>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  cursor: Scalars['String']['output'];
  node: Project;
};

/** The filterable fields of type Project */
export type ProjectFilterInput = {
  and?: InputMaybe<Array<ProjectFilterInput>>;
  description?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ProjectFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
};

/** The parameters for requesting multiple instances of Project. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type ProjectQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<ProjectSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<ProjectFilterInput>;
};

export type ProjectSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** A saved answer supplied by a Person; readable by its owner or an explicit personal-information override. */
export type ProvidedQuestionnaireAnswer = {
  __typename?: 'ProvidedQuestionnaireAnswer';
  answer: Scalars['String']['output'];
  answerChoiceId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  questionId: Scalars['UUID']['output'];
  questionnaireId: Scalars['UUID']['output'];
  timeTakenMs: Scalars['Int']['output'];
};

/** The filterable fields of type ProvidedQuestionnaireAnswer */
export type ProvidedQuestionnaireAnswerFilterInput = {
  and?: InputMaybe<Array<ProvidedQuestionnaireAnswerFilterInput>>;
  not?: InputMaybe<ProvidedQuestionnaireAnswerFilterInput>;
  or?: InputMaybe<Array<ProvidedQuestionnaireAnswerFilterInput>>;
};

/** Input for provisionInvitee — a single email to provision as an external invitee. */
export type ProvisionInviteeInput = {
  /** Email address of the person to provision. Becomes the invitee's Keycloak username. */
  email: Scalars['String']['input'];
};

/** Classification of what provisionInvitee did with the submitted email. */
export enum ProvisionInviteeOutcome {
  /** The email belongs to an established account; nothing was sent and the account was left untouched. */
  Conflict = 'CONFLICT',
  /** No such user existed: an enabled, credential-less invitee was created and a fresh onboarding link sent. */
  Created = 'CREATED',
  /** A still-pending invitee already existed (in invited-outsiders, no credential): the link was re-sent (idempotent). */
  Resent = 'RESENT'
}

/** Result of provisionInvitee. */
export type ProvisionInviteeOutput = {
  __typename?: 'ProvisionInviteeOutput';
  outcome: ProvisionInviteeOutcome;
};

/** The filterable fields of type ProvisionInviteeOutput */
export type ProvisionInviteeOutputFilterInput = {
  and?: InputMaybe<Array<ProvisionInviteeOutputFilterInput>>;
  not?: InputMaybe<ProvisionInviteeOutputFilterInput>;
  or?: InputMaybe<Array<ProvisionInviteeOutputFilterInput>>;
};

export type QnrAnswerChoiceSaveInput = {
  answer: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  qnrAnswerChoiceId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<QuestionnaireStatus>;
  weight: Scalars['Int']['input'];
};

export type QnrQuestionSaveInput = {
  answerChoices: Array<QnrAnswerChoiceSaveInput>;
  creativityElement: CreativityElement;
  position: Scalars['Int']['input'];
  qnrQuestionId?: InputMaybe<Scalars['UUID']['input']>;
  question: Scalars['String']['input'];
  status?: InputMaybe<QuestionnaireStatus>;
};

export type Query = {
  __typename?: 'Query';
  accessGroup: AccessGroup;
  accessGroupMembers: AccessGroupMembersResult;
  /** Access administration only; each person appears once with all independent membership sources. */
  accessGroupRoleAssignments: Array<AccessGroupRoleAssignment>;
  /** Access administration only; bounded keyset pages of at most 50 groups. */
  accessGroups: AccessGroupsResult;
  /** Requires access-configuration administration permission. Does not change membership or configuration. */
  accessMembershipPolicy: AccessMembershipPolicy;
  /** Read-only Permission catalog, guarded by write:access-config. */
  accessPermissions: AccessPermissionsResult;
  accessPersonInspection: AccessPersonInspection;
  /** Bounded impact for a proposed Role edit. Groups and people each have independent 50-entry pages. */
  accessRoleImpact: AccessRoleImpact;
  /** Members of a Group receiving this Role. Loaded separately, 50 Persons per page, ordered by id. */
  accessRoleMembers: AccessRoleMembersResult;
  /** System and custom Roles with their Permission bundles, guarded by write:access-config. */
  accessRoles: AccessRolesResult;
  /** Returns ACTIVE questionnaires whose creativity_element equals the given value, each carrying a per-row flag indicating whether the current user has answered every ACTIVE question of that questionnaire. */
  activeQuestionnairesByElement: Array<QuestionnaireResult>;
  /** Returns ACTIVE questionnaires that have no creativity_element set, each carrying a per-row flag indicating whether the current user has answered every ACTIVE question of that questionnaire. */
  activeQuestionnairesWithoutElement: Array<QuestionnaireResult>;
  agent?: Maybe<Agent>;
  agents: AgentConnection;
  /** The catalogue the toplist game offers for a domain: its active items, best known first. */
  catalogItems: Array<CatalogItem>;
  companies: CompanyConnection;
  company: CompanyResult;
  /** Requires compare:companies; uses the ordinary Company read and logo handling. */
  companyComparison: CompanyResult;
  /** The expertise a company lists, alphabetically. Free text owned by that company — see CompanyCompetency. */
  companyCompetencies: CompanyCompetencyResult;
  /**
   *   A fingerprint of every company's expertise, so a caller holding a copy can tell which companies
   *   changed WITHOUT reading them all back.
   *
   * WHY THIS EXISTS. `companyCompetencies` takes one company id, and nothing else here exposes the
   *   labels: `Company.competencies` is filter-only and there is no catalogue to list. A caller keeping a
   *   derived copy — agent-service embeds the labels so a search can match them by meaning — therefore
   *   had to re-read every company on every refresh. One request of fingerprints turns that into a diff,
   *   and in the steady state into nothing.
   *
   * EVERY COMPANY APPEARS, including one listing no expertise: it hashes the empty string, which is a
   *   real value and is what distinguishes "lists nothing" from "not read yet". Omitting those rows would
   *   make a caller re-read every label-less company for ever.
   *
   * THE HASH IS A CONTRACT, and a caller computing it differently gets no benefit and no error — every
   *   company looks changed, or none ever does. It is sha-256, hex, over the company's labels: sorted
   *   case-insensitively and then by code point, compared IN APPLICATION CODE rather than by the database
   *   collation (which orders umlauts differently), joined with NUL, encoded UTF-8. The label text enters
   *   the hash exactly as stored, so a rename that only changes case still changes the hash.
   *
   * Unpaged on purpose: a row is an id and 64 hex characters, so even a large tenant is well under a
   *   megabyte, and paging would reintroduce the round trips this exists to remove.
   */
  companyCompetencyHashes: CompanyCompetencyHashesResult;
  /**
   *   The contact persons of a company — the "Ansprechpartner" of
   *   the company page, capped per company.
   *
   * UNPAGED ON PURPOSE, and the cap is the reason: §4 fixes the set at a small number of referenced
   *   members (three when it was written, ten since genesis#268), so
   *   there is no page to ask for, and a client that fetched page two of the member strip would still
   *   need the whole contact strip beside it.
   *
   * IT CARRIES EXACTLY THE SAME VISIBILITY RULE AS companyMembers, because it is the same SQL predicate
   *   with one more condition ANDed on. Since concept v5 that rule is the active-person rule alone, so this
   *   answers the same to every caller, exactly as the roster does — a contact person is shown because they
   *   are a member. Non-ACTIVE accounts and the synthetic default user are excluded here too, and an
   *   unknown company id is an error rather than an empty list.
   */
  companyContactPersons: CompanyContactPersonsResult;
  /**
   *   Name and logo for a bounded set of company ids — see CompanyIdentitiesResult for why a hydration
   *   surface exists and why it is not a directory.
   *
   * ONE OF THE THREE PLACES `Company.logo` RESOLVES. The bound is the id list itself, capped at 50 by
   *   the server: the caller decides how many images the response carries and does so before it is sent,
   *   which is the property the logo rule actually turns on.
   */
  companyIdentities: CompanyIdentitiesResult;
  /**
   *   The people of a company — the member strip of
   *   the company page.
   *
   * EVERY MEMBERSHIP ROW IS PUBLISHED, and the answer does not depend on who is asking. Until concept
   *   v5 (2026-08-24) it did: a caller from outside the company saw only the members who shared
   *   CURRENT_EMPLOYER with them (@adr GENESIS-0023-company-membership-is-the-per-company-authorization@4 §7,
   *   now superseded by the company page). Membership is
   *   admin-curated, so the consequence is worth stating plainly: an admin adding somebody publishes "P
   *   works here" to every signed-in reader, whatever P has chosen for their own profile. That is the
   *   decision, with its cost recorded in the concept — not an omission.
   *
   * Non-ACTIVE accounts and the synthetic default user are excluded, as everywhere else, and that is now
   *   the ONLY thing that keeps a membership row off this list. An unknown company id is an error rather
   *   than an empty list.
   *
   * IT IS PAGED (@adr GENESIS-0006-cursor-pagination-discourage-totalcount@1, and
   *   @adr GENESIS-0029-the-member-strip-is-paged-and-the-contact-strip-is-not@3 for why this shape).
   *   The active-person rule is decided INSIDE the query, so a page of N is N members rather than N rows
   *   minus the excluded ones, and `hasNextPage` is honest.
   *
   * THE CONTACT PERSONS of the company page ARE NO LONGER READ
   *   HERE — see companyContactPersons, which is the same SQL predicate with `contactPerson` added. They
   *   used to be the marked rows of this list, which stopped working the moment the list became a page:
   *   "the marked rows of the page you happen to be on" is not the set §4 describes. What made reading
   *   them through the roster safe was that they inherited its visibility rule rather than restating it,
   *   and that property is kept by construction — one predicate, two callers — not by keeping one query.
   */
  companyMembers: CompanyMembershipConnection;
  /**
   *   The posts and projects a company OWNS — what the company itself published.
   *
   * OWNED, NOT DERIVED, and that is the change concept v7 made. Until v7 this field answered "the items
   *   belonging to the people who are currently members", so a company page filled up with whatever its
   *   staff happened to have posted, and emptied again when they left. It now answers only for items the
   *   company wrote in its own name: `shared_item.company_id = this company`
   *   (the company entity model and
   *   the company account model, v7).
   *
   * DISPLAY IS MUTUALLY EXCLUSIVE. An item is either a person's or a company's, never both: a personal
   *   item (`company_id is null`) appears in its author's own area and never here, and a company item
   *   appears here and never on the author's profile. That is what lets a company post outlive the admin
   *   who wrote it.
   *
   * DELETION IS REAL (concept v9). An active company's item is deleted outright — row, children and
   *   blobs — exactly like a personal one; there is no soft delete and no `deleted_at`. An earlier edition
   *   made a company item un-hard-deletable, and it was withdrawn because a surviving row has to be skipped
   *   by every reader and an audit found that forgotten in eight queries.
   *
   * AN INACTIVE COMPANY'S ITEMS STILL APPEAR HERE. Freezing takes its content out of SEARCH, not off its
   *   own page — this field is the page. What an inactive company loses is discoverability and every write;
   *   what it keeps is its content, intact, until somebody reactivates it.
   *
   * AN INACTIVE COMPANY'S PAGE STILL SHOWS ITS ITEMS. Concept v8 takes an inactive company's content out
   *   of the SEARCH INDEX, not off its page — the two are different questions, and the page has never been
   *   gated on status. What v8 stops is finding the company through content it published before it went
   *   quiet.
   *
   * Reuses SharedItemQueryInput, so paging, ordering and filtering behave exactly as on sharedItems.
   *   Matches are deliberately absent from the page (0006 §5): a match is a result of a match case,
   *   context-specific, and not showcase content.
   */
  companyOwnedSharedItems: SharedItemConnection;
  contactPowersDevStats: Array<PowersDevStat>;
  contactsWithHighestScore: Array<ContactWithGrowScore>;
  /** Administrator-selected Groups available for new ordinary content shares. */
  contentSharingRecipients: Array<ContentSharingRecipient>;
  contractTypes: ContractTypesResult;
  conversation?: Maybe<Conversation>;
  conversationMessages: Array<ChatMessage>;
  conversationPresence: Array<PresenceIndicator>;
  conversationReadReceipts: Array<ConversationReadReceipt>;
  conversations: Array<Conversation>;
  countries: CountriesResult;
  countryState?: Maybe<CountryState>;
  countryStatesByCountry: CountryStatesByCountryResult;
  curriculumVitae?: Maybe<CurriculumVitae>;
  curriculumVitaes: CurriculumVitaeConnection;
  defaultCandidateAssessmentPrompt: Scalars['String']['output'];
  /** Configured default Groups for content, preserving the prior internal readership at migration. */
  defaultContentSharingRecipients: Array<ContentSharingRecipient>;
  degrees: DegreesResult;
  discoveryCategories: DiscoveryCategoriesResult;
  document?: Maybe<Document>;
  documentGroup?: Maybe<DocumentGroup>;
  documentGroups: DocumentGroupOutput;
  /**
   * The text of one of the caller's OWN documents, page by page, as the documents extraction reads it:
   * OCR for PDFs and images, text extraction for office formats. The first read runs that extraction and
   * caches the pages per document; every later read comes from the cache without touching the file again.
   * Another person's document is refused as not found, whatever the caller's permissions.
   */
  documentText: DocumentText;
  documents: DocumentConnection;
  emailTemplates: Array<EmailTemplate>;
  /**
   * Exports the selected parts of the caller's own data as a multi-document YAML payload in
   * the importer format (see `importDocuments`). `profile` includes the Person document,
   * details, portraits and profile collections; `documents` includes DocumentGroups and
   * Documents with file content inline as base64. Every document carries `operation: merge`.
   * Contacts, group memberships and shared items are not part of the export. Note the
   * importer's admission limits (payload size, document count) when re-importing profiles
   * with many documents.
   */
  exportMyProfile: Scalars['String']['output'];
  /**
   * Returns the current status of a documents-extraction job started by the caller. Serves as
   * the polling fallback when the events subscription is unavailable, or when a job was
   * interrupted (e.g. by a deployment) and never emitted its terminal event, and the way back to a
   * finished run's result from its notification. Job state is retained for 30 days after the last
   * transition; older jobs report as not found.
   */
  extractionJob: ExtractionJob;
  /**
   * The code-defined feature catalog and each feature's explicit Role Permission.
   * Guarded by `write:access-config`; callers read their effective eligibility through reachableFeatures.
   */
  features: FeaturesResult;
  /** Returns all files belonging to one YAML import batch, in submission order. */
  fileImportBatch: Array<FileImportJob>;
  /**
   * Returns the route-independent snapshot of a file the caller dropped via `startFileImport`,
   * whichever worker ended up running it. This is the query a shared-drop result page reloads after a
   * navigation or a notification deep link, without having to know the route up front. Job state is
   * retained for as long as the underlying route retains it; older jobs report as not found.
   */
  fileImportJob: FileImportJob;
  genders: GendersResult;
  /** Full-text search across all indexed entity types with audience-based visibility filtering. */
  globalSearch: GlobalSearchOutput;
  growRanking: GrowRanking;
  growResource?: Maybe<GrowResource>;
  /** Returns a restorable YAML import progress/result snapshot owned by the caller. */
  importJob: ImportJob;
  /**
   * Returns the YAML import specification of the deployed importer: format version, JSON Schema,
   * Markdown and the generated examples. Read-only - no database access and no effect on any import
   * job.
   */
  importSpecification: ImportSpecification;
  industries: IndustriesResult;
  jobDepartments: JobDepartmentsResult;
  jobLocations: JobLocationsResult;
  maritalStatuses: MaritalStatusesResult;
  match?: Maybe<Match>;
  matchCandidate?: Maybe<MatchCandidate>;
  matchCandidates: MatchCandidateConnection;
  matchCompanies: MatchCompanyConnection;
  matchCompany?: Maybe<MatchCompany>;
  /**
   * Returns the content of a document in this match's design.project.documents, with its stored name.
   * Requires match visibility and design-read access. Files outside this match are treated as not found.
   */
  matchProjectDocumentContent: File;
  matchResult?: Maybe<MatchResult>;
  matchResults: MatchResultConnection;
  matches: MatchConnection;
  microsoftCalendarConfiguration: MicrosoftCalendarConfiguration;
  microsoftCalendarConnection: MicrosoftCalendarConnection;
  microsoftCalendarView: MicrosoftCalendarView;
  myAvatar?: Maybe<File>;
  /**
   *   The caller's own companies, each with the role they hold — the other direction of
   *   the company account model, which requires that a person can see the
   *   companies their own company_membership rows put them in. companyMembers answers the question keyed by
   *   company; this one answers it keyed by the caller.
   *
   * IT ANSWERS FOR THE CALLER ONLY, derived from the token subject, and takes no argument on purpose. A
   *   person id here would make it "which companies does THAT person belong to" — a third-party question —
   *   rather than the self-read it is. Reading one's own membership rows discloses nothing to anyone else,
   *   so nothing gates it beyond being authenticated.
   *
   * EMPLOYER SHARING DECIDES NOTHING HERE, and since concept v5 it decides nothing on companyMembers
   *   either. Someone who has revoked CURRENT_EMPLOYER still sees their own companies, and is still on
   *   their company's member strip.
   *
   * The active-person rule holds as everywhere else: a caller whose own account is not ACTIVE gets an
   *   empty list, as does one with no memberships — never an error.
   *
   * COMPANY.LOGO IS DELIVERED HERE, AND THIS IS THE ONLY LIST THAT DELIVERS IT. The rule that keeps
   *   logos off lists was not forgotten: it exists because the bytes travel base64 inside the response, so
   *   a list of unknown length selecting `logo` ships one full image per row — the reason companyMembers,
   *   the unbounded roster, is paged and carries no logo. This list is bounded in kind, not by a page
   *   size: it is the caller's OWN company_membership rows, so it is as long as the number of companies
   *   one person belongs to, and each Company appears at most once. `summary` and `employeeCount` are
   *   still null here — those are profile text, and the single-company query and `companies` nodes are
   *   where the profile lives.
   */
  myCompanies: MyCompaniesResult;
  myContactCount: Scalars['Int']['output'];
  /** The caller's favourites, best first per domain; of one domain when the input names it. */
  myFavorites: Array<Favorite>;
  /** The caller's own game sessions, newest first and at most 50; filtered to one game when gameKey is given. */
  myGameSessions: Array<GameSession>;
  /**
   * The Permission codes the current principal holds, at the INTERNAL audience — the rights-projection
   * counterpart to `reachableFeatures`. Open to any authenticated principal, unguarded like
   * `reachableFeatures`: the answer is only ever about the caller's own grants, so there is nothing here
   * to hide.
   */
  myPermissions: MyPermissionsResult;
  myPersonalSharing: PersonalSharing;
  myPowersDevStats: Array<PowersDevStat>;
  /** One of the caller's toplist sessions with its snapshot; null when the caller has no toplist session with this id. */
  myToplistSession?: Maybe<ToplistSession>;
  myself: Person;
  /** Returns the current user's notifications ordered from newest to oldest. */
  notifications: Array<Notification>;
  numberOfPinnedItems: NumberOfPinsOutput;
  /**
   * The OrgUnit tree an IT administrator maintains under `write:access-config`. Open to any authenticated
   * principal as the reference-data catalogs are — "which units exist here" is what every picker needs.
   */
  orgUnits: OrgUnitsResult;
  organizationalPowerAnalysis: OrganizationalPowerAnalysis;
  /**
   * The organisational record about one subject: exactly one of `personId` and `companyId` must be set. Reached by
   * capability, not by sight (see `organizationalRecordAccess`); the subject has to be ACTIVE, an inactive one reads
   * as absent.
   */
  organizationalRecord?: Maybe<OrganizationalRecord>;
  organizationalRecordAccess: OrganizationalRecordAccess;
  organizationalRecordBacklinks: OrganizationalRecordBacklinkConnection;
  organizationalRecordComment?: Maybe<OrganizationalRecordComment>;
  organizationalRecordComments: OrganizationalRecordCommentConnection;
  organizationalRecordDocument?: Maybe<OrganizationalRecordDocument>;
  organizationalRecordDocuments: OrganizationalRecordDocumentConnection;
  organizationalRecordEntries: OrganizationalRecordEntryConnection;
  organizationalRecordEntry?: Maybe<OrganizationalRecordEntry>;
  person?: Maybe<Person>;
  personGroup?: Maybe<PersonGroup>;
  personGroupMemberships?: Maybe<PersonGroupMembershipOutput>;
  personGroups: PersonGroupOutput;
  /** One person's account binding and latest invitation, read only from Genesis. */
  personLoginAssignment?: Maybe<PersonLoginAssignment>;
  /**
   * Visible active people, filtered by their Genesis account binding. Requires `provision:invitee`.
   * Binding filters and visibility are applied in SQL before pagination. No Keycloak calls are made.
   */
  personLoginAssignments: PersonLoginAssignmentConnection;
  personalSharingRecipients: Array<PersonalSharingRecipient>;
  persons: PersonConnection;
  pinGroup?: Maybe<PinGroup>;
  pinGroupMemberships?: Maybe<PinGroupMembershipOutput>;
  pinGroups: PinGroupOutput;
  /**
   *   The caller's own pin board: the shared items THEY have pinned.
   *
   * A SEPARATE QUERY BECAUSE IT ASKS A SEPARATE QUESTION, and one visibility rule turns on the
   *   difference. A search asks "what is out there"; a pin board asks "what did I keep". Concept
   *   `0005` §2 (v8) takes an inactive company's posts and projects out of BOTH searches — "weder in der
   *   Topbar-Suche noch in der erweiterten Suche, **mit oder ohne Filter**" — while saying nothing about
   *   a pin board, because a board is not a search: the reader already holds a direct reference to the
   *   item and put it there deliberately.
   *
   * SO THIS QUERY, AND ONLY THIS QUERY, LETS A DORMANT COMPANY'S ITEM THROUGH — and only when the
   *   CALLER pinned it. `sharedItems` never does, under any filter.
   *
   * WHY IT IS NOT A FLAG ON `sharedItems`. It was, briefly, keyed on whether the filter mentioned
   *   `pinned` at all. That premise was false: spark's extended search offers a Pinned pill in its Share
   *   tab, so a plain search could send the same shape and get a frozen item back — the exact disclosure
   *   v8 closed. A rule that depends on guessing which screen is asking cannot be made correct by
   *   guessing harder; the surfaces have to be different queries.
   *
   * Reuses SharedItemQueryInput, so paging, ordering and filtering behave exactly as on `sharedItems`,
   *   and a `pinned` clause in `where` is honoured like any other. Passing `pinned: {eq: false}` here is
   *   legal and returns the caller's unpinned items — the carve-out is about which COMPANY's items are
   *   visible, not about which pins are selected.
   */
  pinnedSharedItems: SharedItemConnection;
  powersEvaluationResults: Array<ElementEvaluationResult>;
  /** Requires compare:profiles; preserves ordinary Person visibility and field consent. */
  profileComparisonPerson?: Maybe<Person>;
  project?: Maybe<Project>;
  projects: ProjectConnection;
  /** Client path: only PUBLISHED groups, in (position, name) order. Drafts are never served here, which is what makes publishing a deliberate editorial act (spark#196). */
  publishedQuestionnaireGroups: Array<QuestionnaireGroup>;
  /**
   * Saved answers for this Person, including before application submission. Requires self-access or
   * an explicit personal-information override. first must be 1–100.
   */
  questionnaireAnswers: QuestionnaireAnswerPage;
  /** Same shape as quizEvaluation, but quizResult, quizResultText, itemCount and answeredItemCount describe one questionnaire group instead of every element-free questionnaire (genesis#183). selfScoreBefore and selfScoreWithQuiz stay person-level: they are the values stored for the person, and a group cannot change them. Drafts are included - the caller has to know the group id, and catalogue visibility is a display rule, not an access rule. */
  questionnaireGroupEvaluation: Array<QuizElementEvaluation>;
  /** Administration path: every questionnaire group including drafts, in (position, name) order. Requires the `write:questionnaire` permission. */
  questionnaireGroups: Array<QuestionnaireGroup>;
  questionnaireQuestions: Array<QuestionnaireQuestion>;
  questionnaires: Array<Questionnaire>;
  /** Returns one row per power element (the 30 elements that belong to an element group), ordered by element group and element, so the evaluation screen never reorders. Legacy: its quiz scope is still the old "element-free and ACTIVE" stand-in, which adopts any new element-free questionnaire. Use questionnaireGroupEvaluation instead. */
  quizEvaluation: Array<QuizElementEvaluation>;
  /**
   * Effective feature keys from the current principal's Role Permissions. Open to any authenticated
   * principal, including immediately after registration. Content sharing never enables a feature.
   */
  reachableFeatures: ReachableFeaturesResult;
  recentInterestedInitiatives: Array<SharedItemWithDate>;
  recentProfileVisitors: Array<PersonWithDate>;
  recentSharedItemsCreatedByUser: Array<SharedItemWithDate>;
  recentlyReadSharedItems: Array<SharedItemWithDate>;
  recipients?: Maybe<Array<Recipient>>;
  selfAssessment?: Maybe<SelfAssessment>;
  selfAssessmentResult: ElementEvaluationResult;
  selfAssessmentResults: Array<ElementEvaluationResult>;
  selfAssessmentSavedAnswers: Array<SelfAssessmentSavedAnswer>;
  selfAssessmentStatements: Array<SelfAssessmentStatement>;
  settings: Settings;
  sharedItem?: Maybe<SharedItem>;
  sharedItemComments: SharedItemCommentConnection;
  sharedItemRatings: SharedItemRatingConnection;
  sharedItemSignUps: PersonConnection;
  sharedItems: SharedItemConnection;
  smartAnalysisResults: Array<SmartAnalysisResult>;
  studioNotebook?: Maybe<StudioNotebook>;
  studioNotebooks: StudioNotebookConnection;
  /** Suggests activity descriptions for a given job position. Does not read the caller's profile. */
  suggestActivityDescriptions: SuggestionResult;
  /** Suggests skill (Expertise.description) values for the caller, informed by their profile. */
  suggestExpertiseDescriptions: SuggestionResult;
  /** Suggests a profile summary (Person.bio) for the caller, informed by their profile. Returns a single-paragraph suggestion in `suggestions[0]`. */
  suggestProfileSummary: SuggestionResult;
  systemSettings?: Maybe<SystemSettings>;
  teamProfiles: TeamProfileConnection;
  topElementsForContacts: Array<ContactTopElements>;
  unreadChatMessageCount: Scalars['Int']['output'];
  /** Returns the unread notification count for the current user, restricted to the types the client declares (see SupportedNotificationTypesInput). */
  unreadNotificationCount: Scalars['Int']['output'];
  usedDocumentTags?: Maybe<UsedDocumentTagsOutput>;
  /**
   * Checks a complete candidate requirement set with the same conversion and match-mode rules as
   * setMatchConditions, without saving it. Requires design-write access to the match.
   */
  validateMatchConditions: Scalars['Boolean']['output'];
  workingTimeModels: WorkingTimeModelsResult;
};


export type QueryAccessGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccessGroupMembersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  groupId: Scalars['ID']['input'];
};


export type QueryAccessGroupRoleAssignmentsArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryAccessGroupsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAccessPersonInspectionArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryAccessRoleImpactArgs = {
  groupsAfter?: InputMaybe<Scalars['ID']['input']>;
  peopleAfter?: InputMaybe<Scalars['ID']['input']>;
  permissionIds: Array<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};


export type QueryAccessRoleMembersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  groupId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type QueryActiveQuestionnairesByElementArgs = {
  input: ActiveQuestionnairesByElementInput;
};


export type QueryAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgentsArgs = {
  input: AgentQueryInput;
};


export type QueryCatalogItemsArgs = {
  input: CatalogItemsInput;
};


export type QueryCompaniesArgs = {
  input: CompanyQueryInput;
};


export type QueryCompanyArgs = {
  input: CompanyInput;
};


export type QueryCompanyComparisonArgs = {
  input: CompanyInput;
};


export type QueryCompanyCompetenciesArgs = {
  input: CompanyCompetenciesInput;
};


export type QueryCompanyContactPersonsArgs = {
  input: CompanyContactPersonsInput;
};


export type QueryCompanyIdentitiesArgs = {
  input: CompanyIdentitiesInput;
};


export type QueryCompanyMembersArgs = {
  input: CompanyMembersInput;
};


export type QueryCompanyOwnedSharedItemsArgs = {
  companyId: Scalars['ID']['input'];
  input?: InputMaybe<SharedItemQueryInput>;
};


export type QueryContactPowersDevStatsArgs = {
  input: ContactPowersDevStatsInput;
};


export type QueryContactsWithHighestScoreArgs = {
  input: ContactsWithHighestScoreInput;
};


export type QueryConversationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryConversationMessagesArgs = {
  input: ConversationMessagesInput;
};


export type QueryConversationPresenceArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type QueryConversationReadReceiptsArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type QueryCountryStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCountryStatesByCountryArgs = {
  input: CountryStatesByCountryInput;
};


export type QueryCurriculumVitaeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCurriculumVitaesArgs = {
  input: CurriculumVitaeQueryInput;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentGroupsArgs = {
  input?: InputMaybe<DocumentGroupInput>;
};


export type QueryDocumentTextArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDocumentsArgs = {
  input: DocumentQueryInput;
};


export type QueryExportMyProfileArgs = {
  input: ProfileExportInput;
};


export type QueryExtractionJobArgs = {
  jobId: Scalars['UUID']['input'];
};


export type QueryFileImportBatchArgs = {
  batchId: Scalars['UUID']['input'];
};


export type QueryFileImportJobArgs = {
  jobId: Scalars['UUID']['input'];
};


export type QueryGlobalSearchArgs = {
  input: GlobalSearchInput;
};


export type QueryGrowResourceArgs = {
  input: GrowResourceQueryInput;
};


export type QueryImportJobArgs = {
  jobId: Scalars['UUID']['input'];
};


export type QueryMatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchCandidatesArgs = {
  input: MatchCandidateQueryInput;
};


export type QueryMatchCompaniesArgs = {
  input: MatchCompanyQueryInput;
};


export type QueryMatchCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchProjectDocumentContentArgs = {
  backdropFileId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
};


export type QueryMatchResultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchResultsArgs = {
  input: MatchResultQueryInput;
};


export type QueryMatchesArgs = {
  input: MatchQueryInput;
};


export type QueryMicrosoftCalendarConnectionArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMicrosoftCalendarViewArgs = {
  accountKind?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['String']['input'];
  organizerEmail: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryMyFavoritesArgs = {
  input: MyFavoritesInput;
};


export type QueryMyGameSessionsArgs = {
  gameKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyPowersDevStatsArgs = {
  input: MyPowersDevStatsInput;
};


export type QueryMyToplistSessionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryNotificationsArgs = {
  input?: InputMaybe<NotificationsInput>;
};


export type QueryOrganizationalPowerAnalysisArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrganizationalRecordArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationalRecordBacklinksArgs = {
  input: OrganizationalRecordBacklinksInput;
};


export type QueryOrganizationalRecordCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationalRecordCommentsArgs = {
  input: OrganizationalRecordPageInput;
  sort?: InputMaybe<OrganizationalRecordCommentSortInput>;
};


export type QueryOrganizationalRecordDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationalRecordDocumentsArgs = {
  input: OrganizationalRecordPageInput;
};


export type QueryOrganizationalRecordEntriesArgs = {
  input: OrganizationalRecordPageInput;
};


export type QueryOrganizationalRecordEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonGroupMembershipsArgs = {
  input: PersonGroupMembershipInput;
};


export type QueryPersonGroupsArgs = {
  input?: InputMaybe<PersonGroupInput>;
};


export type QueryPersonLoginAssignmentArgs = {
  input: PersonLoginAssignmentInput;
};


export type QueryPersonLoginAssignmentsArgs = {
  input?: InputMaybe<PersonLoginAssignmentsInput>;
};


export type QueryPersonsArgs = {
  input: PersonQueryInput;
};


export type QueryPinGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPinGroupMembershipsArgs = {
  input: PinGroupMembershipInput;
};


export type QueryPinGroupsArgs = {
  input: PinGroupInput;
};


export type QueryPinnedSharedItemsArgs = {
  input: SharedItemQueryInput;
};


export type QueryProfileComparisonPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  input: ProjectQueryInput;
};


export type QueryQuestionnaireAnswersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryQuestionnaireGroupEvaluationArgs = {
  questionnaireGroupId: Scalars['UUID']['input'];
};


export type QueryQuestionnaireQuestionsArgs = {
  questionnaireId: Scalars['UUID']['input'];
};


export type QueryQuestionnairesArgs = {
  input?: InputMaybe<QuestionnairesInput>;
};


export type QueryRecentInterestedInitiativesArgs = {
  input: RecentInterestedInitiativesInput;
};


export type QueryRecentProfileVisitorsArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryRecentSharedItemsCreatedByUserArgs = {
  input: RecentSharedItemsCreatedByUserInput;
};


export type QueryRecentlyReadSharedItemsArgs = {
  input: RecentlyReadSharedItemsInput;
};


export type QueryRecipientsArgs = {
  input: RecipientQueryInput;
};


export type QuerySelfAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySelfAssessmentResultArgs = {
  input: SelfAssessmentResultsQueryInput;
};


export type QuerySelfAssessmentSavedAnswersArgs = {
  input: SelfAssessmentStatementsInput;
};


export type QuerySelfAssessmentStatementsArgs = {
  input: SelfAssessmentStatementsInput;
};


export type QuerySettingsArgs = {
  person?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySharedItemArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharedItemCommentsArgs = {
  input: SharedItemCommentQueryInput;
};


export type QuerySharedItemRatingsArgs = {
  input: SharedItemRatingQueryInput;
};


export type QuerySharedItemSignUpsArgs = {
  input: SharedItemSignUpQueryInput;
};


export type QuerySharedItemsArgs = {
  input: SharedItemQueryInput;
};


export type QueryStudioNotebookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStudioNotebooksArgs = {
  input: StudioNotebookQueryInput;
};


export type QuerySuggestActivityDescriptionsArgs = {
  input: SuggestActivityDescriptionsInput;
};


export type QuerySuggestExpertiseDescriptionsArgs = {
  input: SuggestExpertiseDescriptionsInput;
};


export type QuerySuggestProfileSummaryArgs = {
  input: SuggestProfileSummaryInput;
};


export type QueryTeamProfilesArgs = {
  input: TeamProfileQueryInput;
};


export type QueryTopElementsForContactsArgs = {
  input: ContactTopElementsInput;
};


export type QueryUnreadChatMessageCountArgs = {
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUnreadNotificationCountArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type QueryUsedDocumentTagsArgs = {
  input: UsedDocumentTagsInput;
};


export type QueryValidateMatchConditionsArgs = {
  input: SetMatchConditionsInput;
};

/** The filterable fields of type Query */
export type QueryFilterInput = {
  and?: InputMaybe<Array<QueryFilterInput>>;
  not?: InputMaybe<QueryFilterInput>;
  or?: InputMaybe<Array<QueryFilterInput>>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  creativityElement?: Maybe<CreativityElement>;
  instructions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Order within its group. Null exactly when questionnaireGroupId is null - the two are kept in lockstep by a database check. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The group this questionnaire is bundled into, null when it is unassigned. An unassigned questionnaire is not reachable in Grow (spark#196). */
  questionnaireGroupId?: Maybe<Scalars['UUID']['output']>;
  questionnaireId: Scalars['UUID']['output'];
  status: QuestionnaireStatus;
};

export type QuestionnaireAnswerChoice = {
  __typename?: 'QuestionnaireAnswerChoice';
  answer: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  qnrAnswerChoiceId: Scalars['UUID']['output'];
  status: QuestionnaireStatus;
  weight: Scalars['Int']['output'];
};

/** The filterable fields of type QuestionnaireAnswerChoice */
export type QuestionnaireAnswerChoiceFilterInput = {
  and?: InputMaybe<Array<QuestionnaireAnswerChoiceFilterInput>>;
  not?: InputMaybe<QuestionnaireAnswerChoiceFilterInput>;
  or?: InputMaybe<Array<QuestionnaireAnswerChoiceFilterInput>>;
};

export type QuestionnaireAnswerPage = {
  __typename?: 'QuestionnaireAnswerPage';
  answers: Array<ProvidedQuestionnaireAnswer>;
  hasNextPage: Scalars['Boolean']['output'];
  nextAfter?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type QuestionnaireAnswerPage */
export type QuestionnaireAnswerPageFilterInput = {
  and?: InputMaybe<Array<QuestionnaireAnswerPageFilterInput>>;
  not?: InputMaybe<QuestionnaireAnswerPageFilterInput>;
  or?: InputMaybe<Array<QuestionnaireAnswerPageFilterInput>>;
};

/** The filterable fields of type Questionnaire */
export type QuestionnaireFilterInput = {
  and?: InputMaybe<Array<QuestionnaireFilterInput>>;
  not?: InputMaybe<QuestionnaireFilterInput>;
  or?: InputMaybe<Array<QuestionnaireFilterInput>>;
};

/**
 * A named bundle of questionnaires. One group is one entry in the Grow play catalogue (spark#196); the Power
 * Quiz is the first one. Replaces the old stand-in predicate "element-free and active".
 */
export type QuestionnaireGroup = {
  __typename?: 'QuestionnaireGroup';
  /** Fills both the caption on the catalogue tile and the header of the group overview. */
  description?: Maybe<LocalizedText>;
  /** Group artwork, stored in backdrop and owned by the default user (@adr GENESIS-0013-backdrop-blob-storage-boundary@1). Null when no image was uploaded; Grow then falls back to the generated tile. Uploads declare two scaled variants, so profile accepts "card" (max height 140) or "share_preview" (max height 250); omit it for the unscaled original. */
  image?: Maybe<File>;
  /** Number of ACTIVE questions across the ACTIVE members of this group. 0 means Grow renders no tile, and spark#191 warns before publishing. Clients estimate the duration from it, there is no duration field. */
  itemCount: Scalars['Int']['output'];
  name: LocalizedText;
  /** ACTIVE members in (position, name) order, each carrying the flag whether the current user has answered every ACTIVE question of that part. */
  parts: Array<QuestionnaireResult>;
  /** Order of this group in the play catalogue. Distinct from Questionnaire.position, which orders parts within a group. */
  position: Scalars['Int']['output'];
  questionnaireGroupId: Scalars['UUID']['output'];
  status: QuestionnaireGroupStatus;
};


/**
 * A named bundle of questionnaires. One group is one entry in the Grow play catalogue (spark#196); the Power
 * Quiz is the first one. Replaces the old stand-in predicate "element-free and active".
 */
export type QuestionnaireGroupImageArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
};

/** The filterable fields of type QuestionnaireGroup */
export type QuestionnaireGroupFilterInput = {
  and?: InputMaybe<Array<QuestionnaireGroupFilterInput>>;
  not?: InputMaybe<QuestionnaireGroupFilterInput>;
  or?: InputMaybe<Array<QuestionnaireGroupFilterInput>>;
};

/** Artwork being uploaded for a questionnaire group, inlined base64 on the wire. */
export type QuestionnaireGroupImageInput = {
  content: Scalars['Binary']['input'];
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Visibility of a questionnaire group. Deliberately not QuestionnaireStatus: that one carries DELETED as a
 * soft-delete state, while deleting a group ungroups its members instead. Publishing is a stated editorial
 * intent, not a side effect of somebody activating a questionnaire.
 */
export enum QuestionnaireGroupStatus {
  /** Invisible in Grow. Editors build the group up - name it, describe it, add artwork, assign and sort parts. */
  Draft = 'DRAFT',
  /** Visible in the Grow play catalogue. */
  Published = 'PUBLISHED'
}

export type QuestionnaireQuestion = {
  __typename?: 'QuestionnaireQuestion';
  answerChoices: Array<QuestionnaireAnswerChoice>;
  creativityElement: CreativityElement;
  position: Scalars['Int']['output'];
  qnrQuestionId: Scalars['UUID']['output'];
  question: Scalars['String']['output'];
  status: QuestionnaireStatus;
};

/** The filterable fields of type QuestionnaireQuestion */
export type QuestionnaireQuestionFilterInput = {
  and?: InputMaybe<Array<QuestionnaireQuestionFilterInput>>;
  not?: InputMaybe<QuestionnaireQuestionFilterInput>;
  or?: InputMaybe<Array<QuestionnaireQuestionFilterInput>>;
};

export type QuestionnaireResult = {
  __typename?: 'QuestionnaireResult';
  /** True when every ACTIVE question (and its ACTIVE answer choices) of this questionnaire has a qnr_result for the current user. Vacuously true if the questionnaire has no ACTIVE questions. */
  answered: Scalars['Boolean']['output'];
  questionnaire: Questionnaire;
};

/** The filterable fields of type QuestionnaireResult */
export type QuestionnaireResultFilterInput = {
  and?: InputMaybe<Array<QuestionnaireResultFilterInput>>;
  not?: InputMaybe<QuestionnaireResultFilterInput>;
  or?: InputMaybe<Array<QuestionnaireResultFilterInput>>;
};

export type QuestionnaireSaveInput = {
  creativityElement?: InputMaybe<CreativityElement>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
  status: QuestionnaireStatus;
};

export enum QuestionnaireStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type QuestionnairesInput = {
  status?: InputMaybe<QuestionnaireStatus>;
};

/**
 * Per-element view of the Power Quiz for the current user. The only place that keeps the two self-report
 * instruments apart: selfScoreBefore is the self-assessment alone, quizResult the quiz alone, selfScoreWithQuiz
 * both of them weighted by answered items. ElementEvaluationResult.result carries the same merged value but no
 * provenance, which is why this type exists; its questionCount/answeredQuestionCount stay self-assessment-only,
 * because they describe the progress of the per-element assessment and no questionnaire advances that.
 */
export type QuizElementEvaluation = {
  __typename?: 'QuizElementEvaluation';
  /** Quiz items of itemCount the current user has answered. */
  answeredItemCount: Scalars['Int']['output'];
  element: CreativityElement;
  /** Quiz items for this element in ACTIVE questionnaires without a creativity_element. */
  itemCount: Scalars['Int']['output'];
  /** Latest quiz score, null when the element has no quiz answer yet. */
  quizResult?: Maybe<Scalars['Int']['output']>;
  /** Band text for quizResult, from the same scale. Null when quizResult is null. */
  quizResultText?: Maybe<Scalars['String']['output']>;
  /** Band text for selfScoreWithQuiz, from the element's self-assessment scale. Null when the score is null. */
  resultText?: Maybe<Scalars['String']['output']>;
  /** Latest self-assessment score, null when the element has no self-assessment answer yet. */
  selfScoreBefore?: Maybe<Scalars['Int']['output']>;
  /** Both instruments merged, weighted by answered items. Null only when neither instrument contributes. */
  selfScoreWithQuiz?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type QuizElementEvaluation */
export type QuizElementEvaluationFilterInput = {
  and?: InputMaybe<Array<QuizElementEvaluationFilterInput>>;
  not?: InputMaybe<QuizElementEvaluationFilterInput>;
  or?: InputMaybe<Array<QuizElementEvaluationFilterInput>>;
};

export type RateSharedItemInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  fiveStarRating?: InputMaybe<Scalars['Float']['input']>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
};

export type RateSharedItemOutput = RateSharedItemResult;

export type RateSharedItemResult = {
  __typename?: 'RateSharedItemResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type RateSharedItemResult */
export type RateSharedItemResultFilterInput = {
  and?: InputMaybe<Array<RateSharedItemResultFilterInput>>;
  not?: InputMaybe<RateSharedItemResultFilterInput>;
  or?: InputMaybe<Array<RateSharedItemResultFilterInput>>;
};

/** Effective feature keys from the caller's Role Permissions. Never inferred from content sharing. */
export type ReachableFeaturesResult = {
  __typename?: 'ReachableFeaturesResult';
  featureKeys: Array<Scalars['String']['output']>;
};

/** The filterable fields of type ReachableFeaturesResult */
export type ReachableFeaturesResultFilterInput = {
  and?: InputMaybe<Array<ReachableFeaturesResultFilterInput>>;
  not?: InputMaybe<ReachableFeaturesResultFilterInput>;
  or?: InputMaybe<Array<ReachableFeaturesResultFilterInput>>;
};

export type RecentInterestedInitiativesInput = {
  limit: Scalars['Int']['input'];
};

export type RecentSharedItemsCreatedByUserInput = {
  limit: Scalars['Int']['input'];
};

export type RecentlyReadSharedItemsInput = {
  limit: Scalars['Int']['input'];
};

export type Recipient = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RecipientFilterInput = {
  and?: InputMaybe<Array<RecipientFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RecipientFilterInput>;
  or?: InputMaybe<Array<RecipientFilterInput>>;
};

export type RecipientQueryInput = {
  order?: InputMaybe<RecipientSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipientFilterInput>;
};

export type RecipientSortInput = {
  name?: InputMaybe<SortOrder>;
};

export type ReferenceConditionInput = {
  id: Scalars['UUID']['input'];
  kind: ReferenceConditionKind;
};

export enum ReferenceConditionKind {
  Citizenship = 'CITIZENSHIP',
  Country = 'COUNTRY',
  Gender = 'GENDER',
  JobDepartment = 'JOB_DEPARTMENT',
  JobLocation = 'JOB_LOCATION',
  Marital = 'MARITAL'
}

export type RegisterDeviceTokenInput = {
  platform: DevicePlatform;
  token: Scalars['String']['input'];
};

export type RemoveAccessGroupRoleInput = {
  assignmentId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['ID']['input'];
};

/**
 * Removes one expertise from a company, matched case-insensitively and ignoring surrounding whitespace.
 *
 * Answers whether a row was actually removed, so removing an expertise the company never listed is
 * `false` rather than an error.
 */
export type RemoveCompanyCompetencyInput = {
  companyId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type RemoveCompanyMemberInput = {
  companyId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
};

export type RemoveContactsInput = {
  contacts: Array<Scalars['UUID']['input']>;
  person?: InputMaybe<Scalars['UUID']['input']>;
};

export type RemoveContactsOutput = RemoveContactsResult;

export type RemoveContactsResult = {
  __typename?: 'RemoveContactsResult';
  contactsRemoved: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type RemoveContactsResult */
export type RemoveContactsResultFilterInput = {
  and?: InputMaybe<Array<RemoveContactsResultFilterInput>>;
  not?: InputMaybe<RemoveContactsResultFilterInput>;
  or?: InputMaybe<Array<RemoveContactsResultFilterInput>>;
};

export type RemovePinsInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  persons?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sharedItems?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type RemovePinsOutput = RemovePinsResult;

export type RemovePinsResult = {
  __typename?: 'RemovePinsResult';
  personsUnpinned?: Maybe<Array<Scalars['UUID']['output']>>;
  sharedItemsUnpinned?: Maybe<Array<Scalars['UUID']['output']>>;
};

/** The filterable fields of type RemovePinsResult */
export type RemovePinsResultFilterInput = {
  and?: InputMaybe<Array<RemovePinsResultFilterInput>>;
  not?: InputMaybe<RemovePinsResultFilterInput>;
  or?: InputMaybe<Array<RemovePinsResultFilterInput>>;
};

/** Re-send or re-address a still-pending invitation for an existing Person. */
export type ResendExistingPersonInvitationInput = {
  /** The confirmed recipient, re-confirmed in the dialog. May differ from the previous attempt's. */
  email: Scalars['String']['input'];
  personId: Scalars['UUID']['input'];
  requestId: Scalars['UUID']['input'];
};

/**
 * Preview diff for one field of a collection row. `existingValue` / `incomingValue` are
 * MACHINE values (ISO `YYYY[-MM]` for MONTH, a CEFR enum name or `NATIVE` for CEFR, plain
 * text for TEXT) so the client can both render and edit them; the client localizes labels
 * and formats values. `editable` is false for fields the import can show but not accept an
 * edit for (e.g. a language tag).
 */
export type RowFieldDiff = {
  __typename?: 'RowFieldDiff';
  editable: Scalars['Boolean']['output'];
  existingValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  incomingValue?: Maybe<Scalars['String']['output']>;
  kind: RowFieldKind;
};

/** The filterable fields of type RowFieldDiff */
export type RowFieldDiffFilterInput = {
  and?: InputMaybe<Array<RowFieldDiffFilterInput>>;
  not?: InputMaybe<RowFieldDiffFilterInput>;
  or?: InputMaybe<Array<RowFieldDiffFilterInput>>;
};

/**
 * The input kind of one collection-row field — tells the client how to render and edit
 * it. TEXT = free text; MONTH = a year-or-month date carried as `YYYY` or `YYYY-MM`
 * (blank end date = ongoing / "present"); CEFR = a language proficiency level
 * (`A1`..`C2`, or `NATIVE`).
 */
export enum RowFieldKind {
  Cefr = 'CEFR',
  Month = 'MONTH',
  Text = 'TEXT'
}

export type SaveQuestionnaireGroupInput = {
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, only the validation is performed but nothing is written - same meaning as on the create inputs of
   * the other group kinds. Artwork is not uploaded to backdrop either, so a dry run leaves no file behind; the
   * content is still checked for size and format, and the response reports the artwork the group has today
   * rather than the one a real call would store. The questionnaireGroupId of a dry-run create is not reserved:
   * it belongs to a row that was rolled back, so do not keep it.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Uploads new artwork and replaces any existing one. Null leaves the current artwork untouched. */
  image?: InputMaybe<QuestionnaireGroupImageInput>;
  nameDe: Scalars['String']['input'];
  nameEn: Scalars['String']['input'];
  /** Null appends the group at the end of the catalogue on create, and keeps the current position on update. */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Null creates a group. A new group always starts as DRAFT; publishing is its own mutation. */
  questionnaireGroupId?: InputMaybe<Scalars['UUID']['input']>;
  /** Removes the current artwork. Ignored when image is set. */
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * The result of saving a questionnaire group: the same three-armed shape as the group unions above, so a client
 * can treat every group kind alike. TooManyRecordsResult carries the limit that was hit; for the Validate arm
 * see ValidateQuestionnaireGroupResult, which genesis does not answer with today. The group itself is a direct
 * member rather than being wrapped in a SaveQuestionnaireGroupResult, so existing field selections keep working
 * behind an inline fragment. A dry run answers with the group it would have written.
 */
export type SaveQuestionnaireGroupOutput = QuestionnaireGroup | TooManyRecordsResult | ValidateQuestionnaireGroupResult;

export type SaveQuestionnaireInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaire: QuestionnaireSaveInput;
  questions: Array<QnrQuestionSaveInput>;
};

export type SaveQuestionnaireOutput = {
  __typename?: 'SaveQuestionnaireOutput';
  questionnaire: Questionnaire;
  questions: Array<QuestionnaireQuestion>;
};

/** The filterable fields of type SaveQuestionnaireOutput */
export type SaveQuestionnaireOutputFilterInput = {
  and?: InputMaybe<Array<SaveQuestionnaireOutputFilterInput>>;
  not?: InputMaybe<SaveQuestionnaireOutputFilterInput>;
  or?: InputMaybe<Array<SaveQuestionnaireOutputFilterInput>>;
};

export type SaveQuestionnaireResultItem = {
  qnrAnswerChoiceId: Scalars['UUID']['input'];
  timeTakenMs?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveQuestionnaireResultsInput = {
  results: Array<SaveQuestionnaireResultItem>;
};

export type SaveSelfAssessmentResultItem = {
  questionId: Scalars['UUID']['input'];
  scorePercent: Scalars['Int']['input'];
};

export type SaveSelfAssessmentResultsInput = {
  results: Array<SaveSelfAssessmentResultItem>;
};

export enum SearchEntityType {
  /**
   * An AI agent of the instance, as its own result. Visible to every caller who can reach the search feature,
   * like COMPANY; `personId` is null.
   * Indexed: name (highest weight); vendor and role; covers, tool names, tool descriptions and integrations;
   * guardrails; prose in both languages. A text search restricted to exactly [AGENT] that finds nothing by full
   * text falls back to name similarity, so a typo still finds the agent.
   */
  Agent = 'AGENT',
  Certificate = 'CERTIFICATE',
  /**
   *   A company, as its own result (the company search). A hit is the
   *   company itself and opens its company page — not a person who happens to work there, which was the
   *   explicitly rejected alternative.
   *
   * Indexed: name (highest weight), the company's own expertise labels and the industry. The descriptive
   *   summary is deliberately NOT indexed (§2) — it keeps the index lean and matches the three axes the
   *   concept names. The labels are FREE TEXT belonging to one company since concept v4 retired the shared
   *   vocabulary, not entries from a curated catalogue.
   */
  Company = 'COMPANY',
  Document = 'DOCUMENT',
  Education = 'EDUCATION',
  Experience = 'EXPERIENCE',
  Expertise = 'EXPERTISE',
  Match = 'MATCH',
  Person = 'PERSON',
  SharedItemPost = 'SHARED_ITEM_POST',
  SharedItemProject = 'SHARED_ITEM_PROJECT'
}

export type SelfAssessment = Node & {
  __typename?: 'SelfAssessment';
  id: Scalars['ID']['output'];
  questions: Array<SelfAssessmentStatement>;
};

/** The filterable fields of type SelfAssessment */
export type SelfAssessmentFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentFilterInput>>;
  not?: InputMaybe<SelfAssessmentFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentFilterInput>>;
};

export type SelfAssessmentResultsQueryInput = {
  element: CreativityElement;
};

export type SelfAssessmentSavedAnswer = {
  __typename?: 'SelfAssessmentSavedAnswer';
  questionId: Scalars['UUID']['output'];
  scorePercent: Scalars['Int']['output'];
};

/** The filterable fields of type SelfAssessmentSavedAnswer */
export type SelfAssessmentSavedAnswerFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentSavedAnswerFilterInput>>;
  not?: InputMaybe<SelfAssessmentSavedAnswerFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentSavedAnswerFilterInput>>;
};

export type SelfAssessmentStatement = Node & {
  __typename?: 'SelfAssessmentStatement';
  content: LocalizedText;
  element: CreativityElement;
  id: Scalars['ID']['output'];
  invertResult: Scalars['Boolean']['output'];
};

/** The filterable fields of type SelfAssessmentStatement */
export type SelfAssessmentStatementFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentStatementFilterInput>>;
  not?: InputMaybe<SelfAssessmentStatementFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentStatementFilterInput>>;
};

export type SelfAssessmentStatementsInput = {
  element: CreativityElement;
};

export type SendChatMessageInput = {
  content: Scalars['String']['input'];
  conversationId: Scalars['UUID']['input'];
};

/**
 * Adds one expertise to a company. Requires an admin membership row for that company.
 *
 * ADD, NOT UPSERT. A label this company already lists is refused with GENESIS001247, comparing
 * case-insensitively and ignoring surrounding whitespace. The editing model is two verbs — type an
 * expertise and Add; Remove — and since v17 removed the level there is nothing else about an entry to
 * change. The same label on a DIFFERENT company is accepted and means nothing.
 */
export type SetCompanyCompetencyInput = {
  companyId: Scalars['ID']['input'];
  /** 1..255 characters after trimming. Blank is refused (GENESIS001228), over-length is refused (GENESIS001229). */
  label: Scalars['String']['input'];
};

/**
 * Mark or unmark one member as a contact person of the company
 * (the company page).
 *
 * `personId` must already be a member: this marks an existing membership row and never creates one, so
 * an unknown person or a non-member is an error rather than an implicit add.
 */
export type SetCompanyContactPersonInput = {
  companyId: Scalars['ID']['input'];
  contactPerson: Scalars['Boolean']['input'];
  personId: Scalars['ID']['input'];
};

export type SetConversationTypingInput = {
  conversationId: Scalars['UUID']['input'];
  typing: Scalars['Boolean']['input'];
};

export type SetGroupSharingEligibilityInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  eligible: Scalars['Boolean']['input'];
  groupId: Scalars['ID']['input'];
};

export type SetMatchCompanyConditionsInput = {
  conditions: Array<CompanyMatchConditionInput>;
  matchId: Scalars['UUID']['input'];
};

export type SetMatchCompanyConditionsOutput = SetMatchCompanyConditionsResult;

export type SetMatchCompanyConditionsResult = {
  __typename?: 'SetMatchCompanyConditionsResult';
  match: Match;
};

/** The filterable fields of type SetMatchCompanyConditionsResult */
export type SetMatchCompanyConditionsResultFilterInput = {
  and?: InputMaybe<Array<SetMatchCompanyConditionsResultFilterInput>>;
  not?: InputMaybe<SetMatchCompanyConditionsResultFilterInput>;
  or?: InputMaybe<Array<SetMatchCompanyConditionsResultFilterInput>>;
};

export type SetMatchConditionsInput = {
  conditions: Array<MatchConditionInput>;
  matchId: Scalars['UUID']['input'];
};

export type SetMatchConditionsOutput = SetMatchConditionsResult;

export type SetMatchConditionsResult = {
  __typename?: 'SetMatchConditionsResult';
  match: Match;
};

/** The filterable fields of type SetMatchConditionsResult */
export type SetMatchConditionsResultFilterInput = {
  and?: InputMaybe<Array<SetMatchConditionsResultFilterInput>>;
  not?: InputMaybe<SetMatchConditionsResultFilterInput>;
  or?: InputMaybe<Array<SetMatchConditionsResultFilterInput>>;
};

export type SetMatchNotesInput = {
  aiCopilotText?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['UUID']['input'];
};

export type SetMatchNotesOutput = SetMatchNotesResult;

export type SetMatchNotesResult = {
  __typename?: 'SetMatchNotesResult';
  match: Match;
};

/** The filterable fields of type SetMatchNotesResult */
export type SetMatchNotesResultFilterInput = {
  and?: InputMaybe<Array<SetMatchNotesResultFilterInput>>;
  not?: InputMaybe<SetMatchNotesResultFilterInput>;
  or?: InputMaybe<Array<SetMatchNotesResultFilterInput>>;
};

export type SetMatchProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

export type SetMatchProjectOutput = SetMatchProjectResult;

export type SetMatchProjectResult = {
  __typename?: 'SetMatchProjectResult';
  match: Match;
};

/** The filterable fields of type SetMatchProjectResult */
export type SetMatchProjectResultFilterInput = {
  and?: InputMaybe<Array<SetMatchProjectResultFilterInput>>;
  not?: InputMaybe<SetMatchProjectResultFilterInput>;
  or?: InputMaybe<Array<SetMatchProjectResultFilterInput>>;
};

export type SetMatchTeamSizeInput = {
  matchId: Scalars['UUID']['input'];
  teamCount?: InputMaybe<Scalars['Int']['input']>;
  teamSize: Scalars['Int']['input'];
};

export type SetMatchTeamSizeOutput = SetMatchTeamSizeResult;

export type SetMatchTeamSizeResult = {
  __typename?: 'SetMatchTeamSizeResult';
  match: Match;
};

/** The filterable fields of type SetMatchTeamSizeResult */
export type SetMatchTeamSizeResultFilterInput = {
  and?: InputMaybe<Array<SetMatchTeamSizeResultFilterInput>>;
  not?: InputMaybe<SetMatchTeamSizeResultFilterInput>;
  or?: InputMaybe<Array<SetMatchTeamSizeResultFilterInput>>;
};

/**
 * Partial replacement, as on a profile entry: omitted fields keep their value. sharedWith takes Group IDs from
 * contentSharingRecipients; new toplists start with allGroups enabled and publiclyReadable disabled.
 */
export type SetMyToplistSharingInput = {
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  domain: FavoriteDomain;
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWith?: InputMaybe<Array<ContentSharingRecipientRelationInput>>;
};

export type SetPersonalSharingInput = {
  /** Partial replacement: omitted attributes remain unchanged; empty lists revoke their consent. IDs identify Groups. */
  data: CreatePersonSharedAttributesDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Settings = {
  __typename?: 'Settings';
  settings?: Maybe<Scalars['Object']['output']>;
};

/** The filterable fields of type Settings */
export type SettingsFilterInput = {
  and?: InputMaybe<Array<SettingsFilterInput>>;
  not?: InputMaybe<SettingsFilterInput>;
  or?: InputMaybe<Array<SettingsFilterInput>>;
};

export type SharableEntity = {
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

/** The filterable fields of type SharableEntity */
export type SharableEntityFilterInput = {
  and?: InputMaybe<Array<SharableEntityFilterInput>>;
  not?: InputMaybe<SharableEntityFilterInput>;
  or?: InputMaybe<Array<SharableEntityFilterInput>>;
};

export type SharedItem = Node & SharableEntity & {
  __typename?: 'SharedItem';
  /** Applicant-facing classification. Never changes sharing, responsibility or publication. */
  categories: Array<DiscoveryCategory>;
  commented?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  /**
   *   The company this item was published IN THE NAME OF, or null when the author published it as
   *   themselves. Concept v7: the company account model.
   *
   * SET AT CREATION ONLY, never on update — `@constrained(updatable: false)`. A personal post cannot
   *   become a company post later and a company post cannot be taken private: the two live in different
   *   places (the author's own area versus the company page), so a switch would move content between them
   *   and change who may edit it mid-life. Kevin decided that explicitly.
   *
   * WHO MAY SET IT: an admin of that company, by the same `company_membership` row that gates every
   *   other per-company write (@adr GENESIS-0023-company-membership-is-the-per-company-authorization@4 §1). There is no platform role for it.
   *
   * IT DOES NOT REPLACE `createdBy`. `person_id` stays NOT NULL and still names the human who wrote the
   *   item — shown as the byline. This column decides whose the item IS; `createdBy` says who typed it.
   *   For a company item those are two different questions, and the edit gate reads THIS one.
   *
   * THE COMPANY MUST BE ACTIVE (concept v9). Naming an INACTIVE company here is refused with
   *   `GENESIS001250` even when the caller administers it — a distinct code from the authorisation
   *   refusal on purpose, because this one is repaired by reactivating the company and that one by being
   *   made an admin. An inactive company's existing content is FROZEN, not merely closed to new posts:
   *   it cannot be edited, deleted, applied to, rated or counted as viewed, and the documents attached to
   *   it cannot be deleted. Reactivating the company lifts all of it at once.
   *
   * FILTERABLE, AND ONE CRITERION ANSWERS FOUR DIFFERENT QUESTIONS. The filter is a nested
   *   `CompanyFilterInput` reached over a LEFT join, because `company_id` is nullable and a personal item
   *   has no row on the other side:
   *
   *     { company: { name: { any: true } } }         everything published by ANY company
   *       { company: { name: { any: false } } }        the complement — every personal item
   *       { company: { name: { contains: "Acme" } } }  one company, by the name a searcher types
   *       { company: { id: { eq: "<uuid>" } } }        one company, by id
   *
   * AN INNER JOIN WOULD ANSWER THE SECOND LINE WITH NOTHING, silently, which is why the join type is
   *   recorded here rather than left to be rediscovered. `company.name` is NOT NULL, so after the left
   *   join a null name means "there is no company" and nothing else — that is what carries `any`.
   *
   * IT DOES NOT WIDEN WHAT A SEARCH CAN SEE. `sharedItems` still ANDs its `findable` condition on top,
   *   so naming an INACTIVE company here returns nothing: freezing takes a dormant company's content out
   *   of search, and a filter is a search. The company's own page (`companyOwnedSharedItems`) shares this
   *   spec and is deliberately not affected — it never carried the findability condition.
   */
  company?: Maybe<Company>;
  /**
   *   The human who wrote this item, and the byline a client renders under it.
   *
   * IT IS ANSWERED FROM `person_id`, NOT FROM THE `created_by` COLUMN OF THE SAME NAME, and the filter
   *   added with it reads the same column for the same reason. The two columns hold the same id on every
   *   row (`person_id` is written once at create from a value that is always the caller and no update
   *   path rewrites it), but V0044 records that `created_by` is AUDIT ONLY and must never carry an
   *   authorization decision. `owner` already reads `person_id` on exactly that ground
   *   (`SharedItemController#buildSharedItem`); a filter that read the audit column instead would be a
   *   second definition of "who wrote this" waiting to drift from the field above it.
   *
   * FILTERABLE THROUGH A NESTED `PersonFilterInput`, over an INNER join, because `person_id` is NOT NULL, so
   *   every item has a row on the other side and there is no "no author" case for a LEFT join to keep.
   *   That is the one structural difference to `company` above, whose join must be LEFT because a
   *   personal item genuinely has no company.
   *
   *     { createdBy: { id: { eq: "<uuid>" } } }        one person, by id
   *       { createdBy: { formattedName: { contains: "Kim" } } }  by the name a searcher types
   *
   * IT DOES NOT ANSWER "WHOSE IS THIS". A company item carries the id of the human who typed it here
   *   too, so this filter returns it. See `owner` below, whose FILTER renders `person_id = me AND
   *   company_id IS NULL` precisely because "mine" and "written by me" stopped being one question at
   *   concept v7. A caller who wants only what a person published in their OWN name ANDs
   *   `{ company: { name: { any: false } } }` onto this one; spark's person page does exactly that. The
   *   condition is deliberately NOT baked in here: `owner` may be compound because it answers a yes/no
   *   question, while a person filter has to answer literally what its name says.
   *
   * IT CANNOT BE USED TO PAGE AROUND THE FIELD'S OWN WHITELIST. The field is foreign PII: a browser who
   *   is neither the item's owner nor a reader of INTERNAL gets `null` here
   *   (`SharedItemViewer#readsEveryFieldOf`). Without a further condition the FILTER would hand that same
   *   browser the association back as a hit list: ask for one person's items, count the rows. So the
   *   filter arm ANDs `PrincipalAudiences#ownOrReadsInternal` on the item's owner, the same cut
   *   `SharedItemVisibilityScope#onDependentOf` applies to comments and ratings for the identical reason.
   *   A principal who may not read the byline gets an empty page from this filter, never a shortened one.
   */
  createdBy?: Maybe<Person>;
  darkMode?: Maybe<Colors>;
  description?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  filesToDelete?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<File>>;
  imagesToDelete?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  /**
   *   Whether the caller administers the company this item belongs to. Always false for a personal item —
   *   there is no company to administer — so for everything written before concept v7 this reads exactly
   *   as it always did.
   *
   * WHAT IT IS FOR: `owner` answers "did I write this", and since v8 that is no longer the same question
   *   as "may I change this" — any admin of the owning company may edit and delete its posts
   *   (the company account model).
   *
   * THE PREDICATE IS EITHER/OR, NOT AN OR. A client decides Edit and Delete like this:
   *
   *     company == null ? owner : isAdminOfCompany
   *
   * and Apply and Rate on the negation. **`owner` must not contribute to the decision on a company
   *   item.** It is derived from `person_id`, which names the human who wrote it and which nothing ever
   *   rewrites, so the admin who wrote a company post keeps `owner = true` on it after being demoted to
   *   `member` or removed from the company altogether — while `isAdminOfCompany` correctly turns false.
   *   `owner || isAdminOfCompany` would therefore offer that person an Edit button the server refuses,
   *   because `validateMayWriteSharedItem` consults membership alone for a company item and never looks
   *   at who wrote it. Kevin, 2026-08-26:
   *   the creator of a company item cannot edit or delete it once they are no longer an admin.
   *
   * WHY A SECOND FIELD RATHER THAN WIDENING `owner`. `owner` is also `@filterable`, and every "my items"
   *   list is built on that filter. Widening the field to mean "may I change this" would drag company posts
   *   into the author's own area, which 0001 §4 puts on the company page instead. So the two fields answer
   *   different questions on purpose, and the either/or above is how a client picks the right one.
   *
   * `owner` AND ITS FILTER ARE NOT THE SAME PREDICATE, and a reader building a "my items" list has to
   *   know which one they are holding. Both read `person_id` — the field compares it to the caller, and the
   *   filter renders `person_id = me AND company_id IS NULL`. The extra leg is deliberate and belongs to
   *   the filter alone: a company post is reached through its company page (0001 §4), so it must not appear
   *   in the author's own feed, while the FIELD still reports `true` for whoever wrote it because that is
   *   what "did I write this" means. On a company post, therefore, the field says yes and the filter says
   *   no, and both are right. Giving the FIELD the company condition too would turn the byline into a
   *   permission, which is the question `isAdminOfCompany` exists to answer.
   *
   * IT IS A HINT, NOT A GATE. Every write is enforced in genesis against the item's stored `company_id`
   *   (`validateMayWriteSharedItem`), never against anything a client concluded. This field only decides
   *   what a client bothers to offer.
   *
   * SINCE CONCEPT v23 (2026-09-11, EXTENDED 2026-09-12) BOTH ARMS OF THE PREDICATE HAVE A SECOND
   *   CONJUNCT, and a client that keeps the old one offers a button the server now refuses:
   *
   *     company == null ? (owner && !actingAsAnyCompany) : (isAdminOfCompany && actingAsThisCompany)
   *
   * where the right-hand half of each arm is the client's own state, not anything genesis publishes —
   *   the acting context lives in the client and genesis only checks the `actingAsCompanyId` it is sent
   *   (`UpdateSharedItemInput`). The company arm is v23 as decided on 2026-09-11; the PERSONAL arm is its
   *   mirror, added on 2026-09-12, and it is why Edit and Delete must disappear from a caller's own posts
   *   while any company context is active. v23 reverses an alternative that
   *   @external-adr SPARK-0043-a-comment-can-be-written-as-the-company had rejected for "hiding a button the server
   *   allows": the server no longer allows either one. This field is unchanged and still answers only the
   *   membership half.
   */
  isAdminOfCompany?: Maybe<Scalars['Boolean']['output']>;
  itemType?: Maybe<SharedItemType>;
  lightMode?: Maybe<Colors>;
  mainImage?: Maybe<File>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   *   Whether the caller WROTE this item — `created_by = caller`, and nothing else.
   *
   * **The field and the filter of the same name deliberately answer different questions**, and a client
   *   that assumes they agree will be wrong on exactly one kind of row. Since concept v7 a company owns
   *   its posts and projects, which split "did I write this" from "is this mine":
   *
   * * The FIELD, here, still answers *did I write this*. It is true on a company post you typed, because
   *     you did type it. **It is NOT on its own what a client offers Edit on.** The company authorship model
   *     (v8) makes that an EITHER-OR, never an OR: `company == null ? owner : isAdminOfCompany`. An
   *     `owner || isAdminOfCompany` would offer an Edit button to the author of a company post who has
   *     since been demoted from admin — a button `validateMayWriteSharedItem` then refuses. See
   *     `isAdminOfCompany` below, which states the same rule from the other side.
   *   * The FILTER, `SharedItemFilterInput.owner`, answers *is this mine* — `person_id = caller AND
   *     company_id IS NULL`. A company post is the company's, so it is excluded: it belongs on the
   *     company's page, not in your personal lists.
   *
   * So `sharedItem(id) { owner }` can be true for a row that `sharedItems(where: {owner: true})` does
   *   not return. That is the intended behaviour of both and not a defect in either. Widening the filter
   *   to match the field would drag every company post into its author's "my items"; narrowing the field
   *   to match the filter would take Edit away from the person who wrote it.
   */
  owner?: Maybe<Scalars['Boolean']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  rated?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratings?: Maybe<Scalars['Int']['output']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  signUps?: Maybe<Scalars['Int']['output']>;
  signedUp?: Maybe<Scalars['Boolean']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  watches?: Maybe<Scalars['Int']['output']>;
};


export type SharedItemMainImageArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
};

export type SharedItemComment = Node & {
  __typename?: 'SharedItemComment';
  /**
   *   The company this comment was written in the name of, or null for a personal comment.
   *
   * Concept v16 (the company account model, Kevin 2026-09-08) allows an admin
   *   acting as a company to comment. Until v15 the concept forbade it, and gave this type's shape as
   *   the reason — a comment carried a person and nothing else, so one written in company context would
   *   have read as the human's.
   *
   * BOTH ARE SHOWN, company above author, exactly as a company post has read since v10 ("Beides, nicht
   *   statt"): the comment is the company's and it stands behind it, while who typed it stays visible and
   *   the order says whose statement it is. `person` therefore keeps naming the human and stays non-null
   *   in the database. If that person later erases themselves the name goes and this line remains, so a
   *   company comment without an author name still names its company.
   *
   * CREATABLE, NOT UPDATABLE. Which company a comment belongs to is settled when it is written: an
   *   update that could move a comment between companies would let an admin of one company rewrite a
   *   line into another's name. Editing the CONTENT of a company comment is allowed, gated on the
   *   current admin membership rather than on authorship (0002 §6, v8).
   *
   * NO LOGO IS RESOLVED UNDER THIS FIELD. `Company.logo` answers only where a parent supplies a logo
   *   context, and a comment thread is a list whose length the caller does not settle — exactly the case
   *   the four-surface rule for `Company.logo` exists to prevent (see that field's description).
   *
   * NOT `@filterable`, deliberately. Nothing lists comments BY company — a thread is read by its shared
   *   item — and `shared_item_comment.company_id` carries no index for exactly that reason (V0075). A
   *   published filter would offer a sequential scan for a query no screen makes, and it would owe a
   *   filter leg that `FilterSpecCompletenessTest` rightly demands. If a caller ever needs it, the index
   *   and the leg are added together.
   */
  company?: Maybe<Company>;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   *   Whether the caller administers the company this COMMENT belongs to — false for a personal comment,
   *   and false for a company comment whose company the caller does not administer.
   *
   * THE SAME QUESTION `SharedItem.isAdminOfCompany` ANSWERS, asked of the second table that can carry a
   *   `company_id`. Concept v16 (the company account model) settles who may change
   *   a comment as an EITHER-OR, and it is the one a client needs to pick the right field:
   *
   *     company == null ? mine : isAdminOfCompany
   *
   * A `mine || isAdminOfCompany` is the bug this field exists to prevent, exactly as on `SharedItem`:
   *   `person_id` names whoever typed the comment and is never rewritten, so the admin who wrote a company
   *   comment keeps "mine" after being demoted to `member` — while this field correctly turns false. The
   *   server refuses that person's edit, because for a company comment it consults the current
   *   `company_membership` row alone and never asks who wrote it (v8 — authorship is not a right for
   *   company content).
   *
   * AND IT IS THE SAME EITHER-OR IN THE OTHER DIRECTION: for a PERSONAL comment this field is false even
   *   for someone who administers many companies, so a client must fall back to "did I write it" there.
   *   Ownership of a personal comment is still its author's, which is what v16 keeps unchanged.
   *
   * IT IS A HINT, NOT A GATE. Every write is enforced against the comment's STORED `company_id`
   *   (`validateMayWriteComment`), never against anything a client concluded, and never against a company
   *   the client names in an update — which is why `company` above is creatable but not updatable. This
   *   field only decides what a client bothers to offer.
   *
   * SINCE CONCEPT v23 (2026-09-11) THE CLIENT'S PREDICATE GAINS A SECOND CONJUNCT — `isAdminOfCompany &&
   *   actingAsThisCompany` — for the reason v23 was decided: an admin who was NOT acting as the company
   *   could edit a colleague's company comment, which is the case Kevin met in the running product. The
   *   right-hand half is the client's own state and genesis publishes nothing for it; what genesis checks
   *   is the `actingAsCompanyId` the write carries (`UpdateSharedItemCommentInput`,
   *   `DeleteSharedItemCommentInput`). Refusing to offer the button is no longer "hiding something the
   *   server allows": the server refuses it too, with `GENESIS001259`.
   *
   * AND SINCE 2026-09-12 THE OTHER ARM GAINS ONE TOO — `mine && !actingAsAnyCompany`. Kevin extended
   *   v23 in the mirror direction ("if someone acts as a company, he cannot edit/delete/create comments as
   *   private person"), so Edit and Delete disappear from a caller's OWN comment while any company context
   *   is active, and a client that still offers them is answered `GENESIS001260`. The either-or above is
   *   therefore now an either-or between two guarded arms rather than between a guarded and an open one.
   */
  isAdminOfCompany?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<Person>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *   The item this comment hangs off, named once when the comment is written and immutable thereafter.
   *
   * NOT UPDATABLE, stated explicitly (concept v20 follow-up, 2026-09-10). `updatable` defaults to false
   *   in the directive, but the generator keys on the argument being PRESENT: omitting it put both fields
   *   in `UpdateSharedItemCommentDataInput`, where `updateRecord` handles `CONTENT` alone and dropped them
   *   without a word. A client could send "move this comment to that post", be told it succeeded, and find
   *   nothing had happened. `company` and `person` on this type already say `updatable: false` and are
   *   correctly absent from that input; these two now match, so the schema REFUSES the move rather than
   *   accepting and discarding it.
   */
  sharedItem?: Maybe<SharedItem>;
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
  /**
   *   When this comment was last edited, or null if it never was.
   *
   * Concept v20 (the company account model, Kevin 2026-09-10) publishes the
   *   edit. Null is the honest answer rather than a copy of `postedAt` because `createRecord` writes a
   *   new comment with `updated_at` and `updated_by` explicitly NULL: a value here therefore means
   *   somebody changed the comment after it was written, never merely that it was created.
   *
   * WHY IT IS PUBLISHED AT ALL. Since v16 every CURRENT admin of the comment's company may edit it,
   *   while `person` keeps naming whoever typed it. Without this field the visible name stops being the
   *   writer of the visible words the moment a colleague edits — and that byline is the very safeguard
   *   v16 leans on when it keeps both attributions ("wer ihn getippt hat bleibt sichtbar"). Both columns
   *   have been stamped since long before v20; only the publication is new, so there is no migration.
   */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   *   The person who last edited this comment, or null if it was never edited.
   *
   * Resolved exactly like `person` — one batched load per page under the internal audience — so it
   *   answers null for the same two reasons that field does: an erased person, and a person this reader
   *   may not see. Concept v20 wants the editing admin NAMED, and the ordinary dash for the cases where
   *   genesis can name nobody is the answer
   *   @adr GENESIS-0024-person-erasure-classifies-every-reference@2 already settled for the author.
   */
  updatedBy?: Maybe<Person>;
};

export type SharedItemCommentConnection = {
  __typename?: 'SharedItemCommentConnection';
  edges: Array<SharedItemCommentEdge>;
  nodes: Array<SharedItemComment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemCommentEdge = {
  __typename?: 'SharedItemCommentEdge';
  cursor: Scalars['String']['output'];
  node: SharedItemComment;
};

/** The filterable fields of type SharedItemComment */
export type SharedItemCommentFilterInput = {
  and?: InputMaybe<Array<SharedItemCommentFilterInput>>;
  content?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SharedItemCommentFilterInput>;
  or?: InputMaybe<Array<SharedItemCommentFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  /**
   * The item this comment hangs off, named once when the comment is written and immutable thereafter.
   *
   * NOT UPDATABLE, stated explicitly (concept v20 follow-up, 2026-09-10). `updatable` defaults to false
   * in the directive, but the generator keys on the argument being PRESENT: omitting it put both fields
   * in `UpdateSharedItemCommentDataInput`, where `updateRecord` handles `CONTENT` alone and dropped them
   * without a word. A client could send "move this comment to that post", be told it succeeded, and find
   * nothing had happened. `company` and `person` on this type already say `updatable: false` and are
   * correctly absent from that input; these two now match, so the schema REFUSES the move rather than
   * accepting and discarding it.
   */
  sharedItem?: InputMaybe<SharedItemFilterInput>;
  sharedItemId?: InputMaybe<UuidFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItemComment. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemCommentQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemCommentSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemCommentFilterInput>;
};

export type SharedItemCommentSortInput = {
  postedAt?: InputMaybe<SortOrder>;
};

export type SharedItemConnection = {
  __typename?: 'SharedItemConnection';
  edges: Array<SharedItemEdge>;
  nodes: Array<SharedItem>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemEdge = {
  __typename?: 'SharedItemEdge';
  cursor: Scalars['String']['output'];
  node: SharedItem;
};

/** The filterable fields of type SharedItem */
export type SharedItemFilterInput = {
  and?: InputMaybe<Array<SharedItemFilterInput>>;
  /** Applicant-facing classification. Never changes sharing, responsibility or publication. */
  categories?: InputMaybe<DiscoveryCategoryListFilterInput>;
  commented?: InputMaybe<BooleanFilterInput>;
  /**
   * The company this item was published IN THE NAME OF, or null when the author published it as
   * themselves. Concept v7: the company account model.
   *
   * SET AT CREATION ONLY, never on update — `@constrained(updatable: false)`. A personal post cannot
   * become a company post later and a company post cannot be taken private: the two live in different
   * places (the author's own area versus the company page), so a switch would move content between them
   * and change who may edit it mid-life. Kevin decided that explicitly.
   *
   * WHO MAY SET IT: an admin of that company, by the same `company_membership` row that gates every
   * other per-company write (@adr GENESIS-0023-company-membership-is-the-per-company-authorization@4 §1). There is no platform role for it.
   *
   * IT DOES NOT REPLACE `createdBy`. `person_id` stays NOT NULL and still names the human who wrote the
   * item — shown as the byline. This column decides whose the item IS; `createdBy` says who typed it.
   * For a company item those are two different questions, and the edit gate reads THIS one.
   *
   * THE COMPANY MUST BE ACTIVE (concept v9). Naming an INACTIVE company here is refused with
   * `GENESIS001250` even when the caller administers it — a distinct code from the authorisation
   * refusal on purpose, because this one is repaired by reactivating the company and that one by being
   * made an admin. An inactive company's existing content is FROZEN, not merely closed to new posts:
   * it cannot be edited, deleted, applied to, rated or counted as viewed, and the documents attached to
   * it cannot be deleted. Reactivating the company lifts all of it at once.
   *
   * FILTERABLE, AND ONE CRITERION ANSWERS FOUR DIFFERENT QUESTIONS. The filter is a nested
   * `CompanyFilterInput` reached over a LEFT join, because `company_id` is nullable and a personal item
   * has no row on the other side:
   *
   *     { company: { name: { any: true } } }         everything published by ANY company
   *     { company: { name: { any: false } } }        the complement — every personal item
   *     { company: { name: { contains: "Acme" } } }  one company, by the name a searcher types
   *     { company: { id: { eq: "<uuid>" } } }        one company, by id
   *
   * AN INNER JOIN WOULD ANSWER THE SECOND LINE WITH NOTHING, silently, which is why the join type is
   * recorded here rather than left to be rediscovered. `company.name` is NOT NULL, so after the left
   * join a null name means "there is no company" and nothing else — that is what carries `any`.
   *
   * IT DOES NOT WIDEN WHAT A SEARCH CAN SEE. `sharedItems` still ANDs its `findable` condition on top,
   * so naming an INACTIVE company here returns nothing: freezing takes a dormant company's content out
   * of search, and a filter is a search. The company's own page (`companyOwnedSharedItems`) shares this
   * spec and is deliberately not affected — it never carried the findability condition.
   */
  company?: InputMaybe<CompanyFilterInput>;
  /**
   * The human who wrote this item, and the byline a client renders under it.
   *
   * IT IS ANSWERED FROM `person_id`, NOT FROM THE `created_by` COLUMN OF THE SAME NAME, and the filter
   * added with it reads the same column for the same reason. The two columns hold the same id on every
   * row (`person_id` is written once at create from a value that is always the caller and no update
   * path rewrites it), but V0044 records that `created_by` is AUDIT ONLY and must never carry an
   * authorization decision. `owner` already reads `person_id` on exactly that ground
   * (`SharedItemController#buildSharedItem`); a filter that read the audit column instead would be a
   * second definition of "who wrote this" waiting to drift from the field above it.
   *
   * FILTERABLE THROUGH A NESTED `PersonFilterInput`, over an INNER join, because `person_id` is NOT NULL, so
   * every item has a row on the other side and there is no "no author" case for a LEFT join to keep.
   * That is the one structural difference to `company` above, whose join must be LEFT because a
   * personal item genuinely has no company.
   *
   *     { createdBy: { id: { eq: "<uuid>" } } }        one person, by id
   *     { createdBy: { formattedName: { contains: "Kim" } } }  by the name a searcher types
   *
   * IT DOES NOT ANSWER "WHOSE IS THIS". A company item carries the id of the human who typed it here
   * too, so this filter returns it. See `owner` below, whose FILTER renders `person_id = me AND
   * company_id IS NULL` precisely because "mine" and "written by me" stopped being one question at
   * concept v7. A caller who wants only what a person published in their OWN name ANDs
   * `{ company: { name: { any: false } } }` onto this one; spark's person page does exactly that. The
   * condition is deliberately NOT baked in here: `owner` may be compound because it answers a yes/no
   * question, while a person filter has to answer literally what its name says.
   *
   * IT CANNOT BE USED TO PAGE AROUND THE FIELD'S OWN WHITELIST. The field is foreign PII: a browser who
   * is neither the item's owner nor a reader of INTERNAL gets `null` here
   * (`SharedItemViewer#readsEveryFieldOf`). Without a further condition the FILTER would hand that same
   * browser the association back as a hit list: ask for one person's items, count the rows. So the
   * filter arm ANDs `PrincipalAudiences#ownOrReadsInternal` on the item's owner, the same cut
   * `SharedItemVisibilityScope#onDependentOf` applies to comments and ratings for the identical reason.
   * A principal who may not read the byline gets an empty page from this filter, never a shortened one.
   */
  createdBy?: InputMaybe<PersonFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isInAnyPinGroup?: InputMaybe<BooleanFilterInput>;
  itemType?: InputMaybe<SharedItemTypeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SharedItemFilterInput>;
  or?: InputMaybe<Array<SharedItemFilterInput>>;
  /**
   * Whether the caller WROTE this item — `created_by = caller`, and nothing else.
   *
   * **The field and the filter of the same name deliberately answer different questions**, and a client
   * that assumes they agree will be wrong on exactly one kind of row. Since concept v7 a company owns
   * its posts and projects, which split "did I write this" from "is this mine":
   *
   * * The FIELD, here, still answers *did I write this*. It is true on a company post you typed, because
   *   you did type it. **It is NOT on its own what a client offers Edit on.** The company authorship model
   *   (v8) makes that an EITHER-OR, never an OR: `company == null ? owner : isAdminOfCompany`. An
   *   `owner || isAdminOfCompany` would offer an Edit button to the author of a company post who has
   *   since been demoted from admin — a button `validateMayWriteSharedItem` then refuses. See
   *   `isAdminOfCompany` below, which states the same rule from the other side.
   * * The FILTER, `SharedItemFilterInput.owner`, answers *is this mine* — `person_id = caller AND
   *   company_id IS NULL`. A company post is the company's, so it is excluded: it belongs on the
   *   company's page, not in your personal lists.
   *
   * So `sharedItem(id) { owner }` can be true for a row that `sharedItems(where: {owner: true})` does
   * not return. That is the intended behaviour of both and not a defect in either. Widening the filter
   * to match the field would drag every company post into its author's "my items"; narrowing the field
   * to match the filter would take Edit away from the person who wrote it.
   */
  owner?: InputMaybe<BooleanFilterInput>;
  pinGroupId?: InputMaybe<UuidFilterInput>;
  pinned?: InputMaybe<BooleanFilterInput>;
  rated?: InputMaybe<BooleanFilterInput>;
  shortDescription?: InputMaybe<StringFilterInput>;
  signedUp?: InputMaybe<BooleanFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItem. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemFilterInput>;
};

export type SharedItemRating = {
  __typename?: 'SharedItemRating';
  comment?: Maybe<Scalars['String']['output']>;
  fiveStarRating?: Maybe<Scalars['Float']['output']>;
  person?: Maybe<Person>;
  ratedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedItem?: Maybe<SharedItem>;
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

export type SharedItemRatingConnection = {
  __typename?: 'SharedItemRatingConnection';
  edges: Array<SharedItemRatingEdge>;
  nodes: Array<SharedItemRating>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemRatingEdge = {
  __typename?: 'SharedItemRatingEdge';
  cursor: Scalars['String']['output'];
  node: SharedItemRating;
};

/** The filterable fields of type SharedItemRating */
export type SharedItemRatingFilterInput = {
  and?: InputMaybe<Array<SharedItemRatingFilterInput>>;
  comment?: InputMaybe<StringFilterInput>;
  fiveStarRating?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<SharedItemRatingFilterInput>;
  or?: InputMaybe<Array<SharedItemRatingFilterInput>>;
  ratedAt?: InputMaybe<DateTimeFilterInput>;
  sharedItem?: InputMaybe<SharedItemFilterInput>;
  sharedItemId?: InputMaybe<UuidFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItemRating. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemRatingQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemRatingSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemRatingFilterInput>;
};

export type SharedItemRatingSortInput = {
  comment?: InputMaybe<SortOrder>;
  fiveStarRating?: InputMaybe<SortOrder>;
  ratedAt?: InputMaybe<SortOrder>;
};

/** Contains information for linking 'SharedItem' to other entities */
export type SharedItemRelationInput = {
  /** The identifier of 'SharedItem' */
  id: Scalars['ID']['input'];
};

export type SharedItemSignUpQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SharedItemSortInput = {
  comments?: InputMaybe<SortOrder>;
  /**
   * The human who wrote this item, and the byline a client renders under it.
   *
   * IT IS ANSWERED FROM `person_id`, NOT FROM THE `created_by` COLUMN OF THE SAME NAME, and the filter
   * added with it reads the same column for the same reason. The two columns hold the same id on every
   * row (`person_id` is written once at create from a value that is always the caller and no update
   * path rewrites it), but V0044 records that `created_by` is AUDIT ONLY and must never carry an
   * authorization decision. `owner` already reads `person_id` on exactly that ground
   * (`SharedItemController#buildSharedItem`); a filter that read the audit column instead would be a
   * second definition of "who wrote this" waiting to drift from the field above it.
   *
   * FILTERABLE THROUGH A NESTED `PersonFilterInput`, over an INNER join, because `person_id` is NOT NULL, so
   * every item has a row on the other side and there is no "no author" case for a LEFT join to keep.
   * That is the one structural difference to `company` above, whose join must be LEFT because a
   * personal item genuinely has no company.
   *
   *     { createdBy: { id: { eq: "<uuid>" } } }        one person, by id
   *     { createdBy: { formattedName: { contains: "Kim" } } }  by the name a searcher types
   *
   * IT DOES NOT ANSWER "WHOSE IS THIS". A company item carries the id of the human who typed it here
   * too, so this filter returns it. See `owner` below, whose FILTER renders `person_id = me AND
   * company_id IS NULL` precisely because "mine" and "written by me" stopped being one question at
   * concept v7. A caller who wants only what a person published in their OWN name ANDs
   * `{ company: { name: { any: false } } }` onto this one; spark's person page does exactly that. The
   * condition is deliberately NOT baked in here: `owner` may be compound because it answers a yes/no
   * question, while a person filter has to answer literally what its name says.
   *
   * IT CANNOT BE USED TO PAGE AROUND THE FIELD'S OWN WHITELIST. The field is foreign PII: a browser who
   * is neither the item's owner nor a reader of INTERNAL gets `null` here
   * (`SharedItemViewer#readsEveryFieldOf`). Without a further condition the FILTER would hand that same
   * browser the association back as a hit list: ask for one person's items, count the rows. So the
   * filter arm ANDs `PrincipalAudiences#ownOrReadsInternal` on the item's owner, the same cut
   * `SharedItemVisibilityScope#onDependentOf` applies to comments and ratings for the identical reason.
   * A principal who may not read the byline gets an empty page from this filter, never a shortened one.
   */
  createdBy?: InputMaybe<PersonSortInput>;
  description?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  publishedOn?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  shortDescription?: InputMaybe<SortOrder>;
  signUps?: InputMaybe<SortOrder>;
};

export enum SharedItemType {
  Post = 'POST',
  Project = 'PROJECT'
}

export type SharedItemTypeFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<SharedItemTypeFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<SharedItemType>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<SharedItemType>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<SharedItemType>;
  /** Negates the predicate */
  not?: InputMaybe<SharedItemTypeFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<SharedItemTypeFilterInput>>;
};

export type SharedItemWithDate = {
  __typename?: 'SharedItemWithDate';
  dateTime: Scalars['DateTime']['output'];
  sharedItem: SharedItem;
};

/** The filterable fields of type SharedItemWithDate */
export type SharedItemWithDateFilterInput = {
  and?: InputMaybe<Array<SharedItemWithDateFilterInput>>;
  not?: InputMaybe<SharedItemWithDateFilterInput>;
  or?: InputMaybe<Array<SharedItemWithDateFilterInput>>;
};

export type SignUpSharedProjectInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  signedUp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignUpSharedProjectOutput = SignUpSharedProjectResult;

export type SignUpSharedProjectResult = {
  __typename?: 'SignUpSharedProjectResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type SignUpSharedProjectResult */
export type SignUpSharedProjectResultFilterInput = {
  and?: InputMaybe<Array<SignUpSharedProjectResultFilterInput>>;
  not?: InputMaybe<SignUpSharedProjectResultFilterInput>;
  or?: InputMaybe<Array<SignUpSharedProjectResultFilterInput>>;
};

export type SmartAnalysisEvidence = {
  __typename?: 'SmartAnalysisEvidence';
  /** Quelldokument in DOCUMENTS; nullable, falls Nachweise ihr Dokument ueberleben */
  documentId?: Maybe<Scalars['UUID']['output']>;
  documentName: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  quote: Scalars['String']['output'];
  stance: EvidencePolarity;
  support: EvidenceStrength;
};

/** The filterable fields of type SmartAnalysisEvidence */
export type SmartAnalysisEvidenceFilterInput = {
  and?: InputMaybe<Array<SmartAnalysisEvidenceFilterInput>>;
  not?: InputMaybe<SmartAnalysisEvidenceFilterInput>;
  or?: InputMaybe<Array<SmartAnalysisEvidenceFilterInput>>;
};

export type SmartAnalysisResult = {
  __typename?: 'SmartAnalysisResult';
  confidence: Scalars['Float']['output'];
  element: CreativityElement;
  evidences: Array<SmartAnalysisEvidence>;
  rationale?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
};

/** The filterable fields of type SmartAnalysisResult */
export type SmartAnalysisResultFilterInput = {
  and?: InputMaybe<Array<SmartAnalysisResultFilterInput>>;
  not?: InputMaybe<SmartAnalysisResultFilterInput>;
  or?: InputMaybe<Array<SmartAnalysisResultFilterInput>>;
};

/** Defines the sorting order of a field. */
export enum SortOrder {
  /** Sort ascending, null values first */
  Asc = 'ASC',
  /** Sort descending, null values last */
  Desc = 'DESC'
}

export type StringConditionInput = {
  kind: StringConditionKind;
  value: Scalars['String']['input'];
};

export enum StringConditionKind {
  DriversLicense = 'DRIVERS_LICENSE',
  Nationality = 'NATIONALITY'
}

/** Defines case-sensitivity for a string based filter. */
export enum StringFilterCaseSensitivity {
  /** Case insensitive comparisons (a == A) */
  CaseInsensitive = 'CASE_INSENSITIVE',
  /** Case sensitive comparisons (a != A) */
  CaseSensitive = 'CASE_SENSITIVE'
}

/** Filtering for fields of type String */
export type StringFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<StringFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if comparisons should be case-sensitive or not */
  caseSensitivity?: InputMaybe<StringFilterCaseSensitivity>;
  /** Checks if the field's value contains the given value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value ends with the given suffix */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['String']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<StringFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<StringFilterInput>>;
  /** Checks if the field's value begins with the given prefix */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Filtering options for a list of elements with type String */
export type StringListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<StringFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<StringFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<StringFilterInput>;
};

/**
 * Ein Notizbuch im Studio: lose Funde einer Person, als das Markdown gespeichert, das spark schreibt und
 * liest. Nur wer es angelegt hat, sieht und ändert es; auch ein Admin bekommt fremde Notizbücher nicht.
 *
 * Gespeichert wird wie beim Match: der Client schickt den ganzen Text, genesis prüft beim Schreiben die
 * interne Version (@adr GENESIS-0008-optimistic-locking-internal-version@1). Die Version steht bewusst nicht
 * im Vertrag. Ändern zwei Tabs dasselbe Notizbuch, gilt wie im Match-Editor der zuletzt gespeicherte Stand.
 */
export type StudioNotebook = Node & {
  __typename?: 'StudioNotebook';
  /** Der Text des Notizbuchs als Markdown, mit den Abschnitten, die spark darin markiert. */
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StudioNotebookConnection = {
  __typename?: 'StudioNotebookConnection';
  edges: Array<StudioNotebookEdge>;
  nodes: Array<StudioNotebook>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StudioNotebookEdge = {
  __typename?: 'StudioNotebookEdge';
  cursor: Scalars['String']['output'];
  node: StudioNotebook;
};

/** The filterable fields of type StudioNotebook */
export type StudioNotebookFilterInput = {
  and?: InputMaybe<Array<StudioNotebookFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<StudioNotebookFilterInput>;
  or?: InputMaybe<Array<StudioNotebookFilterInput>>;
};

/** The parameters for requesting multiple instances of StudioNotebook. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type StudioNotebookQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<StudioNotebookSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<StudioNotebookFilterInput>;
};

export type StudioNotebookSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Subscription = {
  __typename?: 'Subscription';
  conversationEvents: ConversationEvent;
  conversationLifecycleEvents: ConversationLifecycleEvent;
  /**
   * Streams lifecycle events of a documents-extraction job started via startDocumentsExtraction.
   * Emits a snapshot of the current job state first (QUEUED/STARTED, or the terminal event with
   * result for an already-finished job), then live events; the stream completes after a terminal
   * COMPLETED/FAILED event. Only the person who started the job may subscribe. Note: if the pod
   * executing the job dies, no terminal event is ever emitted — clients should pair the
   * subscription with a timeout and fall back to the extractionJob status query.
   */
  documentsExtractionEvents: DocumentsExtractionEvent;
  /**
   * Streams complete progress snapshots for a detached YAML import until it reaches a terminal state.
   * Only the person who started the job may subscribe. Note: if the pod executing the job dies, the
   * job stays QUEUED/RUNNING and no terminal snapshot is ever emitted — clients should pair the
   * subscription with a timeout and fall back to the importJob status query.
   */
  importJobEvents: ImportJob;
  /**
   * Subscribes to realtime notification changes for the current user. Events for notification
   * types outside input.supportedTypes are filtered out; when the input is absent only the six
   * original types are delivered (see NotificationsInput.supportedTypes).
   */
  notificationEvents: NotificationEvent;
  /**
   * Streams progress snapshots of one long-running operation the caller started with this progressId
   * (for example generateTransientMatchResult). The id is client generated and fresh per start; only the
   * person who started the operation receives anything. Snapshots are complete and arrive at most about
   * twice a second. The stream completes after a SUCCEEDED or FAILED snapshot, when the stored snapshot
   * expires, or when none appears within a minute of subscribing. Progress is best-effort: if the pod
   * running the operation dies, no terminal snapshot follows, so clients bind the display to the
   * operation itself, not to this stream.
   */
  operationProgress: OperationProgress;
  unreadChatMessageCountUpdates: UnreadChatMessageCount;
  /** Subscribes to unread notification count changes for the current user. */
  unreadNotificationCountUpdates: UnreadNotificationCount;
};


export type SubscriptionConversationEventsArgs = {
  afterMessageId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['UUID']['input'];
};


export type SubscriptionDocumentsExtractionEventsArgs = {
  jobId: Scalars['UUID']['input'];
};


export type SubscriptionImportJobEventsArgs = {
  jobId: Scalars['UUID']['input'];
};


export type SubscriptionNotificationEventsArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type SubscriptionOperationProgressArgs = {
  progressId: Scalars['UUID']['input'];
};


export type SubscriptionUnreadChatMessageCountUpdatesArgs = {
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionUnreadNotificationCountUpdatesArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};

/** The filterable fields of type Subscription */
export type SubscriptionFilterInput = {
  and?: InputMaybe<Array<SubscriptionFilterInput>>;
  not?: InputMaybe<SubscriptionFilterInput>;
  or?: InputMaybe<Array<SubscriptionFilterInput>>;
};

export type SuggestActivityDescriptionsInput = {
  /** Optional department context. */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Job title to generate activities for. */
  jobTitle: Scalars['String']['input'];
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the suggestions (free-text). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestExpertiseDescriptionsInput = {
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the suggestions (free-text). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestProfileSummaryInput = {
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the summary (free-text), e.g. "emphasize leadership". */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Result of a suggestion query. `suggestions` is empty for `EMPTY` and `UNAVAILABLE`. */
export type SuggestionResult = {
  __typename?: 'SuggestionResult';
  status: SuggestionStatus;
  suggestions: Array<Scalars['String']['output']>;
};

/** The filterable fields of type SuggestionResult */
export type SuggestionResultFilterInput = {
  and?: InputMaybe<Array<SuggestionResultFilterInput>>;
  not?: InputMaybe<SuggestionResultFilterInput>;
  or?: InputMaybe<Array<SuggestionResultFilterInput>>;
};

/**
 * Outcome of a model-gateway-backed suggestion call.
 *
 * - `OK`: model returned suggestions.
 * - `EMPTY`: model returned no suggestions (e.g., gibberish search).
 * - `UNAVAILABLE`: model-gateway, the model, or schema validation failed; suggestions is always empty.
 *
 * The client decides how to render each status; the server never raises a GraphQL error for a service failure.
 */
export enum SuggestionStatus {
  Empty = 'EMPTY',
  Ok = 'OK',
  Unavailable = 'UNAVAILABLE'
}

/**
 * Declares which notification types the calling client understands. Shared by the
 * notification queries, mutations and subscriptions for backward compatibility with clients
 * built against an older schema.
 */
export type SupportedNotificationTypesInput = {
  /**
   * Notification types this client understands. Notifications and events of other types are
   * filtered out, and counts only include declared types. When absent, only the six original
   * types are considered (see NotificationsInput.supportedTypes for the rationale). The read
   * operations treat an empty list the same way; the bulk mutations take it literally and
   * affect nothing, since deleting or clearing "no types" must never mean "clear six of them".
   */
  supportedTypes?: InputMaybe<Array<NotificationType>>;
};

export type SystemSettings = {
  __typename?: 'SystemSettings';
  accentColor?: Maybe<Scalars['String']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<File>;
  candidateAssessmentPrompt?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<File>;
  /** Ordinary SharedItems always include the default internal recipients when true. Defaults to true. */
  sharedItemsRequireDefaultRecipients: Scalars['Boolean']['output'];
  surfaceColor?: Maybe<Scalars['String']['output']>;
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type SystemSettingsDataInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<SystemSettingsFileInput>;
  candidateAssessmentPrompt?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<SystemSettingsFileInput>;
  /** Controls new items and explicit sharing edits, without rewriting saved items. Null restores true. */
  sharedItemsRequireDefaultRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  surfaceColor?: InputMaybe<Scalars['String']['input']>;
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type SystemSettingsFileInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/** The filterable fields of type SystemSettings */
export type SystemSettingsFilterInput = {
  and?: InputMaybe<Array<SystemSettingsFilterInput>>;
  not?: InputMaybe<SystemSettingsFilterInput>;
  or?: InputMaybe<Array<SystemSettingsFilterInput>>;
};

export type SystemSettingsInput = {
  data: SystemSettingsDataInput;
};

export type TakeOverSharedItemInput = {
  matchId: Scalars['UUID']['input'];
  sharedItemId: Scalars['UUID']['input'];
};

export type TakeOverSharedItemOutput = TakeOverSharedItemResult;

export type TakeOverSharedItemResult = {
  __typename?: 'TakeOverSharedItemResult';
  match: Match;
};

/** The filterable fields of type TakeOverSharedItemResult */
export type TakeOverSharedItemResultFilterInput = {
  and?: InputMaybe<Array<TakeOverSharedItemResultFilterInput>>;
  not?: InputMaybe<TakeOverSharedItemResultFilterInput>;
  or?: InputMaybe<Array<TakeOverSharedItemResultFilterInput>>;
};

/**
 * A named weight vector over the 30 powers (@adr GENESIS-0001-power-cluster-taxonomy@2), surfaced in spark as
 * "Power Profil" under Stammdaten. Explore, Exploit and Ausgewogen are company defaults seeded by
 * migration; their name and weights are treated as immutable, but that is enforced in the spark UI
 * (spark#218) and not here — there is no protection flag on the type on purpose.
 */
export type TeamProfile = Node & {
  __typename?: 'TeamProfile';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
  weights: Array<ElementWeight>;
};

export type TeamProfileConnection = {
  __typename?: 'TeamProfileConnection';
  edges: Array<TeamProfileEdge>;
  nodes: Array<TeamProfile>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeamProfileEdge = {
  __typename?: 'TeamProfileEdge';
  cursor: Scalars['String']['output'];
  node: TeamProfile;
};

/** The filterable fields of type TeamProfile */
export type TeamProfileFilterInput = {
  and?: InputMaybe<Array<TeamProfileFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TeamProfileFilterInput>;
  or?: InputMaybe<Array<TeamProfileFilterInput>>;
};

/** The parameters for requesting multiple instances of TeamProfile. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type TeamProfileQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<TeamProfileSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<TeamProfileFilterInput>;
};

export type TeamProfileSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TextConditionInput = {
  aiMode: ConditionAiMode;
  kind: TextConditionKind;
  value: Scalars['String']['input'];
};

export enum TextConditionKind {
  Certificate = 'CERTIFICATE',
  Education = 'EDUCATION',
  Experience = 'EXPERIENCE'
}

export type TextElement = GrowElement & {
  __typename?: 'TextElement';
  content?: Maybe<Scalars['Binary']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type TextElement */
export type TextElementFilterInput = {
  and?: InputMaybe<Array<TextElementFilterInput>>;
  not?: InputMaybe<TextElementFilterInput>;
  or?: InputMaybe<Array<TextElementFilterInput>>;
};

export type TooManyRecordsResult = {
  __typename?: 'TooManyRecordsResult';
  /** The maximum number of records allowed */
  limit?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type TooManyRecordsResult */
export type TooManyRecordsResultFilterInput = {
  and?: InputMaybe<Array<TooManyRecordsResultFilterInput>>;
  not?: InputMaybe<TooManyRecordsResultFilterInput>;
  or?: InputMaybe<Array<TooManyRecordsResultFilterInput>>;
};

/**
 * A person's toplist of one domain: their ranked favourites, shared with all eligible Groups on first creation.
 * The owner can change this per list. A replay replaces the entries and keeps the saved sharing.
 */
export type Toplist = Node & SharableEntity & {
  __typename?: 'Toplist';
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: Maybe<Scalars['Boolean']['output']>;
  domain: FavoriteDomain;
  /** Best first: ten after a finished game, fewer after deleteMyFavorite. */
  entries: Array<Favorite>;
  id: Scalars['ID']['output'];
  /** Public readership, independent of Group recipients. */
  publiclyReadable?: Maybe<Scalars['Boolean']['output']>;
  /** Selected Group recipients; allGroups independently grants dynamic Group readership. */
  sharedWith?: Maybe<Array<ContentSharingRecipient>>;
};

/**
 * One entry of a finished toplist: a catalogue item of the session's domain or a title of the player's own, exactly one
 * of the two. An own title is trimmed and then 1 to 120 characters long without control characters; it stays with the
 * player's favourite and never enters the catalogue.
 */
export type ToplistEntryInput = {
  catalogItemId?: InputMaybe<Scalars['UUID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The filterable fields of type Toplist */
export type ToplistFilterInput = {
  and?: InputMaybe<Array<ToplistFilterInput>>;
  not?: InputMaybe<ToplistFilterInput>;
  or?: InputMaybe<Array<ToplistFilterInput>>;
};

/** A toplist game session: the shared head plus the client's snapshot to resume from. */
export type ToplistSession = {
  __typename?: 'ToplistSession';
  session: GameSession;
  snapshot?: Maybe<Scalars['Object']['output']>;
  snapshotVersion?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ToplistSession */
export type ToplistSessionFilterInput = {
  and?: InputMaybe<Array<ToplistSessionFilterInput>>;
  not?: InputMaybe<ToplistSessionFilterInput>;
  or?: InputMaybe<Array<ToplistSessionFilterInput>>;
};

export type TypingIndicator = {
  __typename?: 'TypingIndicator';
  conversationId: Scalars['UUID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  observedAt: Scalars['DateTime']['output'];
  personId: Scalars['UUID']['output'];
  typing: Scalars['Boolean']['output'];
};

/** The filterable fields of type TypingIndicator */
export type TypingIndicatorFilterInput = {
  and?: InputMaybe<Array<TypingIndicatorFilterInput>>;
  not?: InputMaybe<TypingIndicatorFilterInput>;
  or?: InputMaybe<Array<TypingIndicatorFilterInput>>;
};

export type UuidFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<UuidFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['UUID']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<UuidFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<UuidFilterInput>>;
};

export type UnlinkProjectMatchInput = {
  /** Wählt den Weg wie bei `UpdateProjectInput.actingAsCompanyId` (genesis#418). */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  matchId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};

export type UnlinkProjectMatchOutput = UnlinkProjectMatchResult;

export type UnlinkProjectMatchResult = {
  __typename?: 'UnlinkProjectMatchResult';
  project: Project;
};

/** The filterable fields of type UnlinkProjectMatchResult */
export type UnlinkProjectMatchResultFilterInput = {
  and?: InputMaybe<Array<UnlinkProjectMatchResultFilterInput>>;
  not?: InputMaybe<UnlinkProjectMatchResultFilterInput>;
  or?: InputMaybe<Array<UnlinkProjectMatchResultFilterInput>>;
};

export type UnreadChatMessageCount = {
  __typename?: 'UnreadChatMessageCount';
  conversationId?: Maybe<Scalars['UUID']['output']>;
  count: Scalars['Int']['output'];
};

/** The filterable fields of type UnreadChatMessageCount */
export type UnreadChatMessageCountFilterInput = {
  and?: InputMaybe<Array<UnreadChatMessageCountFilterInput>>;
  not?: InputMaybe<UnreadChatMessageCountFilterInput>;
  or?: InputMaybe<Array<UnreadChatMessageCountFilterInput>>;
};

/** Unread notification count for the current user. */
export type UnreadNotificationCount = {
  __typename?: 'UnreadNotificationCount';
  count: Scalars['Int']['output'];
};

/** The filterable fields of type UnreadNotificationCount */
export type UnreadNotificationCountFilterInput = {
  and?: InputMaybe<Array<UnreadNotificationCountFilterInput>>;
  not?: InputMaybe<UnreadNotificationCountFilterInput>;
  or?: InputMaybe<Array<UnreadNotificationCountFilterInput>>;
};

export type UpdateAccessGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Edit a custom Role for every current holder. Existing assignment scopes must remain compatible. */
export type UpdateAccessRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  permissionIds: Array<Scalars['ID']['input']>;
};

export type UpdateAgentDataInput = {
  /** Capability areas in plain words. Free text on purpose: how an agent offsets requirements is undecided. */
  covers?: InputMaybe<Array<CreateLocalizedTextDataInput>>;
  guardrails?: InputMaybe<Array<CreateLocalizedTextDataInput>>;
  /** The integration surface as the vendor names it (MCP servers, connectors, plugins). Product tokens. */
  integrations: Array<Scalars['String']['input']>;
  /** The model, when known. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Product name. Must not be blank. `agents` orders by it unless `order` says otherwise. */
  name: Scalars['String']['input'];
  /** What the agent does. At least one of german / english must be non-blank. */
  role?: InputMaybe<CreateLocalizedTextDataInput>;
  tools?: InputMaybe<Array<CreateAgentToolDataInput>>;
  /** The vendor's product page. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** The vendor's name. Must not be blank. */
  vendor: Scalars['String']['input'];
};

export type UpdateAgentInput = {
  data: UpdateAgentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAgentOutput = UpdateAgentResult | ValidateAgentResult;

/** The actual data structure of updating an instance of Agent */
export type UpdateAgentResult = {
  __typename?: 'UpdateAgentResult';
  /** The actual data returned for Agent */
  result: Agent;
};

export type UpdateCertificateDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<CreateDateInstantDataInput>;
  name: Scalars['String']['input'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

export type UpdateCertificateInput = {
  data: UpdateCertificateDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *   Ignored, and kept only so callers that still send it are not rejected.
   *
   * The owner is read from the stored certificate row, and the write is authorized against that owner —
   *   a value here selects nothing and re-targets nothing, and one naming a different person is
   *   silently accepted rather than refused. New callers should omit it (#340).
   *
   * Deprecated, not going away: removing it would reject every request that still carries the field,
   *   and that breaking change is not worth making for an argument the server throws away.
   * @deprecated Never read; the owner comes from the stored row. Omit it in new callers — the field itself stays, so older ones keep working.
   */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCertificateOutput = UpdateCertificateResult | ValidateCertificateResult;

/** The actual data structure of updating an instance of Certificate */
export type UpdateCertificateResult = {
  __typename?: 'UpdateCertificateResult';
  /** The actual data returned for Certificate */
  result: Certificate;
};

export type UpdateCompanyDataInput = {
  /**
   * Size, as a headcount.
   *
   * PROFILE FIELD — POPULATED ON THE SINGLE-COMPANY QUERY AND ON `companies` NODES, the same rule as
   * `summary` below. See
   * `summary` for why, and for why `logo` is no longer governed by that same rule.
   *
   * ONE EXCEPTION, AND ONLY THIS ONE: `MatchCompany.company` and `MatchResultCompany.company` carry it
   * too, because in a company match the head count is the actual value of a size criterion, shown beside
   * every company in the pool and the ranking
   * (@adr GENESIS-0078-a-match-company-carries-its-size-but-not-its-summary@2). `summary` does not
   * follow it there.
   */
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  /** Industry. The curated Industry reference entity, shared with Experience. */
  industry?: InputMaybe<IndustryRelationInput>;
  /**
   * The company logo, stored in backdrop and owned by the default user
   * (@adr GENESIS-0013-backdrop-blob-storage-boundary@1). Null when none was uploaded; the page then renders
   * the monogram fallback that the company page displays.
   *
   * THE TEST IS WHETHER THE CALLER DECIDED THE NUMBER OF IMAGES BEFORE SENDING THE REQUEST. The CSP
   * admits images only from self, data: and blob:, so the bytes travel base64-encoded inside the GraphQL
   * response; one image is a picture, a page of them is a payload. Where the count is settled in advance
   * the caller is asking for exactly those images on purpose, and this field answers. Where it is
   * "whatever matched", it does not.
   *
   * IT THEREFORE RESOLVES IN FOUR PLACES, AND NOWHERE ELSE:
   *
   * - the single-company query — one company, the one being shown;
   * - `myCompanies` — bounded by the caller's own company_membership rows, each Company at most once;
   * - `companyIdentities` — bounded by an explicit, server-capped id list the caller already held;
   * - `SharedItem.company` on the SINGLE-ITEM read and the create/update payloads — one item, one owner,
   *   which is the "Published by <company>" byline of that item's own page.
   *
   * EVERYWHERE ELSE IT IS NULL EVEN WHEN A LOGO EXISTS — CompanyMembership.company in a member roster,
   * and SharedItem.company in any feed or company-page listing. That is structural rather than a
   * convention a client is asked to keep: the logo travels as local context, and the list surfaces
   * attach none, so the field cannot resolve there however the query is written. An earlier revision of
   * this paragraph stated the rule while the code left the context attached on every shared-item
   * surface — a feed selecting `nodes { company { logo } }` really did return one image per row, on an
   * endpoint that takes no page-size cap. Do not re-widen it by attaching the map somewhere new; add a
   * bounded, id-driven query instead, the way `companyIdentities` was.
   *
   * `summary` and `employeeCount` are populated on the single-company query and on `companies` nodes
   * only (GENESIS-0036) — null on every Company beside something else, including `myCompanies`, with
   * the one exception that the Match pool and ranking carry `employeeCount` (see that field). `id`,
   * `name` and `industry` are what a Company beside something else always carries.
   *
   * profile accepts "card" (max height 140) or "share_preview" (max height 250); omit it for the
   * unscaled original.
   *
   * ON WRITE (the generated create/update inputs carry this field as CreateFileDataInput): max 5 MB, and
   * the content must BE a PNG, JPEG, GIF, BMP, TIFF or WebP. The check is on the bytes, never on the
   * declared mimeType, so a payload announcing image/png while carrying something else is rejected. SVG
   * is refused outright — it carries script and the blob store cannot scale it. On update, omitting the
   * field leaves the current logo alone and passing null removes it, the same presence-versus-value rule
   * the other optional fields follow.
   */
  logo?: InputMaybe<CreateFileDataInput>;
  name: Scalars['String']['input'];
  /**
   * ACTIVE or INACTIVE — see the enum for what the two mean and why there are only two.
   *
   * NOT CREATABLE: a company is born ACTIVE and there is no reason to create a dormant one, so the
   * column's default is the only way it is ever first set. Updatable by an admin of this company, which
   * is the same gate `updateCompany` already applies to every other field here — deactivating is a
   * per-company write like any other, and deliberately NOT a platform-moderation action (there is no
   * role for that, and adding one is a realm change).
   *
   * Not `@filterable`, and that is not an oversight: an INACTIVE company is not in the search index at
   * all, so a status filter over search results would have nothing to select from — and the `companies`
   * connection applies `status = ACTIVE` as a row rule to every page and to `totalCount`, so a filter
   * there would have nothing to add either (GENESIS-0036).
   *
   * NULLABLE ON THE WIRE, ALWAYS SET IN PRACTICE. Every resolver that returns a Company populates it,
   * so a caller reading this field gets a value. It is declared nullable because the generated update
   * input mirrors the field's nullability, and a non-null one would make `status` REQUIRED on every
   * `updateCompany` — the same way `name` is — so an edit that only touched the summary would have to
   * restate the status or be rejected. That is the opposite of the property-set mechanism this mutation
   * is built on, where an unmentioned field is left alone.
   */
  status?: InputMaybe<CompanyStatus>;
  /**
   * About us — one free text carrying vision, mission, product, culture and expectations.
   *
   * One unbounded field:
   * everything a company says about itself arrives here, so a populated `summary` is a page of text, not
   * a label.
   *
   * PROFILE FIELD — POPULATED ON THE SINGLE-COMPANY QUERY AND ON `companies` NODES. Everywhere else a
   * Company is reachable — CompanyMembership.company in a member strip, MyCompanyMembership.company in
   * myCompanies, SharedItem.company, SharedItemComment.company, Project.company, `companyIdentities`, and
   * the Match pool and ranking (MatchCompany.company, MatchResultCompany.company) — this resolves to null
   * even when a summary is stored, for the reason `logo` gives: every
   * row of a member strip points at the SAME Company, so populating it would ship one full copy of that
   * text per member beside three short fields. Ask for the profile on the company you are showing, once.
   * A `companies` page is different in kind (@adr GENESIS-0036-a-company-is-queryable-like-a-person@2):
   * every node is a DIFFERENT company, selected on purpose and bounded by `first`, so the text is
   * delivered once per company the caller asked for — the same reasoning that admits `logo` on
   * `myCompanies`.
   *
   * `logo` is NOT the same rule any more, so do not read one off the other: it is also delivered on
   * `myCompanies`, because that list is bounded by the caller's own memberships. `summary` is not,
   * because a whole "About us" page per row is unwelcome at any length of list.
   *
   * A null here therefore means "not asked on this query" on every one of those surfaces, NOT "this
   * company wrote nothing" — and on `company` and `companies` it IS the stored value, so a null there means the
   * company has no description. The identity fields a strip does carry are `id`, `name` and `industry`.
   *
   * NOT FILTERABLE: summary text is excluded from the search index and the filter layer. A consumer that needs to find companies by what
   * their description says reads the descriptions off `companies` nodes and searches them itself
   * (agent-service does, by embedding — @adr GENESIS-0036-a-company-is-queryable-like-a-person@2).
   */
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInput = {
  data: UpdateCompanyDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanyOutput = UpdateCompanyResult | ValidateCompanyResult;

/** The actual data structure of updating an instance of Company */
export type UpdateCompanyResult = {
  __typename?: 'UpdateCompanyResult';
  /** The actual data returned for Company */
  result: Company;
};

export type UpdateContractTypeDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateContractTypeInput = {
  data: UpdateContractTypeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContractTypeOutput = UpdateContractTypeResult | ValidateContractTypeResult;

/** The actual data structure of updating an instance of ContractType */
export type UpdateContractTypeResult = {
  __typename?: 'UpdateContractTypeResult';
  /** The actual data returned for ContractType */
  result: ContractType;
};

export type UpdateCurriculumVitaeDataInput = {
  apiVersion: Scalars['Int']['input'];
  configuration?: InputMaybe<Scalars['Object']['input']>;
  content?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurriculumVitaeInput = {
  data: UpdateCurriculumVitaeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCurriculumVitaeOutput = UpdateCurriculumVitaeResult | ValidateCurriculumVitaeResult;

/** The actual data structure of updating an instance of CurriculumVitae */
export type UpdateCurriculumVitaeResult = {
  __typename?: 'UpdateCurriculumVitaeResult';
  /** The actual data returned for CurriculumVitae */
  result: CurriculumVitae;
};

export type UpdateDegreeDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateDegreeInput = {
  data: UpdateDegreeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDegreeOutput = UpdateDegreeResult | ValidateDegreeResult;

/** The actual data structure of updating an instance of Degree */
export type UpdateDegreeResult = {
  __typename?: 'UpdateDegreeResult';
  /** The actual data returned for Degree */
  result: Degree;
};

export type UpdateDiscoveryCategoryDataInput = {
  name?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateDiscoveryCategoryInput = {
  data: UpdateDiscoveryCategoryDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDiscoveryCategoryOutput = UpdateDiscoveryCategoryResult | ValidateDiscoveryCategoryResult;

/** The actual data structure of updating an instance of DiscoveryCategory */
export type UpdateDiscoveryCategoryResult = {
  __typename?: 'UpdateDiscoveryCategoryResult';
  /** The actual data returned for DiscoveryCategory */
  result: DiscoveryCategory;
};

export type UpdateDocumentDataInput = {
  category?: InputMaybe<DocumentClassifier>;
  group?: InputMaybe<DocumentGroupRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDocumentGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdateDocumentGroupInput = {
  data: UpdateDocumentGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDocumentGroupOutput = UpdateDocumentGroupResult | ValidateDocumentGroupResult;

/** The actual data structure of updating an instance of DocumentGroup */
export type UpdateDocumentGroupResult = {
  __typename?: 'UpdateDocumentGroupResult';
  /** The actual data returned for DocumentGroup */
  result: DocumentGroup;
};

export type UpdateDocumentInput = {
  data: UpdateDocumentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *   Ignored, and kept only so callers that still send it are not rejected.
   *
   * The owner is read from the stored document row, and the write is authorized against that owner —
   *   a value here selects nothing and re-targets nothing, and one naming a different person is
   *   silently accepted rather than refused. New callers should omit it (#340).
   *
   * Deprecated, not going away: removing it would reject every request that still carries the field,
   *   and that breaking change is not worth making for an argument the server throws away.
   * @deprecated Never read; the owner comes from the stored row. Omit it in new callers — the field itself stays, so older ones keep working.
   */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentOutput = UpdateDocumentResult | ValidateDocumentResult;

/** The actual data structure of updating an instance of Document */
export type UpdateDocumentResult = {
  __typename?: 'UpdateDocumentResult';
  /** The actual data returned for Document */
  result: Document;
};

export type UpdateEducationDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  degree?: InputMaybe<DegreeRelationInput>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  field: Scalars['String']['input'];
  institution?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  startDate?: InputMaybe<CreateDateInstantDataInput>;
};

export type UpdateEducationInput = {
  data: UpdateEducationDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEducationOutput = UpdateEducationResult | ValidateEducationResult;

/** The actual data structure of updating an instance of Education */
export type UpdateEducationResult = {
  __typename?: 'UpdateEducationResult';
  /** The actual data returned for Education */
  result: Education;
};

export type UpdateExperienceDataInput = {
  activities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  industry?: InputMaybe<IndustryRelationInput>;
  jobTitle: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  startDate?: InputMaybe<CreateDateInstantDataInput>;
};

export type UpdateExperienceInput = {
  data: UpdateExperienceDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *   Ignored, and kept only so callers that still send it are not rejected.
   *
   * The owner is read from the stored experience row, and the write is authorized against that owner —
   *   a value here selects nothing and re-targets nothing, and one naming a different person is
   *   silently accepted rather than refused. New callers should omit it (#340).
   *
   * Deprecated, not going away: removing it would reject every request that still carries the field,
   *   and that breaking change is not worth making for an argument the server throws away.
   * @deprecated Never read; the owner comes from the stored row. Omit it in new callers — the field itself stays, so older ones keep working.
   */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExperienceOutput = UpdateExperienceResult | ValidateExperienceResult;

/** The actual data structure of updating an instance of Experience */
export type UpdateExperienceResult = {
  __typename?: 'UpdateExperienceResult';
  /** The actual data returned for Experience */
  result: Experience;
};

export type UpdateExpertiseDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

export type UpdateExpertiseInput = {
  data: UpdateExpertiseDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *   Ignored, and kept only so callers that still send it are not rejected.
   *
   * The owner is read from the stored expertise row, and the write is authorized against that owner —
   *   a value here selects nothing and re-targets nothing, and one naming a different person is
   *   silently accepted rather than refused. New callers should omit it (#340).
   *
   * Deprecated, not going away: removing it would reject every request that still carries the field,
   *   and that breaking change is not worth making for an argument the server throws away.
   * @deprecated Never read; the owner comes from the stored row. Omit it in new callers — the field itself stays, so older ones keep working.
   */
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExpertiseOutput = UpdateExpertiseResult | ValidateExpertiseResult;

/** The actual data structure of updating an instance of Expertise */
export type UpdateExpertiseResult = {
  __typename?: 'UpdateExpertiseResult';
  /** The actual data returned for Expertise */
  result: Expertise;
};

export type UpdateGenderDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGenderInput = {
  data: UpdateGenderDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGenderOutput = UpdateGenderResult | ValidateGenderResult;

/** The actual data structure of updating an instance of Gender */
export type UpdateGenderResult = {
  __typename?: 'UpdateGenderResult';
  /** The actual data returned for Gender */
  result: Gender;
};

export type UpdateIndustryDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateIndustryInput = {
  data: UpdateIndustryDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIndustryOutput = UpdateIndustryResult | ValidateIndustryResult;

/** The actual data structure of updating an instance of Industry */
export type UpdateIndustryResult = {
  __typename?: 'UpdateIndustryResult';
  /** The actual data returned for Industry */
  result: Industry;
};

export type UpdateJobDepartmentDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateJobDepartmentInput = {
  data: UpdateJobDepartmentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobDepartmentOutput = UpdateJobDepartmentResult | ValidateJobDepartmentResult;

/** The actual data structure of updating an instance of JobDepartment */
export type UpdateJobDepartmentResult = {
  __typename?: 'UpdateJobDepartmentResult';
  /** The actual data returned for JobDepartment */
  result: JobDepartment;
};

export type UpdateJobLocationDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateJobLocationInput = {
  data: UpdateJobLocationDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobLocationOutput = UpdateJobLocationResult | ValidateJobLocationResult;

/** The actual data structure of updating an instance of JobLocation */
export type UpdateJobLocationResult = {
  __typename?: 'UpdateJobLocationResult';
  /** The actual data returned for JobLocation */
  result: JobLocation;
};

export type UpdateLanguageSkillDataInput = {
  /** Dynamic consent to all current and future eligible Groups, independent of public readership. */
  allGroups?: InputMaybe<Scalars['Boolean']['input']>;
  cefr?: InputMaybe<CefrScale>;
  languageTag: Scalars['String']['input'];
  nativeSpeaker: Scalars['Boolean']['input'];
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  selfAssessed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
};

export type UpdateLanguageSkillInput = {
  data: UpdateLanguageSkillDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLanguageSkillOutput = UpdateLanguageSkillResult | ValidateLanguageSkillResult;

/** The actual data structure of updating an instance of LanguageSkill */
export type UpdateLanguageSkillResult = {
  __typename?: 'UpdateLanguageSkillResult';
  /** The actual data returned for LanguageSkill */
  result: LanguageSkill;
};

export type UpdateMaritalStatusDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMaritalStatusInput = {
  data: UpdateMaritalStatusDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMaritalStatusOutput = UpdateMaritalStatusResult | ValidateMaritalStatusResult;

/** The actual data structure of updating an instance of MaritalStatus */
export type UpdateMaritalStatusResult = {
  __typename?: 'UpdateMaritalStatusResult';
  /** The actual data returned for MaritalStatus */
  result: MaritalStatus;
};

export type UpdateMatchCandidateDataInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchCandidateInput = {
  data: UpdateMatchCandidateDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchCandidateOutput = UpdateMatchCandidateResult | ValidateMatchCandidateResult;

/** The actual data structure of updating an instance of MatchCandidate */
export type UpdateMatchCandidateResult = {
  __typename?: 'UpdateMatchCandidateResult';
  /** The actual data returned for MatchCandidate */
  result: MatchCandidate;
};

export type UpdateMatchDataInput = {
  /**
   * The whole truth about the match's access grants, never a delta: on `updateMatch` the list
   * replaces every existing grant, so a person left out of it loses access. An empty list revokes
   * everyone; `null` — like omitting the field — leaves the existing grants untouched (genesis#326).
   */
  access?: InputMaybe<Array<CreateMatchAccessDataInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * The whole design as one JSON object; on `updateMatch` it replaces the stored design, except that
   * the attached `project.documents` survive. `null` — like omitting the field — leaves the stored
   * design untouched (genesis#407): a match without a design is not assessable, so there is no way to
   * clear it.
   */
  design?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedItem?: InputMaybe<SharedItemRelationInput>;
};

export type UpdateMatchInput = {
  data: UpdateMatchDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchOutput = UpdateMatchResult | ValidateMatchResult;

/** The actual data structure of updating an instance of Match */
export type UpdateMatchResult = {
  __typename?: 'UpdateMatchResult';
  /** The actual data returned for Match */
  result: Match;
};

export type UpdateMatchResultDataInput = {
  hiddenSections?: InputMaybe<Array<Scalars['String']['input']>>;
  kept?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<CreateMatchResultTeamDataInput>>;
};

export type UpdateMatchResultInput = {
  data: UpdateMatchResultDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchResultOutput = UpdateMatchResultResult | ValidateMatchResultResult;

/** The actual data structure of updating an instance of MatchResult */
export type UpdateMatchResultResult = {
  __typename?: 'UpdateMatchResultResult';
  /** The actual data returned for MatchResult */
  result: MatchResult;
};

export type UpdateOrgUnitDataInput = {
  /**
   * Retires the unit: a hidden unit is dropped from the tree query and is not a valid assignment target,
   * without being deleted. This is the retirement path for an in-use unit — one with children or assigned
   * people cannot be hard-deleted (the foreign keys are RESTRICT).
   */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  /** The parent unit, or null for a root. Setting a parent that would form a cycle is refused. */
  parent?: InputMaybe<OrgUnitRelationInput>;
};

export type UpdateOrgUnitInput = {
  data: UpdateOrgUnitDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrgUnitOutput = UpdateOrgUnitResult | ValidateOrgUnitResult;

/** The actual data structure of updating an instance of OrgUnit */
export type UpdateOrgUnitResult = {
  __typename?: 'UpdateOrgUnitResult';
  /** The actual data returned for OrgUnit */
  result: OrgUnit;
};

export type UpdateOrganizationalRecordEntryInput = {
  content: Scalars['String']['input'];
  kind: OrganizationalRecordEntryKind;
  /** Omitted/null preserves references; [] removes them. Saved atomically with the content. */
  links?: InputMaybe<Array<OrganizationalRecordLinkTargetInput>>;
  title: Scalars['String']['input'];
};

export type UpdatePersonDataInput = {
  administrativeGender?: InputMaybe<AdministrativeGender>;
  alternativeAvatar?: InputMaybe<CreateFileDataInput>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<CreateFileDataInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  childCount?: InputMaybe<Scalars['Int']['input']>;
  citizenships?: InputMaybe<Array<InputMaybe<CountryRelationInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<ContractTypeRelationInput>;
  country?: InputMaybe<CountryRelationInput>;
  countryState?: InputMaybe<CountryStateRelationInput>;
  currentActivity?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  currentTasks?: InputMaybe<Scalars['String']['input']>;
  deceased?: InputMaybe<CreateDeceasedDataInput>;
  drivingLicence?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderRelationInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  jobDepartment?: InputMaybe<JobDepartmentRelationInput>;
  jobLocation?: InputMaybe<JobLocationRelationInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatusRelationInput>;
  miscellaneous?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<CreateHumanNameDataInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workingTimeModel?: InputMaybe<WorkingTimeModelRelationInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdatePersonGroupInput = {
  data: UpdatePersonGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePersonGroupOutput = UpdatePersonGroupResult | ValidatePersonGroupResult;

/** The actual data structure of updating an instance of PersonGroup */
export type UpdatePersonGroupResult = {
  __typename?: 'UpdatePersonGroupResult';
  /** The actual data returned for PersonGroup */
  result: PersonGroup;
};

/** Profile edits and owner consent commit atomically. Omitted consent leaves saved sharing unchanged. */
export type UpdatePersonInput = {
  data: UpdatePersonDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Owner-only Group selections. Omitted attributes preserve their saved recipients. */
  personalSharing?: InputMaybe<CreatePersonSharedAttributesDataInput>;
};

export type UpdatePersonOutput = UpdatePersonResult | ValidatePersonResult;

/** The actual data structure of updating an instance of Person */
export type UpdatePersonResult = {
  __typename?: 'UpdatePersonResult';
  /** The actual data returned for Person */
  result: Person;
};

export type UpdatePinGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdatePinGroupInput = {
  data: UpdatePinGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePinGroupOutput = UpdatePinGroupResult | ValidatePinGroupResult;

/** The actual data structure of updating an instance of PinGroup */
export type UpdatePinGroupResult = {
  __typename?: 'UpdatePinGroupResult';
  /** The actual data returned for PinGroup */
  result: PinGroup;
};

export type UpdateProjectDataInput = {
  /**
   * Wer Zugriff hat, als ganzer Sollzustand wie bei `Match.access`: bei `updateProject` ersetzt die
   * Liste alle Zugriffe, wer fehlt, verliert seinen. Eine leere Liste entzieht allen den Zugriff;
   * `null` oder ein weggelassenes Feld lässt ihn stehen. Ausnahme ist bei einem persönlichen Projekt
   * der Ersteller: seine Zeile bleibt mit WRITE auf allen Flächen stehen, Einträge für ihn werden
   * ignoriert (genesis#392). Ein Firmenprojekt hat keine solche Zeile; dort ist der Ersteller ein
   * Eintrag wie jeder andere (genesis#418).
   */
  access?: InputMaybe<Array<CreateProjectAccessDataInput>>;
  data?: InputMaybe<Scalars['Object']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Data structure for updating an instance of Project.
 *
 * HAND-WRITTEN for `actingAsCompanyId` alone (genesis#418); see `CreateProjectInput`.
 */
export type UpdateProjectInput = {
  /**
   * Wählt den Weg, auf dem geschrieben wird (genesis#418). Gleich der Firma des Projekts: der Weg der
   * Firmen-Admins; die Firma muss aktiv sein. Fehlt sie: der persönliche Weg über den Ersteller eines
   * persönlichen Projekts oder eine Zugriffszeile mit WRITE auf `plan`. Eine andere Firma ist
   * `GENESIS001259`, jede Angabe auf einem persönlichen Projekt `GENESIS001260`.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  data: UpdateProjectDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProjectOutput = UpdateProjectResult | ValidateProjectResult;

/** The actual data structure of updating an instance of Project */
export type UpdateProjectResult = {
  __typename?: 'UpdateProjectResult';
  /** The actual data returned for Project */
  result: Project;
};

export type UpdateSharedItemCommentDataInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Data structure for updating an instance of SharedItemComment.
 *
 * HAND-WRITTEN for `actingAsCompanyId` alone; see `UpdateSharedItemInput`.
 */
export type UpdateSharedItemCommentInput = {
  /**
   *   The company the caller declares they are acting AS while editing this comment.
   *
   * REQUIRED ON A COMPANY COMMENT AND FORBIDDEN ON A PERSONAL ONE — the declared context and the
   *   ownership of the row must MATCH. On a company comment it must EQUAL the `company_id` stored on the
   *   row; absent or different is refused with `GENESIS001259`. On a personal comment there must be no
   *   declaration at all, and one is refused with `GENESIS001260`. Concept v23 (Punkt 6, Kevin 2026-09-11)
   *   came from the case that reads wrong on the screen: „although i am a company admin i can still edit
   *   the comment made by another company admin acted as company admin while i did not act as company."
   *   Every current admin may still edit every one of their company's comments (v16, and the orphaning
   *   rule behind it is untouched) — they switch context first.
   *
   * THE SECOND DIRECTION IS THE 2026-09-12 EXTENSION: „if someone acts as a company, he cannot
   *   edit/delete/create comments as private person." Until then this value was IGNORED on a personal
   *   comment and this description said so; the sentence is gone because it is now false. Acting as a
   *   company is a mode with its own subject matter, and correcting your own words means leaving it first.
   *
   * IT NARROWS AND NEVER GRANTS. `company` on `SharedItemComment` is creatable and NOT updatable, so an
   *   edit could never move a comment between companies; this field cannot either. The stored column
   *   decides and the declaration only has to agree with it, which is why v23 leaves
   *   @adr GENESIS-0023-company-membership-is-the-per-company-authorization@4 §1 intact.
   *
   * IT IS NOT AN ACCESS BOUNDARY: the value is CLIENT-DECLARED and every principal who may already
   *   edit this comment can send it (genesis#300). See `UpdateSharedItemInput` for the full reasoning.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  data: UpdateSharedItemCommentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSharedItemCommentOutput = UpdateSharedItemCommentResult | ValidateSharedItemCommentResult;

/** The actual data structure of updating an instance of SharedItemComment */
export type UpdateSharedItemCommentResult = {
  __typename?: 'UpdateSharedItemCommentResult';
  /** The actual data returned for SharedItemComment */
  result: SharedItemComment;
};

export type UpdateSharedItemDataInput = {
  /** Replace classification IDs; omitted preserves them, an empty list clears them. PROJECT items only. */
  categoryIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  darkMode?: InputMaybe<CreateColorsDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<CreateFileDataInput>>;
  filesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  images?: InputMaybe<Array<CreateFileDataInput>>;
  imagesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lightMode?: InputMaybe<CreateColorsDataInput>;
  mainImage?: InputMaybe<CreateFileDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Public readership, independent of Group recipients. Company and HR publication rules still apply. */
  publiclyReadable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group recipients; an empty list grants no ordinary Group readership. */
  sharedWith?: InputMaybe<Array<InputMaybe<ContentSharingRecipientRelationInput>>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Data structure for updating an instance of SharedItem.
 *
 * HAND-WRITTEN rather than generated, for the one field the generator has no way to know about:
 * `actingAsCompanyId`. The rest reproduces what the generator emitted, so nothing else about the
 * mutation's shape changes.
 */
export type UpdateSharedItemInput = {
  /**
   *   The company the caller declares they are acting AS while making this write.
   *
   * THE DECLARED CONTEXT AND THE OWNERSHIP OF THE ROW MUST MATCH — required on company-owned content,
   *   forbidden on personal content. Concept v23
   *   (the company account model, Kevin 2026-09-11) narrows editing and
   *   deleting a company's post or project to two conditions where there was one: a current `admin`
   *   membership AND acting as that company at the time of the write. So on a COMPANY item this must be
   *   present and must EQUAL the `company_id` stored on the row; absent, or naming another company, is
   *   refused with `GENESIS001259`. On a PERSONAL item there must be no declaration at all, and one is
   *   refused with `GENESIS001260` — the mirror code, added when Kevin extended v23 on 2026-09-12: "if
   *   someone acts as a company, he cannot edit/delete/create comments as private person". An earlier
   *   revision of this description said the value was IGNORED for personal content; that was true until
   *   that date and is false now.
   *
   * THAT IS WHAT MAKES THE CONTEXT EXCLUSIVE, and it is the point of the second half rather than a side
   *   effect. Two modes, each with its own subject matter: acting as a company reaches that company's
   *   content and nothing else, acting as nobody reaches your own and nothing else. The cost is deliberate
   *   friction — a typo in your own post, spotted while acting as a company, is repaired after leaving the
   *   context — and what it buys is that "in whose name am I acting" has one answer instead of two.
   *
   * IT NARROWS AND NEVER GRANTS. The governing company is still read from the ROW: this declaration
   *   cannot replace it, widen it or stand in for it, only AGREE with it, and authorisation remains the
   *   `company_membership` row alone
   *   (@adr GENESIS-0023-company-membership-is-the-per-company-authorization@4 §1).
   *
   * IT IS NOT AN ACCESS BOUNDARY, and that is stated plainly because the value is CLIENT-DECLARED.
   *   Anybody who may already write this row can send it, so v23 makes the set of principals who can
   *   write no smaller; what it prevents is writing in the WRONG context, and nothing else. Kevin
   *   accepted that knowingly on 2026-09-11 and it is recorded on genesis#300, which also names the two
   *   shapes a real boundary would have to take. Nobody may later cite this field as a permission.
   *
   * THE OPEN PAGE GOES STALE, which is why the refusal is its own code rather than "not permitted":
   *   the acting context lives in the client's memory and dies with the tab, so a page left open can
   *   believe it is still acting as the company after the context is gone. The server has to answer that
   *   usably.
   */
  actingAsCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  data: UpdateSharedItemDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSharedItemOutput = UpdateSharedItemResult | ValidateSharedItemResult;

/** The actual data structure of updating an instance of SharedItem */
export type UpdateSharedItemResult = {
  __typename?: 'UpdateSharedItemResult';
  /** The actual data returned for SharedItem */
  result: SharedItem;
};

export type UpdateStudioNotebookDataInput = {
  /** Der Text des Notizbuchs als Markdown, mit den Abschnitten, die spark darin markiert. */
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStudioNotebookInput = {
  data: UpdateStudioNotebookDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStudioNotebookOutput = UpdateStudioNotebookResult | ValidateStudioNotebookResult;

/** The actual data structure of updating an instance of StudioNotebook */
export type UpdateStudioNotebookResult = {
  __typename?: 'UpdateStudioNotebookResult';
  /** The actual data returned for StudioNotebook */
  result: StudioNotebook;
};

export type UpdateTeamProfileDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  weights?: InputMaybe<Array<CreateElementWeightDataInput>>;
};

export type UpdateTeamProfileInput = {
  data: UpdateTeamProfileDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTeamProfileOutput = UpdateTeamProfileResult | ValidateTeamProfileResult;

/** The actual data structure of updating an instance of TeamProfile */
export type UpdateTeamProfileResult = {
  __typename?: 'UpdateTeamProfileResult';
  /** The actual data returned for TeamProfile */
  result: TeamProfile;
};

export type UpdateWorkingTimeModelDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateWorkingTimeModelInput = {
  data: UpdateWorkingTimeModelDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWorkingTimeModelOutput = UpdateWorkingTimeModelResult | ValidateWorkingTimeModelResult;

/** The actual data structure of updating an instance of WorkingTimeModel */
export type UpdateWorkingTimeModelResult = {
  __typename?: 'UpdateWorkingTimeModelResult';
  /** The actual data returned for WorkingTimeModel */
  result: WorkingTimeModel;
};

export type UsedDocumentTagsInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
};

export type UsedDocumentTagsOutput = UsedDocumentTagsResult;

export type UsedDocumentTagsResult = {
  __typename?: 'UsedDocumentTagsResult';
  tags: Array<Scalars['String']['output']>;
};

/** The filterable fields of type UsedDocumentTagsResult */
export type UsedDocumentTagsResultFilterInput = {
  and?: InputMaybe<Array<UsedDocumentTagsResultFilterInput>>;
  not?: InputMaybe<UsedDocumentTagsResultFilterInput>;
  or?: InputMaybe<Array<UsedDocumentTagsResultFilterInput>>;
};

export enum UserRank {
  Rank1 = 'RANK1',
  Rank2 = 'RANK2',
  Rank3 = 'RANK3',
  Rank4 = 'RANK4',
  Rank5 = 'RANK5',
  Rank6 = 'RANK6',
  Rank7 = 'RANK7',
  Rank8 = 'RANK8'
}

export type ValidateAgentIssue = ValidationIssue & {
  __typename?: 'ValidateAgentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateAgentResult = ValidationIssues & {
  __typename?: 'ValidateAgentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateCertificateIssue = ValidationIssue & {
  __typename?: 'ValidateCertificateIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateCertificateResult = ValidationIssues & {
  __typename?: 'ValidateCertificateResult';
  issues: Array<ValidationIssue>;
};

export type ValidateCompanyIssue = ValidationIssue & {
  __typename?: 'ValidateCompanyIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateCompanyResult = ValidationIssues & {
  __typename?: 'ValidateCompanyResult';
  issues: Array<ValidationIssue>;
};

export type ValidateContractTypeIssue = ValidationIssue & {
  __typename?: 'ValidateContractTypeIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateContractTypeResult = ValidationIssues & {
  __typename?: 'ValidateContractTypeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateCurriculumVitaeIssue = ValidationIssue & {
  __typename?: 'ValidateCurriculumVitaeIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateCurriculumVitaeResult = ValidationIssues & {
  __typename?: 'ValidateCurriculumVitaeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDegreeIssue = ValidationIssue & {
  __typename?: 'ValidateDegreeIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDegreeResult = ValidationIssues & {
  __typename?: 'ValidateDegreeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDiscoveryCategoryIssue = ValidationIssue & {
  __typename?: 'ValidateDiscoveryCategoryIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDiscoveryCategoryResult = ValidationIssues & {
  __typename?: 'ValidateDiscoveryCategoryResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDocumentGroupIssue = ValidationIssue & {
  __typename?: 'ValidateDocumentGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDocumentGroupResult = ValidationIssues & {
  __typename?: 'ValidateDocumentGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDocumentIssue = ValidationIssue & {
  __typename?: 'ValidateDocumentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDocumentResult = ValidationIssues & {
  __typename?: 'ValidateDocumentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateEducationIssue = ValidationIssue & {
  __typename?: 'ValidateEducationIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateEducationResult = ValidationIssues & {
  __typename?: 'ValidateEducationResult';
  issues: Array<ValidationIssue>;
};

export type ValidateExperienceIssue = ValidationIssue & {
  __typename?: 'ValidateExperienceIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateExperienceResult = ValidationIssues & {
  __typename?: 'ValidateExperienceResult';
  issues: Array<ValidationIssue>;
};

export type ValidateExpertiseIssue = ValidationIssue & {
  __typename?: 'ValidateExpertiseIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateExpertiseResult = ValidationIssues & {
  __typename?: 'ValidateExpertiseResult';
  issues: Array<ValidationIssue>;
};

export type ValidateGenderIssue = ValidationIssue & {
  __typename?: 'ValidateGenderIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateGenderResult = ValidationIssues & {
  __typename?: 'ValidateGenderResult';
  issues: Array<ValidationIssue>;
};

export type ValidateIndustryIssue = ValidationIssue & {
  __typename?: 'ValidateIndustryIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateIndustryResult = ValidationIssues & {
  __typename?: 'ValidateIndustryResult';
  issues: Array<ValidationIssue>;
};

export type ValidateJobDepartmentIssue = ValidationIssue & {
  __typename?: 'ValidateJobDepartmentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateJobDepartmentResult = ValidationIssues & {
  __typename?: 'ValidateJobDepartmentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateJobLocationIssue = ValidationIssue & {
  __typename?: 'ValidateJobLocationIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateJobLocationResult = ValidationIssues & {
  __typename?: 'ValidateJobLocationResult';
  issues: Array<ValidationIssue>;
};

export type ValidateLanguageSkillIssue = ValidationIssue & {
  __typename?: 'ValidateLanguageSkillIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateLanguageSkillResult = ValidationIssues & {
  __typename?: 'ValidateLanguageSkillResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMaritalStatusIssue = ValidationIssue & {
  __typename?: 'ValidateMaritalStatusIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMaritalStatusResult = ValidationIssues & {
  __typename?: 'ValidateMaritalStatusResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchCandidateIssue = ValidationIssue & {
  __typename?: 'ValidateMatchCandidateIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchCandidateResult = ValidationIssues & {
  __typename?: 'ValidateMatchCandidateResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchCompanyIssue = ValidationIssue & {
  __typename?: 'ValidateMatchCompanyIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchCompanyResult = ValidationIssues & {
  __typename?: 'ValidateMatchCompanyResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchIssue = ValidationIssue & {
  __typename?: 'ValidateMatchIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchResult = ValidationIssues & {
  __typename?: 'ValidateMatchResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchResultIssue = ValidationIssue & {
  __typename?: 'ValidateMatchResultIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchResultResult = ValidationIssues & {
  __typename?: 'ValidateMatchResultResult';
  issues: Array<ValidationIssue>;
};

export type ValidateOrgUnitIssue = ValidationIssue & {
  __typename?: 'ValidateOrgUnitIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateOrgUnitResult = ValidationIssues & {
  __typename?: 'ValidateOrgUnitResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePersonGroupIssue = ValidationIssue & {
  __typename?: 'ValidatePersonGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePersonGroupResult = ValidationIssues & {
  __typename?: 'ValidatePersonGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePersonIssue = ValidationIssue & {
  __typename?: 'ValidatePersonIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePersonResult = ValidationIssues & {
  __typename?: 'ValidatePersonResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePinGroupIssue = ValidationIssue & {
  __typename?: 'ValidatePinGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePinGroupResult = ValidationIssues & {
  __typename?: 'ValidatePinGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidateProjectIssue = ValidationIssue & {
  __typename?: 'ValidateProjectIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateProjectResult = ValidationIssues & {
  __typename?: 'ValidateProjectResult';
  issues: Array<ValidationIssue>;
};

/**
 * Validation issues of a questionnaire group save. Hand-written because a questionnaire group is not one of the
 * directive-driven entities the codegen derives its Validate types from; the shape is the generated one
 * (ValidateDocumentGroupResult) so clients can treat every group kind the same way. Like the generated arms of
 * the other group kinds, genesis does not answer with it today - every invalid input comes back as a GraphQL
 * error. Clients keep the branch anyway (spark's PinGroupDialog does), which is why the arm exists.
 */
export type ValidateQuestionnaireGroupIssue = ValidationIssue & {
  __typename?: 'ValidateQuestionnaireGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** The filterable fields of type ValidateQuestionnaireGroupIssue */
export type ValidateQuestionnaireGroupIssueFilterInput = {
  and?: InputMaybe<Array<ValidateQuestionnaireGroupIssueFilterInput>>;
  not?: InputMaybe<ValidateQuestionnaireGroupIssueFilterInput>;
  or?: InputMaybe<Array<ValidateQuestionnaireGroupIssueFilterInput>>;
};

export type ValidateQuestionnaireGroupResult = ValidationIssues & {
  __typename?: 'ValidateQuestionnaireGroupResult';
  issues: Array<ValidationIssue>;
};

/** The filterable fields of type ValidateQuestionnaireGroupResult */
export type ValidateQuestionnaireGroupResultFilterInput = {
  and?: InputMaybe<Array<ValidateQuestionnaireGroupResultFilterInput>>;
  not?: InputMaybe<ValidateQuestionnaireGroupResultFilterInput>;
  or?: InputMaybe<Array<ValidateQuestionnaireGroupResultFilterInput>>;
};

export type ValidateSharedItemCommentIssue = ValidationIssue & {
  __typename?: 'ValidateSharedItemCommentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateSharedItemCommentResult = ValidationIssues & {
  __typename?: 'ValidateSharedItemCommentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateSharedItemIssue = ValidationIssue & {
  __typename?: 'ValidateSharedItemIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateSharedItemResult = ValidationIssues & {
  __typename?: 'ValidateSharedItemResult';
  issues: Array<ValidationIssue>;
};

export type ValidateStudioNotebookIssue = ValidationIssue & {
  __typename?: 'ValidateStudioNotebookIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateStudioNotebookResult = ValidationIssues & {
  __typename?: 'ValidateStudioNotebookResult';
  issues: Array<ValidationIssue>;
};

export type ValidateTeamProfileIssue = ValidationIssue & {
  __typename?: 'ValidateTeamProfileIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateTeamProfileResult = ValidationIssues & {
  __typename?: 'ValidateTeamProfileResult';
  issues: Array<ValidationIssue>;
};

export type ValidateWorkingTimeModelIssue = ValidationIssue & {
  __typename?: 'ValidateWorkingTimeModelIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateWorkingTimeModelResult = ValidationIssues & {
  __typename?: 'ValidateWorkingTimeModelResult';
  issues: Array<ValidationIssue>;
};

/** Technical description of the validation error. */
export enum ValidationError {
  /** The value of the field is supposed to be unique but it is already used elsewhere */
  AlreadyExists = 'ALREADY_EXISTS',
  /** The value of the field does not match the expected format (eg. invalid email address or URL) */
  FormatError = 'FORMAT_ERROR',
  /** The field is mandatory but either an empty value or no value was provided */
  IsMandatory = 'IS_MANDATORY',
  /** Other errors. Human-readable details can be found the message field. */
  Other = 'OTHER'
}

/** Describes an error condition that occurred during input validation */
export type ValidationIssue = {
  /** A technical description of the error */
  error?: Maybe<ValidationError>;
  /** The name of the field that caused the error */
  field?: Maybe<Scalars['String']['output']>;
  /** A human-readable description of the error. The language of the text might depend on the HTTP 'Accept-Language' header */
  message?: Maybe<Scalars['String']['output']>;
};

/** Collection of validation errors occurred during input validation */
export type ValidationIssues = {
  /** List of validation errors */
  issues: Array<ValidationIssue>;
};

export type VideoElement = GrowElement & PlayableGrowElement & {
  __typename?: 'VideoElement';
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  manifest: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['Binary']['output']>;
  title: LocalizedText;
};

/** The filterable fields of type VideoElement */
export type VideoElementFilterInput = {
  and?: InputMaybe<Array<VideoElementFilterInput>>;
  not?: InputMaybe<VideoElementFilterInput>;
  or?: InputMaybe<Array<VideoElementFilterInput>>;
};

export type ViewSharedItemInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewSharedItemOutput = ViewSharedItemResult;

export type ViewSharedItemResult = {
  __typename?: 'ViewSharedItemResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type ViewSharedItemResult */
export type ViewSharedItemResultFilterInput = {
  and?: InputMaybe<Array<ViewSharedItemResultFilterInput>>;
  not?: InputMaybe<ViewSharedItemResultFilterInput>;
  or?: InputMaybe<Array<ViewSharedItemResultFilterInput>>;
};

export type ViewUserProfileInput = {
  userProfileId: Scalars['UUID']['input'];
};

export type ViewUserProfileOutput = ViewUserProfileResult;

export type ViewUserProfileResult = {
  __typename?: 'ViewUserProfileResult';
  userProfileId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type ViewUserProfileResult */
export type ViewUserProfileResultFilterInput = {
  and?: InputMaybe<Array<ViewUserProfileResultFilterInput>>;
  not?: InputMaybe<ViewUserProfileResultFilterInput>;
  or?: InputMaybe<Array<ViewUserProfileResultFilterInput>>;
};

export type WorkingTimeModel = Node & {
  __typename?: 'WorkingTimeModel';
  desc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localizedDesc?: Maybe<LocalizedText>;
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type WorkingTimeModel */
export type WorkingTimeModelFilterInput = {
  and?: InputMaybe<Array<WorkingTimeModelFilterInput>>;
  desc?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<WorkingTimeModelFilterInput>;
  or?: InputMaybe<Array<WorkingTimeModelFilterInput>>;
};

/** Contains information for linking 'WorkingTimeModel' to other entities */
export type WorkingTimeModelRelationInput = {
  /** The identifier of 'WorkingTimeModel' */
  id: Scalars['ID']['input'];
};

export type WorkingTimeModelSortInput = {
  desc?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type WorkingTimeModelsResult = {
  __typename?: 'WorkingTimeModelsResult';
  workingTimeModels: Array<WorkingTimeModel>;
};

/** The filterable fields of type WorkingTimeModelsResult */
export type WorkingTimeModelsResultFilterInput = {
  and?: InputMaybe<Array<WorkingTimeModelsResultFilterInput>>;
  not?: InputMaybe<WorkingTimeModelsResultFilterInput>;
  or?: InputMaybe<Array<WorkingTimeModelsResultFilterInput>>;
};
